/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
/**
 * RFC 8414 metadata. Field names are the RFC's, so they stay snake_case as written.
 */
export type TLMcpAuthorizationServerMetadataResponse = {
  authorization_endpoint: string;
  code_challenge_methods_supported: string[];
  grant_types_supported: string[];
  issuer: string;
  registration_endpoint: string;
  response_types_supported: string[];
  token_endpoint: string;
  token_endpoint_auth_methods_supported: string[];
};

/**
 * RFC 9728 protected-resource metadata for the MCP server.
 */
export type TLProtectedResourceMetadataResponse = {
  authorization_servers: string[];
  bearer_methods_supported?: string[];
  resource: string;
};

export enum TLSAPVersion {
  ECC = 'ECC',
  S4 = 'S4',
}
export type TLAbapFormatRequest = {
  /**
   * Raw ABAP code to format
   * @minLength 1
   */
  code: string;
  /**
   * SAP version to format
   * @minLength 1
   */
  sap_version: TLSAPVersion;
};

export type TLAbapFormatResponse = {
  /** Formatted ABAP code */
  formatted_code: string;
};

export type TLValidationErrorCtx = { [key: string]: unknown };

export type TLValidationError = {
  ctx?: TLValidationErrorCtx;
  input?: unknown;
  loc: (string | number)[];
  msg: string;
  type: string;
};

export type TLHTTPValidationError = {
  detail?: TLValidationError[];
};

export enum TLLlmProvider {
  VLLM = 'VLLM',
  TOGETHER = 'TOGETHER',
  ANTHROPIC = 'ANTHROPIC',
  BEDROCK_ANTHROPIC = 'BEDROCK_ANTHROPIC',
  BEDROCK_COMPATIBLE_HTTP = 'BEDROCK_COMPATIBLE_HTTP',
  VERTEX_ANTHROPIC = 'VERTEX_ANTHROPIC',
  OPENAI = 'OPENAI',
  FOUNDRY_ANTHROPIC = 'FOUNDRY_ANTHROPIC',
  FOUNDRY_GPT = 'FOUNDRY_GPT',
  GEMINI = 'GEMINI',
  OCI_GENERATIVE_AI = 'OCI_GENERATIVE_AI',
}
export enum TLCurrency {
  USD = 'USD',
}
export type TLLLMModelCostResponse = {
  /**
   * Cache read cost per million tokens
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  cache_read_cost_per_mtok: string;
  /**
   * Cache write cost per million tokens
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  cache_write_cost_per_mtok: string;
  /** Input context window in tokens from the llm_models catalog row. None if the catalog row's context_window_tokens is unset. */
  context_limit?: number | null;
  /** Unique identifier */
  cost_id: string;
  /** Email of user who created this entry */
  created_by: string;
  /** UTC creation timestamp */
  created_date: string;
  /** Currency */
  currency: TLCurrency;
  /** UTC datetime this pricing takes effect (inclusive) */
  effective_from: string;
  /** UTC datetime this pricing expires. Null = active. */
  effective_to?: string | null;
  /**
   * Input cost per million tokens
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  input_cost_per_mtok: string;
  /** Model name/identifier */
  model: string;
  /** Catalog model id this cost row is bound to */
  model_id?: string | null;
  /** Optional notes */
  notes?: string | null;
  /**
   * Output cost per million tokens
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  output_cost_per_mtok: string;
  /** LLM provider */
  provider: TLLlmProvider;
  /** Email of user who last updated this entry */
  updated_by: string;
  /** UTC last-updated timestamp */
  updated_date: string;
};

export type TLLLMModelCostListResponse = {
  items?: TLLLMModelCostResponse[];
  /** Page size used for this response */
  limit: number;
  /** Zero-based offset used for this response */
  offset: number;
  /** Total number of entries matching the query */
  total: number;
};

export type TLLLMModelCostCreateRequest = {
  /** Cache read cost per million tokens */
  cache_read_cost_per_mtok?: number | string;
  /** Cache write cost per million tokens */
  cache_write_cost_per_mtok?: number | string;
  /** Currency (currently only USD) */
  currency?: TLCurrency;
  /** UTC datetime this pricing takes effect (inclusive) */
  effective_from: string;
  /** UTC datetime this pricing expires (exclusive). Null means currently active. */
  effective_to?: string | null;
  /** Input cost per million tokens */
  input_cost_per_mtok: number | string;
  /** Model name/identifier. Required when model_id is omitted. */
  model?: string | null;
  /** Catalog model id. When omitted, resolved from provider + model. */
  model_id?: string | null;
  /** Optional notes about this pricing entry */
  notes?: string | null;
  /** Output cost per million tokens */
  output_cost_per_mtok: number | string;
  /** LLM provider. Required when model_id is omitted. */
  provider?: TLLlmProvider | null;
};

export type TLLLMModelCostUpdateRequest = {
  cache_read_cost_per_mtok?: number | string | null;
  cache_write_cost_per_mtok?: number | string | null;
  effective_from?: string | null;
  effective_to?: string | null;
  input_cost_per_mtok?: number | string | null;
  notes?: string | null;
  output_cost_per_mtok?: number | string | null;
};

export type TLApiKeyResponse = {
  created_by: string;
  created_date: string;
  id: string;
  is_active: boolean;
  key_prefix: string;
  last_used_date: string | null;
  name: string;
};

export type TLPaginatedResponseApiKeyResponse = {
  /** List of items */
  data: TLApiKeyResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLApiKeyCreateRequest = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
};

export type TLApiKeyCreatedResponse = {
  created_by: string;
  created_date: string;
  id: string;
  is_active: boolean;
  key: string;
  key_prefix: string;
  last_used_date: string | null;
  name: string;
};

export type TLGroupsGroupResponse = {
  /** The unique identifier of the group */
  id?: string | null;
  /** The name of the group */
  name?: string | null;
};

export type TLGroupsListResponse = {
  /** List of groups */
  groups: TLGroupsGroupResponse[];
  /** Whether more groups exist beyond this page */
  has_more?: boolean;
};

/**
 * Optional attributes for the group
 */
export type TLGroupCreateRequestAttributes = { [key: string]: unknown } | null;

/**
 * Request model for creating a new group.
 */
export type TLGroupCreateRequest = {
  /** Optional attributes for the group */
  attributes?: TLGroupCreateRequestAttributes;
  /**
   * The name of the group to create
   * @minLength 1
   */
  name: string;
};

export type TLDirectoryRoleRef = {
  composite?: boolean | null;
  name?: string | null;
};

export type TLAuthzGroupDirectoryEntry = {
  /** The unique identifier of the group */
  id?: string | null;
  member_count?: number;
  member_count_has_more?: boolean;
  /** The name of the group */
  name?: string | null;
  roles?: TLDirectoryRoleRef[];
};

export type TLPaginatedResponseAuthzGroupDirectoryEntry = {
  /** List of items */
  data: TLAuthzGroupDirectoryEntry[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Optional attributes for the group
 */
export type TLGroupUpdateRequestAttributes = { [key: string]: unknown } | null;

/**
 * Request model for updating a group.
 */
export type TLGroupUpdateRequest = {
  /** Optional attributes for the group */
  attributes?: TLGroupUpdateRequestAttributes;
  /** The new name for the group */
  name?: string | null;
};

/**
 * Request model for removing members from a group.
 */
export type TLGroupMemberRemoveRequest = {
  /**
   * List of email addresses of the users to remove
   * @minItems 1
   */
  emails: string[];
};

export type TLGroupMemberOperationResult = {
  /** The email address of the user */
  email: string;
  /** Error message if the operation failed */
  error?: string | null;
  /** Whether the operation was successful for this user */
  success: boolean;
};

export type TLGroupMembersResponse = {
  /** List of email addresses of the group members */
  emails: string[];
  /** The unique identifier of the group */
  group_id?: string | null;
  /** Whether more members exist beyond this page */
  has_more?: boolean;
};

/**
 * Request model for adding members to a group.
 */
export type TLGroupMemberAddRequest = {
  /**
   * List of email addresses of the users to add
   * @minItems 1
   */
  emails: string[];
};

export type TLGroupRoleResponse = {
  /** Whether the role is a composite role */
  composite?: boolean | null;
  /** The description of the role */
  description?: string | null;
  /** The unique identifier of the role */
  id?: string | null;
  /** The name of the role */
  name?: string | null;
};

export type TLGroupRolesResponse = {
  /** The unique identifier of the group */
  group_id?: string | null;
  /** List of roles assigned to the group */
  roles: TLGroupRoleResponse[];
};

/**
 * Request model for assigning roles to a group.
 */
export type TLGroupRoleAssignRequest = {
  /**
   * List of role names to assign to the group
   * @minItems 1
   */
  role_names: string[];
};

/**
 * Request model for removing roles from a group.
 */
export type TLGroupRoleRemoveRequest = {
  /**
   * List of role names to remove from the group
   * @minItems 1
   */
  role_names: string[];
};

export type TLRoleResponse = {
  /** Whether the role is a composite role */
  composite?: boolean | null;
  /** The description of the role */
  description?: string | null;
  /** The unique identifier of the role */
  id?: string | null;
  /** The name of the role */
  name?: string | null;
};

export type TLRolesListResponse = {
  /** List of roles */
  roles: TLRoleResponse[];
};

/**
 * Request model for creating a new role.
 */
export type TLRoleCreateRequest = {
  /** Optional description for the role */
  description?: string | null;
  /**
   * The name of the role to create
   * @minLength 1
   */
  name: string;
};

export type TLRolesPageResponse = {
  /** Whether more roles exist beyond this page */
  has_more: boolean;
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** List of roles on this page */
  roles: TLRoleResponse[];
};

/**
 * Request model for assigning roles to multiple users.
 */
export type TLUserRoleAssignRequest = {
  /**
   * List of email addresses of the users
   * @minItems 1
   */
  emails: string[];
  /**
   * List of role names to assign to the users
   * @minItems 1
   */
  role_names: string[];
};

export type TLUserRoleResult = {
  /** The email address of the user */
  email: string;
  /** Error message if the operation failed */
  error?: string | null;
  /** Whether the operation was successful for this user */
  success: boolean;
};

export type TLBulkUserRoleOperationResponse = {
  /** Number of users that failed */
  failed: number;
  /** Per-user results */
  results: TLUserRoleResult[];
  /** List of role names that were assigned/removed */
  role_names: string[];
  /** Number of users successfully processed */
  succeeded: number;
  /** Total number of users in the request */
  total: number;
};

/**
 * Request model for removing roles from multiple users.
 */
export type TLUserRoleRemoveRequest = {
  /**
   * List of email addresses of the users
   * @minItems 1
   */
  emails: string[];
  /**
   * List of role names to remove from the users
   * @minItems 1
   */
  role_names: string[];
};

/**
 * Request model for updating a role.
 */
export type TLRoleUpdateRequest = {
  /** The new description for the role */
  description?: string | null;
};

export type TLUserCreateRequestAttributes = { [key: string]: string[] } | null;

/**
 * Keycloak enforces password policy; invalid passwords will be rejected.
 */
export type TLUserCreateRequest = {
  attributes?: TLUserCreateRequestAttributes;
  email: string;
  enabled?: boolean;
  /** @minLength 1 */
  first_name: string;
  /** @minLength 1 */
  last_name: string;
  password?: string | null;
  send_invite?: boolean;
  temporary_password?: boolean;
  username?: string | null;
};

export type TLUserRepresentationAccess = { [key: string]: boolean } | null;

export type TLUserRepresentationApplicationRoles = { [key: string]: string[] } | null;

export type TLUserRepresentationAttributes = { [key: string]: string[] } | null;

export type TLUserRepresentationClientRoles = { [key: string]: string[] } | null;

/**
 * User consent representation
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#UserConsentRepresentation
 */
export type TLUserConsentRepresentation = {
  clientId?: string | null;
  createdDate?: number | null;
  grantedClientScopes?: string[] | null;
  grantedRealmRoles?: string[] | null;
  lastUpdatedDate?: number | null;
  [key: string]: unknown;
};

/**
 * Additional configuration as key-value map
 */
export type TLCredentialRepresentationConfig = { [key: string]: unknown } | null;

/**
 * Keycloak credential representation
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#CredentialRepresentation
 */
export type TLCredentialRepresentation = {
  algorithm?: string | null;
  /** Additional configuration as key-value map */
  config?: TLCredentialRepresentationConfig;
  /** Counter for OTP (Integer/int32) */
  counter?: number | null;
  /** Unix timestamp in milliseconds (Long/int64) */
  createdDate?: number | null;
  credentialData?: string | null;
  device?: string | null;
  /** Number of digits for OTP (Integer/int32) */
  digits?: number | null;
  federationLink?: string | null;
  /** Number of hash iterations (Integer/int32) */
  hashIterations?: number | null;
  hashedSaltedValue?: string | null;
  id?: string | null;
  /** Period for TOTP (Integer/int32) */
  period?: number | null;
  /** Priority value (Integer/int32) */
  priority?: number | null;
  salt?: string | null;
  secretData?: string | null;
  temporary?: boolean | null;
  type?: string | null;
  userLabel?: string | null;
  value?: string | null;
  [key: string]: unknown;
};

/**
 * Federated identity representation
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#FederatedIdentityRepresentation
 */
export type TLFederatedIdentityRepresentation = {
  identityProvider?: string | null;
  userId?: string | null;
  userName?: string | null;
  [key: string]: unknown;
};

/**
 * Social link representation
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#SocialLinkRepresentation
 */
export type TLSocialLinkRepresentation = {
  socialProvider?: string | null;
  socialUserId?: string | null;
  socialUsername?: string | null;
  [key: string]: unknown;
};

export type TLUserProfileAttributeMetadataAnnotations = { [key: string]: unknown } | null;

export type TLUserProfileAttributeMetadataValidators = { [key: string]: { [key: string]: unknown } } | null;

/**
 * Metadata for user profile attributes
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#UserProfileAttributeMetadata
 */
export type TLUserProfileAttributeMetadata = {
  annotations?: TLUserProfileAttributeMetadataAnnotations;
  defaultValue?: string | null;
  displayName?: string | null;
  group?: string | null;
  multivalued?: boolean | null;
  name?: string | null;
  readOnly?: boolean | null;
  required?: boolean | null;
  validators?: TLUserProfileAttributeMetadataValidators;
  [key: string]: unknown;
};

export type TLUserProfileAttributeGroupMetadataAnnotations = { [key: string]: unknown } | null;

/**
 * Metadata for user profile attribute groups
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#UserProfileAttributeGroupMetadata
 */
export type TLUserProfileAttributeGroupMetadata = {
  annotations?: TLUserProfileAttributeGroupMetadataAnnotations;
  displayDescription?: string | null;
  displayHeader?: string | null;
  name?: string | null;
  [key: string]: unknown;
};

/**
 * User profile metadata
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#UserProfileMetadata
 */
export type TLUserProfileMetadata = {
  attributes?: TLUserProfileAttributeMetadata[] | null;
  groups?: TLUserProfileAttributeGroupMetadata[] | null;
  [key: string]: unknown;
};

/**
 * Keycloak UserRepresentation model.
 * All fields are optional as per Keycloak API specification.
 *
 * @see https://www.keycloak.org/docs-api/latest/rest-api/index.html#UserRepresentation
 */
export type TLUserRepresentation = {
  access?: TLUserRepresentationAccess;
  applicationRoles?: TLUserRepresentationApplicationRoles;
  attributes?: TLUserRepresentationAttributes;
  clientConsents?: TLUserConsentRepresentation[] | null;
  clientRoles?: TLUserRepresentationClientRoles;
  createdTimestamp?: number | null;
  credentials?: TLCredentialRepresentation[] | null;
  disableableCredentialTypes?: string[] | null;
  email?: string | null;
  emailVerified?: boolean | null;
  enabled?: boolean | null;
  federatedIdentities?: TLFederatedIdentityRepresentation[] | null;
  federationLink?: string | null;
  firstName?: string | null;
  groups?: string[] | null;
  id?: string | null;
  lastLogin?: number | null;
  lastModified?: number | null;
  lastName?: string | null;
  notBefore?: number | null;
  origin?: string | null;
  realmRoles?: string[] | null;
  requiredActions?: string[] | null;
  self?: string | null;
  serviceAccountClientId?: string | null;
  socialLinks?: TLSocialLinkRepresentation[] | null;
  totp?: boolean | null;
  userProfileMetadata?: TLUserProfileMetadata | null;
  username?: string | null;
  [key: string]: unknown;
};

export type TLDirectoryGroupRef = {
  id?: string | null;
  name?: string | null;
};

export type TLAuthzUserDirectoryEntry = {
  created_timestamp?: number | null;
  direct_roles?: TLDirectoryRoleRef[];
  email?: string | null;
  enabled?: boolean | null;
  first_name?: string | null;
  groups?: TLDirectoryGroupRef[];
  id?: string | null;
  inherited_roles?: TLDirectoryRoleRef[];
  last_login?: number | null;
  last_modified?: number | null;
  last_name?: string | null;
  username?: string | null;
};

export type TLPaginatedResponseAuthzUserDirectoryEntry = {
  /** List of items */
  data: TLAuthzUserDirectoryEntry[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Request model for updating a user's enabled status.
 */
export type TLUserUpdateStatusRequest = {
  enabled: boolean;
};

export enum TLLlmProxyMessageRole {
  user = 'user',
  assistant = 'assistant',
}
export type TLLlmProxyMessage = {
  content: string | unknown[];
  role: TLLlmProxyMessageRole;
};

export type TLLlmProxyRequest = {
  /** @minItems 1 */
  messages: TLLlmProxyMessage[];
  system?: string | null;
  /**
   * @minimum 0
   * @maximum 2
   */
  temperature?: number;
};

export type TLLlmProxyContentBlock = {
  text: string;
  type?: string;
};

export type TLLlmProxyUsage = {
  input_tokens: number;
  output_tokens: number;
};

export type TLLlmProxyResponse = {
  content: TLLlmProxyContentBlock[];
  id: string;
  model: string;
  role?: string;
  stop_reason?: string;
  text: string;
  type?: string;
  usage?: TLLlmProxyUsage | null;
};

export enum TLWfExecutionStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}
export enum TLWfTriggerType {
  MANUAL = 'MANUAL',
  SCHEDULED = 'SCHEDULED',
  RETRY = 'RETRY',
}
export type TLWorkflowExecutionWithWorkflowExecutionMetadata = { [key: string]: unknown } | null;

export type TLWorkflowExecutionWithWorkflow = {
  completed_at?: string | null;
  created_by: string;
  created_date: string;
  duration_ms?: number | null;
  execution_id: string;
  execution_metadata?: TLWorkflowExecutionWithWorkflowExecutionMetadata;
  started_at?: string | null;
  status: TLWfExecutionStatus;
  trigger_type: TLWfTriggerType;
  workflow_id: string;
  workflow_name: string;
  workflow_version: number;
};

export type TLPaginatedRecentExecutions = {
  items: TLWorkflowExecutionWithWorkflow[];
  total: number;
};

export enum TLWfAccessLevel {
  OWNER = 'OWNER',
  EDITOR = 'EDITOR',
  EXECUTOR = 'EXECUTOR',
  VIEWER = 'VIEWER',
}
export enum TLNodeFieldType {
  string = 'string',
  number = 'number',
  boolean = 'boolean',
  object = 'object',
  array = 'array',
  file = 'file',
  file_list = 'file_list',
}
export type TLInputPropertyDefinition = {
  default?: unknown | null;
  description?: string | null;
  type?: TLNodeFieldType;
};

export type TLWorkflowInputSchemaOutputProperties = { [key: string]: TLInputPropertyDefinition };

export type TLWorkflowInputSchemaOutput = {
  properties?: TLWorkflowInputSchemaOutputProperties;
  required?: string[];
};

export enum TLWfNodeType {
  TOOL = 'TOOL',
  WORKFLOW = 'WORKFLOW',
}
export enum TLWfOnFailure {
  FAIL_WORKFLOW = 'FAIL_WORKFLOW',
  CONTINUE = 'CONTINUE',
}
export type TLNodePosition = {
  x?: number;
  y?: number;
};

export type TLTemplateNodeResponseExecutionConfig = { [key: string]: unknown };

export type TLTemplateNodeResponseRetryConfig = { [key: string]: unknown } | null;

export type TLTemplateNodeResponseWhen = { [key: string]: unknown } | null;

export type TLTemplateNodeResponse = {
  activity?: string | null;
  client_node_id?: string | null;
  created_by: string;
  created_date: string;
  description?: string | null;
  execution_config: TLTemplateNodeResponseExecutionConfig;
  name: string;
  node_id: string;
  node_type: TLWfNodeType;
  on_failure: TLWfOnFailure;
  position?: TLNodePosition | null;
  requires?: string[];
  retry_config?: TLTemplateNodeResponseRetryConfig;
  template_id: string;
  timeout_seconds?: number | null;
  version: number;
  when?: TLTemplateNodeResponseWhen;
};

export enum TLWfTemplateStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
export enum TLWfVisibility {
  PRIVATE = 'PRIVATE',
  SHARED = 'SHARED',
  PUBLIC = 'PUBLIC',
}
export type TLTemplateResponseTemplateMetadata = { [key: string]: unknown } | null;

export type TLTemplateResponse = {
  access_level?: TLWfAccessLevel | null;
  created_by: string;
  created_date: string;
  current_version: number;
  description?: string | null;
  input_schema: TLWorkflowInputSchemaOutput;
  instantiated_workflow_count?: number | null;
  name: string;
  nodes?: TLTemplateNodeResponse[];
  source_workflow_id?: string | null;
  source_workflow_version?: number | null;
  status: TLWfTemplateStatus;
  tags?: string[] | null;
  template_id: string;
  template_metadata?: TLTemplateResponseTemplateMetadata;
  updated_by: string;
  updated_date: string;
  visibility: TLWfVisibility;
};

export type TLTemplateListResponse = {
  limit: number;
  offset: number;
  templates: TLTemplateResponse[];
  total: number;
};

export type TLCreateTemplateInputTemplateMetadata = { [key: string]: unknown } | null;

export type TLWorkflowInputSchemaInputProperties = { [key: string]: TLInputPropertyDefinition };

export type TLWorkflowInputSchemaInput = {
  properties?: TLWorkflowInputSchemaInputProperties;
  required?: string[];
};

export type TLNodeInputExecutionConfig = { [key: string]: unknown };

export type TLNodeInputRetryConfig = { [key: string]: unknown } | null;

export type TLNodeInputWhen = { [key: string]: unknown } | null;

export type TLNodeInput = {
  activity?: string | null;
  client_node_id?: string | null;
  description?: string | null;
  execution_config: TLNodeInputExecutionConfig;
  /** @maxLength 200 */
  name: string;
  node_type: TLWfNodeType;
  on_failure?: TLWfOnFailure;
  position?: TLNodePosition | null;
  requires?: string[];
  retry_config?: TLNodeInputRetryConfig;
  timeout_seconds?: number | null;
  when?: TLNodeInputWhen;
};

export type TLCreateTemplateInput = {
  description?: string | null;
  input_schema?: TLWorkflowInputSchemaInput;
  /** @maxLength 100 */
  name: string;
  /** @maxItems 200 */
  nodes: TLNodeInput[];
  source_workflow_id?: string | null;
  source_workflow_version?: number | null;
  tags?: string[] | null;
  template_metadata?: TLCreateTemplateInputTemplateMetadata;
  visibility?: TLWfVisibility;
};

export type TLBulkDeleteTemplatesRequest = {
  /**
   * @minItems 1
   * @maxItems 100
   */
  template_ids: string[];
};

export type TLTemplateBulkDeleteResult = {
  error?: string | null;
  success: boolean;
  template_id: string;
};

export type TLBulkDeleteTemplatesResponse = {
  failed: number;
  results: TLTemplateBulkDeleteResult[];
  succeeded: number;
  total: number;
};

export type TLPatchTemplateInputTemplateMetadata = { [key: string]: unknown } | null;

export type TLPatchTemplateInput = {
  description?: string | null;
  name?: string | null;
  tags?: string[] | null;
  template_metadata?: TLPatchTemplateInputTemplateMetadata;
};

export type TLSaveTemplateGraphInput = {
  change_summary?: string | null;
  description?: string | null;
  input_schema?: TLWorkflowInputSchemaInput | null;
  name?: string | null;
  /** @maxItems 200 */
  nodes: TLNodeInput[];
};

export type TLContributeWorkflowInput = {
  change_summary?: string | null;
  /**
   * @maximum 9999.9
   * @exclusiveMinimum 0
   */
  expected_template_version: number;
  input_schema?: TLWorkflowInputSchemaInput | null;
  /**
   * @minItems 1
   * @maxItems 200
   */
  nodes: TLNodeInput[];
  workflow_id: string;
};

export enum TLWfPermissionType {
  VIEWER = 'VIEWER',
  EXECUTOR = 'EXECUTOR',
  EDITOR = 'EDITOR',
}
export enum TLWfPermissionStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
}
export type TLTemplatePermission = {
  granted_by: string;
  granted_date: string;
  permission_id: string;
  permission_type: TLWfPermissionType;
  status: TLWfPermissionStatus;
  template_id: string;
  updated_by: string;
  updated_date: string;
  user_email: string;
};

export type TLTemplatePermissionListResponse = {
  limit: number;
  offset: number;
  permissions: TLTemplatePermission[];
  total: number;
};

export type TLPermissionEntry = {
  permission_type: TLWfPermissionType;
  /** @maxLength 100 */
  user_email: string;
};

export type TLGrantTemplatePermissionsRequest = {
  /** @maxItems 50 */
  entries: TLPermissionEntry[];
  /** Whether to notify the recipients that the template was shared */
  notify?: boolean;
};

export type TLLeaveTemplateResponse = {
  /** True when an active grant was revoked; False for the PUBLIC implicit-access no-op. */
  removed: boolean;
};

export type TLRevokeTemplatePermissionsRequest = {
  /**
   * @maxItems 50
   * @items.maxLength 100
   */
  user_emails: string[];
};

export type TLRevokeTemplatePermissionsResponse = {
  failed: number;
  requested: number;
  revoked: number;
};

export type TLTemplateVersionSummaryResponse = {
  change_summary?: string | null;
  created_by: string;
  created_date: string;
  description?: string | null;
  is_current: boolean;
  name?: string | null;
  version: number;
};

export type TLTemplateVersionListResponse = {
  limit: number;
  offset: number;
  total: number;
  versions: TLTemplateVersionSummaryResponse[];
};

export type TLTemplateVersionDetailResponse = {
  change_summary?: string | null;
  created_by: string;
  created_date: string;
  description?: string | null;
  input_schema: TLWorkflowInputSchemaOutput;
  is_current: boolean;
  name?: string | null;
  nodes: TLTemplateNodeResponse[];
  version: number;
};

export type TLUpdateTemplateVisibilityRequest = {
  /** New visibility level */
  visibility: TLWfVisibility;
};

export type TLInstantiateTemplateInput = {
  description?: string | null;
  name?: string | null;
  template_version?: number | null;
};

export type TLWorkflowResponseWorkflowMetadata = { [key: string]: unknown } | null;

export type TLWorkflowNodeResponseExecutionConfig = { [key: string]: unknown };

export type TLWorkflowNodeResponseRetryConfig = { [key: string]: unknown } | null;

export type TLWorkflowNodeResponseWhen = { [key: string]: unknown } | null;

export type TLWorkflowNodeResponse = {
  activity?: string | null;
  client_node_id?: string | null;
  created_by: string;
  created_date: string;
  description?: string | null;
  execution_config: TLWorkflowNodeResponseExecutionConfig;
  name: string;
  node_id: string;
  node_type: TLWfNodeType;
  on_failure: TLWfOnFailure;
  position?: TLNodePosition | null;
  requires?: string[];
  retry_config?: TLWorkflowNodeResponseRetryConfig;
  timeout_seconds?: number | null;
  version: number;
  when?: TLWorkflowNodeResponseWhen;
  workflow_id: string;
};

export type TLOutputPropertyDefinitionProperties = { [key: string]: TLOutputPropertyDefinition } | null;

export type TLOutputPropertyDefinition = {
  description?: string | null;
  properties?: TLOutputPropertyDefinitionProperties;
  type?: TLNodeFieldType;
};

export type TLNodeOutputSchemaProperties = { [key: string]: TLOutputPropertyDefinition };

export type TLNodeOutputSchema = {
  properties?: TLNodeOutputSchemaProperties;
};

export type TLWorkflowOutputSchemaNodes = { [key: string]: TLNodeOutputSchema };

/**
 * Schema of a run's ``output_values``, derived from the nodes' declared outputs.
 *
 * Keyed by node name to mirror ``wf_workflow_executions.output_values``
 * (``{node_name: node_output}``); each node's ``properties`` describe the output
 * fields its registered activity declares. Recomputed on every graph save.
 */
export type TLWorkflowOutputSchema = {
  nodes?: TLWorkflowOutputSchemaNodes;
};

export enum TLWfWorkflowStatus {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  DELETED = 'DELETED',
  ARCHIVED = 'ARCHIVED',
}
export type TLWorkflowResponse = {
  access_level?: TLWfAccessLevel | null;
  archived_at?: string | null;
  created_by: string;
  created_date: string;
  current_version: number;
  description?: string | null;
  input_schema: TLWorkflowInputSchemaOutput;
  last_contributed_template_version?: number | null;
  name: string;
  nodes?: TLWorkflowNodeResponse[];
  output_schema?: TLWorkflowOutputSchema | null;
  source_template_id?: string | null;
  source_template_version?: number | null;
  status: TLWfWorkflowStatus;
  tags?: string[] | null;
  updated_by: string;
  updated_date: string;
  visibility: TLWfVisibility;
  workflow_id: string;
  workflow_metadata?: TLWorkflowResponseWorkflowMetadata;
};

export enum TLWfOwnershipScope {
  ALL = 'ALL',
  OWNED = 'OWNED',
  SHARED = 'SHARED',
}
export enum TLWfWorkflowSortField {
  NAME = 'NAME',
  CREATED_DATE = 'CREATED_DATE',
  UPDATED_DATE = 'UPDATED_DATE',
  LAST_EXECUTION_AT = 'LAST_EXECUTION_AT',
}
export enum TLSortDirection {
  asc = 'asc',
  desc = 'desc',
}
export type TLWorkflowExecutionStatsResponse = {
  active_count?: number;
  completed_count?: number;
  failed_count?: number;
  last_execution_at?: string | null;
  last_execution_by?: string | null;
  last_execution_status?: TLWfExecutionStatus | null;
  total_count?: number;
};

export type TLWorkflowListItemResponseWorkflowMetadata = { [key: string]: unknown } | null;

export type TLWorkflowListItemResponse = {
  access_level?: TLWfAccessLevel | null;
  active_schedule_count?: number;
  archived_at?: string | null;
  created_by: string;
  created_date: string;
  current_version: number;
  description?: string | null;
  execution_stats?: TLWorkflowExecutionStatsResponse | null;
  input_schema: TLWorkflowInputSchemaOutput;
  last_contributed_template_version?: number | null;
  name: string;
  next_scheduled_run_at?: string | null;
  node_count?: number;
  nodes?: TLWorkflowNodeResponse[];
  output_schema?: TLWorkflowOutputSchema | null;
  source_template_id?: string | null;
  source_template_version?: number | null;
  status: TLWfWorkflowStatus;
  tags?: string[] | null;
  updated_by: string;
  updated_date: string;
  visibility: TLWfVisibility;
  workflow_id: string;
  workflow_metadata?: TLWorkflowListItemResponseWorkflowMetadata;
};

export type TLWorkflowListResponse = {
  limit: number;
  offset: number;
  total: number;
  workflows: TLWorkflowListItemResponse[];
};

export type TLCreateWorkflowInputInputWorkflowMetadata = { [key: string]: unknown } | null;

export type TLCreateWorkflowInputInput = {
  description?: string | null;
  input_schema?: TLWorkflowInputSchemaInput;
  /** @maxLength 100 */
  name: string;
  /** @maxItems 200 */
  nodes: TLNodeInput[];
  tags?: string[] | null;
  visibility?: TLWfVisibility;
  workflow_metadata?: TLCreateWorkflowInputInputWorkflowMetadata;
};

/**
 * Shared by bulk-archive and bulk-unarchive — the payload is the same for both.
 */
export type TLBulkArchiveWorkflowsRequest = {
  /**
   * @minItems 1
   * @maxItems 100
   */
  workflow_ids: string[];
};

export type TLWorkflowBulkArchiveResult = {
  /** Why the action failed for this item */
  error?: string | null;
  /** Whether the action succeeded for this item */
  success: boolean;
  workflow_id: string;
};

export type TLBulkActionResponseWorkflowBulkArchiveResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLWorkflowBulkArchiveResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export type TLBulkDeleteWorkflowsRequest = {
  /**
   * @minItems 1
   * @maxItems 100
   */
  workflow_ids: string[];
};

export type TLWorkflowBulkDeleteResult = {
  error?: string | null;
  success: boolean;
  workflow_id: string;
};

export type TLBulkDeleteWorkflowsResponse = {
  failed: number;
  results: TLWorkflowBulkDeleteResult[];
  succeeded: number;
  total: number;
};

export type TLBulkShareWorkflowsRequest = {
  /**
   * @minItems 1
   * @maxItems 50
   */
  entries: TLPermissionEntry[];
  /** Whether to notify the recipients that the workflows were shared */
  notify?: boolean;
  /**
   * @minItems 1
   * @maxItems 100
   */
  workflow_ids: string[];
};

export type TLWorkflowBulkShareResult = {
  /** Why the action failed for this item */
  error?: string | null;
  /** Whether the action succeeded for this item */
  success: boolean;
  workflow_id: string;
};

export type TLBulkActionResponseWorkflowBulkShareResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLWorkflowBulkShareResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export type TLWorkflowFilterOptionsResponse = {
  owners: string[];
  tags: string[];
};

export enum TLNodeCategory {
  Data_Processing = 'Data Processing',
  Data_Analytics = 'Data Analytics',
  Salesforce = 'Salesforce',
  Microsoft_Dynamics_365 = 'Microsoft Dynamics 365',
  Oracle_CPQ = 'Oracle CPQ',
  Integrations = 'Integrations',
  Code = 'Code',
  Data_Foundry = 'Data Foundry',
  Data_Harmonization = 'Data Harmonization',
  SAP = 'SAP',
  SAP_BW = 'SAP BW',
  Control_Flow = 'Control Flow',
  Notifications = 'Notifications',
  Converters = 'Converters',
  View_Remediation = 'View Remediation',
}
/**
 * Second-level palette grouping within a ``NodeCategory``.
 *
 * Values are display labels rather than the repo's usual UPPER_SNAKE, matching the
 * sibling ``NodeCategory``: the palette renders category and subcategory as one
 * two-level tree straight from ``.value``, and a snake-cased second level beside a
 * cased first one would need an FE label map to look right.
 *
 * A member may be shared by several categories (``RECORDS`` covers Salesforce and
 * D365); ``CATEGORY_SUBCATEGORIES`` decides which pairings are legal.
 */
export enum TLNodeSubcategory {
  ABAP_Objects = 'ABAP Objects',
  Repository_Search = 'Repository Search',
  Code_Quality = 'Code Quality',
  Transports = 'Transports',
  'Function_Modules_&_BAPIs' = 'Function Modules & BAPIs',
  Master_Data_Loads = 'Master Data Loads',
  Runtime_Execution = 'Runtime Execution',
  Customizing = 'Customizing',
  'Security_&_Notes' = 'Security & Notes',
  Schema = 'Schema',
  Structure = 'Structure',
  Fields = 'Fields',
  Validation = 'Validation',
  Lifecycle = 'Lifecycle',
  Documents = 'Documents',
  Tabular_Data = 'Tabular Data',
  File_Transfer = 'File Transfer',
  'APIs_&_Services' = 'APIs & Services',
  Records = 'Records',
  Data_Cloud = 'Data Cloud',
  Queries = 'Queries',
  'Catalog_&_Schema' = 'Catalog & Schema',
  Ingestion = 'Ingestion',
}
export type TLNodeSummary = {
  /** Grouping category */
  category: TLNodeCategory;
  /** What this node does */
  description: string;
  /** Human-readable name for the UI */
  display_name: string;
  /** Node identifier used in execution_config.activity */
  name: string;
  /** Grouping within the category; null for categories that render as one flat list */
  subcategory?: TLNodeSubcategory | null;
  /** Short verb-first summary for list UIs; fall back to description when absent */
  tagline?: string | null;
  /** Searchable tags */
  tags?: string[];
};

export type TLAvailableNodesResponse = {
  /** Registered nodes available for workflows */
  nodes: TLNodeSummary[];
};

/**
 * A set of fields that must be provided together.
 *
 * Declared either on a node (over its top-level fields) or on an OBJECT field
 * (over that field's sub-fields, via ``NodeFieldDefinition.input_groups``).
 * Exactly one group must be satisfied; all fields in the chosen group are
 * required together.
 */
export type TLInputGroup = {
  /**
   * Field names that must ALL be provided together
   * @minItems 1
   */
  fields: string[];
  /** UI display label for this group */
  label?: string | null;
};

/**
 * What a remote path field is selecting, which decides how its browser resolves a pick.
 */
export enum TLPathBrowserMode {
  FILE = 'FILE',
  DIRECTORY = 'DIRECTORY',
  FOLDER = 'FOLDER',
}
/**
 * Marks a STRING field as a path on a remote system the UI can browse.
 *
 * Protocol-agnostic on purpose: the field says *what is being picked*, and the client decides
 * which listing endpoint to call from the node's own connector inputs, so a future FTP or
 * object-store browser reuses this hint rather than adding a parallel one.
 */
export type TLNodeFieldPathBrowser = {
  /** FILE selects an existing file and stores its full path; DIRECTORY selects a containing directory, leaving the caller to supply the file name */
  mode: TLPathBrowserMode;
};

/**
 * Condition gating a field's visibility on a sibling field's value.
 */
export type TLNodeFieldVisibleWhen = {
  /**
   * Name of the sibling field the condition reads
   * @minLength 1
   */
  field: string;
  /**
   * Show the field only while the sibling's value is one of these
   * @minItems 1
   */
  values: string[];
};

/**
 * A single input or output field exposed to the UI.
 */
export type TLNodeFieldDefinition = {
  /** For FILE/FILE_LIST fields: lowercase file extensions the node accepts (e.g. ['.csv', '.xlsx']). UI hint for upload pickers; not enforced server-side. */
  accepted_file_types?: string[] | null;
  /** For FILE fields only: the field's runtime annotation also accepts a list of files (e.g. InputFile | list[InputFile]), so list-shaped wiring such as an ARRAY-returning operator is valid despite the single-file UI */
  accepts_file_list?: boolean;
  /** Output fields only: the field's runtime value is visible only to platform admins. Non-admin execution reads receive a redaction sentinel in place of the value; the field itself stays declared and wirable. Top-level output fields only. */
  admin_only?: boolean;
  /** Render this field in the UI's separate Advanced settings area instead of the main configuration list. Only optional fields may be marked advanced. */
  advanced?: boolean;
  /** Default value if any */
  default?: string | number | boolean | null;
  /** Guidance shown when this field is superseded, naming what to use instead. Presence marks the field deprecated; it is still populated at runtime, so existing wiring keeps working. Scoped per node — `output_files` may be superseded on one node and the only correct choice on another. Carries the author's message, which pydantic's own JSON schema does not: that emits a bare `deprecated: true` with no replacement name. */
  deprecated?: string | null;
  /** Human-readable description */
  description: string;
  /** Sub-fields for compound types (file, file_list, object, array) */
  fields?: TLNodeFieldDefinition[] | null;
  /** For OBJECT fields only: mutually exclusive sets of this field's sub-fields, rendered as a 'choose one' segmented control. Each group lists sub-fields that must ALL be provided together; exactly one group must be satisfied. Sub-fields in no group follow their own required/optional and visible_when rules. */
  input_groups?: TLInputGroup[] | null;
  /** Human-friendly display name; UIs fall back to humanizing the field name */
  label?: string | null;
  /** Field name */
  name: string;
  /** Valid values for this field, rendered as a dropdown in the UI */
  options?: string[] | null;
  /** For STRING fields only: this value is a path on the remote system the node's connector points at, so the UI may offer a browse-and-pick control beside the text input. The field stays free text — typed and wired values keep working — so a UI without the hint simply shows the plain input. */
  path_browser?: TLNodeFieldPathBrowser | null;
  /** Whether this field is required */
  required?: boolean;
  /** Whether `options` is a closed set the runtime enforces (an enum-typed field) or merely author-supplied suggestions over an open value (a plain `str` field given `input_options`). When False, a literal value outside `options` is NOT flagged as invalid at author time — the runtime may accept more than the listed set (e.g. Salesforce `object_type` aliases like 'Product2'). Set automatically by the `@node_activity` decorator; not surfaced to the LLM. */
  strict_options?: boolean;
  /** Field type for UI rendering */
  type: TLNodeFieldType;
  /** Render this field only while the named sibling field holds one of the listed values. UIs that don't support the hint show the field unconditionally. */
  visible_when?: TLNodeFieldVisibleWhen | null;
};

export type TLMcpToolDefinition = {
  /** What the tool does, as published by the gateway */
  description: string;
  /** Human-readable tool name for the picker */
  display_name: string;
  /** Whether the gateway published an input schema. Distinguishes a tool that genuinely takes no arguments (false only when no schema was published) from one whose fields could not be derived. */
  has_schema: boolean;
  /** Fields making up the tool's `arguments` payload, converted from its JSON Schema. Empty for a tool that takes no arguments and for one whose gateway published no schema — in the latter case the raw JSON editor on `arguments` is the only way to configure it. */
  inputs?: TLNodeFieldDefinition[];
  /** The gateway's own tool name — the value for mcp_call's `tool` input */
  name: string;
  /** McpGatewaySource value — the value for mcp_call's `server` input */
  server: string;
  /** Human-readable server name for grouping in the picker */
  server_display_name: string;
};

export type TLMcpToolsResponse = {
  /** Workflow-executable MCP tools available to this tenant */
  tools?: TLMcpToolDefinition[];
};

/**
 * Slim per-entity field schemas (name, type, label) for UI field pickers
 */
export type TLNodeDefinitionEntitySchemas = { [key: string]: unknown } | null;

export type TLNodeDefinition = {
  /** Grouping category */
  category: TLNodeCategory;
  /** Timeout this node runs with when none is set on it. Seeds the panel's timeout control; null means the platform-wide node default applies */
  default_timeout_seconds?: number | null;
  /** What this node does */
  description: string;
  /** Human-readable name for the UI */
  display_name: string;
  /** Slim per-entity field schemas (name, type, label) for UI field pickers */
  entity_schemas?: TLNodeDefinitionEntitySchemas;
  /** Mutually exclusive sets of input fields. Each group lists fields that must ALL be provided together. Exactly one group must be satisfied. Fields not in any group follow their own required/optional rules. */
  input_groups?: TLInputGroup[] | null;
  /** Input fields */
  inputs?: TLNodeFieldDefinition[];
  /** Node identifier used in execution_config.activity */
  name: string;
  /** Output fields */
  outputs?: TLNodeFieldDefinition[];
  /** Whether this node's activity may be run via the single-node test execution endpoint */
  safe_for_test_execution?: boolean;
  /** Grouping within the category; null for categories that render as one flat list */
  subcategory?: TLNodeSubcategory | null;
  /** Short verb-first summary for list UIs; fall back to description when absent */
  tagline?: string | null;
  /** Searchable tags */
  tags?: string[];
};

export type TLNodeDocCommonError = {
  /** Error message as the user sees it */
  error: string;
  /** What to change; may contain inline markdown */
  fix: string;
};

export type TLNodeDocExampleInputs = { [key: string]: string | number | boolean | string[] };

export type TLNodeDocExampleOutputs = { [key: string]: unknown };

export type TLNodeDocExample = {
  description?: string | null;
  inputs?: TLNodeDocExampleInputs;
  label: string;
  /** Input fields deliberately left unset in this example — only ones worth calling out */
  leave_empty?: string[];
  outputs?: TLNodeDocExampleOutputs;
};

/**
 * Display grouping of input fields on the doc page; not a validation constraint.
 */
export type TLNodeDocInputSection = {
  /** Input field names rendered under this section, in order */
  fields: string[];
  label: string;
};

export type TLNodeDocRelatedNode = {
  category: TLNodeCategory;
  display_name: string;
  /** Registry name of the sibling node */
  name: string;
  /** When to prefer the sibling over this node */
  reason: string;
};

/**
 * Hand-written documentation for one node; every field empty when no doc file exists.
 */
export type TLNodeDocumentation = {
  cautions?: string[];
  caveats?: string[];
  common_errors?: TLNodeDocCommonError[];
  examples?: TLNodeDocExample[];
  input_sections?: TLNodeDocInputSection[];
  preconditions?: string[];
  see_instead?: TLNodeDocRelatedNode[];
  when_to_use?: string | null;
};

export type TLNodeDocumentationResponse = {
  documentation: TLNodeDocumentation;
  node: TLNodeDefinition;
};

export enum TLOperatorCategory {
  COMPARISON = 'COMPARISON',
  LOGICAL = 'LOGICAL',
  MATH = 'MATH',
  STRING = 'STRING',
  ARRAY = 'ARRAY',
  TYPE_CONVERSION = 'TYPE_CONVERSION',
}
export enum TLOperatorParamType {
  ANY = 'ANY',
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  ARRAY = 'ARRAY',
}
export type TLOperatorParameter = {
  /** Expected parameter type */
  type: TLOperatorParamType;
  /** If true, accepts additional values of the same type */
  variadic?: boolean;
};

export enum TLOperatorReturnType {
  ANY = 'ANY',
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  STRING = 'STRING',
  ARRAY = 'ARRAY',
}
export type TLOperatorDefinition = {
  /** Operator category */
  category: TLOperatorCategory;
  /** What this operator does */
  description: string;
  /** Human-readable name for the UI */
  display_name: string;
  /** Operator key used in $tsra_expr, e.g. 'eq', 'concat' */
  name: string;
  /** Parameter types in positional order */
  parameters: TLOperatorParameter[];
  /** Return type */
  return_type: TLOperatorReturnType;
};

export type TLAvailableOperatorsResponse = {
  /** Available expression operators */
  operators: TLOperatorDefinition[];
};

export type TLPatchWorkflowInputWorkflowMetadata = { [key: string]: unknown } | null;

export type TLPatchWorkflowInput = {
  description?: string | null;
  name?: string | null;
  tags?: string[] | null;
  workflow_metadata?: TLPatchWorkflowInputWorkflowMetadata;
};

export type TLSaveGraphInput = {
  change_summary?: string | null;
  description?: string | null;
  expected_current_version?: number | null;
  input_schema?: TLWorkflowInputSchemaInput | null;
  name?: string | null;
  /** @maxItems 200 */
  nodes: TLNodeInput[];
  source_template_version?: number | null;
};

export type TLGenerateChangeSummaryRequest = {
  /**
   * The edited, not-yet-saved node graph
   * @maxItems 200
   */
  nodes: TLNodeInput[];
  /**
   * Saved version to diff the incoming nodes against
   * @maximum 9999.9
   * @exclusiveMinimum 0
   */
  version: number;
};

export type TLChangeSummaryResponse = {
  /** One-sentence, LLM-generated summary of what changed */
  summary: string;
};

export enum TLWfNodeExecutionStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
  SKIPPED = 'SKIPPED',
}
export type TLNodeExecutionError = string | { [key: string]: unknown } | null;

export type TLNodeExecutionOutput = { [key: string]: unknown } | null;

export type TLNodeExecutionResolvedInputs = { [key: string]: unknown } | null;

export type TLNodeExecution = {
  attempt_number: number;
  can_decide?: boolean;
  completed_at?: string | null;
  duration_ms?: number | null;
  error?: TLNodeExecutionError;
  iteration_number?: number;
  node_execution_id: string;
  node_id?: string | null;
  node_name: string;
  output?: TLNodeExecutionOutput;
  resolved_inputs?: TLNodeExecutionResolvedInputs;
  started_at?: string | null;
  status: TLWfNodeExecutionStatus;
  workflow_execution_id: string;
};

export type TLWorkflowExecutionErrorDetails = { [key: string]: unknown } | null;

export type TLWorkflowExecutionExecutionMetadata = { [key: string]: unknown } | null;

export type TLWorkflowExecutionInputValues = { [key: string]: unknown } | null;

export type TLWorkflowExecutionOutputValues = { [key: string]: unknown } | null;

export type TLWorkflowExecution = {
  completed_at?: string | null;
  created_by: string;
  created_date: string;
  duration_ms?: number | null;
  error_details?: TLWorkflowExecutionErrorDetails;
  execution_id: string;
  execution_metadata?: TLWorkflowExecutionExecutionMetadata;
  input_values?: TLWorkflowExecutionInputValues;
  is_test?: boolean;
  node_executions?: TLNodeExecution[];
  output_values?: TLWorkflowExecutionOutputValues;
  started_at?: string | null;
  status: TLWfExecutionStatus;
  trigger_type: TLWfTriggerType;
  workflow_id: string;
  workflow_version: number;
};

export type TLPaginatedExecutions = {
  items: TLWorkflowExecution[];
  total: number;
};

export type TLExecuteWorkflowRequestInputValues = { [key: string]: unknown } | null;

export type TLExecuteWorkflowRequest = {
  input_values?: TLExecuteWorkflowRequestInputValues;
  /** Workflow version to execute; omit to run the current version */
  version?: number | null;
};

/**
 * Optional workflow-level inputs used to resolve ``$wf_input`` references in the node's config. Behaves the same as ``input_values`` on a normal execution.
 */
export type TLTestExecuteNodeRequestInputValues = { [key: string]: unknown } | null;

/**
 * Test values for inputs wired to upstream node outputs, keyed by the node's input field name. A single-node run has no upstream steps, so every upstream-referencing field must be supplied here. File fields accept the same shapes as static file config (program-id string(s) or uploaded-file dicts). Only upstream-referencing fields may be overridden — anything else is rejected with 400.
 */
export type TLTestExecuteNodeRequestUpstreamOverrides = { [key: string]: unknown } | null;

/**
 * Body for ``POST /workflows/{workflow_id}/executions/test`` — run one saved node in isolation.
 *
 * The activity backing the node must be flagged ``safe_for_test_execution=True`` on its
 * ``@node_activity`` decorator; the service rejects unsafe activities with 400.
 */
export type TLTestExecuteNodeRequest = {
  /** Optional workflow-level inputs used to resolve ``$wf_input`` references in the node's config. Behaves the same as ``input_values`` on a normal execution. */
  input_values?: TLTestExecuteNodeRequestInputValues;
  /** ID of the workflow node to test. Must be a node saved on the workflow. */
  node_id: string;
  /** Test values for inputs wired to upstream node outputs, keyed by the node's input field name. A single-node run has no upstream steps, so every upstream-referencing field must be supplied here. File fields accept the same shapes as static file config (program-id string(s) or uploaded-file dicts). Only upstream-referencing fields may be overridden — anything else is rejected with 400. */
  upstream_overrides?: TLTestExecuteNodeRequestUpstreamOverrides;
};

export type TLDownloadUrlResponse = {
  /** The content type of the file */
  content_type?: string | null;
  /** Number of seconds until the URL expires */
  expires_in: number;
  /** The name of the file */
  filename: string;
  /** The presigned URL for downloading the file */
  presigned_url: string;
  /** The UUID of the program */
  program_id: string;
};

export type TLApprovalDecisionRequest = {
  /** Optional comment recorded with the decision. */
  comment?: string | null;
  /** True to approve and continue the workflow; false to reject (fails the node). */
  is_approved: boolean;
  /** The loop pass this decision answers, for a gate inside a Loop Section body. The backend rejects it when the gate is awaiting a different pass, so a panel left open across a pass boundary cannot approve work its reader never saw. Omit for a top-level approval node, which has only one firing. */
  iteration_number?: number | null;
};

export type TLPreviewCapabilities = {
  /** File preview supports offset pagination / load-more */
  paginate?: boolean;
  /** File preview supports toggling between a rendered and a raw view */
  render_toggle?: boolean;
  /** File preview supports in-file search. The mechanism varies by type: server-side line search via /preview/search for text/code, tabular row-filter for parquet/csv/tsv/jsonl, and in-app client-side find for rendered markdown/html. */
  search?: boolean;
};

export type TLTextPreview = {
  /** Whether the preview was truncated */
  is_truncated: boolean;
  /** Preview lines of the text file */
  lines: string[];
  /** Message of the file */
  message: string;
  /** Total number of lines in the file */
  total_lines: number;
  /** Type of the file */
  type?: 'text';
};

/**
 * A word-processor document rendered as the Markdown extracted from it.
 *
 * Browsers cannot display these formats inline, so the preview carries extracted text
 * rather than a URL. The client renders it formatted or raw via the render toggle.
 */
export type TLDocumentPreview = {
  /** Whether the extracted text was truncated */
  is_truncated: boolean;
  /** Markdown lines extracted from the document */
  lines: string[];
  /** Message of the file */
  message: string;
  /** Total number of extracted lines */
  total_lines: number;
  /** Type of the file */
  type?: 'document';
};

export type TLMarkdownPreview = {
  /** Whether the preview was truncated */
  is_truncated: boolean;
  /** Preview lines of the markdown file */
  lines: string[];
  /** Message of the file */
  message: string;
  /** Total number of lines in the file */
  total_lines: number;
  /** Type of the file */
  type?: 'markdown';
};

export type TLHtmlPreview = {
  /** Whether the preview was truncated */
  is_truncated: boolean;
  /** Preview lines of the HTML file */
  lines: string[];
  /** Message of the file */
  message: string;
  /** Total number of lines in the file */
  total_lines: number;
  /** Type of the file */
  type?: 'html';
};

export type TLCSVPreview = {
  /** Column headers of the CSV file */
  headers: string[];
  /** Whether the preview was truncated */
  is_truncated: boolean;
  /** Message of the file */
  message: string;
  /** Data rows of the CSV file */
  rows: string[][];
  /** Total number of lines shown in preview */
  total_lines_shown: number;
  /** Type of the file */
  type?: 'csv';
};

export type TLJSONPreview = {
  /** Parsed JSON content */
  content: unknown;
  /** Formatted JSON string for display */
  formatted: string;
  /** Whether the preview was truncated */
  is_truncated: boolean;
  /** Message of the file */
  message: string;
  /** Type of the file */
  type?: 'json';
};

export type TLCodePreview = {
  /** Whether the preview was truncated */
  is_truncated: boolean;
  /** Programming language of the code file */
  language: string;
  /** Preview lines of the code file */
  lines: string[];
  /** Message of the file */
  message: string;
  /** Total number of lines in the file */
  total_lines: number;
  /** Type of the file */
  type?: 'code';
};

export type TLBinaryPreview = {
  /** Optional content preview for certain binary formats */
  content_preview?: string | null;
  /** Message indicating this is a binary file */
  message: string;
  /** Type of the file */
  type?: 'binary';
};

export type TLEmptyPreview = {
  /** Message indicating the file is empty */
  message: string;
  /** Type of the file */
  type?: 'empty';
};

export type TLParquetColumnInfo = {
  /** Name of the column */
  name: string;
  /** Number of non-null values (not computed in paged preview) */
  non_null?: number | null;
  /** Number of null values (not computed in paged preview) */
  null?: number | null;
  /** Type of the column */
  type: string;
};

export type TLParquetPreviewSampleDataItem = { [key: string]: unknown };

export type TLParquetPreview = {
  /** Columns of the file */
  columns: TLParquetColumnInfo[];
  /** Message of the file */
  message: string;
  /** Sample data of the file */
  sample_data: TLParquetPreviewSampleDataItem[];
  /** Sample rows shown of the file */
  sample_rows_shown: number;
  /** Total columns of the file */
  total_columns: number;
  /** Total rows of the file */
  total_rows: number;
  /** Type of the file */
  type?: 'parquet';
};

export type TLXlsxSheetPreview = {
  /** Column headers of the sheet */
  headers: string[];
  /** Whether this sheet's rows were truncated */
  is_truncated: boolean;
  /** Name of the sheet */
  name: string;
  /** Data rows of the sheet */
  rows: string[][];
  /** Total rows in the sheet before truncation */
  total_rows: number;
};

export type TLXlsxPreview = {
  /** Whether the preview was truncated */
  is_truncated: boolean;
  /** Message of the file */
  message: string;
  /** Names of the sheets included in the preview */
  sheet_names: string[];
  /** Preview data for each included sheet */
  sheets: TLXlsxSheetPreview[];
  /** Total sheets in the workbook before truncation */
  total_sheets: number;
  /** Type of the file */
  type?: 'xlsx';
};

export type TLPreviewError = {
  /** Error message */
  message: string;
  /** Type of the file */
  type?: 'error';
};

export type TLImagePreview = {
  /** Message of the file */
  message: string;
  /** Type of the file */
  type?: 'image';
  /** URL of the image */
  url: string;
};

export type TLPDFPreview = {
  /** Message of the file */
  message: string;
  /** Type of the file */
  type?: 'pdf';
  /** URL of the image */
  url: string;
};

/**
 * Response model for previewing a file.
 */
export type TLPreviewResponse = {
  /** Preview tools (pagination, search, rendered/raw toggle) supported for this file type */
  capabilities?: TLPreviewCapabilities;
  /** Creation date of the file */
  created_date?: string | null;
  /** Size of the file */
  file_size: number;
  /** Type of the file */
  file_type: string;
  /** Name of the file */
  filename: string;
  /** Whether more content can be loaded past this page */
  has_more?: boolean;
  /** Whether the file is truncated */
  is_truncated: boolean;
  /** Offset (lines for text/code, rows for tabular) to request the next page */
  next_offset?: number | null;
  /** Preview of the file */
  preview:
    | TLTextPreview
    | TLDocumentPreview
    | TLMarkdownPreview
    | TLHtmlPreview
    | TLCSVPreview
    | TLJSONPreview
    | TLCodePreview
    | TLBinaryPreview
    | TLEmptyPreview
    | TLParquetPreview
    | TLXlsxPreview
    | TLPreviewError
    | TLImagePreview
    | TLPDFPreview;
  /** ID of the program */
  program_id: string;
  /** Last updated date of the file */
  updated_date?: string | null;
};

export type TLWorkflowPermission = {
  granted_by: string;
  granted_date: string;
  permission_id: string;
  permission_type: TLWfPermissionType;
  status: TLWfPermissionStatus;
  updated_by: string;
  updated_date: string;
  user_email: string;
  workflow_id: string;
};

export type TLPermissionListResponse = {
  limit: number;
  offset: number;
  permissions: TLWorkflowPermission[];
  total: number;
};

export type TLGrantPermissionsRequest = {
  /** @maxItems 50 */
  entries: TLPermissionEntry[];
  /** Whether to notify the recipients that the workflow was shared */
  notify?: boolean;
};

export type TLLeaveWorkflowResponse = {
  /** True when an active grant was revoked; False for the PUBLIC implicit-access no-op. */
  removed: boolean;
};

export type TLWorkflowsV2RevokePermissionsRequest = {
  /**
   * @maxItems 50
   * @items.maxLength 100
   */
  user_emails: string[];
};

export type TLWorkflowsV2RevokePermissionsResponse = {
  failed: number;
  requested: number;
  revoked: number;
};

export enum TLScheduleType {
  CRON = 'CRON',
  ONE_TIME = 'ONE_TIME',
  RRULE = 'RRULE',
}
export type TLWorkflowScheduleResponseInputValues = { [key: string]: unknown } | null;

export type TLWorkflowScheduleResponse = {
  created_by?: string | null;
  created_date?: string | null;
  end_date?: string | null;
  expression: string;
  input_values?: TLWorkflowScheduleResponseInputValues;
  is_active: boolean;
  last_run_at?: string | null;
  next_run_at?: string | null;
  schedule_id: string;
  schedule_type: TLScheduleType;
  start_date?: string | null;
  timezone: string;
  updated_by?: string | null;
  updated_date?: string | null;
  workflow_id: string;
};

export type TLWorkflowSchedulesResponse = {
  schedules: TLWorkflowScheduleResponse[];
};

/**
 * Input values to pass to the workflow on each scheduled execution. Must match the workflow's input schema.
 */
export type TLWorkflowScheduleCreateRequestInputValues = { [key: string]: unknown } | null;

export type TLWorkflowScheduleCreateRequest = {
  /** Schedule won't execute after this UTC datetime. */
  end_date?: string | null;
  /** For CRON: 5-field cron expression (e.g., '0 9 * * *'). For ONE_TIME: ISO datetime string in UTC (e.g., '2026-02-01T10:00:00Z'). For RRULE: RFC 5545 recurrence rule (e.g., 'FREQ=WEEKLY;INTERVAL=2;BYDAY=SU') */
  expression: string;
  /** Input values to pass to the workflow on each scheduled execution. Must match the workflow's input schema. */
  input_values?: TLWorkflowScheduleCreateRequestInputValues;
  /** Schedule type: CRON for recurring, ONE_TIME for single execution, RRULE for RFC 5545 recurrence rules */
  schedule_type: TLScheduleType;
  /** Schedule won't execute before this UTC datetime. */
  start_date?: string | null;
  /** IANA timezone for cron interpretation (e.g., 'America/New_York'). Determines when cron expressions fire. Does not affect start_date/end_date. */
  timezone?: string;
};

/**
 * Input values to pass to the workflow on each scheduled execution. Must match the workflow's input schema.
 */
export type TLWorkflowScheduleUpdateRequestInputValues = { [key: string]: unknown } | null;

export type TLWorkflowScheduleUpdateRequest = {
  /** Schedule won't execute after this UTC datetime. */
  end_date?: string | null;
  /** For CRON: 5-field cron expression. For ONE_TIME: ISO datetime string in UTC. For RRULE: RFC 5545 recurrence rule (e.g., 'FREQ=WEEKLY;INTERVAL=2;BYDAY=SU'). */
  expression?: string | null;
  /** Input values to pass to the workflow on each scheduled execution. Must match the workflow's input schema. */
  input_values?: TLWorkflowScheduleUpdateRequestInputValues;
  /** Set to false to pause the schedule, true to resume. */
  is_active?: boolean | null;
  /** Schedule won't execute before this UTC datetime. */
  start_date?: string | null;
  /** IANA timezone for cron interpretation. Does not affect start_date/end_date. */
  timezone?: string | null;
};

export type TLNotificationUnsubscribeResponse = {
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLNotificationSubscribeResponse = {
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLWorkflowVersionSummaryResponse = {
  change_summary?: string | null;
  created_by: string;
  created_date: string;
  description?: string | null;
  is_current: boolean;
  name?: string | null;
  version: number;
};

export type TLWorkflowVersionListResponse = {
  limit: number;
  offset: number;
  total: number;
  versions: TLWorkflowVersionSummaryResponse[];
};

export type TLWorkflowVersionDetailResponse = {
  change_summary?: string | null;
  created_by: string;
  created_date: string;
  description?: string | null;
  input_schema: TLWorkflowInputSchemaOutput;
  is_current: boolean;
  name?: string | null;
  nodes: TLWorkflowNodeResponse[];
  output_schema?: TLWorkflowOutputSchema | null;
  version: number;
};

export type TLUpdateVisibilityRequest = {
  /** New visibility level */
  visibility: TLWfVisibility;
};

export type TLUserInviteCompleteRequest = {
  /**
   * @minLength 1
   * @maxLength 128
   */
  password: string;
  /**
   * @minLength 1
   * @maxLength 128
   */
  token: string;
};

export type TLUserInviteValidateRequest = {
  /**
   * @minLength 1
   * @maxLength 128
   */
  token: string;
};

export type TLUserInviteValidateResponse = {
  email: string;
};

export type TLLoginAuthRequest = {
  client_id?: string | null;
  client_secret?: string | null;
  grant_type?: string | null;
  password: string;
  scope?: string;
  username: string;
};

/**
 * Model of an auth response.
 */
export type TLAuthResponse = {
  /** The access token of the user. */
  access_token: string;
  /** The expiration time of the access token. */
  expires_in: number;
  /** The expiration time of the refresh token. */
  refresh_expires_in?: number | null;
  /** The refresh token of the user. */
  refresh_token?: string | null;
  /** The scope of the token. */
  scope?: string;
  /** The type of the token. */
  token_type?: string;
};

/**
 * Detail of an authentication failure from the identity provider.
 */
export type TLAuthFailedDetail = {
  /** OAuth2 error code. */
  error: string;
  /** Human-readable error description. */
  error_description: string;
};

/**
 * Model of an unauthorized response.
 */
export type TLAuthFailedResponse = {
  detail: TLAuthFailedDetail;
};

export type TLLogoutAuthRequest = {
  refresh_token?: string | null;
};

/**
 * Generic success response.
 */
export type TLSuccessResponse = {
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

/**
 * Model for password update request.
 */
export type TLUpdatePasswordRequest = {
  /** The user's current password (required for users with existing passwords, optional for SSO-only users) */
  current_password?: string | null;
  /** The new password */
  new_password: string;
};

/**
 * Model for password update response.
 */
export type TLUpdatePasswordResponse = {
  /** Status message */
  message: string;
  /** Whether the password update was successful */
  success: boolean;
};

/**
 * Model for completing a Keycloak-required password update issued at login.
 */
export type TLCompletePasswordUpdateRequest = {
  /** Short-lived token issued by the login endpoint when an UPDATE_PASSWORD action is pending */
  change_password_token: string;
  /** The new password to set */
  new_password: string;
};

/**
 * Model for user profile response.
 */
export type TLUserProfileResponse = {
  /** User email address */
  email: string;
  /** Whether the user has a password set */
  has_password: boolean;
  /** Whether the user only uses SSO authentication */
  is_sso_only: boolean;
  /** User's display name */
  name?: string | null;
  /** Pending Keycloak required actions on the user (e.g. UPDATE_PASSWORD) */
  required_actions?: string[];
  /** User roles */
  roles?: string[];
  /** User identifier */
  user_id: string;
};

export type TLRefreshAuthRequest = {
  refresh_token: string;
};

export type TLSsoCallbackAuthRequest = {
  code: string;
  redirect_uri: string;
  state: string;
};

/**
 * Information about a single Identity Provider.
 */
export type TLIDPInfo = {
  /** Whether the provider is enabled */
  enabled: boolean;
  /** Identity provider ID/alias */
  id: string;
  /** Display name of the provider */
  name: string;
  /** Authentication protocol */
  protocol: string;
  /** Provider type (e.g., saml, oidc, oauth2) */
  type: string;
};

/**
 * Model for SSO configuration response.
 */
export type TLSSOConfigResponse = {
  /** Whether standard username/password login is allowed */
  allow_standard_login?: boolean;
  /** Default SSO provider ID */
  default_provider?: string | null;
  /** Whether SSO is enabled */
  enabled: boolean;
  /** List of available SSO providers */
  providers?: TLIDPInfo[];
};

/**
 * Model for SSO login request.
 */
export type TLSSOLoginRequest = {
  /** Identity provider ID (e.g., 'google', 'microsoft', 'okta') */
  idp: string;
  /** Email hint for SSO login */
  login_hint?: string | null;
  /** Redirect URI after successful authentication */
  redirect_uri?: string | null;
};

/**
 * Model for SSO login response.
 */
export type TLSSOLoginResponse = {
  /** Identity provider ID */
  idp: string;
  /** Identity provider display name */
  idp_name: string;
  /** Identity provider type (saml, oidc, oauth2) */
  idp_type: string;
  /** SSO authentication URL to redirect user to */
  sso_url: string;
  /** OAuth state parameter for CSRF protection */
  state: string;
};

export type TLApplyPseudocodeRequest = {
  /** Code to apply to. Must match SAP active version or error is raised. */
  code: string;
  /** List of finding IDs to apply ignore comments for */
  finding_ids: string[];
  /** ID of the object to apply ignore comments to */
  object_id: string;
};

export type TLApplyPseudocodeResponse = {
  /** Code with applied ignore comments */
  code: string;
};

export enum TLAtcSingleScanRequestSapVersion {
  ECC = 'ECC',
  S4 = 'S4',
}
/**
 * Run an ATC scan against a single ABAP object addressed by its ADT URI.
 *
 * Used by the editor "Run ATC" action — does not persist findings to the
 * Scans/Findings tables, just returns the parsed result for inline display.
 */
export type TLAtcSingleScanRequest = {
  /**
   * ADT object URI, e.g. /sap/bc/adt/oo/classes/zcl_foo
   * @minLength 1
   */
  adt_uri: string;
  /** ATC check variant (defaults to settings.atc.atc_default_check_variant if omitted) */
  check_variant?: string | null;
  sap_version: TLAtcSingleScanRequestSapVersion;
};

/**
 * Flattened representation of a single ATC finding for inline display.
 *
 * Field names mirror the keys produced by `ADTXMLParser.parse_worklist_findings`
 * so the FE can keep one shape across persisted-finding endpoints and this
 * ad-hoc one.
 */
export type TLAtcAdhocFinding = {
  check_title?: string;
  documentation_href?: string | null;
  line?: number | null;
  location?: string | null;
  message?: string;
  priority?: string;
  sap_note?: string | null;
  subobject?: string | null;
};

export type TLAtcSingleScanResponse = {
  adt_uri: string;
  findings?: TLAtcAdhocFinding[];
  sap_version: string;
  timed_out?: boolean;
  total_findings?: number;
  worklist_id?: string | null;
};

export type TLRuleResponse = {
  /** Detailed description of what the rule does */
  description: string;
  /** Name of the rule */
  display_name: string;
  /** Unique identifier of the rule */
  id: string;
};

export type TLRulesListResponse = {
  /** List of all available FLE remediation rules */
  rules: TLRuleResponse[];
};

/**
 * Priority levels for findings. SAP ATC uses numeric values: 1=High, 2=Medium, 3=Low.
 */
export enum TLCodeRemediationV3Priority {
  NUMBER_1 = '1',
  NUMBER_2 = '2',
  NUMBER_3 = '3',
}
export enum TLFindingStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  FLAGGED_FOR_FUNCTIONAL = 'FLAGGED_FOR_FUNCTIONAL',
  BUSINESS_APPROVED_TO_IGNORE = 'BUSINESS_APPROVED_TO_IGNORE',
  ON_HOLD = 'ON_HOLD',
  MANUAL_CHANGE_NEEDED = 'MANUAL_CHANGE_NEEDED',
}
/**
 * Response model for a finding.
 */
export type TLFindingResponse = {
  /** Additional information about the finding */
  additional_info?: string | null;
  /** Detailed message describing the finding */
  check_message: string;
  /** Title of the check that found this issue */
  check_title: string;
  /** ID of the finding */
  finding_id: string;
  /** Line number where the issue was found */
  line?: number | null;
  /** ID of the object this finding is associated with */
  object_id: string;
  /** Priority level of the finding */
  priority: TLCodeRemediationV3Priority;
  /** EC/pragma pseudocomment for the finding */
  pseudocomment?: string | null;
  /** SAP note number related to this finding */
  sap_note_number?: string | null;
  /** Status of the finding */
  status: TLFindingStatus;
  /** Subobject name where the issue was found */
  subobject?: string | null;
};

/**
 * Response model for a list of findings.
 */
export type TLFindingsListResponse = {
  /** List of findings */
  findings: TLFindingResponse[];
};

export type TLUpdateFindingsStatusRequest = {
  /** List of unique identifiers of findings to update */
  finding_ids: string[];
  /** New status for the findings */
  status: TLFindingStatus;
};

/**
 * A (name, type) reference the client deselects from the import.
 */
export type TLPackageImportObjectRef = {
  /** Repository object name */
  name: string;
  /** Short TADIR object type (must match a preview object_type) */
  object_type: string;
};

/**
 * Request to create a remedy from a SAP package (or package range) minus a client deselected list.
 */
export type TLPackageImportCreateRequest = {
  /** ATC check variant for the remedy */
  check_variant: string;
  /** Objects to exclude from the import, matched by (name, object_type) */
  deselected_objects?: TLPackageImportObjectRef[];
  /** Name of the remedy to create */
  name: string;
  /** Name of the SAP package to import, or the range start */
  package_name: string;
  /** Optional inclusive range end (SAP select-options BT). With it set, package_name is the range start and every package in between is imported — each with its full subtree, including sub-packages whose own names sort outside the range. Both endpoints must be literal names sharing at least two leading characters; names compare as uppercase ASCII, so '_' sorts after letters and '/NAMESPACE/' names sort before 'A'. A range matching more packages than the configured ceiling is rejected rather than truncated. */
  package_name_end?: string | null;
  /** SAP system version to walk the package on */
  sap_version?: TLSAPVersion;
};

export enum TLRemedyStatus {
  CREATED = 'CREATED',
  INITIAL_SCAN_IN_PROGRESS = 'INITIAL_SCAN_IN_PROGRESS',
  INITIAL_SCAN_COMPLETED = 'INITIAL_SCAN_COMPLETED',
  INITIAL_SCAN_FAILED = 'INITIAL_SCAN_FAILED',
  SETUP_COMPLETED = 'SETUP_COMPLETED',
  SETUP_IN_PROGRESS = 'SETUP_IN_PROGRESS',
  SETUP_FAILED = 'SETUP_FAILED',
}
/**
 * Response model for creating a remedy.
 */
export type TLRemedyCreateResponse = {
  /** Name of the remedy */
  name: string;
  /** Unique identifier for the created remedy */
  remedy_id: string;
  /** Current status of the remedy */
  status: TLRemedyStatus;
};

/**
 * Request to preview the top-level repository objects of a single SAP package or package range.
 */
export type TLPackageImportPreviewRequest = {
  /** Name of the SAP package to import (fetched live from S/4) */
  package_name: string;
  /** Optional inclusive range end (SAP select-options BT). With it set, package_name is the range start and every package in between is imported — each with its full subtree, including sub-packages whose own names sort outside the range. Both endpoints must be literal names sharing at least two leading characters; names compare as uppercase ASCII, so '_' sorts after letters and '/NAMESPACE/' names sort before 'A'. A range matching more packages than the configured ceiling is rejected rather than truncated. */
  package_name_end?: string | null;
  /** SAP system version to walk the package on */
  sap_version?: TLSAPVersion;
};

/**
 * A single top-level repository object discovered in the package.
 */
export type TLPackageImportObject = {
  /** Repository object name */
  name: string;
  /** Short TADIR object type (e.g. PROG, CLAS, FUGR, INTF, TABL) */
  object_type: string;
  /** Number of subobjects (0 for DDIC/non-expandable types) */
  subobject_count: number;
};

/**
 * One page of the package's top-level repository objects with per-object subobject counts.
 */
export type TLPackageImportPreviewResponse = {
  /** Objects on the requested page */
  objects: TLPackageImportObject[];
  /** Requested page offset */
  offset: number;
  /** Name of the previewed package, or the range start */
  package_name: string;
  /** Normalized inclusive range end when the preview ran as a package range */
  package_name_end?: string | null;
  /** Requested page size (limit) */
  page_size: number;
  /** Total number of top-level objects the package contains */
  total_count: number;
};

export type TLRemediationAnalysisRequest = {
  /**
   * Remedy name (cr_remedies_v3.name) to analyze
   * @minLength 1
   */
  name: string;
};

export enum TLAnalysisJobStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
export type TLRemediationAnalysisJobResponse = {
  created_date: string;
  job_id: string;
  remedy_id: string;
  status: TLAnalysisJobStatus;
};

export type TLRemediationAnalysisStatusResponse = {
  created_date: string;
  download_url?: string | null;
  error_message?: string | null;
  job_id: string;
  remedy_id: string;
  status: TLAnalysisJobStatus;
  updated_date: string;
};

/**
 * Response model for a single remedy in the list.
 */
export type TLRemedyResponse = {
  /** Check variant used for this remedy */
  check_variant: string;
  /** User who created the remedy */
  created_by: string;
  /** Creation timestamp (UTC) */
  created_date: string;
  /** Name of the remedy */
  name: string;
  /** The Code Modernization project this remedy backs, if any. None for a remedy created directly in Code Remediation, and for one whose owning project has been deleted — resolved against live projects, so it is never an id that cannot be fetched. */
  project_id?: string | null;
  /** Unique identifier for the remedy */
  remedy_id: string;
  /** SAP system version */
  sap_system_version: string;
  /** Status of the remedy */
  status: TLRemedyStatus;
  /** User who last updated the remedy */
  updated_by: string;
  /** Last update timestamp (UTC) */
  updated_date: string;
};

/**
 * Response model for listing remedies.
 */
export type TLRemedyListResponse = {
  /** List of remedies */
  remedies: TLRemedyResponse[];
};

export enum TLScopeObjectStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  FLAGGED_FOR_FUNCTIONAL = 'FLAGGED_FOR_FUNCTIONAL',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  COMPLETED = 'COMPLETED',
}
export enum TLAgenticRemediationStatus {
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}
/**
 * Details of an object in the remedy.
 */
export type TLRemedyObjectDetail = {
  /** ADT Resource Path */
  adt_resource_path?: string | null;
  /** Email ID of the user who assigned this object */
  assigned_by?: string | null;
  /** Email ID assigned to this object */
  assigned_to?: string | null;
  /** Category of the object */
  category?: string | null;
  /** Status of this object's most recent agentic-remediation run (QUEUED/RUNNING/SUCCEEDED/FAILED/CANCELLED). None if the object has never had an AI run. */
  latest_agentic_run_status?: TLAgenticRemediationStatus | null;
  /** Name of the object */
  name: string;
  /** Unique identifier for the object */
  object_id: string;
  /** Type of the object */
  object_type: string;
  /** Parent object ID if this is a child object */
  parent_id?: string | null;
  /** Program ID if this object has associated code */
  program_id?: string | null;
  /** Status of the object */
  status?: TLScopeObjectStatus | null;
  /** Subcategory */
  subcategory?: string | null;
  /** Transport request description */
  tr_description?: string | null;
  /** Transport request number */
  tr_number?: string | null;
};

/**
 * Response model for remedy details including all objects.
 */
export type TLRemedyDetailResponse = {
  /** Name of the remedy */
  name: string;
  /** Objects in this remedy, narrowed by the optional status / agentic_run_status query filters when provided (otherwise all). */
  objects: TLRemedyObjectDetail[];
  /** The Code Modernization project this remedy backs, if any. None for a remedy created directly in Code Remediation, and for one whose owning project has been deleted — resolved against live projects, so it is never an id that cannot be fetched. */
  project_id?: string | null;
  /** Unique identifier for the remedy */
  remedy_id: string;
  /** SAP system version */
  sap_system_version: TLSAPVersion;
  /** Status of the remedy */
  status: TLRemedyStatus;
};

export type TLObjectAssignmentItem = {
  /** Email of the user to assign this object to */
  assigned_email: string;
  /** Unique identifier for the object */
  object_id: string;
};

export type TLObjectAssignmentRequest = {
  /** List of object assignments */
  assignments: TLObjectAssignmentItem[];
};

export type TLObjectAssignmentResponse = {
  /** List of object IDs that failed to be assigned (only present if some failed) */
  failed_object_ids?: string[] | null;
  /** Success message if all objects were assigned successfully */
  message?: string | null;
};

export type TLActivationRequest = {
  /** List of unique identifiers of objects to activate */
  object_ids: string[];
};

export enum TLMessageType {
  E = 'E',
  W = 'W',
  I = 'I',
  U = 'U',
}
export type TLCodeRemediationV3ActivationMessage = {
  /** Line number where the message applies */
  line: number;
  /** Object description */
  objDescr: string;
  /** Text of the message */
  shortText: string;
  /** Message type (E=Error, W=Warning, I=Info) */
  type: TLMessageType;
};

export type TLObjectActivationResponse = {
  /** Detailed error messages (only populated when success is false) */
  error_messages?: TLCodeRemediationV3ActivationMessage[];
  /** Unique identifier of the object */
  object_id: string;
  /** Whether the activation request was successful */
  success: boolean;
};

export type TLActivationResponse = {
  /** List of activation results for each object */
  results: TLObjectActivationResponse[];
};

export type TLRemedyTrBulkFromProgramRequest = {
  /** Program ID of the uploaded Excel/CSV listing objects */
  program_id: string;
};

export type TLRemedyTrBulkAcceptedResponse = {
  /** Hint that reconciliation runs in the background after file load and parse */
  message: string;
  /** Remedy this bulk job applies to */
  remedy_id: string;
  /** Status set when the file is accepted (SETUP_IN_PROGRESS); poll GET /remedies/{remedy_id} for completion */
  status: string;
};

export type TLValidateCodeRequest = {
  /** Source code to validate against active version in SAP */
  code: string;
  /** Unique identifier of the remedy object */
  object_id: string;
};

export type TLValidateCodeResponse = {
  /** True if provided code matches active version in SAP */
  is_active: boolean;
};

/**
 * The binary-rule counts, scoped to one ATC priority.
 */
export type TLRemediationDashboardPriorityCounts = {
  blocked?: number;
  introduced?: number;
  resolved?: number;
  total?: number;
};

/**
 * ATC priority as SAP reports it ("1"/"2"/"3") -> counts at this grain
 */
export type TLRemediationDashboardSubobjectByPriority = { [key: string]: TLRemediationDashboardPriorityCounts };

/**
 * One include/subobject's slice of an object's findings.
 */
export type TLRemediationDashboardSubobject = {
  blocked: number;
  /** ATC priority as SAP reports it ("1"/"2"/"3") -> counts at this grain */
  by_priority?: TLRemediationDashboardSubobjectByPriority;
  introduced: number;
  resolved: number;
  /** Include / sub-object name as ATC reports it; null for the main program */
  subobject: string | null;
  total: number;
};

/**
 * ATC priority as SAP reports it ("1"/"2"/"3") -> counts at this grain
 */
export type TLRemediationDashboardObjectEntryByPriority = { [key: string]: TLRemediationDashboardPriorityCounts };

/**
 * Where the findings came from and how they ended, per top-level object.
 */
export type TLRemediationDashboardObjectEntry = {
  blocked: number;
  /** ATC priority as SAP reports it ("1"/"2"/"3") -> counts at this grain */
  by_priority?: TLRemediationDashboardObjectEntryByPriority;
  by_subobject: TLRemediationDashboardSubobject[];
  introduced: number;
  name: string;
  object_id: string;
  package: string | null;
  resolved: number;
  total: number;
  type: string;
};

/**
 * ATC priority as SAP reports it ("1"/"2"/"3") -> counts at this grain
 */
export type TLRemediationDashboardPackageByPriority = { [key: string]: TLRemediationDashboardPriorityCounts };

export type TLRemediationDashboardPackage = {
  /** ATC priority as SAP reports it ("1"/"2"/"3") -> counts at this grain */
  by_priority?: TLRemediationDashboardPackageByPriority;
  findings_blocked: number;
  /** Introduced during remediation; outside total/resolved/blocked, like the headline */
  findings_introduced?: number;
  findings_resolved: number;
  /** Live (non-introduced) findings in this package */
  findings_total?: number;
  objects: number;
  package: string;
};

export type TLRemediationDashboardFindingsByPriority = { [key: string]: number };

/**
 * priority -> resolution -> count; the *how* behind the binary status
 */
export type TLRemediationDashboardFindingsMatrix = { [key: string]: { [key: string]: number } };

export type TLRemediationDashboardFindings = {
  blocked: number;
  by_priority: TLRemediationDashboardFindingsByPriority;
  introduced: number;
  /** priority -> resolution -> count; the *how* behind the binary status */
  matrix: TLRemediationDashboardFindingsMatrix;
  open: number;
  percent_complete: number;
  resolved: number;
  /** Of `resolved`: findings gone from scans with no established cause — auditable, not silently counted */
  resolved_unattributed?: number;
  total: number;
};

export type TLRemediationDashboardObjectsByStatus = { [key: string]: number };

export type TLRemediationDashboardObjects = {
  ai_changed?: number | null;
  /** Objects whose latest agentic run FAILED, excluding COMPLETED objects */
  blocked: number;
  by_status: TLRemediationDashboardObjectsByStatus;
  hand_edited_after_ai?: number | null;
  /** COMPLETED / total, as a percentage */
  percent_complete: number;
  total: number;
  untouched?: number | null;
};

export type TLRemediationDashboardResponse = {
  /** Per-object finding disposition, blocked-first, capped at 200 rows — full finding-level grain lives in the downloadable report */
  by_object?: TLRemediationDashboardObjectEntry[];
  /** True when more objects carry findings than the by_object cap allows */
  by_object_truncated?: boolean;
  by_package: TLRemediationDashboardPackage[];
  findings: TLRemediationDashboardFindings;
  /** Stamped by the analysis pass (Phase 1); null until that ships */
  last_analyzed_at?: string | null;
  objects: TLRemediationDashboardObjects;
  remedy_id: string;
  /** True when the remedy exceeds a live-aggregation ceiling and findings were not derived */
  truncated?: boolean;
  /** Why the findings were not derived, phrased for the user. The two ceilings have different remedies — narrowing to fewer packages relieves the finding cap, but only splitting the project (or raising the limit) relieves the object ceiling — so show this rather than a generic 'run a report instead'. */
  truncated_reason?: string | null;
};

/**
 * Request model for editing a remedy.
 */
export type TLRemedyUpdateRequest = {
  /**
   * New name for the remedy
   * @minLength 1
   * @maxLength 255
   */
  name: string;
};

export type TLFLERemediateRequest = {
  /** Source code to analyze. If not provided, will be fetched from the remedy object */
  code?: string | null;
  /** Unique identifier of the object to remediate */
  object_id: string;
  /** List of rule IDs to apply. If not provided, all rules will be applied */
  rule_ids?: string[] | null;
};

export type TLChangedLine = {
  /** Code after the remediation */
  after: string;
  /** Original code before the remediation */
  before: string;
  /** Line number where the change was made */
  line_num: number;
  /** ID of the rule that was applied to make this change */
  rule_id?: string | null;
};

export type TLFleAnalyzeResponse = {
  /** List of lines that were changed by the remediation */
  changed_lines: TLChangedLine[];
  /** Error message if the remediation failed */
  error?: string | null;
};

/**
 * Which S/4 source version the editor's get-source-code read returns.
 *
 * INACTIVE is the working copy (the version manual edits are saved to before
 * activation) and is the default. ACTIVE is the live version currently running
 * on S/4. An agentic run ships its approved fix as ACTIVE and mirrors the same
 * fix into INACTIVE (the editor reads inactive), so the default read shows a
 * shipped fix; the original survives only in the run snapshot + program v1.0.
 */
export enum TLSourceCodeVersion {
  active = 'active',
  inactive = 'inactive',
}
/**
 * Application domains
 */
export enum TLDomain {
  GLOBAL = 'GLOBAL',
  EDITOR = 'EDITOR',
  WORKFLOWS = 'WORKFLOWS',
  CHAT = 'CHAT',
  PROJECTS = 'PROJECTS',
  DATA_HARMONIZATION = 'DATA_HARMONIZATION',
  CODE_REMEDIATION = 'CODE_REMEDIATION',
  VIEW_REMEDIATION = 'VIEW_REMEDIATION',
  SKILLS = 'SKILLS',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
  DATA_FOUNDRY = 'DATA_FOUNDRY',
  NEXUS = 'NEXUS',
  MIGRATION_ASSESSMENT = 'MIGRATION_ASSESSMENT',
}
export type TLSAPProgramInfo = {
  program_name?: string | null;
  [key: string]: unknown;
};

export type TLSAPPrograms = {
  ECC?: TLSAPProgramInfo | null;
  S4?: TLSAPProgramInfo | null;
  [key: string]: unknown;
};

export type TLProgramMetadata = {
  line_count?: number | null;
  sap_programs?: TLSAPPrograms | null;
  source_conversation_id?: string | null;
  workspace_path?: string | null;
  [key: string]: unknown;
};

/**
 * Program status values
 */
export enum TLProgramStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DELETED = 'DELETED',
}
export type TLProgram = {
  code?: string | unknown | null;
  created_by?: string | null;
  created_date?: string | null;
  domain?: TLDomain | null;
  file_size?: number | null;
  file_type?: string | null;
  filename?: string | null;
  metadata?: TLProgramMetadata | null;
  path?: string | null;
  program_id: string;
  session_id?: string | null;
  status?: TLProgramStatus;
  updated_by?: string | null;
  updated_date?: string | null;
  version?: string | null;
};

export type TLSourceCodeResponse = {
  /** Remedy object */
  object: TLRemedyObjectDetail;
  /** Program object */
  program: TLProgram;
};

export type TLModLogGenerationRequest = {
  /** Unique identifier of the object to check */
  object_id: string;
  /** Optional parent object identifier */
  parent_id?: string | null;
};

export type TLModLogGenerationResponse = {
  /** Comment summarizing the changes done to provided Parent object */
  mod_log_comment: string;
};

export type TLObjectIdsRequest = {
  /** List of object IDs */
  object_ids: string[];
};

export type TLObjectIdsResponse = {
  /** List of object IDs */
  object_ids: string[];
};

export type TLRemediationReportSummaryItem = {
  created_by: string;
  created_date: string;
  finding_count?: number | null;
  job_id: string;
  object_count?: number | null;
  status: TLAnalysisJobStatus;
};

export type TLPaginatedResponseRemediationReportSummaryItem = {
  /** List of items */
  data: TLRemediationReportSummaryItem[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Optional narrowing for both the report and the dashboard.
 */
export type TLRemediationReportFilters = {
  /** Only objects assigned to these emails */
  assigned_to?: string[] | null;
  /** Only findings we did not complete */
  blocked_only?: boolean;
  /** Only objects in these packages */
  packages?: string[] | null;
  /** ATC priorities as SAP reports them: "1", "2", "3" */
  priorities?: string[] | null;
};

export type TLRemediationReportRequest = {
  filters?: TLRemediationReportFilters | null;
};

export type TLRemediationReportJobResponse = {
  created_date: string;
  job_id: string;
  remedy_id: string;
  status: TLAnalysisJobStatus;
};

export type TLRemediationReportStatusResponse = {
  created_date: string;
  download_url?: string | null;
  error?: string | null;
  filename?: string | null;
  finding_count?: number | null;
  job_id: string;
  object_count?: number | null;
  remedy_id: string;
  status: TLAnalysisJobStatus;
  updated_date: string;
};

export type TLScanRequest = {
  /** List of parent object IDs to scan */
  object_ids: string[];
};

export type TLScanResponse = {
  /** List of scan IDs that were created */
  scan_ids: string[];
};

export type TLCodeRemediationV3SyntaxCheckRequest = {
  /** Source code content to perform syntax check on. */
  code?: string | null;
  /** Unique identifier of the object to check */
  object_id: string;
};

export type TLCheckMessage = {
  /** Column number where the error occurred */
  column: number;
  /** File name where the error occurred */
  file: string;
  /** Line number where the error occurred */
  line: number;
  /** Text description of the message */
  text: string;
  /** Message type (E=Error, W=Warning, I=Info, U=Unknown) */
  type: TLMessageType;
};

export type TLCodeRemediationV3SyntaxCheckResponse = {
  /** List of check messages (errors, warnings, info) */
  messages?: TLCheckMessage[];
  /** Whether the syntax check request was successful */
  success: boolean;
};

export type TLUpdateSourceCodeRequest = {
  /** Source code content to update */
  code: string;
  /** Unique identifier of the object (required) */
  object_id: string;
  /** Unique identifier of the parent object (optional) */
  parent_id?: string | null;
};

export type TLUpdateSourceCodeResponse = {
  /** The inactive source as stored by SAP, read back after the write. SAP may normalize the submitted code, so clients should adopt this echo as their buffer. None when the read-back failed (the save itself still succeeded). */
  code?: string | null;
  /** Message describing the result of the update */
  message: string;
  /** Whether the source code was successfully updated */
  success: boolean;
};

/**
 * Remedy object information.
 */
export type TLRemedyObjectInfo = {
  /** Email ID of the user who assigned this object */
  assigned_by?: string | null;
  /** Email ID assigned to this object */
  assigned_to?: string | null;
  /** Category of the object */
  category?: string | null;
  /** Name of the object */
  name: string;
  /** Unique identifier for the object */
  object_id: string;
  /** Type of the object */
  object_type: string;
  /** Parent object ID if this is a child object */
  parent_id?: string | null;
  /** Program ID if this object has associated code */
  program_id?: string | null;
  /** Status of the object */
  status?: TLScopeObjectStatus | null;
  /** Subcategory */
  subcategory?: string | null;
  /** Transport request description */
  tr_description?: string | null;
  /** Transport request number */
  tr_number?: string | null;
};

export enum TLScanStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}
/**
 * Scan information for an object.
 */
export type TLScanInfo = {
  /** Creation timestamp (ISO format) */
  created_date: string;
  /** Unique identifier for the object */
  object_id: string;
  /** Unique identifier for the scan */
  scan_id: string;
  /** Status of the scan */
  status: TLScanStatus;
  /** Last update timestamp (ISO format) */
  updated_date: string;
};

/**
 * Response model for listing remedy objects and scans separately.
 */
export type TLRemedyObjectsListResponse = {
  /** List of objects (parent + subobjects) */
  objects: TLRemedyObjectInfo[];
  /** List of scans for all objects */
  scans?: TLScanInfo[];
};

export type TLUpdateStatusResponse = {
  /** Status message */
  message: string;
  /** Whether the status update was successful */
  success: boolean;
  /** Syntax check messages (errors, warnings, info) when marking ready for review; only populated when present */
  syntax_messages?: TLCheckMessage[] | null;
};

/**
 * Repository object types that can be searched for by name on SAP.
 *
 * A strict subset of `ObjectType`: only these have an ADT long-form mapping in
 * `_get_object_type_mapping`. `METH` is not a top-level repository object, and
 * `INTF_OI` is the long-form duplicate of `INTF` — both are unusable as a
 * quickSearch `objectType`, and are excluded here so the generated frontend
 * client cannot offer them.
 */
export enum TLSearchableObjectType {
  CLAS = 'CLAS',
  FUGR = 'FUGR',
  INTF = 'INTF',
  PROG = 'PROG',
}
/**
 * A (type, name) object the client selected from one or more searches.
 */
export type TLRemediationObjectRef = {
  /**
   * Repository object name
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** Repository object type */
  object_type: TLSearchableObjectType;
};

/**
 * Request to create a remedy from objects picked out of search results.
 */
export type TLRemediationObjectImportRequest = {
  /**
   * ATC check variant for the remedy
   * @minLength 1
   */
  check_variant: string;
  /**
   * Name of the remedy to create
   * @minLength 1
   */
  name: string;
  /**
   * Objects to import, each identified by type and name
   * @minItems 1
   * @maxItems 10000
   */
  objects: TLRemediationObjectRef[];
  /** SAP system the objects live on */
  sap_version?: TLSAPVersion;
};

/**
 * A repository object matched by an object-type/name search.
 */
export type TLRemediationObjectSearchResult = {
  /** Object description in the SAP user's logon language */
  description?: string | null;
  /** Repository object name */
  name: string;
  /** Short object type the search was scoped to */
  object_type: TLSearchableObjectType;
  /** Package the object belongs to */
  package_name?: string | null;
  /** ADT resource URI of the object */
  uri: string;
};

/**
 * One page of repository objects matching an object type and name pattern.
 */
export type TLRemediationObjectSearchResponse = {
  /** Normalized inclusive range end when the search ran as a name range; null for a glob search */
  name_end?: string | null;
  /** Normalized glob the search ran with, or — when name_end is set — the literal range start (never the internal glob the range was served by) */
  name_pattern: string;
  /** Object type the search was scoped to */
  object_type: TLSearchableObjectType;
  /** Objects on the requested page */
  objects: TLRemediationObjectSearchResult[];
  /** Requested page offset */
  offset: number;
  /** Requested page size (limit) */
  page_size: number;
  /** Total objects matched, capped at ATC_OBJECT_SEARCH_MAX_RESULTS */
  total_count: number;
};

export type TLCancelScansRequest = {
  /** List of scan IDs to cancel */
  scan_ids: string[];
};

/**
 * Why a finding's ATC documentation is (or isn't) shown in the UI.
 *
 * Lets the client distinguish an expected absence from a fetch failure instead
 * of rendering every empty case identically.
 */
export enum TLFindingMetadataAvailability {
  AVAILABLE = 'AVAILABLE',
  NO_DOCUMENTATION = 'NO_DOCUMENTATION',
  DOCUMENTATION_EMPTY = 'DOCUMENTATION_EMPTY',
  FETCH_FAILED = 'FETCH_FAILED',
}
/**
 * Response model for finding metadata.
 */
export type TLFindingMetadataResponse = {
  /** Additional information about the finding */
  additional_information?: string | null;
  /** Whether the finding's documentation is available, absent, empty, or failed to load */
  availability: TLFindingMetadataAvailability;
  /** Human-readable reason shown to the user when documentation could not be loaded */
  availability_detail?: string | null;
  /** ID of the finding */
  finding_id: string;
  /** EC/pragma pseudocomment for the finding */
  pseudocomment?: string | null;
};

export type TLObjectDetailsRequest = {
  /** ATC check variant to use */
  check_variant: string;
  /** Name of the remedy (must be unique) */
  name: string;
  /** Program ID to filter objects */
  program_id: string;
  /** SAP system version (default: S4) */
  sap_version?: TLSAPVersion;
};

/**
 * A (name, type) reference the client deselects from transport import.
 */
export type TLTransportImportObjectRef = {
  /** Repository object name */
  name: string;
  /** Short TADIR object type (must match a preview object_type) */
  object_type: string;
};

/**
 * Request to create a remedy from transport requests minus deselections.
 */
export type TLTransportImportCreateRequest = {
  /** ATC check variant for the remedy */
  check_variant: string;
  /**
   * Objects to exclude, matched by (name, object_type)
   * @maxItems 10000
   */
  deselected_objects?: TLTransportImportObjectRef[];
  /** Name of the remedy to create */
  name: string;
  /** SAP system version to read the transport requests from */
  sap_version?: TLSAPVersion;
  /**
   * SAP transport request numbers to import (one to twenty)
   * @minItems 1
   * @maxItems 20
   */
  transport_numbers: string[];
};

/**
 * Request to preview repository objects contained in SAP transport requests.
 */
export type TLTransportImportPreviewRequest = {
  /** SAP system version to read the transport requests from */
  sap_version?: TLSAPVersion;
  /**
   * SAP transport request numbers to import (one to twenty)
   * @minItems 1
   * @maxItems 20
   */
  transport_numbers: string[];
};

/**
 * A top-level repository object discovered in a transport request.
 */
export type TLTransportImportObject = {
  /** Repository object name */
  name: string;
  /** Short TADIR object type (e.g. PROG, CLAS, FUGR, INTF, TABL) */
  object_type: string;
  /** First requested transport containing this object */
  source_transport: string;
  /** Number of subobjects (0 for DDIC/non-expandable types) */
  subobject_count: number;
};

/**
 * One page of transport-request repository objects.
 */
export type TLTransportImportPreviewResponse = {
  /** Objects on the requested page */
  objects: TLTransportImportObject[];
  /** Requested page offset */
  offset: number;
  /** Requested page size (limit) */
  page_size: number;
  /** Total number of distinct top-level repository objects */
  total_count: number;
  /** Normalized transport requests included in the preview */
  transport_numbers: string[];
};

/**
 * Example showing code with issue and its fixed version.
 */
export type TLFixExample = {
  /** Code snippet that contains an issue */
  code_with_issue: string;
  /** Fixed/corrected version of the code */
  fixed_code: string;
};

/**
 * Filter criteria for targeting specific findings.
 */
export type TLTargetFilter = {
  /** Type of filter field (e.g., CHECKMSG, CHECKTITLE, NOTE, REF OBJECT) */
  field: string;
  /** Value to match against the specified field */
  value: string;
};

/**
 * Request model for creating a fix template.
 */
export type TLFixExampleCreateRequest = {
  /** Optional description of the fix template */
  description?: string | null;
  /** Optional list of code examples demonstrating the expected fix format. Each example shows problematic code and its fixed version. */
  examples?: TLFixExample[] | null;
  /** Prompt template used to generate fixes for matching findings */
  prompt: string;
  /**
   * List of filter criteria to match findings. Can contain one or many filters.
   * @minItems 1
   */
  target_filters: TLTargetFilter[];
  /** Title for the fix template (must be unique) */
  title: string;
};

/**
 * Response model for fix template.
 */
export type TLFixExampleResponse = {
  /** Optional description of the fix template */
  description?: string | null;
  /** Optional list of examples demonstrating the fix */
  example?: TLFixExample[] | null;
  /** Unique identifier for the fix template */
  fix_template_id: string;
  /** The prompt/template used to generate fixes for this template */
  prompt: string;
  /** List of filter criteria to match findings */
  target_filters: TLTargetFilter[];
  /** Title of the fix template */
  title: string;
};

export type TLFixExamplesListResponse = {
  /** List of all fix templates */
  fix_examples: TLFixExampleResponse[];
};

/**
 * Wire format for a fix-library export.
 *
 * JSONL is the only format the import side accepts: a rule's target filters and
 * examples are nested, and its examples carry multi-line ABAP, which CSV survives
 * only under strict quoting that spreadsheets routinely break on round-trip. CSV is
 * offered for reading the library in a spreadsheet, not for moving it.
 */
export enum TLFixLibraryExportFormat {
  JSONL = 'JSONL',
  CSV = 'CSV',
}
/**
 * Which rules an export should carry.
 *
 * A body rather than a query string because the ids are the payload: at the transfer cap
 * of 1000 rules, repeated query parameters run to tens of kilobytes and exceed the
 * server's request-line limit, so a selection of any real size cannot be a GET.
 */
export type TLFixLibraryExportSelectionRequest = {
  /**
   * Rules to export, by id. Duplicates are collapsed. Every id must be readable in the caller's own library — the export is refused whole if any is not, rather than silently shipping a smaller file.
   * @minItems 1
   * @maxItems 10000
   */
  fix_template_ids: string[];
};

/**
 * What an import does with a row whose title a rule in the tenant already holds.
 *
 * Titles are unique per tenant (``uq_cr_fix_templates_tenant_title``), so this is
 * the only collision an import can hit.
 */
export enum TLFixLibraryImportConflict {
  IGNORE = 'IGNORE',
  OVERWRITE = 'OVERWRITE',
  RENAME = 'RENAME',
}
export type TLImportFixLibraryRulesRequest = {
  file: Blob;
};

/**
 * What an import actually did with one row. Absent on a failed row.
 */
export enum TLFixLibraryImportAction {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  SKIPPED = 'SKIPPED',
}
/**
 * One row's outcome. ``action`` is set when the row was applied and absent when it
 * failed, so ``success`` and ``action`` can never disagree.
 */
export type TLFixLibraryRuleImportResult = {
  /** What was done with the row; absent when it failed. */
  action?: TLFixLibraryImportAction | null;
  /** Why the action failed for this item */
  error?: string | null;
  /** 1-based line number of this row in the uploaded file. */
  line: number;
  /** Title the rule was actually stored under — differs from `title` only under rename. */
  stored_title?: string | null;
  /** Whether the action succeeded for this item */
  success: boolean;
  /** Title from the file, when it could be read. */
  title?: string | null;
};

export type TLBulkActionResponseFixLibraryRuleImportResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLFixLibraryRuleImportResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export enum TLCodestreamArtifactKind {
  PROCESS = 'PROCESS',
  FS_TEMPLATE = 'FS_TEMPLATE',
  TS_TEMPLATE = 'TS_TEMPLATE',
  TEST_CASES = 'TEST_CASES',
  CODING_RULES = 'CODING_RULES',
  LINKS = 'LINKS',
}
export type TLPutCodestreamArtifactKindRequest = {
  description?: string | null;
  /** .docx/.md/.txt template; exclusive with markdown */
  file?: Blob | null;
  /** Artifact body as markdown; exclusive with file */
  markdown?: string | null;
};

export type TLCodestreamArtifactResponse = {
  configured?: boolean;
  description?: string | null;
  /** True when the original upload is kept as attachment */
  has_source_document?: boolean;
  kind: TLCodestreamArtifactKind;
  label: string;
  /** Reserved platform-skill slug backing this artifact */
  slug: string;
  updated_date?: string | null;
  version?: number | null;
};

export type TLCodestreamConfigResponse = {
  artifacts?: TLCodestreamArtifactResponse[];
};

export type TLCodestreamRenderDocxRequest = {
  /**
   * @minLength 1
   * @maxLength 128
   */
  filename?: string;
  /**
   * @minLength 1
   * @maxLength 500000
   */
  markdown: string;
};

export type TLCredentialMappingResponse = {
  connection_id: string;
  connector_id: string;
  created_by: string;
  created_date: string;
  credential_id: string;
  credential_type: string;
  id: string;
  is_default: boolean;
};

export type TLCredentialMappingsResponse = {
  mappings: TLCredentialMappingResponse[];
};

export type TLAddCredentialMappingRequest = {
  /** Connection ID to map to the credential */
  connection_id: string;
  /** Whether this mapping should be the default for the connection */
  is_default?: boolean;
};

export type TLConversationRequest = {
  /** List of attachment IDs */
  attachments?: string[];
  /** The conversation ID */
  conversation_id?: string;
  /** The user's message */
  message: string;
  /** Turn index */
  turn_index?: number;
};

export enum TLMessageStatus {
  DELIVERED = 'DELIVERED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  TERMINATED = 'TERMINATED',
  STOPPED = 'STOPPED',
  FAILED = 'FAILED',
  DELETED = 'DELETED',
}
/**
 * Response model for chat operations.
 */
export type TLChatResponse = {
  /** The conversation ID */
  conversation_id: string;
  /** The user message ID that was created */
  message_id?: string | null;
  /** The status of the user message */
  message_status?: TLMessageStatus | null;
  /** Server timestamp in ISO format */
  server_time?: string | null;
  /** Operation status */
  status?: string;
  /** Session name */
  title?: string | null;
  /** The turn index of the user message */
  turn_index: number;
};

/**
 * Response for delete all conversations endpoint.
 */
export type TLDeleteAllConversationsResponse = {
  /** Number of conversations deleted */
  deleted_count: number;
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLEditorChatMessageRequestActiveFile = { [key: string]: unknown } | null;

export type TLEditorChatMessageRequestReferencedPrograms = { [key: string]: unknown }[] | null;

export enum TLConversationType {
  CHAT = 'CHAT',
  EDITOR_CHAT = 'EDITOR_CHAT',
  REMEDIATION_CHAT = 'REMEDIATION_CHAT',
  DATA_HARMONIZATION_CHAT = 'DATA_HARMONIZATION_CHAT',
  DATA_FOUNDRY_CHAT = 'DATA_FOUNDRY_CHAT',
  KB_CHAT = 'KB_CHAT',
  WORKFLOW_CHAT = 'WORKFLOW_CHAT',
  NEXUS_CHAT = 'NEXUS_CHAT',
  VIEW_REMEDIATION_CHAT = 'VIEW_REMEDIATION_CHAT',
  LANDSCAPE_SYNC_CHAT = 'LANDSCAPE_SYNC_CHAT',
  RELEASE_CHAT = 'RELEASE_CHAT',
}
/**
 * Represents an authenticated user with their roles and info.
 */
export type TLAuthUser = {
  /** User email address */
  email: string;
  /** User groups */
  groups?: string[];
  /** User roles */
  roles?: string[];
  /** Keycloak login session ID (token 'sid', falling back to 'session_state') */
  session_id?: string | null;
  /** User identifier */
  user_id: string;
};

export type TLLintIssueFix = {
  description?: string;
  key?: string;
};

export type TLLintIssue = {
  column?: number;
  description?: string;
  end_column?: number;
  end_line?: number;
  fixes?: TLLintIssueFix[];
  from?: number;
  id?: string;
  issue_key?: string;
  line?: number;
  title?: string;
  to?: number;
  type?: string;
};

export type TLEditorChatMessageRequest = {
  active_file?: TLEditorChatMessageRequestActiveFile;
  attachments?: string[] | null;
  conversation_id: string;
  conversation_type?: TLConversationType | null;
  current_user?: TLAuthUser | null;
  include_subobjects?: boolean;
  lint_issues?: TLLintIssue[] | null;
  llm_model_cost_id?: string | null;
  llm_model_id?: string | null;
  message: string;
  referenced_programs?: TLEditorChatMessageRequestReferencedPrograms;
  user_email?: string;
};

export type TLForkFromShareRequest = {
  title?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  token: string;
};

export type TLForkFromShareResponse = {
  conversation_id: string;
  copied_attachments: number;
  message_count: number;
  missing_attachments: string[];
  title: string;
};

/**
 * Typed, persisted-as-JSONB metadata for a conversation.
 *
 * Enforces the shape of what may be stored on `conversations.metadata`. Add new
 * optional fields here as conversation-level metadata needs grow.
 */
export type TLConversationMetadata = {
  /** Project-scoped surface the chat was opened against (for example Nexus or Landscape Sync). */
  project_id?: string | null;
  /** Workflow template the chat was opened against. */
  template_id?: string | null;
  /** Workflow the chat was opened against. */
  workflow_id?: string | null;
};

export enum TLConversationStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
}
export type TLConversationSummary = {
  /** The conversation ID */
  conversation_id: string;
  /** User who created the conversation */
  created_by: string;
  /** When conversation was created */
  created_date?: string | null;
  /** Typed conversation metadata (e.g. the Loom workflow the chat was opened against). */
  metadata?: TLConversationMetadata | null;
  /** Conversation status */
  status: TLConversationStatus;
  /** Conversation title */
  title: string;
  /** When conversation was last updated */
  updated_date?: string | null;
};

/**
 * Response model for listing conversations.
 */
export type TLConversationListResponse = {
  /** List of user conversations */
  sessions: TLConversationSummary[];
};

/**
 * Type-specific context. EDITOR_CHAT / REMEDIATION_CHAT: active_file {name, id}, referenced_programs (array of {name, id}), optional conversation_type. CHAT: {input_data}. WORKFLOW_CHAT: workflow_canvas {workflow_id, name, can_edit, nodes, input_schema} — or, from the template editor, {template_id, is_template: true, name, can_edit, nodes, input_schema}. DATA_HARMONIZATION_CHAT: dh_dashboard {dashboard_id, dashboard_name}. DATA_FOUNDRY_CHAT: df_console {tab_type, tab_title, sql, table_name, execution_error}. VIEW_REMEDIATION_CHAT: remediation_canvas {view_id, view_name, view_status, can_edit}. LANDSCAPE_SYNC_CHAT: landscape_sync {project_id, systems, active_area, workspace_mode, queue, focused_transport, visible_actions}.
 */
export type TLSendMessageRequestContext = { [key: string]: unknown };

export type TLSendMessageRequest = {
  /** List of program / file IDs to attach */
  attachments?: string[];
  /** Chat type that determines available tools and behavior */
  chat_type?: TLConversationType;
  /** Type-specific context. EDITOR_CHAT / REMEDIATION_CHAT: active_file {name, id}, referenced_programs (array of {name, id}), optional conversation_type. CHAT: {input_data}. WORKFLOW_CHAT: workflow_canvas {workflow_id, name, can_edit, nodes, input_schema} — or, from the template editor, {template_id, is_template: true, name, can_edit, nodes, input_schema}. DATA_HARMONIZATION_CHAT: dh_dashboard {dashboard_id, dashboard_name}. DATA_FOUNDRY_CHAT: df_console {tab_type, tab_title, sql, table_name, execution_error}. VIEW_REMEDIATION_CHAT: remediation_canvas {view_id, view_name, view_status, can_edit}. LANDSCAPE_SYNC_CHAT: landscape_sync {project_id, systems, active_area, workspace_mode, queue, focused_transport, visible_actions}. */
  context?: TLSendMessageRequestContext;
  /** Client-generated conversation UUID */
  conversation_id: string;
  /**
   * Skill slugs the user explicitly selected for this turn (e.g. from a /command or picker).
   * @maxItems 5
   */
  invoked_skill_slugs?: string[];
  /** Legacy chat-model selection (an `id` from GET /llm/models). Fallback used only when `llm_model_id` is absent. Only honored on the first message of a conversation (binds + locks it); ignored afterwards. */
  llm_model_cost_id?: string | null;
  /** Optional chat-model selection (a stable `model_id` from GET /llm/models). Preferred over `llm_model_cost_id` when both are sent. Only honored on the first message of a conversation (binds + locks it); ignored afterwards. */
  llm_model_id?: string | null;
  /**
   * The user's message content
   * @minLength 1
   * @maxLength 50000
   */
  message: string;
  /** Optional summary carried over from a prior conversation (Summarize & start new chat). Only honored on the first message of a brand-new conversation — persisted as a compacted-summary marker before this message. Ignored on existing conversations. */
  prior_summary?: string | null;
  /** Optional source conversation for a scratchpad clone. Only honored for the first message of a new conversation when the current user owns the source. */
  scratchpad_source_conversation_id?: string | null;
};

/**
 * Response from POST /conversations/{conversation_id}/messages.
 */
export type TLChatMessageResponse = {
  /** The conversation ID */
  conversation_id: string;
  /** The user message ID that was created */
  message_id: string;
  /** Current status of the user message */
  message_status: TLMessageStatus;
  /** Conversation title */
  title?: string | null;
  /**
   * The turn index of the user message
   * @minimum 1
   */
  turn_index: number;
};

/**
 * Lifecycle of a server-side queued follow-up message.
 *
 * QUEUED: waiting for the conversation's in-flight turn to finish.
 * SENDING: atomically claimed by a drainer; prevents double-sends.
 * FAILED: drain attempt failed; kept visible for retry or user edit.
 */
export enum TLQueuedMessageStatus {
  QUEUED = 'QUEUED',
  SENDING = 'SENDING',
  FAILED = 'FAILED',
}
export type TLQueuedMessageResponse = {
  /** The conversation ID */
  conversation_id: string;
  /** ID of the created queue entry */
  queued_message_id: string;
  /** Always QUEUED on enqueue */
  status?: TLQueuedMessageStatus;
};

export enum TLToolExecutionStatus {
  success = 'success',
  error = 'error',
  in_progress = 'in_progress',
}
export enum TLSubStepContentKind {
  text = 'text',
  code = 'code',
  markdown = 'markdown',
}
export type TLSubStepResponse = {
  completed_at?: string | null;
  content: string;
  content_kind?: TLSubStepContentKind | null;
  has_sub_steps?: boolean;
  input_data?: string[] | null;
  output: string;
  output_data?: string[] | null;
  started_at?: string | null;
  sub_step_index: number;
};

export type TLExecutionStepResponse = {
  completed_at: string;
  content: string;
  content_kind?: TLSubStepContentKind | null;
  has_sub_steps: boolean;
  input_data?: string[] | null;
  name: string;
  output: string;
  output_data?: string[] | null;
  started_at?: string | null;
  step_index: number;
  sub_steps?: TLSubStepResponse[] | null;
};

export type TLToolExecutionDetailsResponseToolArguments = { [key: string]: unknown } | null;

export type TLToolExecutionDetailsResponseValidatedArguments = { [key: string]: unknown } | null;

export type TLToolExecutionDetailsResponse = {
  created_date: string;
  execution_status: TLToolExecutionStatus;
  execution_steps?: TLExecutionStepResponse[];
  tool_arguments?: TLToolExecutionDetailsResponseToolArguments;
  tool_execution_id: string;
  tool_name: string;
  updated_date: string;
  validated_arguments?: TLToolExecutionDetailsResponseValidatedArguments;
};

export type TLToolExecutionsListResponse = {
  executions: TLToolExecutionDetailsResponse[];
};

export type TLProgramsRevokePermissionsRequest = {
  /** Program ID to revoke permissions for */
  program_id: string;
  /**
   * List of user emails to revoke access from
   * @minItems 1
   * @maxItems 100
   * @items.maxLength 255
   */
  user_emails: string[];
};

export type TLProgramsRevokePermissionsResponse = {
  /** User emails that failed to revoke */
  failed: string[];
  /** Success message */
  message: string;
  /** User emails that were successfully revoked */
  revoked: string[];
  /** Operation status */
  status?: string;
};

export type TLPaginatedResponseProgram = {
  /** List of items */
  data: TLProgram[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export enum TLProgramsPermissionStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
}
export type TLProgramsPermission = {
  created_by: string;
  created_date?: string | null;
  domain: TLDomain;
  permission_id: string;
  program_id: string;
  status: TLProgramsPermissionStatus;
  updated_by: string;
  updated_date?: string | null;
  user_email: string;
};

export type TLGrantPermissionRequest = {
  /** Whether to notify the recipients that the program was shared */
  notify?: boolean;
  /**
   * List of user emails to grant access to
   * @minItems 1
   * @maxItems 100
   * @items.maxLength 255
   */
  user_emails: string[];
};

export type TLGrantPermissionResponse = {
  /** User emails that failed to be granted permission */
  failed: string[];
  /** Permission IDs that were successfully granted */
  granted: string[];
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

/**
 * Request model for renaming a conversation.
 */
export type TLRenameConversationRequest = {
  /** New name for the conversation */
  new_conversation_name: string;
};

/**
 * Response model for renaming a conversation.
 */
export type TLRenameConversationResponse = {
  /** Success message */
  message: string;
  /** New conversation title */
  new_title: string;
  /** Previous conversation title */
  old_title: string;
  /** Whether the operation was successful */
  success: boolean;
};

/**
 * File attachment metadata for messages.
 */
export type TLFileAttachment = {
  /** When file was created */
  created_at?: string | null;
  /** File type extension (py, csv, txt, etc.) */
  file_type?: string | null;
  /** Name of the attached file */
  filename: string;
  /** Program ID for retrieving file content */
  program_id: string;
};

/**
 * One selectable choice in an ASK_USER_QUESTION clarifying question.
 */
export type TLAskUserQuestionOption = {
  /** Optional explanation of what the choice means. */
  description?: string;
  /** Short choice text shown to the user. */
  label: string;
  /** Whether this is the recommended choice; the UI highlights it. At most one per question. */
  recommended?: boolean;
};

/**
 * A single clarifying question the UI renders as one card in the selection panel.
 */
export type TLAskUserQuestion = {
  /** Short label for the question (truncated to 32 chars). */
  header: string;
  /** Whether the user may pick more than one option. */
  multiSelect?: boolean;
  /** Selectable choices (2-4). */
  options: TLAskUserQuestionOption[];
  /** Question text shown to the user. */
  question: string;
};

/**
 * Structured workflow graph for WORKFLOW messages (loaded onto the Loom canvas).
 */
export type TLConversationMessageResponseWorkflowGraph = { [key: string]: unknown } | null;

/**
 * Message model for conversation history.
 */
export type TLConversationMessageResponse = {
  /** Agent that generated this message (if assistant) */
  agent?: string | null;
  /** List of program IDs for attached files */
  attachments?: string[];
  /** Message author */
  author: string;
  /** Message category */
  category: string;
  /** When message was created */
  created_date: string;
  /** Message ID */
  id: string;
  /** When set on a WORKFLOW message, the canvas should open the graph as a NEW workflow (a copy the user owns) rather than applying it to the workflow currently open. */
  open_as_new_workflow?: boolean | null;
  /** Parent message ID for child messages */
  parent_message_id?: string | null;
  /** Tool/agent processing time in milliseconds (null for user messages or pre-existing data). */
  processing_time_ms?: number | null;
  /** Clarifying multiple-choice questions for ASK_USER_QUESTION messages (rendered as a card). */
  questions?: TLAskUserQuestion[] | null;
  /** Message role (user/assistant) */
  role: string;
  /** Message status */
  status: TLMessageStatus;
  /** Message content */
  text: string;
  /** Captured agent reasoning for this message (powers the collapsible 'Thought' marker). */
  thoughts?: string | null;
  /** Tool used for this message (if any) */
  tool?: string | null;
  /** Turn index in the conversation */
  turn_index: number;
  /** Structured workflow graph for WORKFLOW messages (loaded onto the Loom canvas). */
  workflow_graph?: TLConversationMessageResponseWorkflowGraph;
};

export enum TLLlmModelStatus {
  ACTIVE = 'ACTIVE',
  DEPRECATED = 'DEPRECATED',
  RETIRED = 'RETIRED',
}
/**
 * Response model for a full conversation.
 */
export type TLConversationResponse = {
  /** True once the conversation has been summarized enough times that further sends are rejected until a new chat is started. Lets the client gate queued-message actions after a reload. */
  compaction_limit_reached?: boolean;
  /** Name of the conversation */
  conversation_name: string;
  /** Surface this conversation belongs to. Clients must send this back as chat_type and use it to open the conversation where it lives (a WORKFLOW_CHAT belongs on the Loom canvas, not the chat page). */
  conversation_type?: TLConversationType;
  /** List of files attached to conversation */
  files?: TLFileAttachment[];
  /** List of messages in conversation */
  history: TLConversationMessageResponse[];
  /** Underlying model slug from llm_models (resolves even for retired/repriced models). */
  llm_model?: string | null;
  /** llm_model_costs id this conversation is bound to (None = default). Locked after first message. */
  llm_model_cost_id?: string | null;
  /** Operator-set friendly name from llm_models for the bound model. */
  llm_model_display_name?: string | null;
  /** Stable llm_models model_id resolved from the bound cost id (None = unbound or catalog gone). */
  llm_model_id?: string | null;
  /** Catalog lifecycle status of the bound model. Lets the client explain a locked model: DEPRECATED keeps running, RETIRED routes new messages to the default. */
  llm_model_status?: TLLlmModelStatus | null;
  /** Typed conversation metadata (e.g. the Loom workflow the chat was opened against). */
  metadata?: TLConversationMetadata | null;
};

/**
 * Request model for partially updating a conversation.
 */
export type TLConversationUpdateRequest = {
  /** Workflow template to link this conversation to. */
  template_id?: string | null;
  /** Workflow to link this conversation to. */
  workflow_id?: string | null;
};

export enum TLContextUsageCategoryId {
  system_prompt = 'system_prompt',
  skills = 'skills',
  scratchpad = 'scratchpad',
  tools = 'tools',
  conversation = 'conversation',
  summarized = 'summarized',
}
export type TLContextUsageCategory = {
  approximate?: boolean;
  character_count: number;
  /** Design-token color name, e.g. 'purple', 'blue'. */
  color: string;
  /** Short, user-facing explanation of what this category holds (abstracted). */
  description?: string | null;
  id: TLContextUsageCategoryId;
  /** Count of sub-items this category holds, when that's a meaningful number to surface (active skills for 'skills', individual tools for 'tools', turns for 'conversation'). */
  item_count?: number | null;
  label: string;
  tokens: number;
};

export enum TLContextUsageRole {
  user = 'user',
  assistant = 'assistant',
  tool = 'tool',
  system = 'system',
  summary = 'summary',
}
export type TLContextUsageItem = {
  category_id: TLContextUsageCategoryId;
  character_count: number;
  id: string;
  /** True when this item is a synthetic pruning placeholder, not the original message. */
  is_pruning_stub?: boolean;
  label: string;
  message_id?: string | null;
  role?: TLContextUsageRole | null;
  text_preview?: string | null;
  tokens: number;
  tool?: string | null;
  /** For a tool-group drill item (category_id == 'tools'): number of individual tools in it. */
  tool_count?: number | null;
  /** 1-based display ordinal of the turn this item belongs to. */
  turn?: number | null;
};

export enum TLContextUsageStatus {
  healthy = 'healthy',
  filling = 'filling',
  compacted = 'compacted',
}
export type TLContextUsageTurnGroup = {
  items: TLContextUsageItem[];
  tokens: number;
  turn: number;
  turn_key: string;
};

export type TLCompositionReport = {
  categories: TLContextUsageCategory[];
  context_window_tokens: number;
  conversation_tokens: number;
  /** Estimated conversation tokens pruned away vs. the full history. */
  dropped_tokens?: number;
  estimated_total_tokens: number;
  /** Drill leaves for the tool + summarized categories. */
  items?: TLContextUsageItem[];
  percent_full: number;
  /** Tokens for the always-injected skills catalog block. */
  skills_tokens?: number;
  status: TLContextUsageStatus;
  /** Tokens attributable to compaction summaries still in context. */
  summarized_tokens?: number;
  system_prompt_tokens: number;
  tool_definitions_tokens: number;
  /** Conversation messages grouped by turn (the conversation drill). */
  turn_groups?: TLContextUsageTurnGroup[];
};

export type TLContextUsageReport = {
  chars_per_token: number;
  composition: TLCompositionReport;
  context_window_tokens: number;
  conversation_id: string;
  conversation_type: TLConversationType;
  generated_at: string;
  /** Accuracy caveats to surface as 'approximate'. */
  notes?: string[];
};

export type TLSkillExportResponse = {
  description: string;
  is_fallback: boolean;
  name: string;
  skill_markdown: string;
  slug: string;
};

export enum TLWfExportStatus {
  GENERATED = 'GENERATED',
  MISSING_NODES = 'MISSING_NODES',
}
export type TLCreateWorkflowInputOutputWorkflowMetadata = { [key: string]: unknown } | null;

export type TLCreateWorkflowInputOutput = {
  description?: string | null;
  input_schema?: TLWorkflowInputSchemaOutput;
  /** @maxLength 100 */
  name: string;
  /** @maxItems 200 */
  nodes: TLNodeInput[];
  tags?: string[] | null;
  visibility?: TLWfVisibility;
  workflow_metadata?: TLCreateWorkflowInputOutputWorkflowMetadata;
};

/**
 * API response for conversation-to-workflow export.
 *
 * ``status`` is ``GENERATED`` with a ``workflow``, or ``MISSING_NODES`` with ``workflow=None`` and a
 * user-facing ``message`` naming the tools that have no workflow node yet.
 */
export type TLWorkflowExportResponse = {
  message?: string | null;
  status?: TLWfExportStatus;
  unsupported_tools?: string[];
  validation_issues?: string[];
  workflow?: TLCreateWorkflowInputOutput | null;
};

/**
 * Individual file information in a conversation.
 */
export type TLConversationFile = {
  /** Email of the user who uploaded the file */
  created_by: string;
  /** Date when the file was created */
  created_date?: string | null;
  /** Presigned URL for downloading the file */
  download_url: string;
  /** Name of the file */
  filename: string;
  /** Program ID for retrieving file content */
  program_id: string;
};

export type TLPreviewSearchMatch = {
  /**
   * Zero-based line index of the match; request the preview at this offset to page to it
   * @minimum 0
   */
  line_number: number;
  /** The matching line, truncated for display */
  snippet: string;
};

/**
 * Response model for searching a file preview.
 */
export type TLPreviewSearchResponse = {
  /** Matching lines in file order */
  matches?: TLPreviewSearchMatch[];
  /** ID of the searched program */
  program_id: string;
  /** The query that was searched for */
  query: string;
  /**
   * Number of matches returned
   * @minimum 0
   */
  total_matches: number;
  /** Whether the match cap was hit or the file exceeded the scan window (more may exist) */
  truncated: boolean;
};

export type TLConversationForkRequest = {
  /** Whether the cut-point message itself is included in the fork */
  inclusive?: boolean;
  title?: string | null;
  /** Cut point for the copy; omit to fork the whole conversation */
  up_to_message_id?: string | null;
};

/**
 * Type-specific context, same shape as SendMessageRequest.context (e.g. dh_dashboard, workflow_canvas, kb package) — an edit re-sends from the user's current screen, so the client should pass its live context here.
 */
export type TLEditMessageRequestContext = { [key: string]: unknown };

/**
 * Request model for editing a message in a conversation.
 */
export type TLEditMessageRequest = {
  /**
   * List of program / file IDs to attach to the edited message
   * @maxItems 50
   */
  attachments?: string[];
  /** Type-specific context, same shape as SendMessageRequest.context (e.g. dh_dashboard, workflow_canvas, kb package) — an edit re-sends from the user's current screen, so the client should pass its live context here. */
  context?: TLEditMessageRequestContext;
  /**
   * The new message content to replace the original
   * @minLength 1
   * @maxLength 50000
   */
  message: string;
};

/**
 * A single message in a conversation.
 */
export type TLConversationMessageItem = {
  /** Agent that generated this message */
  agent?: string | null;
  /** Message author */
  author: string;
  /** Message content */
  content: string;
  /** When the message was created */
  created_date?: string | null;
  /** Whether the message has attachments */
  has_attachments?: boolean;
  /** Message ID */
  message_id: string;
  /** Parent message ID for agent responses */
  parent_message_id?: string | null;
  /** Message role (user/assistant) */
  role: string;
  /** Message status */
  status: TLMessageStatus;
  /** Tool used for this message */
  tool?: string | null;
  /** Turn index in the conversation */
  turn_index: number;
};

/**
 * Response from GET /conversations/{conversation_id}/messages.
 */
export type TLConversationMessagesResponse = {
  /** The conversation ID */
  conversation_id: string;
  messages?: TLConversationMessageItem[];
};

export type TLFeedbackRequest = {
  /** True for positive feedback, False for negative feedback */
  is_positive: boolean;
};

export type TLQueuedMessageItem = {
  /** The queued message text */
  content: string;
  /** The conversation this is queued for */
  conversation_id: string;
  /** When the message was queued */
  created_date: string;
  /** Skill slugs selected for this message */
  invoked_skill_slugs?: string[];
  /** Attached program/file IDs */
  program_ids?: string[];
  /** Queued message ID */
  queued_message_id: string;
  /** QUEUED, SENDING, or FAILED */
  status: TLQueuedMessageStatus;
};

export type TLPaginatedResponseQueuedMessageItem = {
  /** List of items */
  data: TLQueuedMessageItem[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLUpdateQueuedMessageRequest = {
  content?: string | null;
  invoked_skill_slugs?: string[] | null;
  /** Replaces the attachment list when provided */
  program_ids?: string[] | null;
};

export enum TLScratchpadAuthor {
  AGENT = 'AGENT',
  COMPACTOR = 'COMPACTOR',
}
export type TLConversationScratchpadResponse = {
  body: string;
  char_count: number;
  conversation_id: string;
  enabled: boolean;
  last_written_by: TLScratchpadAuthor | null;
  revision: number;
  updated_date: string | null;
  write_count: number;
};

export enum TLConversationShareStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
}
export type TLShareMetadataResponse = {
  allow_fork: boolean;
  created_date: string;
  expires_at: string;
  last_viewed_at: string | null;
  message_count: number;
  share_id: string;
  status: TLConversationShareStatus;
  view_count: number;
};

export type TLCreateShareRequest = {
  /** Whether recipients may fork the snapshot into their own tenant */
  allow_fork?: boolean;
  /** Link validity in days; defaults to the deployment setting, clamped to the maximum */
  expires_in_days?: number | null;
};

export type TLCreateShareResponse = {
  allow_fork: boolean;
  expires_at: string;
  share_id: string;
  /** Origin-relative URL path with the token in the fragment */
  share_url_path: string;
  /** The share token. Returned exactly once; only its hash is stored */
  token: string;
};

export type TLSummarizeConversationResponse = {
  /** LLM-generated summary of the conversation history */
  summary: string;
};

/**
 * Credential fields per schema: SAP_ABAP/SAP_HANA, SALESFORCE etc.
 */
export type TLDataConnectorsCredentialCreateRequestCredentialData = { [key: string]: unknown };

export enum TLCredentialSchema {
  SAP_ABAP = 'SAP_ABAP',
  SAP_HANA = 'SAP_HANA',
  SAP_PI_PO = 'SAP_PI_PO',
  SALESFORCE = 'SALESFORCE',
  SALESFORCE_DATA360 = 'SALESFORCE_DATA360',
  DYNAMICS365 = 'DYNAMICS365',
  SNOWFLAKE_PASSWORD = 'SNOWFLAKE_PASSWORD',
  SNOWFLAKE_KEY_PAIR = 'SNOWFLAKE_KEY_PAIR',
  DATABRICKS = 'DATABRICKS',
  MYSQL = 'MYSQL',
  MSSQL = 'MSSQL',
  CLICKHOUSE = 'CLICKHOUSE',
  ORACLE_DB = 'ORACLE_DB',
  TRINO = 'TRINO',
  SAP_INTEGRATION_SUITE_OAUTH = 'SAP_INTEGRATION_SUITE_OAUTH',
  BTP_CLOUD_ALM = 'BTP_CLOUD_ALM',
  EXTERNAL_API_KEY = 'EXTERNAL_API_KEY',
  SFTP_PASSWORD = 'SFTP_PASSWORD',
  TOSCA_OAUTH = 'TOSCA_OAUTH',
  JDE_ODBC = 'JDE_ODBC',
}
export enum TLCredentialType {
  USER = 'USER',
  SERVICE_ACCOUNT = 'SERVICE_ACCOUNT',
}
export type TLDataConnectorsCredentialCreateRequest = {
  /** Optional connection to map this credential to */
  connection_id?: string | null;
  /** ID of the connector this credential belongs to */
  connector_id: string;
  /** Credential fields per schema: SAP_ABAP/SAP_HANA, SALESFORCE etc. */
  credential_data: TLDataConnectorsCredentialCreateRequestCredentialData;
  /**
   * @minLength 1
   * @maxLength 200
   */
  credential_name: string;
  /** Schema type: SAP_ABAP, SAP_HANA, SALESFORCE, DYNAMICS365 */
  credential_schema: TLCredentialSchema;
  /** USER or SERVICE_ACCOUNT */
  credential_type: TLCredentialType;
  description?: string | null;
  is_default?: boolean;
};

export type TLConnectorCredentialResponse = {
  connector_id: string;
  created_by: string;
  created_date: string;
  credential_id: string;
  credential_name: string;
  credential_type: string;
  description?: string | null;
  is_active: boolean;
  is_default: boolean;
  updated_by: string;
  updated_date: string;
};

export enum TLConnectorDomain {
  SAP = 'SAP',
  SALESFORCE = 'SALESFORCE',
  SALESFORCE_DATA360 = 'SALESFORCE_DATA360',
  WORKDAY = 'WORKDAY',
  ORACLE = 'ORACLE',
  DYNAMICS365 = 'DYNAMICS365',
  SNOWFLAKE = 'SNOWFLAKE',
  DATABRICKS = 'DATABRICKS',
  MYSQL = 'MYSQL',
  MSSQL = 'MSSQL',
  CLICKHOUSE = 'CLICKHOUSE',
  ORACLE_DB = 'ORACLE_DB',
  TRINO = 'TRINO',
  JIRA = 'JIRA',
  WORKIQ = 'WORKIQ',
  BTP_CLOUD_ALM = 'BTP_CLOUD_ALM',
  EXTERNAL_API = 'EXTERNAL_API',
  SFTP = 'SFTP',
  TOSCA = 'TOSCA',
  JDE = 'JDE',
  GOOGLE_DRIVE = 'GOOGLE_DRIVE',
}
export enum TLConnectionType {
  RFC = 'RFC',
  ODATA = 'ODATA',
  ADT = 'ADT',
  HANA = 'HANA',
  BAPI = 'BAPI',
  IDOC = 'IDOC',
  SAP_GUI = 'SAP_GUI',
  PI_PO = 'PI_PO',
  REST_API = 'REST_API',
  SOAP = 'SOAP',
  TDS = 'TDS',
  CDP = 'CDP',
  SQL = 'SQL',
  HTTPS = 'HTTPS',
  TRINO = 'TRINO',
  INTEGRATION_SUITE = 'INTEGRATION_SUITE',
  SFTP = 'SFTP',
  JDE = 'JDE',
}
export type TLCredentialListItem = {
  /** Connection IDs this credential is mapped to */
  connection_ids?: string[];
  connector_id: string;
  created_by: string;
  created_date: string;
  credential_id: string;
  credential_name: string;
  credential_type: string;
  description?: string | null;
  /** Connector domain (e.g. SAP, SALESFORCE) */
  domain: string;
  is_active: boolean;
  is_default: boolean;
  updated_by: string;
  updated_date: string;
  user_email?: string | null;
};

export type TLCredentialListResponse = {
  /** Number of credentials in this page */
  count: number;
  /** Paginated list: your USER credentials plus tenant SERVICE_ACCOUNT credentials (no secrets) */
  credentials: TLCredentialListItem[];
  /** Total matching credentials across all pages */
  total: number;
};

export type TLSchemaField = {
  /** Field description */
  description?: string;
  /** Field identifier (e.g. ashost, client) */
  id: string;
  /** Whether the field is required */
  required?: boolean;
  /** Human-readable field label */
  title: string;
  /** Field type (e.g. string, integer, boolean) */
  type: string;
};

export type TLCredentialSchemaItem = {
  /** Connection types this credential can map to */
  allowed_connection_types: string[];
  /** Schema ID (e.g. SAP_ABAP, SAP_HANA) */
  credential_schema: string;
  /** Human-readable name */
  display_name: string;
  /** Credential fields (e.g. username, password) for building forms */
  fields: TLSchemaField[];
};

export type TLCredentialSchemaListResponse = {
  /** Available credential schemas */
  credential_schemas: TLCredentialSchemaItem[];
};

/**
 * Full credential data; requires credential_schema for validation
 */
export type TLDataConnectorsCredentialUpdateRequestCredentialData = { [key: string]: unknown } | null;

export type TLDataConnectorsCredentialUpdateRequest = {
  /** Full credential data; requires credential_schema for validation */
  credential_data?: TLDataConnectorsCredentialUpdateRequestCredentialData;
  credential_name?: string | null;
  /** Required when credential_data is provided */
  credential_schema?: TLCredentialSchema | null;
  description?: string | null;
  is_default?: boolean | null;
};

/**
 * Connection configuration data
 */
export type TLConnectionResponseConnectionData = { [key: string]: unknown };

export type TLConnectionResponse = {
  /** Connection configuration data */
  connection_data: TLConnectionResponseConnectionData;
  /** Unique identifier of the connection */
  connection_id: string;
  /** Name of the connection */
  connection_name: string;
  /** Type of connection (e.g. RFC, ODATA) */
  connection_type: string;
  /** ID of the connector this connection belongs to */
  connector_id: string;
  /** Description of the connection */
  description?: string | null;
  /** Whether the connection is active */
  is_active: boolean;
};

export type TLConnectionListResponse = {
  /** List of connections */
  connections: TLConnectionResponse[];
  /** Number of connections returned */
  count: number;
};

/**
 * Connection configuration with system-level properties
 */
export type TLConnectionCreateRequestConnectionData = { [key: string]: unknown };

export type TLConnectionCreateRequest = {
  /** Connection configuration with system-level properties */
  connection_data: TLConnectionCreateRequestConnectionData;
  /** Type of connection */
  connection_type: TLConnectionType;
  /** ID of the connector this connection belongs to */
  connector_id: string;
  /** Description of the connection */
  description?: string | null;
  /**
   * Name of the connection
   * @minLength 1
   * @maxLength 200
   */
  name: string;
};

export type TLConnectionCreatedResponse = {
  /** ID of the connection that was created */
  connection_id: string;
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLConnectionSchemaItem = {
  /** Connection type (e.g. RFC, REST_API) */
  connection_type: string;
  /** Human-readable label for the connection type (e.g. 'Integration Suite' for INTEGRATION_SUITE) */
  display_name: string;
  /** Connector domain (e.g. SAP, SALESFORCE) */
  domain: string;
  /** List of form fields for connection_data */
  fields: TLSchemaField[];
};

/**
 * Response model for connection schemas - serializes as a list at the top level.
 */
export type TLConnectionSchemaListResponse = TLConnectionSchemaItem[];

/**
 * Connection configuration with system-level properties
 */
export type TLConnectionUpdateRequestConnectionData = { [key: string]: unknown } | null;

export type TLConnectionUpdateRequest = {
  /** Connection configuration with system-level properties */
  connection_data?: TLConnectionUpdateRequestConnectionData;
  /** Description of the connection */
  description?: string | null;
  /** Name of the connection */
  name?: string | null;
};

export enum TLKbPackageStage {
  DRAFT = 'DRAFT',
  PENDING_REVIEW = 'PENDING_REVIEW',
  IN_REVIEW = 'IN_REVIEW',
  EMBEDDED = 'EMBEDDED',
}
export type TLConnectorKbIngestResponse = {
  /** Number of documents ingested into the package */
  document_count: number;
  /** KB package holding the connector's reference docs */
  package_id: string;
  /** Name of the KB package */
  package_name: string;
  /** Current package stage (DRAFT until auto-submit succeeds) */
  stage: TLKbPackageStage;
  /** Whether the package was auto-submitted for embedding */
  submitted: boolean;
};

export type TLIngestConnectionDocsDataRequest = {
  docs_text?: string | null;
  files?: Blob[];
};

export type TLSftpBrowseEntry = {
  /** Whether this entry can be navigated into */
  is_directory: boolean;
  /** Last-modified time as a Unix timestamp, absent when the server did not report one */
  modified_at?: number | null;
  /** Entry name within the listed directory */
  name: string;
  /** Absolute path of this entry, so a caller navigating into it or selecting it never has to join path segments itself */
  path: string;
  /** Size in bytes, absent when the server did not report one */
  size?: number | null;
};

export type TLSftpBrowseResponse = {
  /** Directories and files in this directory */
  entries: TLSftpBrowseEntry[];
  /** Absolute path of the containing directory, or null at the filesystem root */
  parent_path?: string | null;
  /** Absolute path of the directory that was listed, resolved by the server — a blank request resolves to the login directory, which is all a chrooted account can see */
  path: string;
  /** True when the directory holds more entries than sftp_node_browse_max_entries, so the list is incomplete and the caller should say so rather than imply the directory is small */
  truncated: boolean;
};

/**
 * Note: Salesforce and Workday are not included here as they are single products
 * with no product line distinctions. For these systems, version_identifier should be NULL.
 */
export enum TLVersionIdentifier {
  ECC = 'ECC',
  S4 = 'S4',
  BW = 'BW',
  PI_PO = 'PI_PO',
  IS = 'IS',
  ORACLE_EBS = 'ORACLE_EBS',
  ORACLE_PEOPLESOFT = 'ORACLE_PEOPLESOFT',
  ORACLE_FUSION_CLOUD = 'ORACLE_FUSION_CLOUD',
  D365_AX = 'D365_AX',
  D365_NAV = 'D365_NAV',
  D365_BUSINESS_CENTRAL = 'D365_BUSINESS_CENTRAL',
  D365_FINANCE_OPERATIONS = 'D365_FINANCE_OPERATIONS',
  D365_SALES = 'D365_SALES',
  D365_CUSTOMER_SERVICE = 'D365_CUSTOMER_SERVICE',
  JDE_WORLD_7_3 = 'JDE_WORLD_7_3',
}
/**
 * Additional metadata for the connector
 */
export type TLConnectorResponseConnectorMetadata = { [key: string]: unknown } | null;

export type TLConnectorResponse = {
  /** Unique identifier of the connector */
  connector_id: string;
  /** Additional metadata for the connector */
  connector_metadata?: TLConnectorResponseConnectorMetadata;
  /** Immutable snake_case identifier for the connector, derived from the display name at creation time. Used as a stable machine-readable reference; not intended for end-user display. */
  connector_name: string;
  /** Description of the connector */
  description?: string | null;
  /** Human-readable label for the connector, shown in user-facing interfaces. */
  display_name?: string | null;
  /** Domain of the connector */
  domain: string;
  /** Whether the connector is active */
  is_active: boolean;
  /** Whether this is the default connector for its domain and version */
  is_default: boolean;
  /** Version identifier */
  version_identifier?: string | null;
};

export type TLConnectorListResponse = {
  /** List of connectors */
  connectors: TLConnectorResponse[];
  /** Number of connectors returned in this response */
  count: number;
  /** Total number of matching connectors across all pages */
  total: number;
};

/**
 * Additional metadata for the connector
 */
export type TLConnectorCreateRequestConnectorMetadata = { [key: string]: unknown } | null;

export type TLConnectorCreateRequest = {
  /** Additional metadata for the connector */
  connector_metadata?: TLConnectorCreateRequestConnectorMetadata;
  /** Description of the connector */
  description?: string | null;
  /** Domain of the connector */
  domain: TLConnectorDomain;
  /** Whether this is the default connector for its domain and version */
  is_default?: boolean;
  /**
   * Human-readable display name. An immutable snake_case identifier is derived from this value.
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** Version identifier */
  version_identifier?: TLVersionIdentifier | null;
};

export type TLConnectorCreatedResponse = {
  /** ID of the connector that was created */
  connector_id: string;
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLConnectorNamePreviewResponse = {
  /** Whether the sanitized identifier is available for the given domain and version. */
  available: boolean;
  /** The sanitized snake_case identifier that would be assigned to a connector with this label. */
  connector_name: string;
};

/**
 * Additional metadata for the connector
 */
export type TLConnectorUpdateRequestConnectorMetadata = { [key: string]: unknown } | null;

export type TLConnectorUpdateRequest = {
  /** Additional metadata for the connector */
  connector_metadata?: TLConnectorUpdateRequestConnectorMetadata;
  /** Description of the connector */
  description?: string | null;
  /** Whether this is the default connector for its domain and version */
  is_default?: boolean | null;
  /** Human-readable display name. The underlying connector identifier is immutable. */
  name?: string | null;
};

export type TLEditorAutocompleteRelatedSource = {
  /** @maxLength 128 */
  name: string;
  /** @maxLength 200000 */
  source: string;
};

export type TLEditorAutocompleteRequest = {
  /**
   * Zero-based cursor column.
   * @minimum 0
   */
  column: number;
  /**
   * One-based cursor line.
   * @minimum 1
   */
  line: number;
  object_name?: string | null;
  object_type?: string | null;
  object_uri?: string | null;
  /** @maxItems 12 */
  related_sources?: TLEditorAutocompleteRelatedSource[];
  sap_version?: TLSAPVersion | null;
  /** @maxLength 2000000 */
  source: string;
};

export type TLEditorAutocompleteResponse = {
  completion: string | null;
  /** @minimum 0 */
  latency_ms: number;
  model: string | null;
};

export type TLEditorAutocompleteConfiguration = {
  enabled: boolean;
  fast_mode: boolean;
};

export type TLEditorSemanticCompletionProposal = {
  description?: string | null;
  insert_text: string;
  kind?: string | null;
  label: string;
  type?: string | null;
};

export type TLEditorSemanticCompletionsResponse = {
  proposals: TLEditorSemanticCompletionProposal[];
};

export enum TLToolCatalogSource {
  native = 'native',
  gateway = 'gateway',
}
export type TLToolCatalogEntry = {
  /** All parameter names for the tool */
  args: string[];
  description: string;
  /** True for gateway tools, whose availability can change at runtime */
  is_dynamic: boolean;
  name: string;
  /** Required parameter names (a subset of args) */
  required_args: string[];
  /** NATIVE (always available) or GATEWAY (dynamic, from the MCP gateway) */
  source: TLToolCatalogSource;
  /** Target SAP system for gateway tools; null for native/non-system tools */
  system?: TLSAPVersion | null;
};

export type TLToolCatalogResponse = {
  /** False when the MCP gateway is disabled or unreachable */
  gateway_available: boolean;
  generated_at: string;
  tools: TLToolCatalogEntry[];
};

export type TLCreateDirectoryRequest = {
  /**
   * Directory name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** Parent directory UUID (None = domain root) */
  parent_id?: string | null;
};

/**
 * Filesystem node types.
 */
export enum TLNodeType {
  FILE = 'FILE',
  DIRECTORY = 'DIRECTORY',
}
/**
 * Filesystem node statuses.
 */
export enum TLNodeStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
export type TLFilesystemNodeResponse = {
  /** Creator email */
  created_by: string;
  /** Creation timestamp */
  created_date: string;
  /** Domain the node belongs to */
  domain?: string | null;
  /** Private to the creator when true */
  is_private?: boolean;
  /** System-created directory */
  is_system?: boolean;
  /** Node name */
  name: string;
  /** Node UUID */
  node_id: string;
  /** FILE or DIRECTORY */
  node_type: TLNodeType;
  /** Parent node UUID */
  parent_id?: string | null;
  /** Linked program UUID */
  program_id?: string | null;
  /** Node status */
  status: TLNodeStatus;
  /** Tenant identifier */
  tenant_id: string;
  /** Last updater email */
  updated_by: string;
  /** Last update timestamp */
  updated_date: string;
};

export type TLLinkProgramRequest = {
  /**
   * File name
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** Parent directory UUID (None = domain root) */
  parent_id?: string | null;
  /** Program UUID to link */
  program_id: string;
};

export type TLPaginatedFilesystemResponse = {
  /** List of nodes */
  items: TLFilesystemNodeResponse[];
  /** Page size */
  limit: number;
  /** Page offset */
  offset: number;
  /** Total number of items */
  total: number;
};

export type TLMoveNodeRequest = {
  /** Target domain when moving to domain root (required if new_parent_id is None) */
  domain?: string | null;
  /** New parent directory UUID (None = domain root) */
  new_parent_id?: string | null;
};

export type TLRenameNodeRequest = {
  /**
   * New name for the node
   * @minLength 1
   * @maxLength 255
   */
  new_name: string;
};

export enum TLGatewayDataSourceType {
  SELECT = 'SELECT',
  RFC = 'RFC',
  HAND_CODED = 'HAND_CODED',
  DYNAMIC_SQL = 'DYNAMIC_SQL',
  CDS = 'CDS',
}
export type TLGatewayServiceSummary = {
  data_source_types?: TLGatewayDataSourceType[];
  description: string;
  dpc_class: string;
  has_reference_data_source: boolean;
  is_active: boolean;
  last_modified_at: string;
  last_modified_by: string;
  /** True when any method uses HAND_CODED or DYNAMIC_SQL retrieval */
  needs_review: boolean;
  /** @minimum 0 */
  redefined_method_count: number;
  service_name: string;
  /** @minimum 0 */
  total_method_count: number;
};

export type TLGatewayServiceListResponse = {
  /** @minimum 0 */
  limit?: number;
  /** @minimum 0 */
  offset?: number;
  services?: TLGatewayServiceSummary[];
  /** @minimum 0 */
  total?: number;
};

export enum TLGatewayMethodType {
  GET_ENTITY = 'GET_ENTITY',
  GET_ENTITYSET = 'GET_ENTITYSET',
}
export type TLConfirmCdsResponse = {
  /** @minimum 0 */
  converted_method_count: number;
  /** @minimum 0 */
  convertible_method_count: number;
  entity_name: string;
  is_converted: boolean;
  method_type: TLGatewayMethodType;
  service_name: string;
};

export type TLGatewayMethod = {
  /** How the redefined method retrieves data; None for inherited methods */
  data_source_type?: TLGatewayDataSourceType | null;
  /** True once the user confirmed a generated CDS view */
  is_converted?: boolean;
  /** False when the method cannot be converted to CDS (e.g. DYNAMIC_SQL) */
  is_convertible?: boolean;
  /** True when the method is redefined in the *_DPC_EXT class */
  is_redefined: boolean;
  method_type: TLGatewayMethodType;
};

export type TLGatewayEntity = {
  /** True when the entity is already CDS/RDS backed */
  has_reference_data_source: boolean;
  methods?: TLGatewayMethod[];
  name: string;
  reference_data_source?: string | null;
  underlying_tables?: string[];
};

export type TLGatewayServiceDetail = {
  description: string;
  dpc_class: string;
  entities?: TLGatewayEntity[];
  is_active: boolean;
  last_modified_at: string;
  last_modified_by: string;
  mpc_class: string;
  package: string;
  service_name: string;
  version: string;
};

export type TLGeneratedCdsResponse = {
  abap_source: string;
  cds_source: string;
  cds_view_name: string;
  entity_name: string;
  method_type: TLGatewayMethodType;
  /** Behavioural differences between the ABAP logic and the generated CDS view */
  semantic_warnings?: string[];
  service_name: string;
};

export type TLMethodSourceResponse = {
  abap_source: string;
  entity_name: string;
  method_type: TLGatewayMethodType;
  service_name: string;
};

export enum TLCdsArtifactType {
  CDS_VIEW = 'CDS_VIEW',
  CONSUMPTION_VIEW = 'CONSUMPTION_VIEW',
  SERVICE_DEFINITION = 'SERVICE_DEFINITION',
  SERVICE_BINDING = 'SERVICE_BINDING',
  ACCESS_CONTROL = 'ACCESS_CONTROL',
}
export type TLCdsArtifact = {
  artifact_type: TLCdsArtifactType;
  description: string;
  entity_name?: string | null;
  name: string;
  source: string;
};

export enum TLRemediationStrategy {
  FULL_CDS = 'FULL_CDS',
  HYBRID_GW = 'HYBRID_GW',
}
export type TLRemediationPlanResponse = {
  artifacts?: TLCdsArtifact[];
  /** User-facing guidance, e.g. hybrid copy-service steps or /IWFND/MAINT_SERVICE activation */
  guidance?: string[];
  /** @minimum 0 */
  migrated_entity_count: number;
  /** @minimum 0 */
  preserved_annotation_count: number;
  service_name: string;
  skipped_entities?: string[];
  strategy: TLRemediationStrategy;
  target: string;
  /** @minimum 0 */
  total_entity_count: number;
};

export type TLPushTransportRequest = {
  /**
   * @minLength 1
   * @maxLength 200
   */
  transport_description: string;
};

export enum TLGatewayTransportStatus {
  PENDING = 'PENDING',
  ACTIVATING = 'ACTIVATING',
  ACTIVATED = 'ACTIVATED',
  FAILED = 'FAILED',
}
export type TLPushTransportResponse = {
  artifact_names?: string[];
  service_name: string;
  status: TLGatewayTransportStatus;
  transport_id: string;
};

export type TLTransportStatusResponse = {
  message: string;
  service_name: string;
  status: TLGatewayTransportStatus;
  transport_id: string;
};

/**
 * Who a Data Foundry table-access entry is for.
 *
 * Only the two governance subject types data-foundry can match at check time: it asserts
 * the acting user's Keycloak id and groups, never a service identity, so service grants
 * would be dead weight in this UI-facing model.
 */
export enum TLFoundryAccessPrincipalType {
  USER = 'USER',
  GROUP = 'GROUP',
}
export type TLFoundryAccessPrincipalResponse = {
  display_name: string;
  email?: string | null;
  subject_id: string;
  subject_type: TLFoundryAccessPrincipalType;
};

export type TLFoundryAccessPrincipalListResponse = {
  /** List of items */
  data: TLFoundryAccessPrincipalResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLTableColumnItem = {
  data_type?: string | null;
  name: string;
  nullable?: boolean | null;
};

export type TLCatalogTreeTableItem = {
  columns?: TLTableColumnItem[] | null;
  name: string;
  replication_error?: string | null;
  replication_status?: string | null;
  schema_name: string;
  type?: string | null;
};

export type TLCatalogTreeBulkSchemaItem = {
  name: string;
  tables: TLCatalogTreeTableItem[];
  tables_next_cursor?: string | null;
};

export type TLCatalogTreeBulkCatalogItem = {
  name: string;
  schemas: TLCatalogTreeBulkSchemaItem[];
  schemas_next_cursor?: string | null;
};

export type TLCatalogTreeResponse = {
  catalogs: TLCatalogTreeBulkCatalogItem[];
  next_cursor?: string | null;
};

export type TLCatalogTreeCatalogItem = {
  name: string;
};

export type TLCatalogTreeCatalogPageResponse = {
  items: TLCatalogTreeCatalogItem[];
  next_cursor?: string | null;
};

export type TLCatalogTreeSchemaItem = {
  name: string;
};

export type TLCatalogTreeSchemaPageResponse = {
  items: TLCatalogTreeSchemaItem[];
  next_cursor?: string | null;
};

export type TLCatalogTreeTablePageResponse = {
  items: TLCatalogTreeTableItem[];
  next_cursor?: string | null;
};

export enum TLConsoleTabType {
  QUERY = 'QUERY',
  DATA = 'DATA',
}
export type TLConsoleTabResponse = {
  active_job_id?: string | null;
  active_job_is_batch?: boolean;
  id: string;
  is_active: boolean;
  position: number;
  sql?: string | null;
  table_name?: string | null;
  title: string;
  type: TLConsoleTabType;
};

export type TLConsoleTabsListResponse = {
  active_tab_id?: string | null;
  tabs?: TLConsoleTabResponse[];
};

export type TLCreateConsoleTabRequest = {
  /**
   * Ordering index
   * @minimum 0
   */
  position: number;
  /** SQL content (for QUERY tabs) */
  sql?: string | null;
  /** Fully qualified table name (for DATA tabs) */
  table_name?: string | null;
  /**
   * Tab display title
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /** Tab type: QUERY or DATA */
  type: TLConsoleTabType;
};

export type TLConsoleTabItem = {
  /** Tab ID */
  id: string;
  /** Whether this tab is the active tab */
  is_active?: boolean;
  /**
   * Ordering index
   * @minimum 0
   */
  position: number;
  /** SQL content (for QUERY tabs) */
  sql?: string | null;
  /** Fully qualified table name (for DATA tabs) */
  table_name?: string | null;
  /**
   * Tab display title
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /** Tab type: QUERY or DATA */
  type: TLConsoleTabType;
};

export type TLBulkSaveConsoleTabsRequest = {
  /** ID of the currently active tab */
  active_tab_id?: string | null;
  /**
   * Full list of tabs to save
   * @maxItems 50
   */
  tabs: TLConsoleTabItem[];
};

export type TLLakeResponse = {
  created_at: string;
  lake: string;
  updated_at: string;
};

export enum TLSourceSystemKey {
  sap = 'sap',
}
export type TLDataFoundryControlPlaneCatalogResponse = {
  created_at: string;
  name: string;
  source_system?: TLSourceSystemKey | null;
  updated_at: string;
};

export type TLCatalogPageResponse = {
  items: TLDataFoundryControlPlaneCatalogResponse[];
  next_cursor?: string | null;
};

export type TLPutCatalogRequest = {
  source_system?: TLSourceSystemKey | null;
};

export enum TLReplicationStrategy {
  full_table_load = 'full_table_load',
}
export type TLReplicationTable = {
  schema_name?: string | null;
  /** @minLength 1 */
  table_name: string;
};

export type TLReplicationGroupResponse = {
  adapter: string;
  created_at: string;
  id: string;
  schedule_dtstart?: string | null;
  schedule_enabled: boolean;
  schedule_rrule?: string | null;
  schedule_timezone?: string | null;
  strategy: TLReplicationStrategy;
  tables: TLReplicationTable[];
  updated_at: string;
};

export type TLReplicationGroupPageResponse = {
  items: TLReplicationGroupResponse[];
  next_cursor?: string | null;
};

export type TLCreateReplicationGroupRequest = {
  /** @minLength 1 */
  adapter: string;
  schedule_dtstart?: string | null;
  schedule_enabled?: boolean;
  schedule_rrule?: string | null;
  schedule_timezone?: string | null;
  strategy: TLReplicationStrategy;
  /** @minItems 1 */
  tables: TLReplicationTable[];
};

export enum TLReplicationRunStatus {
  queued = 'queued',
  running = 'running',
  succeeded = 'succeeded',
  failed = 'failed',
  cancelled = 'cancelled',
}
export type TLReplicationRunSpec = {
  adapter: string;
  source_system: TLSourceSystemKey;
  strategy: TLReplicationStrategy;
  tables: TLReplicationTable[];
};

export type TLReplicationGroupRunResponseError = { [key: string]: unknown } | null;

export type TLReplicationGroupRunResponse = {
  catalog: string;
  created_at: string;
  error?: TLReplicationGroupRunResponseError;
  finished_at?: string | null;
  id: string;
  lake: string;
  replication_group_id: string;
  spec: TLReplicationRunSpec;
  started_at?: string | null;
  status: TLReplicationRunStatus;
};

export type TLReplicationGroupRunPageResponse = {
  items: TLReplicationGroupRunResponse[];
  next_cursor?: string | null;
};

export type TLStartReplicationRunRequest = {
  /** @minLength 1 */
  connection_id: string;
  /** @minLength 1 */
  credential_id: string;
};

export type TLStartReplicationRunResponse = {
  run_id: string;
  status: TLReplicationRunStatus;
};

export type TLReplicationTableRunResponseError = { [key: string]: unknown } | null;

export type TLReplicationTableRunResponse = {
  created_at: string;
  error?: TLReplicationTableRunResponseError;
  finished_at?: string | null;
  id: string;
  started_at?: string | null;
  status: TLReplicationRunStatus;
  table_name: string;
  workflow_id: string;
  workflow_run_id?: string | null;
};

export type TLReplicationTableRunPageResponse = {
  items: TLReplicationTableRunResponse[];
  next_cursor?: string | null;
};

export type TLLatestReplicationRun = {
  created_at: string;
  error?: string | null;
  failed_table_count?: number | null;
  finished_at?: string | null;
  run_id: string;
  started_at?: string | null;
  status: TLReplicationRunStatus;
};

export type TLReplicationGroupSummary = {
  adapter: string;
  latest_run?: TLLatestReplicationRun | null;
  replication_group_id: string;
  schedule_consecutive_failures?: number | null;
  schedule_dtstart?: string | null;
  schedule_enabled: boolean;
  schedule_next_run_at?: string | null;
  schedule_rrule?: string | null;
  schedule_timezone?: string | null;
  strategy: TLReplicationStrategy;
  tables: TLReplicationTable[];
};

export type TLSourceSummary = {
  created_at: string;
  replication_groups: TLReplicationGroupSummary[];
  source_name: string;
  source_system?: TLSourceSystemKey | null;
};

export type TLListSourcesResponse = {
  lake: string;
  sources: TLSourceSummary[];
};

export type TLProvisionReplicationGroupInput = {
  /** @minLength 1 */
  adapter: string;
  schedule_dtstart?: string | null;
  schedule_enabled?: boolean;
  schedule_rrule?: string | null;
  schedule_timezone?: string | null;
  strategy: TLReplicationStrategy;
  /** @minItems 1 */
  tables: TLReplicationTable[];
};

export type TLProvisionSourceRequest = {
  /** @minLength 1 */
  connection_id: string;
  /** @minLength 1 */
  credential_id: string;
  /** @minItems 1 */
  replication_groups: TLProvisionReplicationGroupInput[];
  /**
   * Catalog name in the lake
   * @minLength 1
   */
  source_name: string;
  source_system: TLSourceSystemKey;
};

export type TLProvisionedReplicationGroup = {
  replication_group_id: string;
  run_id: string;
  status: TLReplicationRunStatus;
};

export type TLProvisionSourceResponse = {
  catalog: string;
  lake: string;
  replication_groups: TLProvisionedReplicationGroup[];
};

export type TLUpdateReplicationGroupInput = {
  /** @minLength 1 */
  adapter: string;
  is_dirty?: boolean;
  replication_group_id?: string | null;
  schedule_dtstart?: string | null;
  schedule_enabled?: boolean;
  schedule_rrule?: string | null;
  schedule_timezone?: string | null;
  strategy: TLReplicationStrategy;
  /** @minItems 1 */
  tables: TLReplicationTable[];
};

export type TLUpdateSourceRequest = {
  replication_groups: TLUpdateReplicationGroupInput[];
};

export type TLUpdatedReplicationGroup = {
  action: string;
  replication_group_id: string;
};

export type TLUpdateSourceResponse = {
  replication_groups: TLUpdatedReplicationGroup[];
  source_name: string;
};

export enum TLCatalogMountSpecAdapter {
  ducklake = 'ducklake',
  erpl = 'erpl',
  hana_odbc = 'hana_odbc',
  databricks_adbc = 'databricks_adbc',
  trino_odbc = 'trino_odbc',
  oracle_odbc = 'oracle_odbc',
  jde_world_odbc = 'jde_world_odbc',
}
export type TLCatalogMountSpecOptions = { [key: string]: string };

export type TLCatalogMountSpec = {
  adapter: TLCatalogMountSpecAdapter;
  /** @minLength 1 */
  catalog_name: string;
  connector_id?: string | null;
  credential_id?: string | null;
  options?: TLCatalogMountSpecOptions;
};

export type TLExecuteQueryRequest = {
  /** Rows per chunk in the output */
  chunk_size?: number | null;
  /** Console tab this query was run from, recorded on the query history row */
  console_tab_id?: string | null;
  /** Optional catalog mounts; ERPL mounts resolve from connector IDs, HANA ODBC mounts resolve from HANA connector IDs or live options */
  custom_catalog_mounts?: TLCatalogMountSpec[];
  /**
   * SQL query to execute against DuckLake
   * @maxLength 250000
   */
  sql: string;
};

/**
 * Full result rows, present only when the result was small enough to inline
 */
export type TLQueryStatusResponseInlineRows = { [key: string]: unknown }[] | null;

export enum TLQueryStatus {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  PARTIAL = 'PARTIAL',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  UNKNOWN = 'UNKNOWN',
}
export type TLQueryStatusResponse = {
  /** Number of parquet files created */
  chunk_count?: number | null;
  /** Error message if the query failed */
  error?: string | null;
  /** Full result rows, present only when the result was small enough to inline */
  inline_rows?: TLQueryStatusResponseInlineRows;
  /** Temporal workflow ID */
  job_id: string;
  /** Cloud URI where result parquet chunks were written */
  result_path?: string | null;
  /** Total rows returned */
  row_count?: number | null;
  /** Current status of the query */
  status: TLQueryStatus;
};

export type TLFoundryQueryRunHistoryItem = {
  created_date: string;
  job_id: string;
  sql: string;
  statement_index: number;
};

export type TLPaginatedResponseFoundryQueryRunHistoryItem = {
  /** List of items */
  data: TLFoundryQueryRunHistoryItem[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLExecuteQueryBatchRequest = {
  /** Rows per chunk in each step output */
  chunk_size?: number | null;
  /** Console tab this batch was run from, recorded on each query history row */
  console_tab_id?: string | null;
  /** Optional catalog mounts; ERPL mounts resolve from connector IDs, HANA ODBC mounts resolve from HANA connector IDs or live options */
  custom_catalog_mounts?: TLCatalogMountSpec[];
  /**
   * Ordered SQL statements to execute. The combined statements are also capped at an aggregate byte ceiling (server-configured via DATA_FOUNDRY_MAX_BATCH_SQL_BYTES); a batch over that limit is rejected with 413 even if every individual statement is under 250,000 characters.
   * @minItems 1
   * @maxItems 100
   * @items.maxLength 250000
   */
  sql: string[];
};

export type TLQueryBatchStatusResponse = {
  /** Error message if the query failed */
  error?: string | null;
  /** Temporal workflow ID */
  job_id: string;
  /** Current status of the query batch */
  status: TLQueryStatus;
  /** Per-step query statuses */
  steps: TLQueryStatusResponse[];
};

export type TLCatalogTableEntry = {
  /** Number of columns */
  column_count?: number | null;
  /** Estimated row count */
  estimated_row_count?: number | null;
  /** Error message if replication failed */
  replication_error?: string | null;
  /** Replication status: succeeded, running, queued, failed, cancelled, or null */
  replication_status?: string | null;
  /** Catalog name */
  table_catalog?: string | null;
  /** Table name */
  table_name?: string | null;
  /** Schema name */
  table_schema?: string | null;
  /** Table type (e.g. BASE TABLE, VIEW) */
  table_type?: string | null;
};

export type TLFoundryConfigCatalogResponse = {
  /** Catalog table entries */
  tables?: TLCatalogTableEntry[];
};

export type TLQueryResultDataResponseRowsItem = { [key: string]: unknown };

export type TLQueryResultDataResponse = {
  /** Column names */
  columns?: string[];
  /** Current page */
  page?: number;
  /** Rows per page */
  page_size?: number;
  /** Result rows */
  rows?: TLQueryResultDataResponseRowsItem[];
  /** Total pages */
  total_pages?: number | null;
  /** Total rows across all chunks */
  total_row_count?: number | null;
};

export type TLFoundryExportStatusResponse = {
  /** Presigned URL of the exported file, once completed */
  download_url?: string | null;
  /** Error message if the export failed */
  error?: string | null;
  /** Filename of the exported file */
  filename?: string | null;
  /** Temporal export workflow ID */
  job_id: string;
  /** True when the export is large and the user will be notified instead of polled */
  notify_on_completion?: boolean;
  /** Rows written to the exported file */
  row_count?: number | null;
  /** Current status of the export */
  status: TLQueryStatus;
};

export enum TLFoundryExportFormat {
  csv = 'csv',
  parquet = 'parquet',
  xlsx = 'xlsx',
}
export type TLExportQueryResultRequest = {
  /** File format of the exported query result */
  export_format?: TLFoundryExportFormat;
};

export type TLFoundrySourceConfig = {
  /** Custom TSRA endpoint path on the SAP system (defaults to /sap/ztsra) */
  tsra_api_base_path?: string | null;
  /** Use HTTPS for the SAP connection (set to False for HTTP) */
  use_https?: boolean;
  [key: string]: unknown;
};

export type TLFoundrySourceResponse = {
  /** Adapter used for data access */
  adapter_name: string;
  /** Catalog name in the control plane */
  catalog_name: string;
  /** Source-specific configuration */
  config?: TLFoundrySourceConfig | null;
  /** Data connector connection ID */
  connection_id?: string | null;
  /** When this source was created */
  created_at: string;
  /** Data connector credential ID */
  credential_id?: string | null;
  /** Replication groups from the control plane */
  replication_groups?: TLReplicationGroupSummary[];
  /** Local DB record ID */
  source_id: string;
  /** Source system type */
  source_system: string;
  /** REPLICATION or LIVE_CONNECTION */
  type: string;
};

export type TLListFoundrySourcesResponse = {
  /** Lake name for the tenant */
  lake: string;
  sources?: TLFoundrySourceResponse[];
};

export enum TLAdapterName {
  TSRA = 'TSRA',
  ERPL = 'ERPL',
  DUCKLAKE = 'DUCKLAKE',
  HANA_ODBC = 'HANA_ODBC',
  DATABRICKS_ADBC = 'DATABRICKS_ADBC',
  TRINO_ODBC = 'TRINO_ODBC',
  ORACLE_ODBC = 'ORACLE_ODBC',
  JDE_WORLD_ODBC = 'JDE_WORLD_ODBC',
}
export enum TLFoundrySourceSystem {
  SAP = 'SAP',
  SAP_BW = 'SAP_BW',
  TRINO = 'TRINO',
  ORACLE_DB = 'ORACLE_DB',
  DATABRICKS = 'DATABRICKS',
  JDE = 'JDE',
}
export enum TLSourceType {
  REPLICATION = 'REPLICATION',
  LIVE_CONNECTION = 'LIVE_CONNECTION',
}
export type TLCreateFoundrySourceRequest = {
  /** Adapter used for data access */
  adapter_name: TLAdapterName;
  /** Source-specific configuration */
  config?: TLFoundrySourceConfig | null;
  /** Data connector connection ID */
  connection_id: string;
  /** Data connector credential ID */
  credential_id: string;
  /** Replication groups to provision (only for REPLICATION type) */
  replication_groups?: TLProvisionReplicationGroupInput[];
  /**
   * Catalog name for the source
   * @minLength 1
   * @maxLength 255
   */
  source_name: string;
  /** Source system type */
  source_system: TLFoundrySourceSystem;
  /** Source type: REPLICATION or LIVE_CONNECTION */
  type: TLSourceType;
};

export type TLListAvailableSourceTablesRequest = {
  /** Source config overrides (https, TSRA path) */
  config?: TLFoundrySourceConfig | null;
  /** Data connector connection ID (ADT) */
  connection_id: string;
  /** Data connector credential ID */
  credential_id: string;
  /** Keyset cursor from the previous page */
  next_cursor?: string | null;
  /** Table name prefix to search for */
  search?: string | null;
};

export type TLFoundrySourceTableItem = {
  /** Human-readable table description */
  description?: string | null;
  /** Table name in the source system */
  table: string;
};

export type TLFoundrySourceTablePage = {
  items?: TLFoundrySourceTableItem[];
  /** Opaque cursor for the next page */
  next_cursor?: string | null;
};

export type TLUpdateFoundrySourceRequest = {
  /** Adapter used for data access */
  adapter_name?: TLAdapterName | null;
  /** Source-specific configuration */
  config?: TLFoundrySourceConfig | null;
  /** Data connector connection ID */
  connection_id?: string | null;
  /** Data connector credential ID */
  credential_id?: string | null;
  /** Replication groups to reconcile (create/update/delete) */
  replication_groups?: TLUpdateReplicationGroupInput[] | null;
  /** Source type */
  type?: TLSourceType | null;
};

/**
 * Access tier a principal holds on a Data Foundry table.
 *
 * Each level is exactly one governance action (read / write / manage). The governance
 * service implies MANAGE ⇒ WRITE ⇒ READ, so a principal holds one level rather than a
 * set of actions; grout implies export from read, so there is no separate export capability.
 */
export enum TLFoundryTableAccessLevel {
  READ = 'READ',
  WRITE = 'WRITE',
  MANAGE = 'MANAGE',
}
/**
 * Where an access entry is granted. TABLE entries are direct and editable from the
 * table; the others are inherited through the governance prefix cascade (a grant on a
 * schema, catalog, or the whole lake also covers every table beneath it).
 */
export enum TLFoundryTableAccessScope {
  TABLE = 'TABLE',
  SCHEMA = 'SCHEMA',
  CATALOG = 'CATALOG',
  LAKE = 'LAKE',
}
export type TLFoundryTableAccessEntryResponse = {
  display_name?: string | null;
  expires_at?: string | null;
  grant_ids: string[];
  granted_at?: string | null;
  granted_by?: string | null;
  /** Granted on the addressed node itself (editable there) rather than inherited */
  is_direct: boolean;
  /** Strongest read/write/manage grant held; read implies export */
  level: TLFoundryTableAccessLevel;
  resource_pattern: string;
  /** Where the grant sits: the table, or a schema / catalog / the lake */
  scope: TLFoundryTableAccessScope;
  /** Keycloak user id for users, Keycloak group path (e.g. /finance) for groups */
  subject_id: string;
  subject_type: TLFoundryAccessPrincipalType;
};

export type TLFoundryTableAccessListResponse = {
  /** The caller may change this node's grants (manager, or foundry-admin break-glass) */
  can_manage: boolean;
  /** The caller may add or remove themselves as reader/writer: nobody manages the node yet and the governance policy already lets them read it */
  can_self_serve: boolean;
  catalog?: string | null;
  /** List of items */
  data: TLFoundryTableAccessEntryResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Governance resource of the addressed node, e.g. data-foundry:lake/t/catalog/c */
  resource: string;
  schema_name?: string | null;
  /** Scope of the addressed node */
  scope: TLFoundryTableAccessScope;
  table?: string | null;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Desired direct access of one principal on one node — a full replacement.
 *
 * The service converges the principal's direct grants to exactly this state (creating,
 * replacing, or revoking grants as needed), so a client edits the level or the expiry by
 * sending the whole desired row back. Export needs no field: grout implies it from read.
 */
export type TLFoundryTableAccessSetRequest = {
  expires_at?: string | null;
  level: TLFoundryTableAccessLevel;
};

/**
 * A catalog-tree node: nothing set addresses the whole lake, a table needs its schema and catalog.
 */
export type TLFoundryTableTargetRequest = {
  catalog?: string | null;
  schema_name?: string | null;
  table?: string | null;
};

/**
 * Nodes to read access for at once — a POST only because the list does not fit a query string.
 */
export type TLFoundryTableAccessBulkListRequest = {
  /**
   * @minItems 1
   * @maxItems 100
   */
  targets: TLFoundryTableTargetRequest[];
};

export type TLFoundryTableAccessCoverResponse = {
  /** The grant sits on this node itself rather than on an ancestor */
  is_direct: boolean;
  /** Index into `nodes` */
  node: number;
};

export type TLFoundryTableAccessMatrixEntryResponse = {
  /** Every requested node this entry applies to */
  covers: TLFoundryTableAccessCoverResponse[];
  display_name?: string | null;
  expires_at?: string | null;
  grant_ids: string[];
  granted_at?: string | null;
  granted_by?: string | null;
  /** Strongest read/write/manage grant held; read implies export */
  level: TLFoundryTableAccessLevel;
  resource_pattern: string;
  /** Where the grant sits: the table, or a schema / catalog / the lake */
  scope: TLFoundryTableAccessScope;
  /** Keycloak user id for users, Keycloak group path (e.g. /finance) for groups */
  subject_id: string;
  subject_type: TLFoundryAccessPrincipalType;
};

export type TLFoundryTableAccessMatrixNodeResponse = {
  /** The caller may change this node's grants (manager, or foundry-admin break-glass) */
  can_manage: boolean;
  /** The caller may add or remove themselves as reader/writer on this node */
  can_self_serve: boolean;
  catalog?: string | null;
  resource: string;
  schema_name?: string | null;
  scope: TLFoundryTableAccessScope;
  table?: string | null;
};

/**
 * Each folded grant appears once with the nodes it covers, so a lake-wide grant is one entry
 * plus an index per node — the response grows with the grants, not with grants times nodes.
 */
export type TLFoundryTableAccessBulkListResponse = {
  /** Every principal's access to any requested node, narrowest scope first, then by name */
  entries: TLFoundryTableAccessMatrixEntryResponse[];
  /** One per requested target, in request order */
  nodes: TLFoundryTableAccessMatrixNodeResponse[];
};

export type TLFoundryTableAccessBulkRevokeRequest = {
  /** @minLength 1 */
  subject_id: string;
  subject_type: TLFoundryAccessPrincipalType;
  /**
   * @minItems 1
   * @maxItems 100
   */
  targets: TLFoundryTableTargetRequest[];
};

export type TLFoundryTableAccessBulkResult = {
  catalog?: string | null;
  /** Why the action failed for this item */
  error?: string | null;
  schema_name?: string | null;
  /** Whether the action succeeded for this item */
  success: boolean;
  table?: string | null;
};

export type TLBulkActionResponseFoundryTableAccessBulkResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLFoundryTableAccessBulkResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

/**
 * The same desired access, applied to many nodes for one principal (best effort, per node).
 */
export type TLFoundryTableAccessBulkSetRequest = {
  expires_at?: string | null;
  level: TLFoundryTableAccessLevel;
  /** @minLength 1 */
  subject_id: string;
  subject_type: TLFoundryAccessPrincipalType;
  /**
   * @minItems 1
   * @maxItems 100
   */
  targets: TLFoundryTableTargetRequest[];
};

/**
 * How a change to a Data Foundry node's grants is authorized (``data_foundry_access_manage_guard``).
 *
 * OFF: only foundry-admins may change grants, anywhere — the behaviour before the guard existed.
 * SHADOW: the same gate, but every change is also evaluated against the manage guard and a
 * would-deny is logged, so a rollout can be measured (and owners seeded) before it bites.
 * ENFORCE: any Data Foundry user may open the access surfaces; a change is allowed for a manager
 * of the node (a ``manage`` grant, direct or inherited), for a foundry-admin (break-glass, logged),
 * or as self-service on a node nobody manages yet — a user formalizing read/write access the
 * brownfield policy already gives them.
 */
export enum TLFoundryAccessGuardMode {
  OFF = 'OFF',
  SHADOW = 'SHADOW',
  ENFORCE = 'ENFORCE',
}
/**
 * What the caller may do with table access at all — the UI decides which surfaces to show from this.
 */
export type TLFoundryTableAccessCapabilitiesResponse = {
  /** May open the access dialogs (foundry-admin, or any Data Foundry user under ENFORCE) */
  can_open: boolean;
  /** May search people and groups to grant to others (foundry-admin, or manages at least one node) */
  can_search_principals: boolean;
  guard_mode: TLFoundryAccessGuardMode;
};

export enum TLFoundryTableImportFormat {
  CSV = 'CSV',
  JSON = 'JSON',
  PARQUET = 'PARQUET',
  XLSX = 'XLSX',
}
export type TLFoundryTableImportRequest = {
  /** Destination catalog; must be writable (not replicated from a source system) */
  catalog?: string;
  /** File format override; inferred from the filename when omitted */
  file_format?: TLFoundryTableImportFormat | null;
  /** Excel only: create one table per visible sheet, named after the sheet, when the workbook has more than one. Off imports the first sheet into table_name */
  multi_sheet?: boolean;
  /** Replace the table if it already exists */
  overwrite?: boolean;
  /** Program id of the completed staged upload */
  program_id: string;
  /** Destination schema; created if it does not exist */
  schema_name?: string;
  /** Destination table name */
  table_name: string;
};

/**
 * Full result rows, present only when the result was small enough to inline
 */
export type TLFoundryTableImportResponseInlineRows = { [key: string]: unknown }[] | null;

/**
 * Why a sheet in an uploaded workbook produces no table.
 */
export enum TLWorkbookSheetSkipReason {
  HIDDEN = 'HIDDEN',
  VERY_HIDDEN = 'VERY_HIDDEN',
  CHART_SHEET = 'CHART_SHEET',
  DIALOG_SHEET = 'DIALOG_SHEET',
  DUPLICATE_IDENTIFIER = 'DUPLICATE_IDENTIFIER',
  EMPTY = 'EMPTY',
  NAME_IN_USE = 'NAME_IN_USE',
}
/**
 * Outcome of one sheet within a multi-sheet workbook import.
 */
export enum TLFoundryImportSheetStatus {
  PENDING = 'PENDING',
  CREATED = 'CREATED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED',
}
/**
 * What one sheet of a workbook import produced.
 */
export type TLFoundryImportSheetOutcome = {
  /** Failure message when the sheet's statement failed */
  error?: string | null;
  /** Sheet this outcome belongs to. Null when the sheet names for a job are no longer resolvable; the outcome still maps to its statement by position */
  sheet?: string | null;
  /** Why the sheet produced no table */
  skip_reason?: TLWorkbookSheetSkipReason | null;
  /** Whether the sheet produced a table */
  status: TLFoundryImportSheetStatus;
  /** Table this sheet created, when it created one */
  table_name?: string | null;
};

/**
 * Import job status, plus the per-sheet breakdown for a multi-sheet workbook.
 *
 * Single-table imports leave ``sheets`` empty and read exactly like a query status.
 */
export type TLFoundryTableImportResponse = {
  /** Number of parquet files created */
  chunk_count?: number | null;
  /** Error message if the query failed */
  error?: string | null;
  /** Full result rows, present only when the result was small enough to inline */
  inline_rows?: TLFoundryTableImportResponseInlineRows;
  /** Temporal workflow ID */
  job_id: string;
  /** Cloud URI where result parquet chunks were written */
  result_path?: string | null;
  /** Total rows returned */
  row_count?: number | null;
  /** Per-sheet outcomes; empty for single-table imports */
  sheets?: TLFoundryImportSheetOutcome[];
  /** Current status of the query */
  status: TLQueryStatus;
};

export type TLFoundryImportUploadAbortRequest = {
  /** Program id returned by upload init */
  program_id: string;
};

export type TLFoundryImportUploadAbortResponse = {
  program_id: string;
};

export type TLFoundryImportUploadCompleteRequest = {
  /** Program id returned by upload init */
  program_id: string;
};

export type TLFoundryImportUploadCompleteResponse = {
  file_size?: number | null;
  filename?: string | null;
  program_id: string;
};

export type TLFoundryImportUploadInitiateRequest = {
  /** Content type of the file */
  content_type?: string | null;
  /**
   * Total file size in bytes
   * @exclusiveMinimum 0
   */
  file_size: number;
  /** Name of the file to upload, including its extension: .csv, .tsv, .json, .jsonl, .parquet, .xlsx, or .xlsm */
  filename: string;
};

/**
 * Required headers for PUT uploads (Content-Type, Content-Disposition, etc.). Client must include these in the upload request.
 */
export type TLPutUploadInitiateHeaders = { [key: string]: string };

/**
 * Upload initiation response for PUT-based uploads.
 */
export type TLPutUploadInitiate = {
  /** Required headers for PUT uploads (Content-Type, Content-Disposition, etc.). Client must include these in the upload request. */
  headers?: TLPutUploadInitiateHeaders;
  /** The presigned URL for uploading the file */
  presigned_url: string;
  /** The created program record id */
  program_id: string;
  /** HTTP method (always PUT) */
  upload_method: 'PUT';
};

/**
 * Required form fields for POST uploads (key, policy, signature, etc.). Client must include these as form data in multipart/form-data request.
 */
export type TLPostUploadInitiateFormFields = { [key: string]: string };

/**
 * Upload initiation response for POST-based uploads.
 */
export type TLPostUploadInitiate = {
  /** Required form fields for POST uploads (key, policy, signature, etc.). Client must include these as form data in multipart/form-data request. */
  form_fields: TLPostUploadInitiateFormFields;
  /** The presigned URL for uploading the file */
  presigned_url: string;
  /** The created program record id */
  program_id: string;
  /** HTTP method (always POST) */
  upload_method: 'POST';
};

export type TLFoundryImportUploadInitiateResponse = {
  /** Presigned upload instructions for the staged import file */
  upload: TLPutUploadInitiate | TLPostUploadInitiate;
};

export type TLStreamFoundryImportUploadTableRequest = {
  file: Blob;
};

export type TLFoundryWorkbookSkippedSheet = {
  /** Sheet name as it appears in the workbook */
  name: string;
  /** Why this sheet will not become a table */
  reason: TLWorkbookSheetSkipReason;
};

export type TLFoundryWorkbookSheetsResponse = {
  program_id: string;
  /** Visible worksheet names in workbook order; an import creates one table per name */
  sheets: string[];
  /** Sheets that will not become tables, with the reason for each */
  skipped?: TLFoundryWorkbookSkippedSheet[];
};

export enum TLGovernanceGrantSubjectType {
  user = 'user',
  group = 'group',
  service = 'service',
}
export type TLGovernanceGrantResponse = {
  action: string;
  created_at: string;
  created_by: string;
  expires_at?: string | null;
  id: string;
  namespace: string;
  resource_pattern: string;
  subject_id: string;
  subject_type: TLGovernanceGrantSubjectType;
  tenant_id: string;
};

export type TLGovernanceGrantListResponse = {
  grants: TLGovernanceGrantResponse[];
  has_more: boolean;
  limit: number;
  offset: number;
};

/**
 * Create a grant in the caller's tenant.
 *
 * Deliberately carries no tenant_id and no created_by — both are stamped
 * server-side from the request's tenant context and authenticated user.
 * extra="forbid" makes a payload that tries to set them (e.g. a cross-tenant
 * tenant_id) fail loudly with a 422 instead of being silently dropped.
 */
export type TLGovernanceGrantCreateRequest = {
  /** @minLength 1 */
  action: string;
  expires_at?: string | null;
  /** @minLength 1 */
  namespace: string;
  /** @minLength 1 */
  resource_pattern: string;
  /** @minLength 1 */
  subject_id: string;
  subject_type: TLGovernanceGrantSubjectType;
};

export enum TLPriority {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}
export enum TLReviewDecision {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
export enum TLHanaViewStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  READY_FOR_REVIEW = 'READY_FOR_REVIEW',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
}
export enum TLHanaViewType {
  CALCULATION_VIEW = 'CALCULATION_VIEW',
  ATTRIBUTE_VIEW = 'ATTRIBUTE_VIEW',
  ANALYTIC_VIEW = 'ANALYTIC_VIEW',
  PROCEDURE = 'PROCEDURE',
}
export enum TLWritebackStatus {
  PENDING = 'PENDING',
  SAVED_TO_SAP = 'SAVED_TO_SAP',
  FAILED = 'FAILED',
}
export type TLHanaViewTargetSummary = {
  id: string;
  target_view_name: string;
  target_view_type: TLHanaViewType;
  writeback_error?: string | null;
  writeback_status: TLWritebackStatus;
};

export type TLHanaViewResponse = {
  assigned_at?: string | null;
  assigned_by?: string | null;
  assigned_note?: string | null;
  assigned_to?: string | null;
  connection_id?: string | null;
  connector_name?: string | null;
  created_by: string;
  created_date: string;
  description: string | null;
  id: string;
  package: string | null;
  priority: TLPriority;
  program_id: string | null;
  review_decision?: TLReviewDecision | null;
  review_due_date?: string | null;
  review_priority_note?: string | null;
  review_rejection_reason?: string | null;
  reviewer_email?: string | null;
  status: TLHanaViewStatus;
  tags: string[] | null;
  /** Total number of remediated targets for this view. */
  target_count?: number;
  /** First 5 remediated targets; the full set is served by GET /hana-views/{view_id}/targets. */
  targets?: TLHanaViewTargetSummary[];
  updated_by: string;
  updated_date: string;
  view_name: string;
  view_type: TLHanaViewType;
};

export type TLPaginatedResponseHanaViewResponse = {
  /** List of items */
  data: TLHanaViewResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLHanaViewBulkAssignmentRequest = {
  /**
   * Email of the user to assign all views to.
   * @minLength 1
   */
  assigned_email: string;
  /** Optional free-text note attached to each assignment. */
  notes?: string | null;
  /**
   * IDs of views to assign.
   * @minItems 1
   * @maxItems 500
   */
  view_ids: string[];
};

export type TLHanaViewBulkAssignmentResponse = {
  /** Number of views successfully assigned. */
  assigned_count: number;
  /** View IDs that were not assigned: either not found, or not in an assignable status (OPEN/IN_PROGRESS). */
  failed_view_ids: string[];
};

export type TLBulkUploadRemediatedHanaViewsRequest = {
  /** CSV/XLSX mapping of source view → target view. */
  mapping_file: Blob;
  /** Zip archive of remediated view files (matched by basename). */
  views_zip: Blob;
};

export type TLHanaViewBulkUploadResponse = {
  job_id: string;
  rows_submitted: number;
};

export enum TLBulkUploadFailureReason {
  duplicate_source_row = 'duplicate_source_row',
  duplicate_target_row = 'duplicate_target_row',
  duplicate_target_for_source = 'duplicate_target_for_source',
  too_many_targets = 'too_many_targets',
  target_already_saved = 'target_already_saved',
  zip_entry_unresolved = 'zip_entry_unresolved',
  view_file_too_large = 'view_file_too_large',
  view_file_not_utf8 = 'view_file_not_utf8',
  view_xml_malformed = 'view_xml_malformed',
  source_not_found = 'source_not_found',
  source_wrong_status = 'source_wrong_status',
  source_no_program = 'source_no_program',
  target_collision = 'target_collision',
  processing_failed = 'processing_failed',
  mapping_file_invalid = 'mapping_file_invalid',
  archive_invalid = 'archive_invalid',
}
/**
 * A single failed mapping row, surfaced in the job's error_details.
 */
export type TLBulkRowError = {
  error: string;
  package: string;
  reason_code?: TLBulkUploadFailureReason | null;
  source_view_name: string;
};

export enum TLHanaViewSetupStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  PARTIAL_FAILURE = 'PARTIAL_FAILURE',
  FAILED = 'FAILED',
}
export type TLHanaViewBulkUploadJobStatusResponse = {
  created_by: string;
  created_date: string;
  error_details: TLBulkRowError[] | null;
  failure_count: number;
  job_id: string;
  status: TLHanaViewSetupStatus;
  success_count: number;
  total_count: number;
  updated_date: string;
};

export type TLHanaViewBulkWriteBackRequest = {
  /**
   * IDs of APPROVED views to write back to SAP (deduplicated; ≤50).
   * @minItems 1
   * @maxItems 50
   */
  view_ids: string[];
};

export type TLHanaViewBulkWriteBackSubmitResponse = {
  /** Background job id; poll the job-status endpoint for progress. */
  job_id: string;
  /** Number of distinct views accepted for write-back. */
  submitted_count: number;
};

export enum TLWriteBackOutcome {
  PUBLISHED = 'PUBLISHED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED',
}
export enum TLWriteBackSkipReason {
  not_approved = 'not_approved',
  not_assignee = 'not_assignee',
  missing_package = 'missing_package',
  missing_connection = 'missing_connection',
  target_collision = 'target_collision',
  intra_batch_collision = 'intra_batch_collision',
  no_credential_mapped = 'no_credential_mapped',
  not_found = 'not_found',
  no_targets = 'no_targets',
}
export type TLWriteBackRowError = {
  error: string;
  outcome: TLWriteBackOutcome;
  skip_reason?: TLWriteBackSkipReason | null;
  view_id: string;
  view_name: string;
};

export type TLHanaViewWriteBackJobStatusResponse = {
  created_by: string;
  created_date: string;
  /** Per-view reasons for failed and skipped views. */
  error_details?: TLWriteBackRowError[] | null;
  /** Views whose SAP write-back was attempted but failed. */
  failed_count: number;
  job_id: string;
  /** Views whose SAP write-back succeeded. */
  published_count: number;
  /** Views rejected by a pre-check without a SAP write attempt. */
  skipped_count: number;
  status: TLHanaViewSetupStatus;
  total_count: number;
  updated_date: string;
};

export type TLHanaViewImportRequest = {
  /** HANA Connections row used to authenticate. */
  connection_id: string;
  /** HANA ConnectorCredentials row used to authenticate. */
  credential_id: string;
  /** Optional human-readable description. If omitted, the value of `<descriptions defaultDescription=...>` from the SAP-fetched XML is used. */
  description?: string | null;
  /**
   * HANA PACKAGE_ID containing the artifact, e.g. 'Models'.
   * @minLength 1
   */
  package: string;
  /** Remediation priority: CRITICAL / HIGH / MEDIUM / LOW. Defaults to MEDIUM. */
  priority?: TLPriority;
  /** Optional list of tags (≤10 tags, ≤50 chars each) */
  tags?: string[] | null;
  /**
   * HANA OBJECT_NAME of the artifact. This is both the user-facing label and the SAP-side identifier — write-back will target SAP using this exact name.
   * @minLength 1
   */
  view_name: string;
  /** CALCULATION_VIEW / ANALYTIC_VIEW / ATTRIBUTE_VIEW */
  view_type: TLHanaViewType;
};

export type TLHanaViewBulkApprovalRequest = {
  /**
   * IDs of views whose pending reviews should be approved.
   * @minItems 1
   * @maxItems 500
   */
  view_ids: string[];
};

export type TLHanaViewBulkApprovalResponse = {
  /** Number of views successfully approved. */
  approved_count: number;
  /** View IDs skipped because they had no pending review or the caller is not the assigned reviewer. */
  failed_view_ids: string[];
};

export type TLHanaViewBulkReviewRequest = {
  /** Optional deadline for the reviewer to decide. */
  due_date?: string | null;
  /** Optional context shown to the reviewer for each view. */
  priority_note?: string | null;
  /**
   * Email of the user to assign as reviewer for all views.
   * @minLength 1
   */
  reviewer_email: string;
  /**
   * IDs of views to submit for review.
   * @minItems 1
   * @maxItems 500
   */
  view_ids: string[];
};

export type TLHanaViewBulkReviewResponse = {
  /** View IDs skipped because they were not found, are already APPROVED/COMPLETED, or have no remediated target to review. */
  failed_view_ids: string[];
  /** Number of views successfully submitted for review. */
  submitted_count: number;
};

export enum TLHanaArtifactSuffix {
  calculationview = 'calculationview',
  analyticview = 'analyticview',
  attributeview = 'attributeview',
  procedure = 'procedure',
}
export type TLSapRepositoryViewResponse = {
  /** HANA OBJECT_NAME of the artifact. Pass this back as view_name to /views/import. */
  id: string;
  /** HANA PACKAGE_ID containing the artifact. */
  package?: string | null;
  /** HANA OBJECT_NAME (same value as id). */
  view_name: string;
  /** calculationview / analyticview / attributeview */
  view_type: TLHanaArtifactSuffix;
};

export type TLHanaViewSetupRequest = {
  connection_id: string;
  credential_id: string;
  program_id: string;
};

export type TLHanaViewSetupResponse = {
  job_id: string;
  rows_submitted: number;
};

export enum TLSetupImportFailureReason {
  not_found_in_sap = 'not_found_in_sap',
  sap_auth_failed = 'sap_auth_failed',
  sap_connection_failed = 'sap_connection_failed',
  sap_read_failed = 'sap_read_failed',
  import_failed = 'import_failed',
  setup_file_invalid = 'setup_file_invalid',
  workflow_start_failed = 'workflow_start_failed',
}
export type TLRowImportError = {
  error: string;
  package: string;
  reason_code?: TLSetupImportFailureReason | null;
  view_name: string;
};

export type TLHanaViewSetupJobStatusResponse = {
  created_by: string;
  created_date: string;
  error_details: TLRowImportError[] | null;
  failure_count: number;
  job_id: string;
  status: TLHanaViewSetupStatus;
  success_count: number;
  total_count: number;
  truncated_count: number;
  updated_date: string;
};

export type TLHanaViewUploadRequest = {
  /** HANA Connections row to tie this view to. Required for write-back to SAP. */
  connection_id: string;
  /** Optional human-readable description. If omitted, the value of `<descriptions defaultDescription=...>` from the view XML is used. */
  description?: string | null;
  /**
   * HANA package in dot-notation, e.g. 'mycompany.views'
   * @minLength 1
   */
  package: string;
  /** Remediation priority: CRITICAL / HIGH / MEDIUM / LOW. Defaults to MEDIUM. */
  priority?: TLPriority;
  /** ID of the previously uploaded program holding the XML. */
  program_id: string;
  /** Optional list of tags (≤10 tags, ≤50 chars each) */
  tags?: string[] | null;
  /**
   * View name, e.g. CV_MSTRPROJACTCOST
   * @minLength 1
   */
  view_name: string;
  /** CALCULATION_VIEW / ANALYTIC_VIEW / ATTRIBUTE_VIEW */
  view_type: TLHanaViewType;
};

export type TLHanaViewUpdateRequest = {
  /** Human-readable description. */
  description?: string | null;
  /** HANA PACKAGE_ID (dot-notation). */
  package?: string | null;
  /** CRITICAL / HIGH / MEDIUM / LOW. */
  priority?: TLPriority | null;
  /** Replaces the whole tag set (≤10 tags, ≤50 chars each). Entries are trimmed and de-duplicated server-side. */
  tags?: string[] | null;
  /** View display name. Trimmed; must be non-empty when present. */
  view_name?: string | null;
  /** CALCULATION_VIEW / ANALYTIC_VIEW / ATTRIBUTE_VIEW. */
  view_type?: TLHanaViewType | null;
};

export enum TLAuditAction {
  IMPORTED = 'IMPORTED',
  ASSIGNED = 'ASSIGNED',
  REASSIGNED = 'REASSIGNED',
  SUBMITTED_FOR_REVIEW = 'SUBMITTED_FOR_REVIEW',
  REVIEWER_REASSIGNED = 'REVIEWER_REASSIGNED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  STATUS_CHANGED = 'STATUS_CHANGED',
  SAVED_TO_SAP = 'SAVED_TO_SAP',
  BULK_REMEDIATED_UPLOAD = 'BULK_REMEDIATED_UPLOAD',
  SAVE_TO_SAP_FAILED = 'SAVE_TO_SAP_FAILED',
  SAVE_TO_SAP_SKIPPED = 'SAVE_TO_SAP_SKIPPED',
  WORKFLOW_EXECUTED = 'WORKFLOW_EXECUTED',
  TARGET_UPDATED = 'TARGET_UPDATED',
  PUBLISH_REQUESTED = 'PUBLISH_REQUESTED',
}
export type TLViewAuditLogEntryResponseDetails = { [key: string]: unknown } | null;

export type TLViewAuditLogEntryResponse = {
  action: TLAuditAction;
  actor_email: string;
  details?: TLViewAuditLogEntryResponseDetails;
  id: string;
  timestamp: string;
  view_id: string;
};

export type TLViewActivityResponse = {
  entries: TLViewAuditLogEntryResponse[];
  page: number;
  page_size: number;
  total: number;
  total_pages: number;
};

export type TLHanaViewAssignmentRequest = {
  /**
   * Email of the user to assign this view to.
   * @minLength 1
   */
  assigned_email: string;
  /** Optional free-text note attached to this assignment. */
  notes?: string | null;
};

export type TLDagEdge = {
  id: string;
  source: string;
  target: string;
};

export type TLDagMetadata = {
  edgeCount: number;
  nodeCount: number;
  viewName: string;
  viewType: string;
};

export type TLDagLogicalModelAttribute = {
  dataType?: string | null;
  formula?: string | null;
  isCalculated: boolean;
  isHidden: boolean;
  name: string;
};

export type TLDagFieldEntry = {
  aggregationType?: string | null;
  dataType?: string | null;
  fieldType?: string | null;
  formula?: string | null;
  isAggregation?: boolean | null;
  isCalculated: boolean;
  isHidden: boolean;
  name: string;
  source?: string | null;
  sourceName?: string | null;
  [key: string]: unknown;
};

export type TLDagJoinKeyEntry = {
  leftField: string;
  rightField: string;
};

export type TLDagJoinSideField = {
  isHidden: boolean;
  name: string;
  targetName?: string | null;
};

export type TLDagLogicalModelMeasure = {
  aggregationType?: string | null;
  isHidden: boolean;
  name: string;
};

export type TLDagNodeData = {
  attributes?: TLDagLogicalModelAttribute[] | null;
  cardinality?: string | null;
  datasourceType?: string | null;
  fields?: TLDagFieldEntry[];
  filterExpression?: string | null;
  fullId: string;
  hasFilter?: boolean;
  joinKeys?: TLDagJoinKeyEntry[] | null;
  joinType?: string | null;
  label: string;
  leftFields?: TLDagJoinSideField[] | null;
  measures?: TLDagLogicalModelMeasure[] | null;
  nodeType: string;
  resourceUri?: string | null;
  rightFields?: TLDagJoinSideField[] | null;
  schemaName?: string | null;
  tableName?: string | null;
  [key: string]: unknown;
};

export type TLDagNode = {
  data: TLDagNodeData;
  id: string;
};

export type TLCalculationViewDag = {
  edges: TLDagEdge[];
  metadata: TLDagMetadata;
  nodes: TLDagNode[];
};

export type TLProcedureSqlResponse = {
  /** The procedure body SQL (the <definition> element). */
  definition?: string | null;
  /** The procedure header SQL (the <header> element), if present. */
  header?: string | null;
  /** Local table-type declarations (the <localTableType> element), if present. */
  local_table_type?: string | null;
  /** Resolved version that was returned, if known. */
  version?: string | null;
};

export type TLUploadRemediatedHanaViewXmlRequest = {
  /** Remediated view XML to store as the latest program version. */
  file: Blob;
};

export type TLHanaViewReviewerAssignmentRequest = {
  /** Optional deadline for the reviewer to decide. */
  due_date?: string | null;
  /** Optional context shown to the reviewer. */
  priority_note?: string | null;
  /**
   * Email of the user to assign as reviewer.
   * @minLength 1
   */
  reviewer_email: string;
};

export type TLHanaViewReviewRejectRequest = {
  /**
   * Required reason explaining why the review is being rejected.
   * @minLength 1
   * @maxLength 5000
   */
  rejection_reason: string;
};

export type TLHanaViewTargetResponse = {
  /** Bulk job that last touched this target, if any. */
  bulk_job_id?: string | null;
  created_by: string;
  created_date: string;
  id: string;
  /** Program holding this target's remediated XML (versioned). */
  program_id: string;
  /** SAP artifact name this target will be written back under. */
  target_view_name: string;
  target_view_type: TLHanaViewType;
  updated_by: string;
  updated_date: string;
  writeback_attempted_at?: string | null;
  writeback_error?: string | null;
  writeback_status: TLWritebackStatus;
};

export type TLPaginatedResponseHanaViewTargetResponse = {
  /** List of items */
  data: TLHanaViewTargetResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLHanaViewVersionResponse = {
  /** Email of the user who created this version, if known. */
  created_by?: string | null;
  created_date: string;
  /** File type/suffix recorded for this version (e.g. 'calculationview'). */
  file_type?: string | null;
  /** Filename recorded for this version — reflects the target name after a remediated rename. */
  filename?: string | null;
  /** True if this is the most recent version. */
  latest: boolean;
  /** Version string, e.g. '1.0' for the original. */
  version: string;
};

export type TLPaginatedResponseHanaViewVersionResponse = {
  /** List of items */
  data: TLHanaViewVersionResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLHanaViewXmlResponse = {
  /** Resolved version that was returned, if known. */
  version?: string | null;
  /** Raw artifact XML for the requested version. */
  xml: string;
};

export type TLHanaViewTargetXmlUpdateRequest = {
  /**
   * Full remediated XML for this target; saved as a new version of the target's program.
   * @minLength 1
   * @maxLength 10485760
   */
  xml: string;
};

export type TLListJobsResponse = {
  jobs: string[];
};

export type TLJobScheduleResponse = {
  cron_expression: string;
  job_name: string;
  last_run_at: string | null;
  last_run_id: string | null;
  next_run_at: string | null;
  paused: boolean;
  timezone: string;
};

export type TLPaginatedResponseJobScheduleResponse = {
  /** List of items */
  data: TLJobScheduleResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Mirrors Temporal's ``WorkflowExecutionStatus`` members.
 */
export enum TLJobRunStatus {
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  TERMINATED = 'TERMINATED',
  CONTINUED_AS_NEW = 'CONTINUED_AS_NEW',
  TIMED_OUT = 'TIMED_OUT',
}
/**
 * How a job run was started.
 */
export enum TLJobRunTrigger {
  SCHEDULED = 'SCHEDULED',
  MANUAL = 'MANUAL',
}
export type TLJobRunResponse = {
  completed_at: string | null;
  run_id: string;
  started_at: string;
  status: TLJobRunStatus;
  trigger: TLJobRunTrigger;
};

export type TLPaginatedResponseJobRunResponse = {
  /** List of items */
  data: TLJobRunResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLJobRunDetailResponse = {
  completed_at: string | null;
  error_message?: string | null;
  result?: unknown | null;
  run_id: string;
  started_at: string;
  status: TLJobRunStatus;
  trigger: TLJobRunTrigger;
};

export type TLTriggerJobResponse = {
  job_name: string;
  status: string;
  workflow_id: string;
};

/**
 * Exactly one of document_ids (docs already in a package) or program_ids
 * (freshly uploaded files, upload-first create flow) must be provided.
 */
export type TLKbAiPrefillRequest = {
  document_ids?: string[] | null;
  program_ids?: string[] | null;
};

export enum TLKbAiPrefillFailureReason {
  TIMEOUT = 'TIMEOUT',
  LLM_ERROR = 'LLM_ERROR',
  UNPARSEABLE_RESPONSE = 'UNPARSEABLE_RESPONSE',
  NO_TEXT_AVAILABLE = 'NO_TEXT_AVAILABLE',
  EXTRACTION_FAILED = 'EXTRACTION_FAILED',
}
export type TLKbAiPrefillResponse = {
  confidence?: number | null;
  description?: string | null;
  documents_total?: number;
  documents_used?: number;
  failure_reason?: TLKbAiPrefillFailureReason | null;
  generated: boolean;
  name?: string | null;
  skipped_documents?: string[];
  tags?: string[];
  topic_id?: string | null;
  topic_name?: string | null;
};

export enum TLKbDocumentStatus {
  DRAFT = 'DRAFT',
  PENDING_REVIEW = 'PENDING_REVIEW',
  APPROVED = 'APPROVED',
  LIVE = 'LIVE',
  REJECTED = 'REJECTED',
  FAILED = 'FAILED',
}
export enum TLKbReviewDecision {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
/**
 * Same shape as the business model; distinct name keeps the orval schema stable.
 */
export type TLPackageReviewerResponse = {
  decided_at: string | null;
  decision: TLKbReviewDecision | null;
  reason: string | null;
  reviewer_email: string;
};

export enum TLKbDocumentSourceType {
  UPLOAD = 'UPLOAD',
  CHAT = 'CHAT',
  CONNECTOR = 'CONNECTOR',
  NEXUS_PROJECT = 'NEXUS_PROJECT',
  SCHEMA_SYNC = 'SCHEMA_SYNC',
}
export type TLKbDocumentListItemResponse = {
  assigned_to: string | null;
  created_by: string | null;
  created_date: string;
  description: string | null;
  document_id: string;
  document_name: string;
  file_size: number | null;
  filename: string;
  grandfathered: boolean;
  last_approved_at: string | null;
  package_id: string | null;
  package_name: string | null;
  program_id: string;
  reviewers: TLPackageReviewerResponse[];
  source_label: string | null;
  source_type: TLKbDocumentSourceType | null;
  status: TLKbDocumentStatus;
  tags: string[];
  topic_id: string | null;
  topic_name: string | null;
  updated_date: string;
};

export type TLPaginatedResponseKbDocumentListItemResponse = {
  /** List of items */
  data: TLKbDocumentListItemResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Counts by effective document status, for the Files table header chips.
 */
export type TLKbDocumentStatsResponse = {
  counts?: Partial<Record<TLKbDocumentStatus, number>>;
  total: number;
};

/**
 * A member document inlined under its package row.
 */
export type TLKbTopLevelChildResponse = {
  assigned_to: string | null;
  document_id: string;
  file_size: number | null;
  name: string;
  package_id: string;
  program_id: string;
  status: TLKbDocumentStatus;
  tags: string[];
  updated_date: string;
};

export enum TLKbTopLevelItemKind {
  PACKAGE = 'PACKAGE',
  DOCUMENT = 'DOCUMENT',
}
/**
 * One top-level row of the Files view: an expandable package or a loose document.
 */
export type TLKbTopLevelItemResponse = {
  assigned_to: string | null;
  children?: TLKbTopLevelChildResponse[];
  file_count: number;
  item_id: string;
  kind: TLKbTopLevelItemKind;
  name: string;
  program_id: string | null;
  reviewers: TLPackageReviewerResponse[];
  status: TLKbDocumentStatus;
  tags: string[];
  topic_id: string | null;
  topic_name: string | null;
  total_size: number | null;
  updated_date: string;
};

export type TLPaginatedResponseKbTopLevelItemResponse = {
  /** List of items */
  data: TLKbTopLevelItemResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export enum TLArchiveMemberSkipReason {
  IGNORED_METADATA = 'IGNORED_METADATA',
  NESTED_ARCHIVE = 'NESTED_ARCHIVE',
  UNSUPPORTED_FILE_TYPE = 'UNSUPPORTED_FILE_TYPE',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
}
export type TLKbArchiveSkippedMember = {
  name: string;
  reason: TLArchiveMemberSkipReason;
};

export type TLKbArchiveManifestResponse = {
  filename: string;
  skipped?: TLKbArchiveSkippedMember[];
  supported?: string[];
};

export type TLKbDocumentSourceResponse = {
  expires_in_seconds: number;
  filename: string;
  mime_type: string;
  url: string;
};

export type TLKbExternalSourceEntryStatus = {
  can_import: boolean;
  can_retry: boolean;
  external: boolean;
};

export enum TLKbPackagePriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}
export type TLKbExternalSourceImportRequest = {
  assigned_to?: string | null;
  connection_id: string;
  description?: string | null;
  package_id?: string | null;
  package_name?: string | null;
  priority?: TLKbPackagePriority;
  program_ids?: string[] | null;
  resource_ids?: string[] | null;
  tags?: string[] | null;
  topic_id?: string | null;
};

export type TLKbExternalSourceImportResult = {
  document_id?: string | null;
  error?: string | null;
  filename: string;
  resource_id: string;
};

export type TLKbExternalSourceImportResponse = {
  package_id: string | null;
  publishing: boolean;
  results: TLKbExternalSourceImportResult[];
};

export enum TLKbDocumentSourceProvider {
  SHAREPOINT = 'SHAREPOINT',
  GOOGLE_DRIVE = 'GOOGLE_DRIVE',
}
export type TLExternalSourceConnection = {
  connection_id: string;
  directory_id?: string | null;
  hosted_domain?: string | null;
  name: string;
  provider: TLKbDocumentSourceProvider;
};

export enum TLKbExternalSourceUnavailableReason {
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  COMPENDIUM_AUTHORING = 'COMPENDIUM_AUTHORING',
}
export type TLKbExternalSourceCatalog = {
  available: boolean;
  connections: TLExternalSourceConnection[];
  unavailable_reason?: TLKbExternalSourceUnavailableReason | null;
};

export type TLKbExternalSourceConnectResponse = {
  url: string;
};

export enum TLExternalSourceItemKind {
  FOLDER = 'FOLDER',
  FILE = 'FILE',
}
export type TLExternalSourceItem = {
  kind: TLExternalSourceItemKind;
  mime_type?: string | null;
  name: string;
  path: string;
  resource_id: string;
  size?: number | null;
};

export type TLKbExternalSourcePage = {
  items: TLExternalSourceItem[];
  next_cursor?: string | null;
};

export type TLKbExternalSourceStageRequest = {
  /**
   * @minItems 1
   * @maxItems 1000
   */
  resource_ids: string[];
};

export type TLKbExternalSourceStagedFile = {
  error?: string | null;
  filename: string;
  path: string;
  program_id?: string | null;
  resource_id: string;
};

export type TLKbExternalSourceStageResponse = {
  files: TLKbExternalSourceStagedFile[];
};

export type TLKbExternalSourceConnectionStatus = {
  connected: boolean;
  provider: TLKbDocumentSourceProvider;
};

export enum TLKbPackageStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
export enum TLKbEmbeddingStatus {
  EMBEDDING_IN_PROGRESS = 'EMBEDDING_IN_PROGRESS',
  EMBEDDING_FAILED = 'EMBEDDING_FAILED',
  EMBEDDING_COMPLETE = 'EMBEDDING_COMPLETE',
  TRANSFER_IN_PROGRESS = 'TRANSFER_IN_PROGRESS',
  TRANSFER_FAILED = 'TRANSFER_FAILED',
  CLEANUP_IN_PROGRESS = 'CLEANUP_IN_PROGRESS',
  CLEANUP_FAILED = 'CLEANUP_FAILED',
}
export type TLPackageResponse = {
  ai_summary: string | null;
  assigned_to: string | null;
  created_by: string;
  created_date: string;
  description: string | null;
  document_count: number;
  embedding_status: TLKbEmbeddingStatus | null;
  package_id: string;
  package_name: string;
  priority: TLKbPackagePriority;
  reviewers: TLPackageReviewerResponse[];
  stage: TLKbPackageStage;
  status: TLKbPackageStatus | null;
  tags: string[] | null;
  topic_id: string;
  total_file_size: number | null;
  updated_by: string | null;
  updated_date: string;
};

export type TLPaginatedResponsePackageResponse = {
  /** List of items */
  data: TLPackageResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLCreatePackageRequest = {
  assigned_to?: string | null;
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  package_name: string;
  priority?: TLKbPackagePriority;
  /** Uploaded files to attach on creation (upload-first flow) */
  program_ids?: string[] | null;
  /** Reviewer emails; deduplicated, package owner not allowed */
  reviewers?: string[] | null;
  tags?: string[] | null;
  topic_id: string;
};

export type TLPackageStatsResponse = {
  draft: number;
  embedded: number;
  in_review: number;
  pending_review: number;
  total: number;
};

export type TLDocumentResponse = {
  ai_summary: string | null;
  chunks: number | null;
  created_date: string;
  document_id: string;
  file_size: number | null;
  filename: string;
  package_id: string;
  program_id: string;
  updated_date: string;
};

export type TLWikiDocumentStatusCountsResponse = {
  excluded?: number;
  failed?: number;
  incorporated?: number;
  partially_incorporated?: number;
  pending?: number;
  untracked?: number;
};

export enum TLKbSynthesisStatus {
  SYNTHESIS_IN_PROGRESS = 'SYNTHESIS_IN_PROGRESS',
  SYNTHESIS_COMPLETE = 'SYNTHESIS_COMPLETE',
  SYNTHESIS_PARTIAL = 'SYNTHESIS_PARTIAL',
  SYNTHESIS_FAILED = 'SYNTHESIS_FAILED',
}
export type TLTopicResponse = {
  created_by: string;
  created_date: string;
  default_reviewers?: string[] | null;
  description: string | null;
  partition: string;
  topic_id: string;
  topic_name: string;
  updated_by: string | null;
  updated_date: string;
  wiki_document_status_counts?: TLWikiDocumentStatusCountsResponse | null;
  wiki_synthesis_status?: TLKbSynthesisStatus | null;
};

export type TLPackageDetailResponse = {
  ai_summary: string | null;
  assigned_to: string | null;
  created_by: string;
  created_date: string;
  description: string | null;
  document_count: number;
  documents: TLDocumentResponse[];
  embedding_status: TLKbEmbeddingStatus | null;
  package_id: string;
  package_name: string;
  priority: TLKbPackagePriority;
  reviewers: TLPackageReviewerResponse[];
  stage: TLKbPackageStage;
  status: TLKbPackageStatus | null;
  tags: string[] | null;
  topic: TLTopicResponse;
  topic_id: string;
  total_file_size: number | null;
  updated_by: string | null;
  updated_date: string;
};

export type TLUpdatePackageRequest = {
  assigned_to?: string | null;
  description?: string | null;
  package_name?: string | null;
  priority?: TLKbPackagePriority | null;
  /** Replaces the working reviewer set; deduplicated, package owner not allowed */
  reviewers?: string[] | null;
  tags?: string[] | null;
  topic_id?: string | null;
};

export type TLCommentRequest = {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  comment: string;
};

export enum TLKbHistoryEventType {
  CREATED = 'CREATED',
  STAGE_CHANGE = 'STAGE_CHANGE',
  FILE_UPLOADED = 'FILE_UPLOADED',
  COMMENT = 'COMMENT',
  ASSIGNED = 'ASSIGNED',
  REVIEWERS_ASSIGNED = 'REVIEWERS_ASSIGNED',
  REVIEW_DECISION = 'REVIEW_DECISION',
  WIKI_PUBLISHED = 'WIKI_PUBLISHED',
  WIKI_VERIFIED = 'WIKI_VERIFIED',
  WIKI_FLAGGED = 'WIKI_FLAGGED',
}
export type TLHistoryEntryResponse = {
  comment: string | null;
  event_type: TLKbHistoryEventType;
  history_id: string;
  package_id: string;
  stage_from: TLKbPackageStage | null;
  stage_to: TLKbPackageStage | null;
  timestamp: string;
  user_email: string;
};

export type TLKbSendMessageRequest = {
  conversation_id: string;
  /**
   * @minLength 1
   * @maxLength 50000
   */
  message: string;
};

export type TLPaginatedResponseDocumentResponse = {
  /** List of items */
  data: TLDocumentResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLAddDocumentPackagesRequest = {
  program_id: string;
};

/**
 * Result of adding an upload: one document per file, plus any zip members that were
 * skipped (unsupported/nested/noise) so the UI can surface them without persisting them.
 */
export type TLAddDocumentResponse = {
  documents?: TLDocumentResponse[];
  skipped?: TLKbArchiveSkippedMember[];
};

export type TLPaginatedResponseHistoryEntryResponse = {
  /** List of items */
  data: TLHistoryEntryResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLRejectPackageRequest = {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  comment: string;
};

export type TLKbSearchRequest = {
  /** @minLength 1 */
  query: string;
  /**
   * @minimum 1
   * @maximum 50
   */
  top_k?: number;
};

export type TLKbSearchResult = {
  content: string;
  document_id: string;
  filename: string;
  package_id: string;
  package_name: string;
  score: number;
};

export type TLKbSearchResponse = {
  results: TLKbSearchResult[];
};

export type TLKbSuggestedPromptsResponse = {
  prompts: string[];
};

export enum TLKbDocValidationStatus {
  QUEUED = 'QUEUED',
  EXTRACTING = 'EXTRACTING',
  CHUNKING = 'CHUNKING',
  EMBEDDING = 'EMBEDDING',
  STORING = 'STORING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
}
export type TLKbValidationDocStatusResponse = {
  document_id: string;
  embedded_chunks?: number | null;
  error?: string | null;
  filename: string;
  finished_at?: string | null;
  started_at?: string | null;
  status?: TLKbDocValidationStatus | null;
  total_chunks?: number | null;
};

export type TLKbValidationStatusResponse = {
  can_retry?: boolean;
  can_retry_promotion?: boolean;
  completed_documents?: number;
  documents?: TLKbValidationDocStatusResponse[];
  embedding_status?: TLKbEmbeddingStatus | null;
  failed_documents?: number;
  package_id: string;
  total_documents?: number;
  validation_started_at?: string | null;
};

export type TLSaveConversationToKbRequest = {
  conversation_id: string;
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 500
   */
  package_name: string;
  topic_id: string;
};

export type TLSaveDocumentToKbRequest = {
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 500
   */
  package_name: string;
  program_id: string;
  topic_id: string;
};

export type TLSchemaSyncRequest = {
  auto_submit?: boolean;
  connection_id: string;
  exclude?: string[] | null;
  include?: string[] | null;
  package_id?: string | null;
  table_names?: string[] | null;
  topic_id?: string | null;
};

export enum TLSchemaSyncTriggerStatus {
  started = 'started',
  already_running = 'already_running',
}
export type TLSchemaSyncTriggerResponse = {
  connection_id: string;
  job_id: string;
  status: TLSchemaSyncTriggerStatus;
};

export type TLSchemaSyncResultResponse = {
  connection_id: string;
  connection_name: string;
  documents_created?: number;
  documents_updated?: number;
  errors?: string[];
  package_id?: string | null;
  submitted?: boolean;
  tables_discovered?: number;
  tables_failed?: number;
  tables_skipped?: number;
  tables_synced?: number;
};

export type TLTagResponse = {
  created_by: string;
  created_date: string;
  description: string | null;
  tag_id: string;
  tag_name: string;
  updated_by: string;
  updated_date: string;
};

export type TLPaginatedResponseTagResponse = {
  /** List of items */
  data: TLTagResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLCreateTagRequest = {
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  tag_name: string;
};

export type TLUpdateTagRequest = {
  description?: string | null;
  tag_name?: string | null;
};

export type TLPaginatedResponseTopicResponse = {
  /** List of items */
  data: TLTopicResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLCreateTopicRequest = {
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  topic_name: string;
};

export type TLUpdateTopicRequest = {
  default_reviewers?: string[] | null;
  description?: string | null;
  topic_name?: string | null;
};

export enum TLKbWikiLinkRel {
  PART_OF = 'PART_OF',
  RELATES_TO = 'RELATES_TO',
  SUPERSEDES = 'SUPERSEDES',
  CITES = 'CITES',
}
export type TLWikiLinkResponse = {
  from_program_id: string;
  rel: TLKbWikiLinkRel;
  to_program_id: string;
};

export enum TLKbWikiGraphNodeKind {
  PAGE = 'PAGE',
  SOURCE_DOCUMENT = 'SOURCE_DOCUMENT',
}
export enum TLKbWikiScope {
  index = 'index',
  concept = 'concept',
}
export type TLWikiGraphNodeResponse = {
  kind: TLKbWikiGraphNodeKind;
  program_id: string;
  scope?: TLKbWikiScope | null;
  title: string;
};

export type TLWikiTopicGraphSummaryResponse = {
  links: TLWikiLinkResponse[];
  nodes: TLWikiGraphNodeResponse[];
  synthesis_status?: TLKbSynthesisStatus | null;
  topic_id: string;
  topic_name: string;
  total_pages: number;
  total_sources?: number;
  truncated: boolean;
};

export type TLWikiTopicGraphListResponse = {
  data: TLWikiTopicGraphSummaryResponse[];
  total_count: number;
};

export enum TLKbWikiVerificationStatus {
  UNVERIFIED = 'UNVERIFIED',
  VERIFIED = 'VERIFIED',
  FLAGGED = 'FLAGGED',
}
export type TLWikiPageResponse = {
  content: string;
  description?: string | null;
  program_id: string;
  scope: TLKbWikiScope;
  slug: string;
  title: string;
  verification_findings?: string[] | null;
  verification_status?: TLKbWikiVerificationStatus | null;
  version?: string | null;
};

export type TLWikiSourceResponse = {
  download_url: string;
  expires_in: number;
  file_size: number | null;
  file_type: string | null;
  filename: string | null;
  program_id: string;
};

export type TLWikiTopicSummaryResponse = {
  summary: string;
  synthesis_status?: TLKbSynthesisStatus | null;
  topic_id: string;
  topic_name: string;
};

export type TLPaginatedResponseWikiTopicSummaryResponse = {
  /** List of items */
  data: TLWikiTopicSummaryResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export enum TLKbWikiDocStatus {
  INCORPORATED = 'INCORPORATED',
  PARTIALLY_INCORPORATED = 'PARTIALLY_INCORPORATED',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  EXCLUDED = 'EXCLUDED',
}
export type TLWikiDocumentStatusResponse = {
  document_id: string;
  file_size?: number | null;
  filename: string;
  package_id: string;
  program_id: string;
  updated_date: string;
  wiki_status?: TLKbWikiDocStatus | null;
};

export type TLPaginatedResponseWikiDocumentStatusResponse = {
  /** List of items */
  data: TLWikiDocumentStatusResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLWikiPageSummaryResponse = {
  description?: string | null;
  program_id: string;
  scope: TLKbWikiScope;
  slug: string;
  title: string;
  verification_status?: TLKbWikiVerificationStatus | null;
  version?: string | null;
};

export type TLWikiTopicGraphResponse = {
  documents: TLWikiDocumentStatusResponse[];
  links: TLWikiLinkResponse[];
  pages: TLWikiPageSummaryResponse[];
  total_documents: number;
  total_links: number;
  total_pages: number;
  truncated: boolean;
};

export type TLPaginatedResponseWikiLinkResponse = {
  /** List of items */
  data: TLWikiLinkResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLPaginatedResponseWikiPageSummaryResponse = {
  /** List of items */
  data: TLWikiPageSummaryResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLWikiTopicResetResponse = {
  documents_reset: number;
  pages_deleted: number;
  topic_id: string;
};

export type TLWikiSynthesisTriggerRequest = {
  /** Documents to re-synthesize; omit for a full topic rebuild */
  document_ids?: string[] | null;
};

export enum TLKbWikiTriggerOutcome {
  STARTED = 'STARTED',
  ENQUEUED = 'ENQUEUED',
}
export type TLWikiSynthesisTriggerResponse = {
  outcome: TLKbWikiTriggerOutcome;
  topic_id: string;
};

export type TLLlmModelResponse = {
  /** Input context window in tokens. */
  context_window_tokens?: number | null;
  /** Actor that created the row ('system' for reconciler-seeded). */
  created_by: string;
  /** UTC creation timestamp. */
  created_date: string;
  /** One-line descriptor. */
  description?: string | null;
  /** Operator-facing friendly name. */
  display_name: string;
  /** Max output tokens; null inherits the connection default. */
  max_output_tokens?: number | null;
  /** Wire model slug. */
  model: string;
  /** Stable catalog identity; never rotates. */
  model_id: string;
  /** Provider serving the model. */
  provider: TLLlmProvider;
  /** Ordering within the picker; lower sorts first. */
  sort_order: number;
  /** Catalog lifecycle status. */
  status: TLLlmModelStatus;
  /** False when this provider/model rejects temperature; a non-null temperature above is then ignored. */
  readonly supports_temperature: boolean;
  /** Operator-set labels. */
  tags?: string[];
  /** Sampling temperature; null inherits the connection default. */
  temperature?: number | null;
  /** Request timeout (seconds); null inherits the connection default. */
  timeout_seconds?: number | null;
  /** Actor that last updated the row ('system' for reconciler-owned). */
  updated_by: string;
  /** UTC last-updated timestamp. */
  updated_date: string;
};

export type TLLlmModelListResponse = {
  items?: TLLlmModelResponse[];
  /** Page size used for this response. */
  limit: number;
  /** Zero-based offset used for this response. */
  offset: number;
  /** Total number of entries matching the query. */
  total: number;
};

export type TLLlmModelCreateRequest = {
  /** Input context window in tokens. Required when status is ACTIVE. */
  context_window_tokens?: number | null;
  /** Optional one-line descriptor. */
  description?: string | null;
  /**
   * Operator-facing friendly name.
   * @minLength 1
   * @maxLength 500
   */
  display_name: string;
  /** Max output tokens; null inherits the connection default. */
  max_output_tokens?: number | null;
  /**
   * Wire model slug, e.g. claude-sonnet-4-6.
   * @minLength 1
   * @maxLength 100
   */
  model: string;
  /** Provider serving the model. */
  provider: TLLlmProvider;
  /** Ordering within the picker; lower sorts first. */
  sort_order?: number;
  /** Catalog lifecycle status. */
  status?: TLLlmModelStatus;
  /** Operator-set labels (e.g. fast, premium). */
  tags?: string[];
  /** Sampling temperature; null inherits the connection default. */
  temperature?: number | null;
  /** Request timeout (seconds); null inherits the connection default. */
  timeout_seconds?: number | null;
};

export type TLLlmModelUpdateRequest = {
  context_window_tokens?: number | null;
  description?: string | null;
  display_name?: string | null;
  max_output_tokens?: number | null;
  sort_order?: number | null;
  tags?: string[] | null;
  temperature?: number | null;
  timeout_seconds?: number | null;
};

export type TLLlmModelStatusUpdateRequest = {
  /** New catalog lifecycle status. */
  status: TLLlmModelStatus;
};

export enum TLUsageGranularity {
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}
export type TLCostUsageBucket = {
  /**
   * Summed cache read token cost (USD)
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  cache_read_cost: string;
  /**
   * Summed cache write token cost (USD)
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  cache_write_cost: string;
  /** Conversation type, null if not set */
  conversation_type?: TLConversationType | null;
  /** Currency for all cost fields */
  currency?: TLCurrency;
  /**
   * Summed input token cost (USD)
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  input_cost: string;
  /** LLM model name for this bucket */
  model: string;
  /**
   * Summed output token cost (USD)
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  output_cost: string;
  /** UTC bucket start timestamp */
  period_start: string;
  /** LLM provider for this bucket */
  provider: TLLlmProvider;
  /** Tenant identifier */
  tenant_id: string;
  /**
   * Summed total cost (USD)
   * @pattern ^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$
   */
  total_cost: string;
  /** Conversation owner email */
  user_id: string;
};

export type TLCostUsageTimeseriesResponse = {
  /** Aggregated cost buckets */
  buckets?: TLCostUsageBucket[];
  /** Inclusive lower bound (UTC) */
  from_date: string;
  /** Time bucket granularity */
  granularity: TLUsageGranularity;
  /** Page size used for this response */
  limit: number;
  /** Zero-based offset used for this response */
  offset: number;
  /** Exclusive upper bound (UTC) */
  to_date: string;
  /** Total number of matching buckets across all pages */
  total: number;
};

export type TLModelUsageStat = {
  /** Number of calls to this model */
  calls: number;
  /** Summed input tokens */
  input_tokens: number;
  /** Model name */
  model: string;
  /** Summed output tokens */
  output_tokens: number;
  /** LLM provider */
  provider: TLLlmProvider;
  /** Summed total tokens */
  total_tokens: number;
};

export type TLProviderUsageStat = {
  /** Number of calls to this provider */
  calls: number;
  /** LLM provider */
  provider: TLLlmProvider;
  /** Summed total tokens */
  total_tokens: number;
};

export type TLLatencyStats = {
  /** Mean call duration in ms (null if no data) */
  avg_duration_ms?: number | null;
  /** Mean time-to-first-token in ms (null if no data) */
  avg_time_to_first_token_ms?: number | null;
  /** 95th percentile call duration in ms (null if no data) */
  p95_duration_ms?: number | null;
};

export type TLReliabilityStats = {
  /** Calls with status CANCELLED */
  cancelled: number;
  /** Calls with status FAILED */
  failed: number;
  /** Calls with status SUCCESS */
  success: number;
  /** success / total_calls (null when total_calls is 0) */
  success_rate?: number | null;
  /** Total recorded calls in range */
  total_calls: number;
};

export type TLUsageMetadataResponse = {
  /** Usage broken down by model, busiest first */
  by_model?: TLModelUsageStat[];
  /** True when more models exist than the returned cap, so by_model is not exhaustive */
  by_model_truncated?: boolean;
  /** Usage broken down by provider, busiest first */
  by_provider?: TLProviderUsageStat[];
  /** Inclusive lower bound (UTC) */
  from_date: string;
  /** Latency aggregates across matching calls */
  latency: TLLatencyStats;
  /** Success / failure breakdown across matching calls */
  reliability: TLReliabilityStats;
  /** Exclusive upper bound (UTC) */
  to_date: string;
};

export type TLTokenUsageBucket = {
  /** Conversation type, null if not set */
  conversation_type?: TLConversationType | null;
  /** Summed input tokens */
  input_tokens: number;
  /** LLM model name for this bucket */
  model: string;
  /** Summed output tokens */
  output_tokens: number;
  /** UTC bucket start timestamp */
  period_start: string;
  /** LLM provider for this bucket */
  provider: TLLlmProvider;
  /** Tenant identifier */
  tenant_id: string;
  /** Summed total tokens */
  total_tokens: number;
  /** Conversation owner email */
  user_id: string;
};

export type TLTokenUsageTimeseriesResponse = {
  /** Aggregated usage buckets */
  buckets?: TLTokenUsageBucket[];
  /** Inclusive lower bound (UTC) */
  from_date: string;
  /** Time bucket granularity */
  granularity: TLUsageGranularity;
  /** Page size used for this response */
  limit: number;
  /** Zero-based offset used for this response */
  offset: number;
  /** Exclusive upper bound (UTC) */
  to_date: string;
  /** Total number of matching buckets across all pages */
  total: number;
};

export type TLChatModelOption = {
  /** Catalog cache-read cost per million tokens; null when the model is unpriced. */
  cache_read_cost_per_mtok?: string | null;
  /** Catalog cache-write cost per million tokens; null when the model is unpriced. */
  cache_write_cost_per_mtok?: string | null;
  /** Input context window from llm_models (tokens); None uses the global default. */
  context_limit?: number | null;
  /** Pricing currency; null when the model is unpriced. */
  currency?: TLCurrency | null;
  /** Operator-set one-line descriptor (llm_models.description). */
  description?: string | null;
  /** Operator-set friendly name (llm_models.display_name). */
  display_name?: string | null;
  /** Cost row id (llm_model_costs cost_id, UUID); null when the model is unpriced. Prefer `model_id` for selection. When sending a selection back, this is the `llm_model_cost_id` request field (a rollout fallback, omit it for an unpriced model). */
  id?: string | null;
  /** Catalog input cost per million tokens; null when the model is unpriced. */
  input_cost_per_mtok?: string | null;
  /** True for the model the chat agent uses when none is selected. */
  is_default: boolean;
  /** False when the model has no active cost row; unpriced models are still selectable but have null pricing and `id`. */
  is_priced: boolean;
  /** Max tokens generated per response (profile max_tokens). */
  max_output_tokens?: number | null;
  /** Underlying model identifier (e.g. 'claude-sonnet-4-6', 'gpt-5.1'). */
  model: string;
  /** Stable llm_models model_id (UUID); the catalog identity, never rotates. When sending a selection back, this is the `llm_model_id` request field (the preferred one). */
  model_id: string;
  /** Catalog output cost per million tokens; null when the model is unpriced. */
  output_cost_per_mtok?: string | null;
  /** LLM_PROFILES key serving this model. */
  profile_id: string;
  /** Provider serving the model. */
  provider: TLLlmProvider;
  /** True when the model can be picked for a new conversation. */
  selectable: boolean;
  /** Catalog lifecycle status from llm_models (ACTIVE for listed). */
  status: TLLlmModelStatus;
  /** Operator-set labels from llm_models.tags (e.g. fast, premium). */
  tags?: string[];
  /** Sampling temperature (profile temperature). */
  temperature?: number | null;
  /** Per-call timeout in seconds (profile timeout_seconds). */
  timeout_seconds?: number | null;
};

export type TLChatModelsResponse = {
  /** Stable model_id of the default chat model, if one is resolvable; send back as the `llm_model_id` request field. */
  default_id?: string | null;
  models?: TLChatModelOption[];
};

export type TLResolveModelIdentitiesRequest = {
  /**
   * Bound model ids (UUIDs) to resolve to catalog identity + lifecycle status. Each may be a stable llm_models.model_id or a legacy llm_model_costs.cost_id; resolution is catalog-first with a cost_id fallback. The `cost_ids` body key is a deprecated alias for `ids`.
   * @minItems 1
   * @maxItems 100
   */
  ids: string[];
};

export type TLResolvedModelIdentityResponse = {
  /** Operator-set friendly name from llm_models. */
  display_name: string;
  /** Underlying model identifier (e.g. 'claude-sonnet-4-6'). */
  model: string;
  /** Stable llm_models model_id (UUID); the catalog identity. */
  model_id: string;
  /** Catalog lifecycle status (ACTIVE, DEPRECATED, RETIRED). */
  status: TLLlmModelStatus;
};

/**
 * Map of each requested id to its resolved identity; ids that cannot be resolved are omitted.
 */
export type TLResolveModelIdentitiesResponseIdentities = { [key: string]: TLResolvedModelIdentityResponse };

export type TLResolveModelIdentitiesResponse = {
  /** Map of each requested id to its resolved identity; ids that cannot be resolved are omitted. */
  identities?: TLResolveModelIdentitiesResponseIdentities;
};

/**
 * One connected agent, as its own user sees it.
 *
 * `client_name` is whatever the client called itself at registration and is never verified,
 * so the UI has to present it as unverified; it is null for a client with no local
 * registration row.
 */
export type TLMcpConnectionResponse = {
  client_name: string | null;
  created_date: string;
  id: string;
  last_used_date: string | null;
};

export type TLPaginatedResponseMcpConnectionResponse = {
  /** List of items */
  data: TLMcpConnectionResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLConnectUrlResponse = {
  url: string;
};

export type TLDisconnectResponse = {
  status: string;
};

export type TLConnectionStatusResponse = {
  connected: boolean;
};

export enum TLNexusLibraryInstantiateStatus {
  PENDING = 'PENDING',
  POPULATING = 'POPULATING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
/**
 * A table the Template names that the tenant's lakehouse does not hold.
 *
 * Split rather than served as the stored ``SAP S4.VBAK`` identifier: a dot in this domain
 * reads as catalog-or-table qualification, and the system label is neither. Keeping the
 * system alongside is what makes the shortfall actionable — six tables from one system and
 * four from another names the two sources to connect, where a flat list of ten does not.
 */
export type TLNexusLibraryUnresolvedTable = {
  system?: string | null;
  table: string;
};

/**
 * One shape for both the 202 accept and every poll, per the data-upload job precedent.
 *
 * ``project_id`` is populated from the accept onward — the Mapping row is created in the
 * accepting request, so a failed job still leaves a real, inspectable, deletable Mapping
 * rather than a message with no artifact.
 */
export type TLNexusLibraryInstantiateResponse = {
  error?: string | null;
  field_mapping_count?: number;
  job_id: string;
  node_count?: number;
  progress: number;
  project_id: string;
  status: TLNexusLibraryInstantiateStatus;
  unresolved_tables?: TLNexusLibraryUnresolvedTable[];
};

export enum TLNexusLibrarySort {
  RECENT = 'RECENT',
  NAME = 'NAME',
}
/**
 * One side of a template's system pair.
 *
 * The edition is load-bearing, not decoration: both sides of the commonest template are
 * domain ``SAP``, so without it a card reads "SAP → SAP".
 */
export type TLNexusLibrarySystem = {
  domain?: TLConnectorDomain | null;
  version?: TLVersionIdentifier | null;
};

export type TLNexusLibraryTemplateResponse = {
  description: string;
  field_mapping_count: number;
  name: string;
  owner: string;
  source_system: TLNexusLibrarySystem;
  target_system: TLNexusLibrarySystem;
  template_id: string;
  transform_count: number;
  updated_date: string;
};

/**
 * A page of the Library.
 *
 * ``total_count`` is the one addition to the cursor-page shape the rest of the codebase
 * uses — the footer renders a range out of it. There is deliberately no ``prev_cursor``:
 * the client holds a page index over pages it already fetched, so stepping back never
 * reaches the server.
 */
export type TLNexusLibraryTemplatesPage = {
  items: TLNexusLibraryTemplateResponse[];
  next_cursor?: string | null;
  total_count: number;
};

export type TLNexusGraphResponseOpenThreadCounts = { [key: string]: number };

export enum TLNexusCardinality {
  '1:1' = '1:1',
  '1:N' = '1:N',
  'N:1' = 'N:1',
  'N:M' = 'N:M',
}
export enum TLNexusEdgeType {
  FOREIGN_KEY = 'FOREIGN_KEY',
  RELATED = 'RELATED',
}
export enum TLNexusSourceOrigin {
  AUTO_DETECTED = 'AUTO_DETECTED',
  AI_SUGGESTED = 'AI_SUGGESTED',
  USER_CREATED = 'USER_CREATED',
  PLATFORM_SEED = 'PLATFORM_SEED',
}
export enum TLNexusEntityStatus {
  ACTIVE = 'ACTIVE',
  REMOVED = 'REMOVED',
}
export type TLNexusEdgeResponseEvidence = { [key: string]: unknown } | null;

export type TLNexusEdgeResponseJoinSpec = { [key: string]: unknown } | null;

export type TLNexusEdgeResponseMetadata = { [key: string]: unknown } | null;

export type TLNexusEdgeResponse = {
  cardinality?: TLNexusCardinality | null;
  confidence?: number | null;
  created_by: string;
  created_date: string;
  description?: string | null;
  edge_id: string;
  edge_type: TLNexusEdgeType;
  evidence?: TLNexusEdgeResponseEvidence;
  join_spec?: TLNexusEdgeResponseJoinSpec;
  label?: string | null;
  metadata?: TLNexusEdgeResponseMetadata;
  project_id: string;
  source_node_id: string;
  source_origin: TLNexusSourceOrigin;
  status: TLNexusEntityStatus;
  target_node_id: string;
  tenant_id: string;
  updated_by: string;
  updated_date: string;
};

export enum TLNexusMappingType {
  DIRECT = 'DIRECT',
  CONCATENATION = 'CONCATENATION',
  AGGREGATION = 'AGGREGATION',
  CALCULATED = 'CALCULATED',
  SPLIT = 'SPLIT',
  CONDITIONAL = 'CONDITIONAL',
  STRUCTURAL = 'STRUCTURAL',
}
export type TLNexusFieldMappingResponseEvidence = { [key: string]: unknown } | null;

export type TLNexusFieldMappingResponseSourceFieldsItem = { [key: string]: unknown };

export type TLNexusFieldMappingResponseTransformSpec = { [key: string]: unknown } | null;

export type TLNexusFieldMappingResponse = {
  confidence?: number | null;
  created_by: string;
  created_date: string;
  edge_id?: string | null;
  evidence?: TLNexusFieldMappingResponseEvidence;
  last_match_rate?: number | null;
  last_validated_at?: string | null;
  last_validation_error?: string | null;
  mapping_id: string;
  mapping_type: TLNexusMappingType;
  project_id: string;
  source_fields: TLNexusFieldMappingResponseSourceFieldsItem[];
  source_origin: TLNexusSourceOrigin;
  status: TLNexusEntityStatus;
  target_node_id: string;
  tenant_id: string;
  transform_spec?: TLNexusFieldMappingResponseTransformSpec;
  updated_by: string;
  updated_date: string;
};

export enum TLNexusNodeType {
  TABLE = 'TABLE',
  FIELD = 'FIELD',
}
export type TLNexusNodeResponseMetadata = { [key: string]: unknown } | null;

export type TLNexusNodeResponse = {
  created_by: string;
  created_date: string;
  description?: string | null;
  identifier: string;
  label: string;
  metadata?: TLNexusNodeResponseMetadata;
  node_id: string;
  node_type: TLNexusNodeType;
  parent_node_id?: string | null;
  project_id: string;
  source_domain?: TLConnectorDomain | null;
  status: TLNexusEntityStatus;
  tenant_id: string;
  updated_by: string;
  updated_date: string;
  version_identifier?: TLVersionIdentifier | null;
};

export enum TLNexusAccessLevel {
  OWNER = 'OWNER',
  EDITOR = 'EDITOR',
  REVIEWER = 'REVIEWER',
  VIEWER = 'VIEWER',
}
export enum TLNexusSignoffStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}
export enum TLNexusProjectStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  REMOVED = 'REMOVED',
}
export enum TLNexusVisibility {
  PRIVATE = 'PRIVATE',
  SHARED = 'SHARED',
  PUBLIC = 'PUBLIC',
}
export type TLNexusProjectResponseSettings = { [key: string]: unknown } | null;

export type TLNexusProjectResponse = {
  access_level?: TLNexusAccessLevel | null;
  created_by: string;
  created_date: string;
  current_version?: number | null;
  description?: string | null;
  mapping_count?: number | null;
  name: string;
  pending_count?: number | null;
  project_id: string;
  settings?: TLNexusProjectResponseSettings;
  signoff_status?: TLNexusSignoffStatus | null;
  source_count?: number | null;
  source_system?: string | null;
  status: TLNexusProjectStatus;
  target_system?: string | null;
  tenant_id: string;
  updated_by: string;
  updated_date: string;
  visibility?: TLNexusVisibility;
};

export type TLNexusGraphResponse = {
  edge_count: number;
  edges: TLNexusEdgeResponse[];
  field_mapping_count: number;
  field_mappings: TLNexusFieldMappingResponse[];
  node_count: number;
  nodes: TLNexusNodeResponse[];
  open_thread_counts?: TLNexusGraphResponseOpenThreadCounts;
  project: TLNexusProjectResponse;
  truncated?: boolean;
};

export enum TLNexusMappingArity {
  ONE_TO_ONE = 'ONE_TO_ONE',
  MANY_TO_ONE = 'MANY_TO_ONE',
  CONSTANT = 'CONSTANT',
}
/**
 * One side of a template mapping, split so a client never parses an identifier.
 *
 * ``field`` is ``None`` when the identifier names a whole table — a STRUCTURAL row's
 * endpoints are unqualified on both sides, and calling that a field is what drops the row.
 */
export type TLNexusLibraryEndpoint = {
  field?: string | null;
  node_type: TLNexusNodeType;
  table?: string | null;
};

export type TLNexusLibraryTemplateMappingTransformSpec = { [key: string]: unknown } | null;

export type TLNexusLibraryTemplateMapping = {
  arity: TLNexusMappingArity;
  confidence?: number | null;
  mapping_id: string;
  mapping_type: TLNexusMappingType;
  source_endpoints: TLNexusLibraryEndpoint[];
  target_endpoints: TLNexusLibraryEndpoint[];
  transform_spec?: TLNexusLibraryTemplateMappingTransformSpec;
};

export type TLPaginatedResponseNexusLibraryTemplateMapping = {
  /** List of items */
  data: TLNexusLibraryTemplateMapping[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export enum TLNexusOwnershipScope {
  ALL = 'ALL',
  OWNED = 'OWNED',
  SHARED = 'SHARED',
}
export type TLPaginatedResponseNexusProjectResponse = {
  /** List of items */
  data: TLNexusProjectResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLNexusProjectCreateSettings = { [key: string]: unknown } | null;

export type TLNexusProjectCreate = {
  description?: string | null;
  /** @maxLength 200 */
  name: string;
  settings?: TLNexusProjectCreateSettings;
  source_system?: string | null;
  target_system?: string | null;
};

export type TLNexusProjectUpdateSettings = { [key: string]: unknown } | null;

export type TLNexusProjectUpdate = {
  description?: string | null;
  name?: string | null;
  settings?: TLNexusProjectUpdateSettings;
  source_system?: string | null;
  status?: TLNexusProjectStatus | null;
  target_system?: string | null;
  visibility?: TLNexusVisibility | null;
};

export enum TLNexusThreadStatus {
  OPEN = 'OPEN',
  RESOLVED = 'RESOLVED',
}
export type TLNexusCommentThreadResponse = {
  comment_count?: number;
  created_by: string;
  created_date: string;
  node_id: string;
  project_id: string;
  resolved_by?: string | null;
  resolved_date?: string | null;
  status: TLNexusThreadStatus;
  thread_id: string;
  updated_date: string;
};

export type TLPaginatedResponseNexusCommentThreadResponse = {
  /** List of items */
  data: TLNexusCommentThreadResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLNexusCommentThreadCreateRequest = {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  body: string;
  node_id: string;
};

export type TLNexusCommentResponse = {
  author: string;
  body: string | null;
  comment_id: string;
  created_date: string;
  is_deleted: boolean;
  thread_id: string;
  updated_date: string;
};

export type TLPaginatedResponseNexusCommentResponse = {
  /** List of items */
  data: TLNexusCommentResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Body for a thread reply or a comment edit — one ceiling, shared with `NexusCommentRequest`.
 */
export type TLNexusCommentBodyRequest = {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  body: string;
};

export enum TLNexusFilterBoolOp {
  AND = 'AND',
  OR = 'OR',
}
export enum TLNexusCompareOp {
  EQ = 'EQ',
  NEQ = 'NEQ',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
  IS_NULL = 'IS_NULL',
  IS_NOT_NULL = 'IS_NOT_NULL',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
}
export type TLNexusCaseCondition = {
  /** @minLength 1 */
  column: string;
  op: TLNexusCompareOp;
  /** Scalar to compare against (omit for IS_NULL/IS_NOT_NULL) */
  value?: boolean | number | string | null;
  /** Set to match for IN / NOT_IN */
  values?: (boolean | number | string | null)[] | null;
};

/**
 * Single-table column predicate on the chain's root table.
 */
export type TLNexusComparisonPredicateInput = {
  bool_op?: TLNexusFilterBoolOp;
  /** @minItems 1 */
  conditions: TLNexusCaseCondition[];
  kind?: 'COMPARISON';
};

export type TLNexusJoinKey = {
  /**
   * Column on the chain's root table
   * @minLength 1
   */
  base_column: string;
  /**
   * Column on the related table
   * @minLength 1
   */
  related_column: string;
};

/**
 * A predicate over a related table, correlated to the root ([NOT] EXISTS).
 *
 * Models the join-dependent scope layers the customer authors per row but that read
 * against another table — e.g. "keep an order header with >=1 line AWAITING_RETURN".
 */
export type TLNexusExistsPredicateInput = {
  bool_op?: TLNexusFilterBoolOp;
  conditions?: TLNexusCaseCondition[];
  /** @minItems 1 */
  join_on: TLNexusJoinKey[];
  kind?: 'EXISTS';
  negated?: boolean;
  /** @minLength 1 */
  related_table: string;
};

/**
 * A free-text scope layer the structured model can't express.
 *
 * ``executable=False`` marks business-rule prose (e.g. "must resolve to an active
 * customer account") that is recorded and shown but never compiled — so a documented
 * scope is never mistaken for an applied one.
 */
export type TLNexusRawPredicate = {
  executable?: boolean;
  /** @minLength 1 */
  expression: string;
  kind?: 'RAW';
};

export type TLNexusScopeLayerInput = {
  /**
   * @minLength 1
   * @maxLength 200
   */
  label: string;
  notes?: string | null;
  predicate: TLNexusComparisonPredicateInput | TLNexusExistsPredicateInput | TLNexusRawPredicate;
};

/**
 * An ordered funnel of scope layers that narrow a source extraction, root-first.
 *
 * Mirrors the customer's "Filter Chain": each layer narrows the surviving population
 * further, and the preview reports the in-scope volume after each one.
 */
export type TLNexusScopeChainInput = {
  layers?: TLNexusScopeLayerInput[];
};

export type TLNexusFilterPreviewRequest = {
  chain: TLNexusScopeChainInput;
  /** @minLength 1 */
  source_table: string;
};

export enum TLNexusScopePredicateKind {
  COMPARISON = 'COMPARISON',
  EXISTS = 'EXISTS',
  RAW = 'RAW',
}
export type TLNexusScopeLayerPreview = {
  executed: boolean;
  kind: TLNexusScopePredicateKind;
  label: string;
  surviving_rows?: number | null;
};

export type TLNexusFilterPreviewResponse = {
  documentation_only?: string[];
  error?: string | null;
  layers?: TLNexusScopeLayerPreview[];
  surviving_rows?: number | null;
  total_rows?: number | null;
  valid: boolean;
  where_clause?: string;
};

export type TLNexusRunQueryRequest = {
  sql: string;
};

export type TLNexusQueryResultResponse = {
  columns?: string[];
  row_count?: number;
  rows?: unknown[][];
};

export type TLNexusReuseCandidatesRequestSourceFieldsItem = { [key: string]: unknown };

export type TLNexusReuseCandidatesRequestTargetField = { [key: string]: unknown };

export type TLNexusReuseCandidatesRequest = {
  /**
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
  /** @maxItems 50 */
  source_fields: TLNexusReuseCandidatesRequestSourceFieldsItem[];
  target_field: TLNexusReuseCandidatesRequestTargetField;
};

export enum TLNexusMappingKind {
  SCHEMA_FIELD = 'SCHEMA_FIELD',
  CODE = 'CODE',
  CONFIG = 'CONFIG',
  API = 'API',
  PROCESS = 'PROCESS',
}
export type TLNexusReuseCandidateSourceEndpointsItem = { [key: string]: unknown };

export type TLNexusReuseCandidateTargetEndpointsItem = { [key: string]: unknown };

export type TLNexusReuseCandidateTransformSpec = { [key: string]: unknown } | null;

export type TLNexusReuseCandidate = {
  accepted_mapping_id: string;
  confidence?: number | null;
  kind: TLNexusMappingKind;
  mapping_type: TLNexusMappingType;
  rank_score?: number;
  source_domain?: TLConnectorDomain | null;
  source_endpoints: TLNexusReuseCandidateSourceEndpointsItem[];
  source_origin: TLNexusSourceOrigin;
  source_project_id?: string | null;
  source_version?: string | null;
  target_domain?: TLConnectorDomain | null;
  target_endpoints: TLNexusReuseCandidateTargetEndpointsItem[];
  target_version?: string | null;
  transform_spec?: TLNexusReuseCandidateTransformSpec;
};

export type TLNexusReuseCandidatesResponse = {
  candidates: TLNexusReuseCandidate[];
  count: number;
};

export type TLNexusSearchTablesRequest = {
  keyword?: string;
};

export type TLNexusTableSearchResult = {
  catalog?: string;
  description?: string;
  table_name?: string;
  table_schema?: string;
};

export type TLNexusSearchTablesResponse = {
  results: TLNexusTableSearchResult[];
};

export type TLNexusSuggestMappingRequestSourceFieldsItem = { [key: string]: unknown };

export type TLNexusSuggestMappingRequestTargetField = { [key: string]: unknown };

export type TLNexusSuggestMappingRequestValidationFeedback = { [key: string]: unknown } | null;

export type TLNexusSuggestMappingRequest = {
  source_fields: TLNexusSuggestMappingRequestSourceFieldsItem[];
  target_field: TLNexusSuggestMappingRequestTargetField;
  validation_feedback?: TLNexusSuggestMappingRequestValidationFeedback;
};

export type TLNexusMappingSuggestionLogEntry = {
  role: string;
  text: string;
};

export enum TLNexusReuseApplication {
  EXACT = 'EXACT',
  PRIOR = 'PRIOR',
}
export type TLNexusMappingReuseInfo = {
  accepted_mapping_id: string;
  applied: TLNexusReuseApplication;
  confidence?: number | null;
  rank_score?: number;
  source_project_id?: string | null;
};

export type TLNexusMappingSuggestionResponse = {
  attempts?: number;
  confidence?: number;
  expression?: string | null;
  function?: string | null;
  log?: TLNexusMappingSuggestionLogEntry[];
  mapping_type: string;
  reasoning?: string;
  reuse?: TLNexusMappingReuseInfo | null;
  separator?: string | null;
};

export type TLNexusAddTableRequest = {
  catalog_name?: string | null;
  filter?: TLNexusScopeChainInput | null;
  system?: string | null;
  table_name: string;
  table_schema?: string | null;
};

export type TLNexusAddTableResponse = {
  edges: TLNexusEdgeResponse[];
  nodes: TLNexusNodeResponse[];
};

export type TLNexusAddTablesRequest = {
  /**
   * @minItems 1
   * @maxItems 25
   */
  tables: TLNexusAddTableRequest[];
};

export type TLNexusAddTableResult = {
  /** Why the action failed for this item */
  error?: string | null;
  node_count?: number;
  /** Whether the action succeeded for this item */
  success: boolean;
  table: string;
};

export type TLBulkActionResponseNexusAddTableResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLNexusAddTableResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export type TLNexusValidateMappingRequest = {
  /**
   * @minimum 1
   * @maximum 10000
   */
  limit?: number;
  source_expression: string;
  /** Source FIELD node id; when set, resolves the qualified parent-table identifier so a table name shared by two systems (jm_ecc.KNVV vs jm_s4.KNVV) is disambiguated. */
  source_node_id?: string | null;
  source_table: string;
  target_field: string;
  /** Target FIELD node id; when set, resolves the qualified parent-table identifier so a table name shared by two systems (jm_ecc.KNVV vs jm_s4.KNVV) is disambiguated. */
  target_node_id?: string | null;
  target_table: string;
};

export type TLNexusMappingComparisonRow = {
  match?: boolean;
  source?: string;
  target?: string;
};

/**
 * What kind of thing a blueprint column holds, in Nexus' own vocabulary.
 *
 * Deliberately smaller than the lakehouse's own type list — ten integer widths are all
 * just "an integer" to a consumer — and deliberately separate from the raw ``datatype``
 * the column row already stores, which carries the lakehouse's vocabulary on one write
 * path and SAP's on another.
 */
export enum TLNexusLogicalType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  TIME = 'TIME',
  DATETIME = 'DATETIME',
  CATEGORICAL = 'CATEGORICAL',
  UNSUPPORTED = 'UNSUPPORTED',
}
export type TLNexusValidateMappingResponse = {
  comparison?: TLNexusMappingComparisonRow[];
  conformance_applicable?: boolean;
  conformance_rate?: number | null;
  conformance_rule?: TLNexusLogicalType | null;
  error?: string | null;
  match_rate?: number;
  nonconforming_sample?: string[];
  overlap_count?: number | null;
  overlap_sample?: string[];
  source_count?: number | null;
  source_only_sample?: string[];
  target_count?: number | null;
  target_empty?: boolean;
  target_only_sample?: string[];
  valid: boolean;
};

export type TLNexusValidateSqlRequest = {
  expression: string;
  /** @maximum 100 */
  limit?: number;
  source_table: string;
};

export type TLNexusValidateSqlResponse = {
  columns?: string[];
  error?: string | null;
  row_count?: number | null;
  rows?: unknown[][];
  valid: boolean;
};

export type TLNexusEdgeCreateEvidence = { [key: string]: unknown } | null;

export type TLNexusEdgeCreateJoinSpec = { [key: string]: unknown } | null;

export type TLNexusEdgeCreateMetadata = { [key: string]: unknown } | null;

export type TLNexusEdgeCreate = {
  cardinality?: TLNexusCardinality | null;
  confidence?: number | null;
  description?: string | null;
  edge_type: TLNexusEdgeType;
  evidence?: TLNexusEdgeCreateEvidence;
  join_spec?: TLNexusEdgeCreateJoinSpec;
  label?: string | null;
  metadata?: TLNexusEdgeCreateMetadata;
  source_node_id: string;
  source_origin?: TLNexusSourceOrigin;
  target_node_id: string;
};

export type TLNexusEdgeUpdateEvidence = { [key: string]: unknown } | null;

export type TLNexusEdgeUpdateJoinSpec = { [key: string]: unknown } | null;

export type TLNexusEdgeUpdateMetadata = { [key: string]: unknown } | null;

export type TLNexusEdgeUpdate = {
  cardinality?: TLNexusCardinality | null;
  confidence?: number | null;
  description?: string | null;
  evidence?: TLNexusEdgeUpdateEvidence;
  join_spec?: TLNexusEdgeUpdateJoinSpec;
  label?: string | null;
  metadata?: TLNexusEdgeUpdateMetadata;
  source_origin?: TLNexusSourceOrigin | null;
  status?: TLNexusEntityStatus | null;
};

export type TLNexusFieldMappingCreateEvidence = { [key: string]: unknown } | null;

export type TLNexusFieldMappingCreateSourceFieldsItem = { [key: string]: unknown };

export type TLNexusFieldMappingCreateTransformSpec = { [key: string]: unknown } | null;

export type TLNexusFieldMappingCreate = {
  confidence?: number | null;
  edge_id?: string | null;
  evidence?: TLNexusFieldMappingCreateEvidence;
  mapping_type: TLNexusMappingType;
  source_fields: TLNexusFieldMappingCreateSourceFieldsItem[];
  source_origin?: TLNexusSourceOrigin;
  target_node_id: string;
  transform_spec?: TLNexusFieldMappingCreateTransformSpec;
};

export type TLNexusValidateMappingsBulkRequest = {
  /**
   * @minimum 1
   * @maximum 10000
   */
  limit?: number;
  /**
   * @minItems 1
   * @maxItems 100
   */
  mapping_ids: string[];
};

export type TLNexusMappingValidationResult = {
  /** Why the action failed for this item */
  error?: string | null;
  mapping_id: string;
  match_rate?: number | null;
  /** Whether the action succeeded for this item */
  success: boolean;
};

export type TLBulkActionResponseNexusMappingValidationResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLNexusMappingValidationResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export type TLNexusFieldMappingUpdateEvidence = { [key: string]: unknown } | null;

export type TLNexusFieldMappingUpdateSourceFields = { [key: string]: unknown }[] | null;

export type TLNexusFieldMappingUpdateTransformSpec = { [key: string]: unknown } | null;

export type TLNexusFieldMappingUpdate = {
  confidence?: number | null;
  evidence?: TLNexusFieldMappingUpdateEvidence;
  mapping_type?: TLNexusMappingType | null;
  source_fields?: TLNexusFieldMappingUpdateSourceFields;
  source_origin?: TLNexusSourceOrigin | null;
  status?: TLNexusEntityStatus | null;
  transform_spec?: TLNexusFieldMappingUpdateTransformSpec;
};

export type TLNexusNodeCreateMetadata = { [key: string]: unknown } | null;

export type TLNexusNodeCreate = {
  description?: string | null;
  /** @maxLength 500 */
  identifier: string;
  /** @maxLength 500 */
  label: string;
  metadata?: TLNexusNodeCreateMetadata;
  node_type: TLNexusNodeType;
  parent_node_id?: string | null;
};

export type TLNexusNodeUpdateMetadata = { [key: string]: unknown } | null;

export type TLNexusNodeUpdate = {
  description?: string | null;
  label?: string | null;
  metadata?: TLNexusNodeUpdateMetadata;
};

export type TLNexusNodeDataResponse = {
  columns?: string[];
  limit?: number;
  offset?: number;
  row_count?: number | null;
  rows?: unknown[][];
};

/**
 * Single-table column predicate on the chain's root table.
 */
export type TLNexusComparisonPredicateOutput = {
  bool_op?: TLNexusFilterBoolOp;
  /** @minItems 1 */
  conditions: TLNexusCaseCondition[];
  kind?: 'COMPARISON';
};

/**
 * A predicate over a related table, correlated to the root ([NOT] EXISTS).
 *
 * Models the join-dependent scope layers the customer authors per row but that read
 * against another table — e.g. "keep an order header with >=1 line AWAITING_RETURN".
 */
export type TLNexusExistsPredicateOutput = {
  bool_op?: TLNexusFilterBoolOp;
  conditions?: TLNexusCaseCondition[];
  /** @minItems 1 */
  join_on: TLNexusJoinKey[];
  kind?: 'EXISTS';
  negated?: boolean;
  /** @minLength 1 */
  related_table: string;
};

export type TLNexusScopeLayerOutput = {
  /**
   * @minLength 1
   * @maxLength 200
   */
  label: string;
  notes?: string | null;
  predicate: TLNexusComparisonPredicateOutput | TLNexusExistsPredicateOutput | TLNexusRawPredicate;
};

/**
 * An ordered funnel of scope layers that narrow a source extraction, root-first.
 *
 * Mirrors the customer's "Filter Chain": each layer narrows the surviving population
 * further, and the preview reports the in-scope volume after each one.
 */
export type TLNexusScopeChainOutput = {
  layers?: TLNexusScopeLayerOutput[];
};

export type TLNexusTableFilterResponse = {
  chain?: TLNexusScopeChainOutput | null;
  documentation_only?: string[];
  node_id: string;
  node_label: string;
};

export type TLNexusRemeasureResponse = {
  measured_columns: number;
};

export type TLImportSchemaNexusProjectsGraphRequest = {
  file: Blob;
  system_name?: string | null;
};

export enum TLNexusSchemaImportRowStatus {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  SKIPPED = 'SKIPPED',
  FAILED = 'FAILED',
  EDGE_CREATED = 'EDGE_CREATED',
}
export type TLNexusSchemaImportRowResult = {
  column?: string | null;
  edge_id?: string | null;
  error?: string | null;
  node_id?: string | null;
  row: number;
  status: TLNexusSchemaImportRowStatus;
  table?: string | null;
};

export type TLNexusSchemaImportResponse = {
  edges_created: number;
  failed: number;
  fields_created: number;
  fields_updated: number;
  results: TLNexusSchemaImportRowResult[];
  skipped: number;
  tables_created: number;
  total_rows: number;
};

export type TLNexusSchemaImportColumn = {
  description: string;
  name: string;
  required: boolean;
};

export type TLNexusSchemaImportTemplate = {
  columns: TLNexusSchemaImportColumn[];
};

export type TLNexusKnowledgeDocument = {
  content_type?: string | null;
  created_by?: string | null;
  created_date: string;
  document_id: string;
  file_size?: number | null;
  filename: string;
};

export type TLNexusKnowledgeDocumentListResponse = {
  documents: TLNexusKnowledgeDocument[];
  total: number;
};

export type TLUploadKnowledgeDocumentNexusProjectsRequest = {
  file: Blob;
};

export type TLNexusKnowledgeDocumentUploadResponse = {
  content_length?: number | null;
  document_id: string;
  file_size?: number | null;
  filename: string;
  package_id?: string | null;
  program_id: string;
  source?: string | null;
};

export type TLNexusKnowledgeFromProgramRequest = {
  program_id: string;
};

export type TLNexusKnowledgeSearchRequest = {
  /** @minLength 1 */
  query: string;
};

export enum TLNexusKnowledgeSource {
  WIKI = 'WIKI',
  FALLBACK = 'FALLBACK',
  ORG_KB = 'ORG_KB',
}
export type TLNexusKnowledgeSearchMatch = {
  document_id: string;
  filename: string;
  snippet: string;
  source: TLNexusKnowledgeSource;
};

export type TLNexusKnowledgeSearchResponse = {
  matches: TLNexusKnowledgeSearchMatch[];
  org_kb_requested?: boolean;
  org_kb_searched?: boolean;
  query: string;
  source?: TLNexusKnowledgeSource | null;
};

export type TLNexusKnowledgeDocumentContentResponse = {
  content_length: number;
  content_text: string;
  document_id: string;
  filename: string;
};

export enum TLNexusPermissionType {
  VIEWER = 'VIEWER',
  REVIEWER = 'REVIEWER',
  EDITOR = 'EDITOR',
}
export enum TLNexusPermissionStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
}
export type TLNexusProjectPermission = {
  created_by: string;
  created_date: string;
  permission_id: string;
  permission_type: TLNexusPermissionType;
  project_id: string;
  status: TLNexusPermissionStatus;
  updated_by: string;
  updated_date: string;
  user_email: string;
};

export type TLNexusPermissionListResponse = {
  limit: number;
  offset: number;
  permissions: TLNexusProjectPermission[];
  total: number;
};

export type TLNexusPermissionEntry = {
  permission_type: TLNexusPermissionType;
  /** @maxLength 255 */
  user_email: string;
};

export type TLNexusGrantPermissionsRequest = {
  /** @maxItems 50 */
  entries: TLNexusPermissionEntry[];
  /** Whether to notify the recipients that the blueprint was shared */
  notify?: boolean;
};

export type TLNexusLeaveResponse = {
  /** True when an active grant was revoked; False for the PUBLIC implicit-access no-op. */
  removed: boolean;
};

export type TLNexusRevokePermissionsRequest = {
  /**
   * @maxItems 50
   * @items.maxLength 255
   */
  user_emails: string[];
};

export type TLNexusRevokePermissionsResponse = {
  failed: number;
  requested: number;
  revoked: number;
};

export type TLPlexusAssignTablesRequest = {
  /** Restrict source tables to these systems. Ignored when source_tables is set (explicit tables win). */
  source_systems?: string[] | null;
  source_tables?: string[] | null;
  target_system?: string | null;
  target_tables?: string[] | null;
  /**
   * @minimum 1
   * @maximum 9
   */
  votes?: number;
};

export type TLPlexusTableAlternative = {
  table: string;
  vote_count: number;
};

export type TLPlexusTableAssignment = {
  alternatives?: TLPlexusTableAlternative[];
  proposed_target: string;
  secondary_target?: string | null;
  source_table: string;
  total_votes: number;
  vote_count: number;
};

export type TLPlexusAssignTablesResponse = {
  assignments: TLPlexusTableAssignment[];
  target_tables: string[];
  votes: number;
};

export type TLPlexusClearAssumptionCacheResponse = {
  cleared: number;
};

export enum TLNexusConfidence {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  REVIEW = 'REVIEW',
}
export enum TLNexusConventionDecisionSource {
  USER_CONFIRMED = 'USER_CONFIRMED',
  AUTO_RESOLVED = 'AUTO_RESOLVED',
}
export type TLNexusConventionDecisionResponse = {
  batch_id: string;
  chosen_option_id: string;
  chosen_option_label: string;
  confidence: TLNexusConfidence;
  consistency_engine: string;
  created_by: string;
  created_date: string;
  decision_id: string;
  group_id: string;
  group_label: string;
  project_id: string;
  source: TLNexusConventionDecisionSource;
  suggested_option_id?: string | null;
  tenant_id: string;
  was_overridden: boolean;
};

export type TLNexusConventionDecisionListResponse = {
  decisions: TLNexusConventionDecisionResponse[];
  offset: number;
  page_size: number;
  total_count: number;
};

export type TLPlexusConfirmedAssignment = {
  secondary_target?: string | null;
  source_table: string;
  target_table: string;
};

export enum TLConsistencyEngine {
  llm = 'llm',
}
export enum TLPlexusConventionMode {
  manual = 'manual',
  auto_high = 'auto_high',
  auto_all = 'auto_all',
}
export type TLPlexusProposeRequest = {
  assignments?: TLPlexusConfirmedAssignment[] | null;
  /**
   * @minimum 1
   * @maximum 3
   */
  chase_depth?: number;
  consistency_engine?: TLConsistencyEngine;
  convention_mode?: TLPlexusConventionMode;
  enable_assumptions?: boolean;
  enable_expressions?: boolean;
  enable_structural?: boolean;
  /**
   * @minimum 1
   * @maximum 24
   */
  match_concurrency?: number;
  /**
   * @minimum 0
   * @maximum 100
   */
  max_expressions?: number;
  /**
   * @minimum 0
   * @maximum 1000
   */
  sample_limit?: number;
  source_columns?: string[] | null;
  /** Restrict source tables to these systems. Ignored when source_tables is set (explicit tables win). */
  source_systems?: string[] | null;
  source_tables?: string[] | null;
  target_system?: string | null;
  target_table?: string | null;
  target_tables?: string[] | null;
};

export type TLImportFieldMappingProposalsNexusProjectsRequest = {
  file: Blob;
};

export enum TLNexusMappingImportRowStatus {
  FILED = 'FILED',
  SKIPPED = 'SKIPPED',
  UNBOUND = 'UNBOUND',
  FAILED = 'FAILED',
}
export type TLNexusMappingImportRowResult = {
  error?: string | null;
  proposal_id?: string | null;
  row: number;
  status: TLNexusMappingImportRowStatus;
  target?: string | null;
};

export type TLNexusMappingImportResponse = {
  failed: number;
  filed: number;
  results: TLNexusMappingImportRowResult[];
  skipped: number;
  total_rows: number;
  unbound: number;
};

export type TLNexusMappingImportColumn = {
  description: string;
  name: string;
  required: boolean;
};

export type TLNexusMappingImportTemplate = {
  columns: TLNexusMappingImportColumn[];
  multi_source_delimiter: string;
};

export enum TLNexusReviewAuditAction {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  NEEDS_INFO = 'NEEDS_INFO',
  ASSIGNED = 'ASSIGNED',
  SIGNOFF_SUBMITTED = 'SIGNOFF_SUBMITTED',
  SIGNOFF_APPROVED = 'SIGNOFF_APPROVED',
  SIGNOFF_REJECTED = 'SIGNOFF_REJECTED',
  VERSION_PUBLISHED = 'VERSION_PUBLISHED',
  VERSION_RESTORED = 'VERSION_RESTORED',
}
export type TLNexusReviewAuditEntryDetails = { [key: string]: unknown } | null;

export type TLNexusReviewAuditEntry = {
  action: TLNexusReviewAuditAction;
  actor: string;
  audit_id: string;
  comment?: string | null;
  created_date: string;
  details?: TLNexusReviewAuditEntryDetails;
  project_id: string;
  proposal_id?: string | null;
  signoff_id?: string | null;
};

export type TLNexusReviewAuditListResponse = {
  items: TLNexusReviewAuditEntry[];
  offset: number;
  page_size: number;
  total_count: number;
};

export type TLNexusSignoffResponse = {
  created_date: string;
  decided_at?: string | null;
  decided_by?: string | null;
  decision_comment?: string | null;
  is_stale?: boolean;
  pinned_version_hash: string;
  project_id: string;
  signoff_id: string;
  status: TLNexusSignoffStatus;
  submitted_at: string;
  submitted_by: string;
  tenant_id: string;
  updated_date: string;
};

export type TLNexusSignoffStatusResponse = {
  current_version_hash: string;
  locked?: boolean;
  signoff?: TLNexusSignoffResponse | null;
};

export type TLNexusSignoffDecisionRequest = {
  comment?: string | null;
};

export type TLNexusSignoffListResponse = {
  items: TLNexusSignoffResponse[];
  offset: number;
  page_size: number;
  total_count: number;
};

export type TLUploadDataFileNexusProjectsRequest = {
  description?: string | null;
  file: Blob;
  system_name: string;
  /** Table name for a single-table file; a workbook names its tables after its sheets */
  table_name?: string | null;
};

/**
 * What one planned sheet ended up producing.
 *
 * Carries its own ``physical_table`` so each step after the import reads one outcome
 * rather than re-zipping the plan against a result list by position.
 */
export type TLNexusUploadSheetOutcome = {
  error?: string | null;
  field_count?: number | null;
  label: string;
  physical_table: string;
  sheet?: string | null;
  skip_reason?: TLWorkbookSheetSkipReason | null;
  status: TLFoundryImportSheetStatus;
  table_node_id?: string | null;
};

export enum TLNexusUploadStatus {
  PENDING = 'PENDING',
  IMPORTING = 'IMPORTING',
  DESCRIBING = 'DESCRIBING',
  ANALYZING = 'ANALYZING',
  PERSISTING = 'PERSISTING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
/**
 * One shape for both the 202 accept and every poll of the upload job.
 */
export type TLNexusDataUploadResponse = {
  error?: string | null;
  field_count?: number | null;
  job_id: string;
  progress: number;
  /** Per-sheet outcomes; empty for a single-table upload still in flight */
  sheets?: TLNexusUploadSheetOutcome[];
  status: TLNexusUploadStatus;
  table_node_id?: string | null;
};

export type TLNexusProjectVersionSummary = {
  change_summary?: string | null;
  created_by: string;
  created_date: string;
  is_current?: boolean;
  project_id: string;
  version: number;
};

export type TLPaginatedResponseNexusProjectVersionSummary = {
  /** List of items */
  data: TLNexusProjectVersionSummary[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLNexusProjectVersionCreate = {
  change_summary?: string | null;
};

export type TLNexusProjectVersionDetailEdgesItem = { [key: string]: unknown };

export type TLNexusProjectVersionDetailFieldMappingsItem = { [key: string]: unknown };

export type TLNexusProjectVersionDetailNodesItem = { [key: string]: unknown };

export type TLNexusProjectVersionDetail = {
  change_summary?: string | null;
  created_by: string;
  created_date: string;
  edges: TLNexusProjectVersionDetailEdgesItem[];
  field_mappings: TLNexusProjectVersionDetailFieldMappingsItem[];
  is_current?: boolean;
  nodes: TLNexusProjectVersionDetailNodesItem[];
  project_id: string;
  version: number;
};

export enum TLNexusProposalStatus {
  PROPOSED = 'PROPOSED',
  NEEDS_INFO = 'NEEDS_INFO',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
}
export enum TLNexusProposalType {
  FIELD_MAPPING = 'FIELD_MAPPING',
  EDGE = 'EDGE',
  SCHEMA_SUGGESTION = 'SCHEMA_SUGGESTION',
}
export enum TLNexusReviewerLens {
  MINE = 'MINE',
  UNASSIGNED = 'UNASSIGNED',
  EVERYTHING = 'EVERYTHING',
}
export type TLNexusQueueListResponseNeighborhoodSummary = { [key: string]: { [key: string]: unknown } };

export type TLNexusProposalResponseOriginalPayload = { [key: string]: unknown } | null;

export type TLNexusProposalResponseProposedPayload = { [key: string]: unknown };

export type TLNexusProposalResponseSignals = { [key: string]: unknown };

export type TLNexusProposalResponse = {
  assigned_to?: string | null;
  batch_id?: string | null;
  confidence?: number | null;
  created_by: string;
  created_date: string;
  expires_at?: string | null;
  original_payload?: TLNexusProposalResponseOriginalPayload;
  previous_proposal_id?: string | null;
  project_id: string;
  project_name?: string | null;
  proposal_id: string;
  proposal_type: TLNexusProposalType;
  proposed_payload: TLNexusProposalResponseProposedPayload;
  reasoning?: string | null;
  review_comment?: string | null;
  reviewed_by?: string | null;
  reviewed_date?: string | null;
  signals: TLNexusProposalResponseSignals;
  signals_stale_for_payload?: boolean;
  source_node_id?: string | null;
  source_origin: TLNexusSourceOrigin;
  status: TLNexusProposalStatus;
  summary?: string | null;
  target_edge_id?: string | null;
  target_mapping_id?: string | null;
  target_node_id?: string | null;
  tenant_id: string;
  updated_by: string;
  updated_date: string;
  was_edited?: boolean;
};

export type TLNexusQueueTotals = {
  commented: number;
  needs_info: number;
  proposed: number;
};

export type TLNexusQueueListResponse = {
  default_lens: TLNexusReviewerLens;
  items: TLNexusProposalResponse[];
  neighborhood_summary?: TLNexusQueueListResponseNeighborhoodSummary;
  next_cursor?: string | null;
  totals: TLNexusQueueTotals;
};

export type TLNexusCreateProposalRequestProposedPayload = { [key: string]: unknown };

export type TLNexusCreateProposalRequest = {
  assigned_to?: string | null;
  project_id: string;
  proposal_type: TLNexusProposalType;
  proposed_payload: TLNexusCreateProposalRequestProposedPayload;
  reasoning?: string | null;
  source_node_id?: string | null;
};

export enum TLNexusBulkActionType {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
  NEEDS_INFO = 'NEEDS_INFO',
  ASSIGN = 'ASSIGN',
}
export type TLNexusBulkActionRequest = {
  action: TLNexusBulkActionType;
  assigned_to?: string | null;
  comment?: string | null;
  /**
   * @minItems 1
   * @maxItems 200
   */
  proposal_ids: string[];
};

export type TLNexusBulkActionItemResult = {
  already_resolved_by?: string | null;
  error?: string | null;
  new_status?: TLNexusProposalStatus | null;
  ok: boolean;
  proposal_id: string;
};

export type TLNexusBulkActionResponse = {
  already_resolved: number;
  failed: number;
  items: TLNexusBulkActionItemResult[];
  succeeded: number;
};

export type TLNexusBulkActionByFilterRequest = {
  action: TLNexusBulkActionType;
  /** Target assignee, used only when action is ASSIGN. */
  assigned_to?: string | null;
  /** Restrict to proposals assigned to this user. */
  assignee?: string | null;
  batch_id?: string | null;
  comment?: string | null;
  confidence_max?: number | null;
  confidence_min?: number | null;
  created_after?: string | null;
  has_comments?: boolean;
  /** Resolved against the caller like the queue list: MINE / UNASSIGNED narrow the scope. */
  lens?: TLNexusReviewerLens;
  project_ids?: string[] | null;
  proposal_types?: TLNexusProposalType[] | null;
  search?: string | null;
  source_origins?: TLNexusSourceOrigin[] | null;
  statuses?: TLNexusProposalStatus[] | null;
  unassigned?: boolean;
};

export type TLNexusBulkActionByFilterResponse = {
  already_resolved: number;
  failed: number;
  /** A bounded sample of the items that failed; not the full list. */
  failed_sample?: TLNexusBulkActionItemResult[];
  matched: number;
  succeeded: number;
};

export type TLNexusReviewerStatsResponse = {
  default_lens: TLNexusReviewerLens;
  everything: number;
  mine: number;
  unassigned: number;
};

export type TLNexusProposalDetailResponseConversationLog = { [key: string]: unknown } | null;

export type TLNexusProposalDetailResponseDataEvidence = { [key: string]: unknown } | null;

export type TLNexusProposalDetailResponseOriginalPayload = { [key: string]: unknown } | null;

export type TLNexusProposalDetailResponseProposedPayload = { [key: string]: unknown };

export type TLNexusProposalDetailResponseSignals = { [key: string]: unknown };

export type TLNexusProposalDetailResponse = {
  assigned_to?: string | null;
  batch_id?: string | null;
  confidence?: number | null;
  conversation_log?: TLNexusProposalDetailResponseConversationLog;
  created_by: string;
  created_date: string;
  data_evidence?: TLNexusProposalDetailResponseDataEvidence;
  expires_at?: string | null;
  original_payload?: TLNexusProposalDetailResponseOriginalPayload;
  previous_proposal_id?: string | null;
  project_id: string;
  project_name?: string | null;
  proposal_id: string;
  proposal_type: TLNexusProposalType;
  proposed_payload: TLNexusProposalDetailResponseProposedPayload;
  reasoning?: string | null;
  review_comment?: string | null;
  reviewed_by?: string | null;
  reviewed_date?: string | null;
  signals: TLNexusProposalDetailResponseSignals;
  signals_stale_for_payload?: boolean;
  source_node_id?: string | null;
  source_origin: TLNexusSourceOrigin;
  status: TLNexusProposalStatus;
  summary?: string | null;
  target_edge_id?: string | null;
  target_mapping_id?: string | null;
  target_node_id?: string | null;
  tenant_id: string;
  updated_by: string;
  updated_date: string;
  was_edited?: boolean;
};

export type TLNexusProposalTransitionRequestEditedPayload = { [key: string]: unknown } | null;

export type TLNexusProposalTransitionRequest = {
  comment?: string | null;
  edited_payload?: TLNexusProposalTransitionRequestEditedPayload;
};

/**
 * Request body for the assign endpoint — `assigned_to=None` unassigns.
 */
export type TLNexusAssignProposalRequest = {
  assigned_to?: string | null;
};

export type TLNexusCommentRequest = {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  comment: string;
};

export enum TLNexusNeighborhoodEntryKind {
  MAPPING = 'MAPPING',
  EDGE = 'EDGE',
}
export type TLNexusNeighborhoodEntryResponse = {
  confidence?: number | null;
  id: string;
  kind: TLNexusNeighborhoodEntryKind;
  label: string;
  mapping_type?: TLNexusMappingType | null;
};

export type TLNexusNeighborhoodResponse = {
  count: number;
  entries: TLNexusNeighborhoodEntryResponse[];
  proposal_id: string;
};

export enum TLNotificationStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
}
export enum TLNotificationPriority {
  CRITICAL = 'CRITICAL',
  WARNING = 'WARNING',
  INFO = 'INFO',
}
export enum TLResourceType {
  MESSAGE = 'MESSAGE',
  WF_WORKFLOW = 'WF_WORKFLOW',
  WF_WORKFLOW_EXECUTION = 'WF_WORKFLOW_EXECUTION',
  DH_BATCH_EXECUTION = 'DH_BATCH_EXECUTION',
  DH_DATA_CHECK_EXECUTION = 'DH_DATA_CHECK_EXECUTION',
  DH_CUSTOM_VIEW = 'DH_CUSTOM_VIEW',
  DH_CUSTOM_VIEW_EXECUTION = 'DH_CUSTOM_VIEW_EXECUTION',
  DH_DASHBOARD = 'DH_DASHBOARD',
  PROGRAM = 'PROGRAM',
  KNOWLEDGE_BASE_DOCUMENT = 'KNOWLEDGE_BASE_DOCUMENT',
  KNOWLEDGE_BASE_PACKAGE = 'KNOWLEDGE_BASE_PACKAGE',
  CR_REMEDY_OBJECT = 'CR_REMEDY_OBJECT',
  CR_SCAN = 'CR_SCAN',
  PROGRAM_PERMISSION = 'PROGRAM_PERMISSION',
  WF_WORKFLOW_PERMISSION = 'WF_WORKFLOW_PERMISSION',
  WF_WORKFLOW_TEMPLATE_PERMISSION = 'WF_WORKFLOW_TEMPLATE_PERMISSION',
  DH_DASHBOARD_PERMISSION = 'DH_DASHBOARD_PERMISSION',
  KNOWLEDGE_BASE_TOPIC = 'KNOWLEDGE_BASE_TOPIC',
  WF_WORKFLOW_TEMPLATE = 'WF_WORKFLOW_TEMPLATE',
  DH_DATA_CHECK = 'DH_DATA_CHECK',
  DH_DATA_SOURCE = 'DH_DATA_SOURCE',
  DH_EXPORT_LOG = 'DH_EXPORT_LOG',
  DATA_EXPORT = 'DATA_EXPORT',
  DH_IMPORT_LOG = 'DH_IMPORT_LOG',
  CR_FINDING = 'CR_FINDING',
  CR_REMEDY = 'CR_REMEDY',
  CR_TRANSPORT_REQUEST = 'CR_TRANSPORT_REQUEST',
  VR_VIEW_REVIEW = 'VR_VIEW_REVIEW',
  VR_HANA_VIEW = 'VR_HANA_VIEW',
  VR_VIEW_ASSIGNMENT = 'VR_VIEW_ASSIGNMENT',
  PROJECT = 'PROJECT',
  LANDSCAPE_SYNC_RUN = 'LANDSCAPE_SYNC_RUN',
  FUNCTIONAL_SPEC = 'FUNCTIONAL_SPEC',
  CONVERSATION = 'CONVERSATION',
  SCHEDULE = 'SCHEDULE',
  CHAT_PROGRAM = 'CHAT_PROGRAM',
  PROJECT_PROGRAM = 'PROJECT_PROGRAM',
  RETROFIT = 'RETROFIT',
  RETROFIT_REMEDIATION_OBJECT = 'RETROFIT_REMEDIATION_OBJECT',
  NEXUS_PROPOSAL = 'NEXUS_PROPOSAL',
}
export enum TLNotificationType {
  TOAST = 'TOAST',
  BANNER = 'BANNER',
  MODAL = 'MODAL',
}
export type TLNotificationMetadata = { [key: string]: unknown } | null;

export type TLNotification = {
  actor_email?: string | null;
  created_date: string;
  deep_link?: string | null;
  delivered_date?: string | null;
  domain: TLDomain;
  is_read: boolean;
  message: string;
  metadata?: TLNotificationMetadata;
  notification_id: string;
  parent_resource_id?: string | null;
  priority: TLNotificationPriority;
  read_date?: string | null;
  resource_id?: string | null;
  resource_name?: string | null;
  resource_type?: TLResourceType | null;
  status: TLNotificationStatus;
  type: TLNotificationType;
  updated_date: string;
  user_email: string;
};

export type TLNotificationListResponse = {
  /** Page size */
  limit: number;
  /** Success message */
  message: string;
  /** List of notifications */
  notifications: TLNotification[];
  /** Current offset */
  offset: number;
  /** Operation status */
  status?: string;
  /** Total number of notifications matching the filter */
  total_count: number;
  /** Total number of unread notifications */
  unread_count: number;
};

export type TLNotificationCreateRequestMetadata = { [key: string]: unknown } | null;

export type TLNotificationCreateRequest = {
  domain: TLDomain;
  message: string;
  metadata?: TLNotificationCreateRequestMetadata;
  priority: TLNotificationPriority;
  resource_id?: string | null;
  resource_name?: string | null;
  resource_type?: TLResourceType | null;
  status: TLNotificationStatus;
  type: TLNotificationType;
};

export type TLNotificationCreateResponse = {
  /** Success message */
  message: string;
  notification_ids: string[];
  /** Operation status */
  status?: string;
};

export type TLMarkAllNotificationsReadResponse = {
  /** Number of notifications marked as read */
  marked_count: number;
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLMarkNotificationsDeliveredRequest = {
  /**
   * List of notification IDs to mark as delivered
   * @maxItems 100
   */
  notification_ids: string[];
};

export type TLMarkNotificationsDeliveredResponse = {
  /** Number of notifications marked as delivered */
  marked_count: number;
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLMarkNotificationsReadRequest = {
  /**
   * List of notification IDs to mark as read
   * @maxItems 100
   */
  notification_ids: string[];
};

export type TLMarkNotificationsReadResponse = {
  /** Number of notifications marked as read */
  marked_count: number;
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLMarkNotificationsUnreadRequest = {
  /**
   * List of notification IDs to mark as unread
   * @maxItems 100
   */
  notification_ids: string[];
};

export type TLMarkNotificationsUnreadResponse = {
  /** Number of notifications marked as unread */
  marked_count: number;
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLNotificationSubscriptionRequest = {
  /** ID of the resource to subscribe to */
  resource_id: string;
  /** Type of resource to subscribe to */
  resource_type: TLResourceType;
};

export enum TLNotificationChannel {
  IN_APP = 'IN_APP',
  EMAIL = 'EMAIL',
}
export enum TLSubscriberStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
export type TLSubscriberMetadata = { [key: string]: unknown } | null;

export type TLSubscriber = {
  channel: TLNotificationChannel;
  created_by: string;
  created_date: string;
  id: string;
  metadata?: TLSubscriberMetadata;
  resource_id: string;
  resource_type: TLResourceType;
  status: TLSubscriberStatus;
  updated_date: string;
  user_email: string;
};

export type TLNotificationSubscriptionListResponse = {
  /** Page size */
  limit: number;
  /** Success message */
  message: string;
  /** Current offset */
  offset: number;
  /** Operation status */
  status?: string;
  /** The current user's active subscriptions */
  subscriptions: TLSubscriber[];
  /** Total number of active subscriptions for the user */
  total_count: number;
};

export type TLNotificationDeleteResponse = {
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLNotificationArchiveResponse = {
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
};

export type TLApproveMcpAuthorizationOauthAuthorizeRequest = {
  request_id: string;
};

export type TLMcpOAuthApproveResponse = {
  redirect_to: string;
};

export type TLDeclineMcpAuthorizationOauthAuthorizeRequest = {
  request_id: string;
};

/**
 * What the consent page shows. `client_name` is supplied by whoever registered the
 * client and is never verified, so the page must present it as unverified.
 */
export type TLMcpConsentRequestResponse = {
  client_name: string;
  redirect_host: string;
};

/**
 * RFC 7591 registration request. Only the fields we honor are declared; anything else a
 * client sends is ignored rather than rejected, per the RFC's extension rules.
 */
export type TLMcpClientRegistrationRequest = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  client_name: string;
  /**
   * @minItems 1
   * @maxItems 5
   */
  redirect_uris: string[];
};

export type TLMcpClientRegistrationResponse = {
  client_id: string;
  client_name: string;
  redirect_uris: string[];
  token_endpoint_auth_method?: string;
};

export type TLRevokeMcpOauthTokenRequest = {
  token: string;
};

/**
 * RFC 7009 wants an empty 200; a declared model keeps the endpoint out of the
 * response_model exception list.
 */
export type TLMcpOAuthRevokeResponse = { [key: string]: unknown };

export type TLIssueMcpOauthTokenRequest = {
  client_id?: string | null;
  code?: string | null;
  code_verifier?: string | null;
  grant_type: string;
  redirect_uri?: string | null;
  refresh_token?: string | null;
  resource?: string | null;
};

export type TLMcpOAuthTokenResponse = {
  access_token: string;
  expires_in: number;
  refresh_token: string;
  token_type?: string;
};

export enum TLSkillStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
}
export enum TLSkillSource {
  USER = 'USER',
  AGENT = 'AGENT',
  PLATFORM_SEED = 'PLATFORM_SEED',
  IMPORT = 'IMPORT',
}
export type TLPlatformSkillResponse = {
  created_by: string;
  /** Resolved display name of the creator (for 'Added by'); None if unresolved. */
  created_by_name?: string | null;
  created_date: string;
  description: string;
  domain: TLDomain;
  id: string;
  name: string;
  slug: string;
  source: TLSkillSource;
  status: TLSkillStatus;
  tags?: string[] | null;
  updated_date: string;
  version: number;
};

export type TLPlatformSkillsListResponse = {
  /** @minimum 1 */
  limit?: number;
  /** @minimum 0 */
  offset?: number;
  skills?: TLPlatformSkillResponse[];
  /** @minimum 0 */
  total?: number;
};

export type TLPlatformSkillCreateRequest = {
  /**
   * @minLength 1
   * @maxLength 1024
   */
  description: string;
  domain: TLDomain;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** Replace an existing same-slug platform skill instead of erroring */
  overwrite?: boolean;
  /** Initial SKILL.md body */
  skill_markdown?: string | null;
  /**
   * @minLength 1
   * @maxLength 128
   * @pattern ^[a-z0-9]+(?:-[a-z0-9]+)*$
   */
  slug: string;
  tags?: string[] | null;
};

export type TLImportPlatformSkillZipRequest = {
  /** ZIP archive containing SKILL.md */
  file: Blob;
};

export type TLPreviewPlatformSkillZipImportRequest = {
  /** ZIP or .skill archive containing SKILL.md */
  file: Blob;
};

export type TLSkillNormalizeResponse = {
  description: string;
  name: string;
  /** Canonical, repaired SKILL.md ready to save. */
  skill_markdown: string;
  slug: string;
  /** Human-readable notes on what was inferred or repaired during normalization. */
  warnings?: string[];
};

export type TLPlatformSkillUpdateRequest = {
  description?: string | null;
  domain?: TLDomain | null;
  name?: string | null;
  skill_markdown?: string | null;
  status?: TLSkillStatus | null;
  tags?: string[] | null;
};

export enum TLSkillAttachmentRole {
  REFERENCE = 'REFERENCE',
  SCRIPT = 'SCRIPT',
  TEMPLATE = 'TEMPLATE',
  ASSET = 'ASSET',
}
export type TLUserSkillAttachmentResponse = {
  created_at: string;
  display_name?: string | null;
  id: string;
  path: string;
  /** Underlying program id, for previewing the attachment's stored file */
  program_id: string;
  role: TLSkillAttachmentRole;
  skill_id: string;
  sort_order: number;
  updated_at: string;
};

export type TLUserSkillAttachmentListResponse = {
  attachments?: TLUserSkillAttachmentResponse[];
  /** @minimum 0 */
  limit?: number;
  /** @minimum 0 */
  offset?: number;
  /** @minimum 0 */
  total?: number;
};

export type TLUserSkillAttachmentCreateRequest = {
  /**
   * @minLength 1
   * @maxLength 120000
   */
  attachment_body: string;
  display_name?: string | null;
  /**
   * @minLength 1
   * @maxLength 512
   */
  path: string;
  role: TLSkillAttachmentRole;
  /** @minimum 0 */
  sort_order?: number;
};

export type TLSkillAttachmentUploadAbortRequest = {
  /** Pending program id to abort */
  program_id: string;
};

export type TLSkillAttachmentUploadAbortResponse = {
  program_id: string;
};

/**
 * Finalize an uploaded attachment and create the attachment row at ``path``.
 */
export type TLSkillAttachmentUploadCompleteRequest = {
  display_name?: string | null;
  /**
   * @minLength 1
   * @maxLength 512
   */
  path: string;
  /** Pending program id returned by initiate */
  program_id: string;
  role: TLSkillAttachmentRole;
  /** @minimum 0 */
  sort_order?: number;
};

/**
 * Initiate a presigned upload for an image/binary skill attachment.
 */
export type TLSkillAttachmentUploadInitiateRequest = {
  /** MIME content type of the file */
  content_type?: string | null;
  /**
   * Total file size in bytes (validated against the upload cap)
   * @exclusiveMinimum 0
   */
  file_size: number;
  /**
   * Filename of the attachment to upload
   * @minLength 1
   * @maxLength 512
   */
  filename: string;
};

export type TLSkillAttachmentUploadInitiateResponse = {
  /** Pending program id to reference on complete/abort */
  program_id: string;
  /** Presigned upload instructions (PUT or POST) */
  upload: TLPutUploadInitiate | TLPostUploadInitiate;
};

export type TLUserSkillAttachmentUpdateRequest = {
  display_name?: string | null;
  /** Rename the attachment to a new path */
  new_path?: string | null;
  role?: TLSkillAttachmentRole | null;
  sort_order?: number | null;
};

export type TLUserSkillAttachmentContentResponse = {
  /** Inline UTF-8 text for text attachments; a short placeholder for images/binary (use download_url). */
  attachment_body: string;
  /** Presigned download URL for image/binary attachments; None for text */
  download_url?: string | null;
  /** Why this attachment's content cannot be replaced with inline text, for the client to surface on a disabled edit control. None when the content is editable. */
  edit_blocked_reason?: string | null;
  /** Stored file type (extension) of the attachment */
  file_type?: string | null;
  /** Whether the attachment is an image */
  is_image?: boolean;
  path: string;
  role: TLSkillAttachmentRole;
  version?: string | null;
};

export type TLUserSkillAttachmentContentPutRequest = {
  /**
   * @minLength 1
   * @maxLength 120000
   */
  attachment_body: string;
};

export type TLSkillAttachmentDownloadResponse = {
  /** Presigned download URL */
  download_url: string;
  /** URL validity in seconds */
  expiration: number;
  file_type?: string | null;
};

export type TLUserSkillContentResponse = {
  skill_markdown: string;
  version: number;
};

/**
 * Body for `POST /preview-atc-scans`.
 *
 * The caller supplies the ABAP object URI and a blob of new source code.
 * The endpoint snapshots the current active source, activates the new code,
 * runs ATC, then restores the original active source.
 */
export type TLPreviewAtcScanCreateRequest = {
  /** ATC check variant (e.g. DEFAULT, S4HANA_READINESS). */
  check_variant?: string;
  /** The proposed ABAP source to scan against. */
  new_source_code: string;
  /** Object name (uppercased). If omitted, derived from the last segment of object_uri. */
  object_name?: string | null;
  /** ADT URI of the object to preview-scan. */
  object_uri: string;
  /** SAP system version (S4 or ECC). */
  sap_version?: TLSAPVersion;
};

export enum TLPreviewAtcScanStatus {
  CREATED = 'CREATED',
  STARTED = 'STARTED',
  SNAPSHOT_TAKEN = 'SNAPSHOT_TAKEN',
  NEW_CODE_ACTIVATED = 'NEW_CODE_ACTIVATED',
  SCAN_IN_PROGRESS = 'SCAN_IN_PROGRESS',
  SCAN_COMPLETED = 'SCAN_COMPLETED',
  RESTORING = 'RESTORING',
  RESTORED = 'RESTORED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  RESTORE_FAILED = 'RESTORE_FAILED',
  APPLIED = 'APPLIED',
}
/**
 * `POST /preview-atc-scans` response.
 *
 * Returned with HTTP 202. The scan runs durably in a Temporal workflow;
 * poll `GET /preview-atc-scans/{preview_scan_id}` for findings.
 */
export type TLPreviewAtcScanCreatedResponse = {
  preview_scan_id: string;
  status: TLPreviewAtcScanStatus;
  temporal_workflow_id: string;
};

export type TLPreviewAtcScanResultResponseFindings = { [key: string]: unknown } | null;

/**
 * `GET /preview-atc-scans/{preview_scan_id}` response.
 *
 * Strict subset of ``PreviewAtcScan`` — the candidate source blobs are
 * omitted (the caller already has the new code, and the snapshot is only
 * relevant to the restore step). Pydantic populates the fields directly from
 * the business model via ``model_validate`` thanks to ``from_attributes``.
 */
export type TLPreviewAtcScanResultResponse = {
  check_variant: string;
  created_by: string;
  created_date: string;
  error_message: string | null;
  findings: TLPreviewAtcScanResultResponseFindings;
  object_name: string;
  object_uri: string;
  preview_scan_id: string;
  reconcile_attempts: number;
  restore_error_message: string | null;
  sap_version: TLSAPVersion;
  status: TLPreviewAtcScanStatus;
  temporal_workflow_id: string | null;
  updated_by: string;
  updated_date: string;
  user_email: string;
};

export type TLCreateProgramRequest = {
  /** Program content */
  content?: string | null;
  /** Correlation ID for tracking */
  correlation_id?: string | null;
  /** Program domain */
  domain: TLDomain;
  /** Program filename */
  filename: string;
  /** Session ID */
  session_id?: string | null;
  /** Program status */
  status?: TLProgramStatus;
};

export type TLCreateProgramResponse = {
  /** Success message */
  message: string;
  /** Program UUID */
  program_id: string;
  /** Program version */
  version: string;
};

export type TLBulkDeleteRequest = {
  /**
   * List of program IDs to delete
   * @minItems 1
   * @maxItems 500
   */
  program_ids: string[];
};

export type TLDeleteResult = {
  /** Error message if deletion failed */
  error?: string | null;
  /** Program ID */
  program_id: string;
  /** Whether deletion was successful */
  success: boolean;
};

export type TLBulkDeleteResponse = {
  /** Number of programs that failed to delete */
  failed: number;
  /** Individual results for each program */
  results: TLDeleteResult[];
  /** Number of programs successfully deleted */
  succeeded: number;
  /** Total number of programs to delete */
  total: number;
};

/**
 * Execution types
 */
export enum TLExecutionType {
  PYTHON = 'PYTHON',
}
export type TLInputFile = {
  /** Inline text content for the file. Either url or content must be provided. */
  content?: string | null;
  /** The name (and extension) that should be used to refer to the file when it is downloaded. */
  filename: string;
  /** Program ID this file was resolved from, when sourced from a stored program. */
  program_id?: string | null;
  /** An absolute URL to a single remote file. Must match cloud file URL pattern when provided. */
  url?: string | null;
};

/**
 * Takes in EITHER a Program ID OR a code block and executes it
 */
export type TLBaseExecutorRequest = {
  code?: string | null;
  domain?: TLDomain;
  execution_type: TLExecutionType;
  filename_suffix?: string | null;
  generate_file?: boolean;
  include_code?: boolean;
  input_files?: TLInputFile[] | null;
  output_file_name?: string | null;
  program_id?: string | null;
  timeout_s?: number | null;
  [key: string]: unknown;
};

export type TLUploadProgramsRequest = {
  files: Blob[];
};

export type TLFile = {
  created_by?: string | null;
  created_date?: string | null;
  download_url?: string | null;
  expiration?: number | null;
  filename: string;
  is_platform_asset?: boolean;
  path?: string | null;
  program_id?: string | null;
  type?: string | null;
};

/**
 * Response model for program upload operations.
 */
export type TLProgramUploadResponse = {
  /** List of filenames that failed to upload */
  failed_files?: string[];
  /** Upload status */
  status?: string;
  /** List of uploaded files with metadata */
  uploaded_files: TLFile[];
};

/**
 * Request model for aborting an upload.
 */
export type TLUploadAbortRequest = {
  /** The program record id */
  program_id: string;
};

/**
 * Response model for aborting an upload.
 */
export type TLUploadAbortResponse = {
  /** Success or error message */
  message?: string | null;
  /** The program record id */
  program_id: string;
  /** Whether the operation was successful */
  success: boolean;
};

/**
 * Request model for completing an upload.
 */
export type TLUploadCompleteRequest = {
  /** The program record id */
  program_id: string;
};

/**
 * Response model for completing an upload.
 */
export type TLUploadCompleteResponse = {
  /** Success or error message */
  message?: string | null;
  /** The program record id */
  program_id: string;
  /** Whether the operation was successful */
  success: boolean;
  /** The program version after activation */
  version?: string | null;
};

/**
 * Request model for initiating an upload.
 */
export type TLUploadInitiateRequest = {
  /** Content type of the file */
  content_type?: string | null;
  /** Program domain */
  domain: TLDomain;
  /** Total file size in bytes */
  file_size?: number | null;
  /** Filename to upload */
  filename: string;
};

/**
 * Response model for upload initiation.
 */
export type TLUploadInitiateResponse = {
  /** Whether direct-to-storage upload is enabled for this deployment. When false, the client must fall back to proxied upload. */
  direct_upload_enabled?: boolean;
  /** List of filenames that failed to initiate */
  failed_files?: string[];
  /** Success message */
  message: string;
  /** Operation status */
  status?: string;
  /** List of initiated uploads */
  uploads: (TLPutUploadInitiate | TLPostUploadInitiate)[];
};

export type TLProgramOperationResponse = {
  /** Error message if operation failed */
  error?: string | null;
  /** Success or error message */
  message?: string | null;
  /** Whether the operation was successful */
  success: boolean;
};

export type TLSaveProgramRequest = {
  /** Program code content */
  code?: string | null;
  /** Correlation ID for tracking */
  correlation_id?: string | null;
  /** Program domain */
  domain?: TLDomain | null;
  /** Program filename */
  filename?: string | null;
  /** Session ID */
  session_id?: string | null;
};

export type TLSaveProgramResponse = {
  /** Success message */
  message: string;
  /** Program UUID */
  program_id: string;
  /** Program version */
  version: number;
};

export type TLRenameProgramRequest = {
  /**
   * New filename for the program
   * @minLength 1
   * @maxLength 255
   */
  new_filename: string;
};

export type TLUpdateProgramRequest = {
  /** Program code content */
  content: string;
  /** Session ID */
  session_id?: string | null;
};

export type TLUpdateProgramResponse = {
  /** Success message */
  message: string;
  /** Program UUID */
  program_id: string;
  /** Program version */
  version: string | null;
};

export type TLProgramVersionEntry = {
  created_by?: string | null;
  created_date: string;
  file_size?: number | null;
  filename: string;
  latest: boolean;
  version: string;
};

export type TLProgramVersionHistoryResponse = {
  program_id: string;
  versions: TLProgramVersionEntry[];
};

export type TLFunctionGroupInfo = {
  description?: string | null;
  name: string;
};

export type TLFunctionGroupSearchResponse = {
  groups?: TLFunctionGroupInfo[];
};

export enum TLProjectExplorerNodeKind {
  folder = 'folder',
  object = 'object',
}
/**
 * A single node in the Project Explorer tree.
 *
 * `id` is the stable identifier the frontend uses when asking the backend
 * to expand the node. For packages and virtual subfolders inside a package
 * it is the SAP package/tech name ($TMP, ZDPR_DATAGEN, ...). For leaf
 * objects it is the full ADT URI so the "open object" endpoints can use it
 * as-is without re-resolving.
 */
export type TLProjectExplorerNode = {
  description?: string;
  expandable?: boolean;
  id: string;
  kind: TLProjectExplorerNodeKind;
  name: string;
  package?: string;
  type: string;
  uri?: string;
};

export type TLProjectExplorerTreeResponse = {
  limit: number;
  nodes: TLProjectExplorerNode[];
  offset: number;
  total: number;
};

export type TLNamingConventionsResponseConventions = { [key: string]: string };

export type TLNamingConventionsResponse = {
  conventions?: TLNamingConventionsResponseConventions;
};

export enum TLObjectKind {
  PROG = 'PROG',
  INCL = 'INCL',
  CLAS = 'CLAS',
  INTF = 'INTF',
  FUGR = 'FUGR',
  FUNC = 'FUNC',
  DDLS = 'DDLS',
}
export type TLTransportInfo = {
  /** Creation date as reported by SAP */
  created_date?: string;
  /** Transport request description */
  description?: string;
  /** SAP user owning the transport */
  owner?: string;
  /** Transport status (e.g. 'D' modifiable, 'R' released) */
  status?: string;
  /** Transport request number (CORRNR) */
  transport: string;
};

export type TLObjectTransportCandidatesResponse = {
  assigned_transport?: string | null;
  candidates?: TLTransportInfo[];
  package?: string | null;
  recommended?: string | null;
  requires_transport?: boolean;
};

export enum TLCdsViewType {
  INTERFACE = 'INTERFACE',
  CONSUMPTION = 'CONSUMPTION',
}
export type TLObjectCreateRequest = {
  /** DDLS only: seeds an annotated Interface/Consumption skeleton on create */
  cds_view_type?: TLCdsViewType | null;
  /**
   * @minLength 1
   * @maxLength 60
   */
  description: string;
  kind: TLObjectKind;
  /**
   * @minLength 1
   * @maxLength 30
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 30
   */
  package: string;
  parent_group?: string | null;
  /** Existing transport request to create into */
  transport?: string | null;
};

export type TLObjectCreateResponse = {
  kind: TLObjectKind;
  name: string;
  open_uri: string;
  transport?: string | null;
  uri: string;
};

export type TLProjectExplorerActivationMessage = {
  /** ADT href anchor for navigating to the issue */
  href?: string;
  /** Line extracted from the href anchor; 0 if absent */
  line?: number;
  /** ADT object descriptor (when present) */
  obj_descr?: string;
  /** Human-readable short text */
  short_text?: string;
  /** ADT severity code: E (error), W (warning), I (info) */
  type?: string;
};

export type TLObjectActivateResponse = {
  /** Raw ADT activationExecuted flag */
  activation_executed?: boolean;
  /** Raw ADT checkExecuted flag */
  check_executed?: boolean;
  messages?: TLProjectExplorerActivationMessage[];
  /** False when SAP declined to activate (checkExecuted set, activationExecuted not) or reported any error-severity message. A no-op — neither flag set, meaning SAP had nothing to activate — is a success. */
  success: boolean;
  uri: string;
};

export type TLObjectChildNode = {
  display_name: string;
  name: string;
  start_line?: number | null;
  type: string;
  uri: string;
};

export type TLObjectChildrenResponse = {
  children: TLObjectChildNode[];
  limit: number;
  offset: number;
  total: number;
  uri: string;
};

/**
 * Raw metadata XML for an ABAP object that does not serve `/source/main`.
 *
 * Used for DDIC/DTEL/DOMA/TABL and similar metadata-only types where ADT
 * returns a definition document at the object URI itself rather than a
 * separate source endpoint. The frontend displays this as a read-only
 * XML tab (or, later, parses it into a structured view per type).
 */
export type TLObjectMetadataResponse = {
  content: string;
  content_type: string;
  uri: string;
};

/**
 * Click position for forward-nav. Line is 1-based, column 0-based.
 */
export type TLNavigateRequest = {
  /** @minimum 0 */
  column: number;
  end_column?: number | null;
  end_line?: number | null;
  /** @minimum 1 */
  line: number;
  source?: string | null;
};

/**
 * Resolved navigation target for a Ctrl/Cmd-click.
 *
 * `None` is encoded by the controller as 204 No Content — no symbol at
 * that position, or filter excluded the candidate. Frontends should treat
 * that as "leave the cursor where it is".
 */
export type TLNavigateResponse = {
  target_column?: number | null;
  target_line?: number | null;
  target_uri: string;
};

export type TLPrettyPrintRequest = {
  /**
   * @minLength 1
   * @maxLength 5242880
   */
  source: string;
};

export type TLPrettyPrintResponse = {
  formatted_source: string;
  uri: string;
};

/**
 * Read-only source view of an ABAP object.
 *
 * Returned on double-click in the editor. Lock / save flows come in a
 * separate PR — this response does not attempt to convey editability.
 */
export type TLObjectSourceResponse = {
  source: string;
  uri: string;
  version: string;
};

/**
 * Body for PUT /project-explorer/objects/{uri}/source.
 *
 * `transport` is optional. Resolution order at save time:
 *   1. SAP's lock response includes a `corrnr` (object already in a TR)
 *      → the existing TR wins; SAP auto-adds a task for the saving user.
 *   2. Caller passed `transport` → that TR is used.
 *   3. Neither → save without a TR (works for $TMP / local-package
 *      objects; SAP will reject with a domain error otherwise).
 */
export type TLObjectSourceUpdateRequest = {
  /**
   * Full ABAP source for the object/include
   * @maxLength 5242880
   */
  source: string;
  /** Optional TR number to assign the change to; ignored if SAP's lock returns one */
  transport?: string | null;
};

export type TLObjectSourceUpdateResponse = {
  /** TR number actually used (empty for $TMP / local objects) */
  transport?: string;
  uri: string;
};

export enum TLProjectExplorerSyntaxCheckRequestVersion {
  active = 'active',
  inactive = 'inactive',
}
export type TLProjectExplorerSyntaxCheckRequest = {
  /** @maxLength 5242880 */
  source: string;
  version?: TLProjectExplorerSyntaxCheckRequestVersion;
};

export type TLSyntaxMessage = {
  column?: number;
  line?: number;
  short_text?: string;
  /** ADT severity code: E (error), W (warning), I (info) */
  type?: string;
  uri?: string;
};

export type TLProjectExplorerSyntaxCheckResponse = {
  messages?: TLSyntaxMessage[];
  success: boolean;
  uri: string;
};

export type TLTableDataPreviewColumn = {
  abap_type?: string;
  case_sensitive?: boolean;
  ddic_type?: string;
  description?: string;
  is_key?: boolean;
  is_key_figure?: boolean;
  length?: number;
  name: string;
};

export type TLTableDataPreviewResponse = {
  columns: TLTableDataPreviewColumn[];
  ddic_entity_name: string;
  executed_in_ms: number;
  is_hana_analytical_view?: boolean;
  rows: string[][];
  total_rows: number;
  uri: string;
};

export type TLObjectTransportInfoResponse = {
  description?: string | null;
  transport?: string | null;
};

export type TLUsageReferencesResponseTypeCounts = { [key: string]: number };

/**
 * One reference returned by the editor's where-used query.
 *
 * `type` is the raw ADT type code (e.g. `CLAS/OC`, `INTF/OI`, `FUGR/F`,
 * `PROG/P`, `METH/I`). Frontends render a pill from it and use it as the
 * type-filter key. `package` is the development package name when SAP
 * returned a `<adtcore:packageRef>` for the reference.
 */
export type TLUsageReferenceItem = {
  name: string;
  package?: string | null;
  parent_uri?: string | null;
  responsible?: string | null;
  type: string;
  uri: string;
};

/**
 * Paginated where-used result.
 *
 * `type_counts` reflects the **post-filter, pre-pagination** result so the
 * frontend can render `CLAS (12)`-style facets next to its checkbox group
 * even when the visible window is a slice. That means
 * `sum(type_counts.values()) == total`, NOT `len(references)`.
 *
 * `truncated` is True when SAP returned more rows than the tenant cap
 * allows; the modal uses it to surface a "refine the filter" hint.
 */
export type TLUsageReferencesResponse = {
  limit: number;
  offset: number;
  references: TLUsageReferenceItem[];
  total: number;
  truncated: boolean;
  type_counts: TLUsageReferencesResponseTypeCounts;
  uri: string;
};

export type TLPackageInfo = {
  description?: string | null;
  name: string;
};

export type TLPackageSearchResponse = {
  packages?: TLPackageInfo[];
};

export enum TLPrettyPrintCase {
  UPPER = 'UPPER',
  LOWER = 'LOWER',
  KEEP = 'KEEP',
}
/**
 * User-scoped Pretty Printer settings on the SAP system.
 *
 * Same data Eclipse manages under Window → Preferences → ABAP
 * Development → Editors → Source Code Editors → ABAP Formatter, and
 * SE38 → Utilities → Settings → Pretty Printer. Lives on the SAP user
 * profile — pretty-print output depends on whichever user's creds we
 * call ADT with.
 */
export type TLPrettyPrintSettings = {
  identifier_case: TLPrettyPrintCase;
  indent: boolean;
  keyword_case: TLPrettyPrintCase;
};

export type TLSubobjectListItem = {
  adt_uri?: string;
  filename: string;
  object_type?: string;
  program_id: string;
  sap_version?: string;
};

export type TLSubobjectListResponse = {
  parent_program_id: string;
  subobjects?: TLSubobjectListItem[];
};

/**
 * Result of `GET /project-explorer/sap-gui-url`. `url` always populated
 * so the FE has something to render even when WebGUI is offline; the FE
 * uses `webgui_active` to decide whether the "Open in SAP GUI" button is
 * clickable. `tcode` is included for the tooltip.
 */
export type TLSapGuiLinkResponse = {
  tcode: string;
  url: string;
  webgui_active: boolean;
};

export enum TLSaveAsProgramsRequestDomain {
  EDITOR = 'EDITOR',
  PROJECTS = 'PROJECTS',
}
export enum TLParentInputSapVersion {
  ECC = 'ECC',
  S4 = 'S4',
}
/**
 * Top-level object the user is saving (PROG / CLAS / FUGR / INTF / standalone INCL).
 */
export type TLParentInput = {
  /**
   * @minLength 1
   * @maxLength 1024
   */
  adt_uri: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * ADT object type: PROG / CLAS / FUGR / INTF / INCL / ...
   * @minLength 1
   * @maxLength 32
   */
  object_type: string;
  sap_version: TLParentInputSapVersion;
  /** @maxLength 5242880 */
  source: string;
};

/**
 * Child of the parent object (include, function module, class section, ...).
 */
export type TLSubobjectInput = {
  /**
   * @minLength 1
   * @maxLength 1024
   */
  adt_uri: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 32
   */
  object_type: string;
  /** @maxLength 5242880 */
  source: string;
};

export type TLSaveAsProgramsRequest = {
  correlation_id?: string | null;
  domain?: TLSaveAsProgramsRequestDomain;
  parent: TLParentInput;
  /** @maxItems 50 */
  subobjects?: TLSubobjectInput[];
};

/**
 * Per-item outcome for save-as-programs (parent + each subobject).
 */
export enum TLSaveStatus {
  ok = 'ok',
  error = 'error',
}
export type TLSaveItemStatus = {
  error?: string | null;
  name: string;
  program_id?: string | null;
  status: TLSaveStatus;
};

export type TLSaveAsProgramsResponse = {
  parent: TLSaveItemStatus;
  subobjects?: TLSaveItemStatus[];
};

/**
 * Paginated TR list. SAP's ADT CTS endpoint doesn't paginate server-side
 * so the slice is applied in `TransportService.list_modifiable`.
 */
export type TLTransportListResponse = {
  limit: number;
  offset: number;
  total: number;
  transports: TLTransportInfo[];
};

export type TLTransportCreateRequest = {
  /**
   * TR description (max 60 chars in SAP)
   * @minLength 1
   * @maxLength 60
   */
  description: string;
  /** Package the TR is created for */
  package?: string | null;
};

export enum TLProjectListSortField {
  CREATED_DATE = 'CREATED_DATE',
  UPDATED_DATE = 'UPDATED_DATE',
  NAME = 'NAME',
}
/**
 * Access level a user holds on a project.
 *
 * Members are declared most-privileged first; `values()` feeds the API schema and
 * reads better that way. The privilege *ranking* runs the other direction and lives
 * in `_ROLE_RANK` below — VIEWER < EDITOR < OWNER. Compare roles with
 * `role_satisfies`, never by declaration order.
 */
export enum TLProjectRole {
  OWNER = 'OWNER',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
}
/**
 * Project status values
 */
export enum TLProjectStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
/**
 * What a project is for, which decides the tabs it shows and the rules it obeys.
 *
 * The full taxonomy is seeded now (D8) even though the UI offers only two, so adding a type
 * later is a registry entry rather than a schema change. Which types a *user* may create is a
 * UI concern and lives in the frontend's create modal — the API accepts any of these, and the
 * frontend's tab registry already falls back for a type it has no layout for.
 *
 * Values are the strings stored in `projects.type` and must stay SCREAMING_SNAKE. The D10
 * partial indexes match `type = 'CODE_MODERNIZATION'` in SQL, where `BaseEnum`'s
 * case-insensitive comparison does not reach — a display-style value like the `Workstream`
 * enum's would satisfy every Python test while indexing nothing.
 */
export enum TLProjectType {
  GENERAL = 'GENERAL',
  CODE_MODERNIZATION = 'CODE_MODERNIZATION',
  VIEW_REMEDIATION = 'VIEW_REMEDIATION',
  DATA_HARMONIZATION = 'DATA_HARMONIZATION',
  MIGRATION = 'MIGRATION',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
}
export type TLProject = {
  created_by?: string | null;
  created_date?: string | null;
  /** The description of the project's default SAP transport request. */
  default_tr_description?: string | null;
  /** The project's default SAP transport request number. */
  default_tr_number?: string | null;
  my_role?: TLProjectRole | null;
  name: string;
  project_id?: string | null;
  /** The Code Remediation remedy backing this project, for CODE_MODERNIZATION projects. None for every other type, and for a Code Modernization project whose remedy import did not complete. */
  remedy_id?: string | null;
  source_system?: string | null;
  status: TLProjectStatus;
  target_system?: string | null;
  type: TLProjectType;
  updated_by?: string | null;
  updated_date?: string | null;
};

/**
 * A page of projects, with the total available and the paging values used.
 */
export type TLProjectsListResponse = {
  /** List of items */
  data: TLProject[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLPackageSource = {
  /** @maxItems 10000 */
  deselected_objects?: TLPackageImportObjectRef[];
  kind: 'PACKAGE';
  /**
   * @minLength 1
   * @maxLength 100
   */
  package_name: string;
  package_name_end?: string | null;
};

export type TLTransportsSource = {
  /** @maxItems 10000 */
  deselected_objects?: TLTransportImportObjectRef[];
  kind: 'TRANSPORTS';
  /**
   * @minItems 1
   * @maxItems 20
   */
  transport_numbers: string[];
};

export type TLObjectsSource = {
  kind: 'OBJECTS';
  /**
   * @minItems 1
   * @maxItems 10000
   */
  objects: TLRemediationObjectRef[];
};

export type TLFileSource = {
  kind: 'FILE';
  program_id: string;
};

export type TLCodeModernizationPayload = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  check_variant: string;
  sap_version?: TLSAPVersion;
  source: TLPackageSource | TLTransportsSource | TLObjectsSource | TLFileSource;
};

/**
 * Body for `POST /projects`.
 *
 * Phase 1 moved this endpoint off a query parameter — the one breaking API change in the
 * project — so that later phases can add per-type fields (Phase 2's `code_modernization`)
 * without changing its shape again.
 *
 * `type` defaults to GENERAL so a caller that only cares about a name still gets the pre-Phase-1
 * behaviour, and it matches both the column default and what every existing row became at
 * migration time.
 */
export type TLCreateProjectRequest = {
  code_modernization?: TLCodeModernizationPayload | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  type?: TLProjectType;
};

export type TLBulkDeleteProjectsRequest = {
  /**
   * List of project IDs to delete (at most 100)
   * @maxItems 100
   */
  project_ids: string[];
};

export type TLBulkDeleteProjectsResponse = {
  /** Number of projects successfully deleted */
  deleted_count: number;
  message: string;
  success: boolean;
};

export type TLMoveProgramsRequest = {
  program_ids: string[];
  target_project_id: string;
};

export type TLMoveProgramsResponse = {
  execution_id?: string | null;
  message: string;
  moved_count: number;
  success: boolean;
};

export type TLRenameProjectResponse = {
  message: string;
  new_name: string;
  old_name: string;
  success: boolean;
};

export enum TLFunctionalSpecStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
export type TLFunctionalSpecResponse = {
  created_by: string;
  created_date: string;
  current_version_id?: string | null;
  name: string;
  original_filename: string;
  project_id: string;
  spec_id: string;
  status: TLFunctionalSpecStatus;
  updated_date: string;
};

export type TLFunctionalSpecsListResponse = {
  specs: TLFunctionalSpecResponse[];
  total: number;
};

export type TLCreateFunctionalSpecRequest = {
  /**
   * Display name for the functional spec
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * Original uploaded filename
   * @minLength 1
   * @maxLength 255
   */
  original_filename: string;
};

export type TLUploadFunctionalSpecDocxProjectsRequest = {
  /** DOCX file to upload and extract SAP objects from */
  file: Blob;
};

export type TLExtractedObjectResponse = {
  object_name: string;
  object_type: string;
  object_uri: string;
};

export type TLUploadDocxResponse = {
  extracted_objects: TLExtractedObjectResponse[];
  spec_id: string;
  version_id: string;
  version_number: number;
};

/**
 * Which side of the paired-system pair gets the write. Default 'to-target' is the standard retrofit direction (source→target). 'to-source' is the reverse path used for TARGET_AHEAD back-port — target's content becomes the new source-of-truth on the source system.
 */
export enum TLApplyObjectRequestDirection {
  'to-target' = 'to-target',
  'to-source' = 'to-source',
}
export type TLApplyObjectRequest = {
  /** Must be true; explicit confirmation that this is a destructive write. */
  confirm_destructive?: boolean;
  /** Which side of the paired-system pair gets the write. Default 'to-target' is the standard retrofit direction (source→target). 'to-source' is the reverse path used for TARGET_AHEAD back-port — target's content becomes the new source-of-truth on the source system. */
  direction?: TLApplyObjectRequestDirection;
  object_uri: string;
  /** If true, after a successful apply also release the target TR (child tasks first, then parent) via ADT /newreleasejobs. S/4 only today — ECC release goes through a separate SICF service that isn't FE-exposed yet. */
  release_target_tr?: boolean;
  /** Full source body to write (text/plain). */
  source: string;
  /** Driving source transport, when the apply comes from a TR-scoped flow. Recorded in history for the source-TR → target-TR audit chain; None for object-level by-package applies. */
  source_tr?: string | null;
  /** Required when the object doesn't yet exist on target (CREATE_ON_TARGET). */
  target_package?: string | null;
  /** Existing modifiable workbench transport on the write-side system. When omitted, SAP assigns one. */
  target_tr?: string | null;
};

export type TLReleaseStep = {
  message?: string | null;
  status?: string | null;
  success: boolean;
  transport_number: string;
};

export type TLApplyObjectResponse = {
  actual_hash?: string | null;
  bytes_written?: number | null;
  created?: boolean;
  dry_run: boolean;
  error?: string | null;
  error_step?: string | null;
  intended_hash?: string | null;
  name: string;
  object_uri: string;
  project_id: string;
  /** Per-step release outcomes if release_target_tr was true on the request. Empty list if release wasn't requested. */
  release_steps?: TLReleaseStep[];
  steps?: string[];
  success: boolean;
  target_tr?: string | null;
  type_label: string;
};

export type TLLcaSummary = {
  candidates_examined?: number;
  outcome: string;
  reason: string;
  walkback_days?: number | null;
};

export type TLClassifyObjectResponse = {
  fetch_error?: string | null;
  lca?: TLLcaSummary | null;
  mode: string;
  name: string;
  object_uri: string;
  overlapping_ranges?: number;
  project_id: string;
  reason: string;
  source_changed_lines?: number | null;
  target_changed_lines?: number | null;
  type_label: string;
};

export type TLDiffArtifactResponse = {
  diff_text: string;
  has_conflicts: boolean;
  /** Just the merged source body for AUTO_MERGE / MANUAL_WORKBENCH (extracted from diff_text). None for other modes. */
  merged_source?: string | null;
  mode: string;
  object_uri: string;
  project_id: string;
  /** Full source-system HEAD body. Used by the FE to render a proper side-by-side editor view; absent when source is missing. */
  source_head?: string | null;
  suggested_filename: string;
  /** Full target-system HEAD body. Used by the FE to render a proper side-by-side editor view; absent when target is missing. */
  target_head?: string | null;
};

export type TLDiscoveredObjectResponse = {
  error?: string | null;
  name: string;
  object_uri: string;
  raw_type: string;
  source_hash?: string | null;
  source_package?: string | null;
  status: string;
  target_hash?: string | null;
  target_package?: string | null;
  type_label: string;
};

export type TLDiscoverPackageResponse = {
  objects: TLDiscoveredObjectResponse[];
  project_id: string;
  source_package: string;
  target_package: string;
};

/**
 * Current walk phase. 'starting' — request landed, no engine work yet. 'enumerate' — walking nodestructure on both sides; total unknown. 'compare' — per-object compare loop; processed/total are meaningful.
 */
export enum TLDiscoverProgressResponsePhase {
  starting = 'starting',
  enumerate = 'enumerate',
  compare = 'compare',
}
/**
 * Snapshot of an in-flight discover walk. Polled by the FE while the
 * main /discoveries GET is still running so the UI can render
 * "Comparing X/Y — 0:42s elapsed" instead of an opaque spinner.
 */
export type TLDiscoverProgressResponse = {
  /** Current walk phase. 'starting' — request landed, no engine work yet. 'enumerate' — walking nodestructure on both sides; total unknown. 'compare' — per-object compare loop; processed/total are meaningful. */
  phase: TLDiscoverProgressResponsePhase;
  /** Number of objects compared so far (0 outside 'compare' phase). */
  processed: number;
  /** When the discover request was received (UTC). */
  started_at: string;
  /** Total objects to compare (0 until 'compare' phase). */
  total: number;
};

/**
 * One persisted apply attempt — mirrors what the FE used to keep in
 * localStorage, now served from the `landscape_sync_history` table.
 */
export type TLHistoryEntry = {
  actual_hash?: string | null;
  bytes_written?: number | null;
  created?: boolean;
  direction: string;
  error?: string | null;
  error_step?: string | null;
  id: string;
  intended_hash?: string | null;
  mode?: string | null;
  object_name: string;
  object_uri: string;
  outcome: string;
  project_id: string;
  release_failures?: string[];
  released_trs?: string[];
  source_tr?: string | null;
  steps?: string[];
  target_tr?: string | null;
  timestamp: string;
  type_label: string;
  user_email: string;
};

export type TLHistoryListResponse = {
  entries: TLHistoryEntry[];
  project_id: string;
  /** Total rows matching the filter — for the header count + pagination. May be greater than len(entries) when limit is hit. */
  total: number;
};

/**
 * Output format. 'markdown' (default) returns a paste-able text document. 'docx' renders the same content as a Word file; the FE base64-decodes `content` and triggers a binary download.
 */
export enum TLChangeRecordExportRequestFormat {
  markdown = 'markdown',
  docx = 'docx',
}
/**
 * Render a markdown change-record from selected history rows.
 *
 * The export is read-only — it queries `landscape_sync_history` for the
 * rows the operator selected, formats them as a paste-able audit document
 * (title, description, summary stats, per-object table, per-TR roll-up),
 * and returns it as text. Nothing is persisted; the history rows ARE the
 * source of truth.
 */
export type TLChangeRecordExportRequest = {
  /** Optional change purpose / business context. */
  description?: string | null;
  /**
   * List of LandscapeSyncHistory row IDs to include.
   * @minItems 1
   * @maxItems 500
   */
  entry_ids: string[];
  /** Output format. 'markdown' (default) returns a paste-able text document. 'docx' renders the same content as a Word file; the FE base64-decodes `content` and triggers a binary download. */
  format?: TLChangeRecordExportRequestFormat;
  /** Optional external ticket reference (e.g. 'SNOW INC0098765'). */
  ticket_ref?: string | null;
  /**
   * Document title (e.g. 'ECC→S/4 retrofit of OM CR-2026-04812').
   * @minLength 1
   * @maxLength 120
   */
  title: string;
};

/**
 * How to interpret `content`. 'text' means the string IS the body; 'base64' means decode it before writing to disk (DOCX path).
 */
export enum TLChangeRecordExportResponseContentEncoding {
  text = 'text',
  base64 = 'base64',
}
export type TLChangeRecordExportResponse = {
  /** The rendered document body. For 'markdown' this is plain text; for 'docx' this is base64-encoded binary (decode before saving). */
  content: string;
  /** How to interpret `content`. 'text' means the string IS the body; 'base64' means decode it before writing to disk (DOCX path). */
  content_encoding?: TLChangeRecordExportResponseContentEncoding;
  /** MIME type of `content`. */
  content_type?: string;
  entry_count: number;
  failed_count: number;
  project_id: string;
  success_count: number;
  suggested_filename: string;
};

/**
 * Which paired system to scan. Default target (S/4): readiness findings are only meaningful there, and the S/4-readiness variant lives on that box.
 */
export enum TLAtcObjectScanRequestSide {
  source = 'source',
  target = 'target',
}
/**
 * Ad-hoc ATC scan for one or more workbench objects, run over the chosen
 * side's connector ADT session — the same path the transport cockpit uses,
 * not the version-keyed Code Remediation scanner.
 */
export type TLAtcObjectScanRequest = {
  /** ATC check variant; defaults to the tenant's atc_default_check_variant. */
  check_variant?: string | null;
  /**
   * @minItems 1
   * @maxItems 200
   */
  object_uris: string[];
  /** Which paired system to scan. Default target (S/4): readiness findings are only meaningful there, and the S/4-readiness variant lives on that box. */
  side?: TLAtcObjectScanRequestSide;
};

export enum TLAtcObjectScanResponseSide {
  source = 'source',
  target = 'target',
}
export type TLCockpitAtcFinding = {
  check_title: string;
  /** An automatic or AI-based ATC quick fix is available. */
  has_quickfix?: boolean;
  message?: string;
  object_name: string;
  object_type: string;
  object_uri?: string | null;
  /** ATC priority; 1 = most severe. */
  priority: number;
};

export type TLAtcObjectScanResponse = {
  check_variant: string;
  error?: string | null;
  /** False when the scan didn't run (nothing to scan, timeout, error). */
  evaluated: boolean;
  findings?: TLCockpitAtcFinding[];
  side: TLAtcObjectScanResponseSide;
  total_findings?: number;
};

/**
 * Which paired system to query. Usually 'source' — the operator wants to know which source-side TR currently has pending changes for the discovered object.
 */
export enum TLObjectsInTransportsRequestSide {
  source = 'source',
  target = 'target',
}
export type TLObjectsInTransportsRequest = {
  /**
   * ADT URIs to look up. Backend lists all modifiable TRs on `side` once, then filters the result to just these URIs.
   * @minItems 1
   * @maxItems 500
   */
  object_uris: string[];
  /** Which paired system to query. Usually 'source' — the operator wants to know which source-side TR currently has pending changes for the discovered object. */
  side?: TLObjectsInTransportsRequestSide;
};

/**
 * Map of object URI → list of modifiable TR numbers currently containing it on `side`. URIs not in any modifiable TR are omitted.
 */
export type TLObjectsInTransportsResponseByUri = { [key: string]: string[] };

export type TLObjectsInTransportsResponse = {
  /** Map of object URI → list of modifiable TR numbers currently containing it on `side`. URIs not in any modifiable TR are omitted. */
  by_uri?: TLObjectsInTransportsResponseByUri;
  project_id: string;
  side: string;
};

/**
 * Which system's usageReferences to query. Usually 'source' — we order by the dependency graph as it exists on the system we're reading from. Target-side ordering can differ if the systems have diverged, but operators rarely want that.
 */
export enum TLOrderObjectsRequestSide {
  source = 'source',
  target = 'target',
}
/**
 * Topo-sort a set of ADT URIs by their inter-object usage references.
 *
 * Used by the FE's BatchApplyDialog so a mass-apply applies dependencies
 * before dependents. Without this, applying a subclass before its base
 * class fails activation; operators have to manually re-run on errors.
 *
 * Optionally also detects "missing dependencies": objects in `object_uris`
 * that depend on something in `candidate_pool` but NOT in `object_uris`
 * itself. Surfaces as a warning so the operator can decide whether to
 * add the missing piece to the batch before applying.
 */
export type TLOrderObjectsRequest = {
  /**
   * Optional broader pool of URIs to consider when looking for missing dependencies. Typically the full divergent set from the discover panel. For each URI in `object_uris`, the backend checks whether any candidate (that's not also in `object_uris`) is a dependency. If so, it's flagged in `missing_deps`. Empty list disables the check (no extra work).
   * @maxItems 2000
   */
  candidate_pool?: string[];
  /**
   * ADT URIs to order. Backend fetches usageReferences for each (bounded concurrency) and returns a topo-sort respecting the dependency graph.
   * @minItems 1
   * @maxItems 500
   */
  object_uris: string[];
  /** Which system's usageReferences to query. Usually 'source' — we order by the dependency graph as it exists on the system we're reading from. Target-side ordering can differ if the systems have diverged, but operators rarely want that. */
  side?: TLOrderObjectsRequestSide;
};

/**
 * Map of URI → list of candidate-pool URIs it depends on that weren't included in the batch. Only populated when `candidate_pool` was supplied. Empty when nothing's missing.
 */
export type TLOrderObjectsResponseMissingDeps = { [key: string]: string[] };

export type TLOrderObjectsResponse = {
  /** Number of edges that participated in a cycle (could not be ordered). Operators should know this — apply may still fail on the objects involved. */
  cycle_count?: number;
  /** Map of URI → list of candidate-pool URIs it depends on that weren't included in the batch. Only populated when `candidate_pool` was supplied. Empty when nothing's missing. */
  missing_deps?: TLOrderObjectsResponseMissingDeps;
  /** Topo-sorted URIs. Always a complete permutation of the input. */
  ordered_uris: string[];
  project_id: string;
  side: string;
};

/**
 * Explicit operator resolution for a no-LCA object.
 *
 * No SAP source is written. The current target bytes are verified and the
 * decision is recorded against the driving source transport.
 */
export type TLRetainTargetRequest = {
  confirm_retain_target?: boolean;
  object_uri: string;
  source_tr?: string | null;
};

/**
 * Explicit operator choices that resolve a manual retrofit object.
 */
export enum TLLandscapeSyncResolution {
  RETAIN_TARGET = 'RETAIN_TARGET',
}
export type TLRetainTargetResponse = {
  already_recorded?: boolean;
  classification_mode: string;
  name: string;
  object_uri: string;
  project_id: string;
  resolution?: TLLandscapeSyncResolution;
  source_tr?: string | null;
  success?: boolean;
  target_hash: string;
  type_label: string;
};

/**
 * Per-system probe outcome.
 */
export type TLProbeSlotResponse = {
  adt_available?: boolean;
  base_url: string;
  bytes_received?: number | null;
  error?: string | null;
  fm_check_ok?: boolean;
  /** Required FMs not installed on this box. */
  missing_fms?: string[];
  reachable: boolean;
  /** Z_RFC_CTS_* FMs this side's flows need. */
  required_fms?: string[];
  rfc_available?: boolean;
  rfc_error?: string | null;
  rfc_reachable?: boolean | null;
  rfc_unavailable_reason?: string | null;
  /** Role in the pairing: 'source' or 'target'. */
  role: string;
  sap_version: string;
  status_code?: number | null;
  /** System tag (M_ECC | P_S4) per the project's source/target. */
  system: string;
};

/**
 * Result of a paired-system reachability probe.
 */
export type TLProbeResponse = {
  project_id: string;
  source: TLProbeSlotResponse;
  target: TLProbeSlotResponse;
};

export type TLRemediationHandoffObject = {
  /**
   * @minLength 1
   * @maxLength 120
   */
  name: string;
  /**
   * @minLength 1
   * @maxLength 30
   */
  object_type: string;
  /** Display label naming the TR(s) this object came from — free text, feeds tr_description verbatim for per-object traceability when the handoff spans a release set; defaults to the request's transport_number. Not parsed as a list. */
  tr?: string | null;
};

/**
 * Create a Code Remediation remedy from retrofit objects with ATC findings,
 * targeting the pair's S/4 side — the routed alternative to the CSV download.
 * The CR sink is keyed by object name, so same-named objects collapse to one.
 */
export type TLRemediationHandoffRequest = {
  /** ATC check variant for the remedy; defaults to the tenant's atc_default_check_variant. */
  check_variant?: string | null;
  /**
   * @minItems 1
   * @maxItems 200
   */
  objects: TLRemediationHandoffObject[];
  /**
   * @minLength 1
   * @maxLength 20
   */
  transport_number: string;
};

export type TLTargetPackageCheckResponse = {
  /** True if the package exists on the target system. */
  exists: boolean;
  package: string;
};

/**
 * Terminal operator-visible outcomes for a source retrofit transport.
 */
export enum TLRetrofitTransportStatus {
  RETROFITTED = 'RETROFITTED',
  MANUAL_RETROFIT = 'MANUAL_RETROFIT',
  RETROFIT_REJECTED = 'RETROFIT_REJECTED',
}
export type TLTransportDispositionEventResponse = {
  comment?: string | null;
  from?: TLRetrofitTransportStatus | null;
  target_tr?: string | null;
  timestamp: string;
  to?: TLRetrofitTransportStatus | null;
  user_email: string;
};

export type TLTransportDispositionResponse = {
  comment?: string | null;
  events?: TLTransportDispositionEventResponse[];
  project_id: string;
  source_tr: string;
  status?: TLRetrofitTransportStatus | null;
  target_tr?: string | null;
  updated_at: string;
  updated_by: string;
};

export type TLTransportDispositionListResponse = {
  dispositions?: TLTransportDispositionResponse[];
  offset: number;
  page_size: number;
  project_id: string;
  total_count: number;
};

/**
 * Which paired system to read TRs from. Typically the target (S/4).
 */
export enum TLRunCockpitChecksRequestSide {
  source = 'source',
  target = 'target',
}
export type TLRunCockpitChecksRequest = {
  /**
   * ATC check variant to run when run_atc is true.
   * @minLength 1
   * @maxLength 60
   */
  atc_variant?: string;
  /** Run an ATC scan per TR (feeds atc_safety). Set false to skip — ATC creates a worklist and polls, so it is the slowest of the checks. */
  run_atc?: boolean;
  /** Which paired system to read TRs from. Typically the target (S/4). */
  side?: TLRunCockpitChecksRequestSide;
  /** SID of the downstream system the TRs will be imported INTO (e.g. the QAS in the S/4 path). When set, the cockpit reads that system's STMS import buffer and flags out-of-order TRs; mirrors /SDF/TRCHECK's 'RFC to Target System'. Blank = skip the live import-queue check. */
  target_sid?: string | null;
  /**
   * TRs to check + sequence together (a release set).
   * @minItems 1
   * @maxItems 500
   */
  tr_numbers: string[];
};

/**
 * Cross-reference / sequencing finding category.
 */
export enum TLCrossRefKind {
  SHARED_OBJECT = 'SHARED_OBJECT',
  MISSING_PREDECESSOR = 'MISSING_PREDECESSOR',
  CATEGORY_ORDER = 'CATEGORY_ORDER',
  CIRCULAR = 'CIRCULAR',
  OUT_OF_SEQUENCE = 'OUT_OF_SEQUENCE',
  MISSING_IN_TARGET = 'MISSING_IN_TARGET',
}
/**
 * Cross-reference / sequencing finding severity.
 */
export enum TLCrossRefSeverity {
  BLOCKING = 'BLOCKING',
  WARNING = 'WARNING',
}
export type TLCrossRefFindingResponse = {
  detail: string;
  /** SHARED_OBJECT | MISSING_PREDECESSOR | CATEGORY_ORDER | CIRCULAR | OUT_OF_SEQUENCE | MISSING_IN_TARGET */
  kind: TLCrossRefKind;
  missing_tr?: string | null;
  object_name?: string | null;
  /** Recommended sequence already enforces this pair's order */
  order_resolved?: boolean;
  related_trs?: string[];
  /** BLOCKING | WARNING */
  severity: TLCrossRefSeverity;
  tr: string;
};

/**
 * Retrofit safety verdict from an upfront ATC scan. NOT_EVALUATED is
 * distinct from SAFE — an unscanned TR must never render as clean.
 */
export enum TLAtcSafetyCategory {
  SAFE = 'SAFE',
  REVIEW = 'REVIEW',
  UNSAFE = 'UNSAFE',
  NOT_EVALUATED = 'NOT_EVALUATED',
}
export enum TLCompleteCheckStatus {
  PASS = 'PASS',
  WARN = 'WARN',
  FAIL = 'FAIL',
  NOT_RUN = 'NOT_RUN',
  EMPTY = 'EMPTY',
}
export type TLCompleteCheckSummary = {
  consistency_issues?: number;
  inactive_count?: number;
  inactive_evaluated?: boolean;
  /** PASS | WARN | FAIL | NOT_RUN | EMPTY */
  status: TLCompleteCheckStatus;
  syntax_errors?: number;
  syntax_warnings?: number;
};

export type TLSequencedTrResponse = {
  /** True if an ATC scan ran for this TR. */
  atc_evaluated?: boolean;
  atc_finding_count?: number;
  /** ATC findings for this TR — drives the route-to-remediation handoff. */
  atc_findings?: TLCockpitAtcFinding[];
  /** SAFE (scanned clean), REVIEW (priority-2/3 findings), UNSAFE (priority-1), NOT_EVALUATED (no scan / scan failed). */
  atc_safety?: TLAtcSafetyCategory;
  /** Most severe ATC priority across this TR's findings (lowest int). */
  atc_worst_priority?: number | null;
  category: string;
  category_rank: number;
  category_reason: string;
  complete_check: TLCompleteCheckSummary;
  /** Number of cross-reference findings touching this TR. */
  conflict_count?: number;
  export_at?: string | null;
  number: string;
  object_count?: number;
  owner?: string | null;
  /** 1-based import position in the recommended sequence. */
  position: number;
  /** In-set TRs that must import before this one. */
  predecessors?: string[];
  /** Set when the computed order disagrees with the live target import queue. */
  queue_conflict?: string | null;
};

export type TLCockpitCheckResponse = {
  /** True if ATC actually scanned at least one TR — lets the FE tell 'clean' from 'unscannable'. */
  atc_evaluated?: boolean;
  /** Why a requested ATC run produced no evaluation (e.g. no checkable code objects in the set). */
  atc_note?: string | null;
  /** True if the operator asked for an ATC scan (request.run_atc). */
  atc_requested?: boolean;
  /** Total ATC findings across the release set. */
  atc_total_findings?: number;
  cycle_count?: number;
  error?: string | null;
  findings: TLCrossRefFindingResponse[];
  project_id: string;
  sequence: TLSequencedTrResponse[];
  side: string;
  /** True when referenced-object existence was probed on the paired target system. False means MISSING_IN_TARGET was NOT checked. */
  target_xref_evaluated?: boolean;
  /** Referenced object keys not probed on the target (no ADT URI, or cap reached); non-zero means the check is partial. */
  target_xref_unprobed_keys?: number;
  /** False when the trcheck RFC could not be executed — most commonly the Z_RFC_CTS_TRCHECK FM is missing, but also transient RFC/worker failures; `error` carries the specific cause and fix. */
  trcheck_available?: boolean;
  /** True when the installed FM (v2) returned the cross-reference feed, so missing-transport analysis actually ran. False on a v1 FM — the FE must render 'not checked' rather than implying zero missing transports. */
  xref_evaluated?: boolean;
};

/**
 * Release-state filter for the cockpit list. RELEASED is the default;
 * applied server-side so paging and `total` reflect the requested set.
 */
export enum TLCockpitTransportStatusFilter {
  released = 'released',
  modifiable = 'modifiable',
  all = 'all',
}
/**
 * CTS transport status (E070-TRSTATUS).
 *
 * The cockpit list is filtered to modifiable + released, so those two
 * dominate; the rest are included for completeness. Codes outside this set
 * normalize to None at the service boundary rather than 500 an unexpected
 * value.
 */
export enum TLCtsStatus {
  D = 'D',
  L = 'L',
  O = 'O',
  R = 'R',
  N = 'N',
}
/**
 * CTS request function (E070-TRFUNCTION) — the request types the cockpit
 * recognizes. Other codes normalize to None at the service boundary.
 */
export enum TLTrFunction {
  K = 'K',
  W = 'W',
  C = 'C',
}
/**
 * One TR in the auto-pulled project transport list (metadata + category).
 */
export type TLCockpitTransportSummary = {
  /** Import category (see TransportCategory enum). */
  category: string;
  /** Import-order rank for the category (lower imports first). */
  category_rank: number;
  /** Plain-English reason the TR landed in this category. */
  category_reason: string;
  description?: string | null;
  number: string;
  object_count?: number;
  owner?: string | null;
  /** Terminal transport outcome: RETROFITTED, MANUAL_RETROFIT, or RETROFIT_REJECTED. */
  retrofit_status?: TLRetrofitTransportStatus | null;
  /** At least one object of this TR was already applied successfully by a retrofit in this project (source rows match the apply's source_tr, target rows its target_tr). Partial retrofits count, so this is a marker, not proof of completeness. */
  retrofitted?: boolean;
  /** CTS status (E070-TRSTATUS): D=modifiable, R=released. */
  status?: TLCtsStatus | null;
  /** CTS request function (E070-TRFUNCTION): K=workbench, W=customizing, C=correction. */
  tr_type?: TLTrFunction | null;
};

export type TLCockpitListResponse = {
  project_id: string;
  /** Which paired system was listed: 'source' or 'target'. */
  side: string;
  /** Total TRs matching `side` and the requested `status` filter — for the header count + pagination. May be greater than len(transports) when a page limit is hit. */
  total?: number;
  transports: TLCockpitTransportSummary[];
  /** True when more TRs exist than this page returned — page forward or narrow by status. */
  truncated?: boolean;
};

/**
 * Per-TR post-retrofit remediation note from the cockpit's opt-in ATC run (the export itself does not re-run ATC). TRs absent here print as 'not scanned'.
 */
export type TLTrackerExportRequestAtcNotes = { [key: string]: string };

/**
 * Master tracker output format.
 */
export enum TLTrackerExportRequestFormat {
  xlsx = 'xlsx',
  docx = 'docx',
}
export enum TLTrackerExportRequestSide {
  source = 'source',
  target = 'target',
}
export type TLTrackerExportRequest = {
  /** Per-TR post-retrofit remediation note from the cockpit's opt-in ATC run (the export itself does not re-run ATC). TRs absent here print as 'not scanned'. */
  atc_notes?: TLTrackerExportRequestAtcNotes;
  description?: string | null;
  /** Master tracker output format. */
  format?: TLTrackerExportRequestFormat;
  side?: TLTrackerExportRequestSide;
  /** Downstream import-target SID for the live import-queue check (see RunCockpitChecksRequest). */
  target_sid?: string | null;
  /**
   * @minLength 1
   * @maxLength 120
   */
  title?: string;
  /**
   * @minItems 1
   * @maxItems 500
   */
  tr_numbers: string[];
};

export type TLTrackerExportResponse = {
  blocking_count: number;
  /** Base64-encoded file body (xlsx or docx). */
  content: string;
  content_encoding?: 'base64';
  content_type: string;
  project_id: string;
  suggested_filename: string;
  transport_count: number;
  warning_count: number;
  /** True when missing-transport analysis ran for this export (v2 FM). False means the tracker's zero missing-transport findings are 'not checked', not 'verified clean'. */
  xref_evaluated?: boolean;
};

export type TLRetrofitTrRequest = {
  /** Apply even when the pre-retrofit Complete Check reports FAIL. Default false: refuse. */
  allow_check_failures?: boolean;
  /** Apply even when another transport changes the same objects out of order. Default false: refuse and return the conflicts. */
  allow_out_of_sequence?: boolean;
  /** Allow TRs that contain SAP-namespace (non-Z*\/Y*) entries — typical of SAP Note TRs. Default false: refuse. High-risk override. */
  allow_sap_modifications?: boolean;
  /** Apply even when the sequencing check or Complete Check could not run at all. Default false: a confirmed apply with unevaluated safety checks is refused (fail closed). */
  allow_unchecked_apply?: boolean;
  /** Must be true to actually write to target. Default false = dry-run. */
  confirm_destructive?: boolean;
  /** When true (default), topo-sort entries by ADT usageReferences so dependencies retrofit before their users. */
  dag_order?: boolean;
  /** Existing modifiable workbench transport on the target system for every applied code object. */
  target_tr?: string | null;
  /**
   * @minLength 1
   * @maxLength 20
   */
  transport_number: string;
};

/**
 * Complete Check issue severity, mapped from the ADT message class.
 */
export enum TLCheckIssueSeverity {
  E = 'E',
  W = 'W',
  I = 'I',
}
/**
 * Which Complete Check produced an issue.
 */
export enum TLCheckIssueSource {
  SYNTAX = 'SYNTAX',
  CONSISTENCY = 'CONSISTENCY',
  INACTIVE = 'INACTIVE',
}
export type TLCockpitCheckIssue = {
  object_name?: string | null;
  /** E=error | W=warning | I=info */
  severity: TLCheckIssueSeverity;
  /** SYNTAX | CONSISTENCY | INACTIVE */
  source: TLCheckIssueSource;
  text: string;
  uri?: string | null;
};

/**
 * Per-entry outcome from a TR-driven retrofit.
 */
export type TLRetrofitTrEntryOutcome = {
  mode: string;
  name: string;
  note: string;
  object_uri?: string | null;
  /** APPLIED | DRY-RUN | SKIPPED | FAILED | MANUAL | ERROR */
  status: string;
};

export type TLRetrofitTrResponse = {
  auto_count?: number;
  check_issues?: TLCockpitCheckIssue[];
  /** Pre-retrofit Complete Check for the source TR. FAIL blocks apply unless allow_check_failures=true. */
  complete_check?: TLCompleteCheckSummary | null;
  customizing_count?: number;
  /** DAG-sort outcome signal. >=0: number of cycle edges detected during DAG sort (0 means cleanly sorted, >0 means partial fallback). -1: DAG sort errored entirely and we fell back to TR insertion order — applies may run in dependency-violating order. */
  dag_cycles?: number;
  description?: string | null;
  dry_run: boolean;
  entries: TLRetrofitTrEntryOutcome[];
  failed_count?: number;
  manual_count?: number;
  project_id: string;
  /** True when the TR is released on source; modifiable TRs are refused. */
  released?: boolean;
  /** Other transports changing the same objects out of order. Only BLOCKING findings block apply (unless allow_out_of_sequence=true). */
  sequencing_conflicts?: TLCrossRefFindingResponse[];
  /** True when the sequencing check ran. False means conflicts were NOT checked, not that there are none. */
  sequencing_evaluated?: boolean;
  /** True when released overlaps beyond the sequencing cap went unexamined; modifiable overlaps are always fully examined. */
  sequencing_partial?: boolean;
  /** Source-side CTS status: D=modifiable, R=released, … */
  tr_status?: string | null;
  transport_number: string;
  unknown_count?: number;
  unsupported_count?: number;
  workbench_count?: number;
};

/**
 * One entry in a TR's content list, with the engine's retrofit verdict.
 */
export type TLInspectedTrObject = {
  /** WORKBENCH_SUPPORTED | WORKBENCH_UNSUPPORTED | CUSTOMIZING | SYSTEM_GENERATED | UNKNOWN */
  category: string;
  cts_type?: string | null;
  description?: string | null;
  name?: string | null;
  note: string;
  object_uri?: string | null;
  program_id?: string | null;
  retrofit_action: string;
  workbench_type?: string | null;
};

export type TLCockpitTrDetailResponse = {
  category: string;
  check_issues?: TLCockpitCheckIssue[];
  complete_check: TLCompleteCheckSummary;
  conflicts?: TLCrossRefFindingResponse[];
  description?: string | null;
  objects: TLInspectedTrObject[];
  owner?: string | null;
  project_id: string;
  side: string;
  transport_number: string;
};

export type TLCompleteTransportResponse = {
  already_recorded?: boolean;
  blockers?: string[];
  complete: boolean;
  expected_count: number;
  project_id: string;
  resolved_count: number;
  source_tr: string;
  unresolved_object_uris?: string[];
};

/**
 * Where one customizing entry goes in the retrofit plan.
 */
export enum TLRetrofitRoute {
  BC_SET = 'BC_SET',
  SKIP_SAME = 'SKIP_SAME',
  HANDOFF_SIMPLIFIED = 'HANDOFF_SIMPLIFIED',
  HANDOFF_NON_TRANSPARENT = 'HANDOFF_NON_TRANSPARENT',
  HANDOFF_KEY_MISMATCH = 'HANDOFF_KEY_MISMATCH',
  HANDOFF_DELETE = 'HANDOFF_DELETE',
  HANDOFF_UNREADABLE = 'HANDOFF_UNREADABLE',
}
/**
 * Per-route counts across the transport's customizing entries — drives the
 * 'auto-retrofit vs manual handoff' plan header.
 */
export type TLRetrofitPlanSummaryResponse = {
  /** BC-Set entries whose target changed independently (overwrite warning). */
  conflicted?: number;
  /** Number of entries per retrofit route. */
  counts?: Partial<Record<TLRetrofitRoute, number>>;
  total?: number;
};

/**
 * One field of the row, side by side. None = the field is initial (unset)
 * on that system — the FM only serializes non-initial fields.
 */
export type TLCustomizingFieldDiff = {
  differs?: boolean;
  fieldname: string;
  source_value?: string | null;
  target_value?: string | null;
  /** Value hit the 255-char serialization cap — compared partially. */
  truncated?: boolean;
};

/**
 * One customizing key entry's identity — echoed back verbatim from the
 * rows response when the operator selects rows to split. Never an entry id
 * (those are per-call handles on the SAP side).
 */
export type TLCustomizingKeyRef = {
  /** True = a concrete row inside a range entry (cherry-pick), not the transport entry itself. Disambiguates a covered row whose key equals its range's recorded key. */
  covered?: boolean;
  /** Logical parent name — rows sharing one form one logical object. */
  master_name?: string;
  /** Logical parent type (view cluster etc.), when SAP recorded one. */
  master_type?: string;
  /** E071K OBJNAME — usually the table name. */
  obj_name: string;
  /** E071K OBJECT — entry type code (TABU | CDAT | VDAT | …). */
  obj_type: string;
  /** E071K PGMID (R3TR | LIMU | CORR …). */
  pgmid: string;
  /** Concatenated character image of the row's key fields. */
  tabkey: string;
};

/**
 * One labeled key-field value ('Company Code' → '1000') for jargon-free display.
 */
export type TLCustomizingKeyDisplayPart = {
  label: string;
  value: string;
};

/**
 * Per-row outcome inside an expanded generic range (source vs target).
 */
export enum TLCustCoveredRowOutcome {
  SAME = 'SAME',
  DIFFERS = 'DIFFERS',
  ONLY_ON_SOURCE = 'ONLY_ON_SOURCE',
  ONLY_ON_TARGET = 'ONLY_ON_TARGET',
}
/**
 * One concrete row inside an expanded generic range, aligned source-vs-
 * target, with a per-row outcome.
 */
export type TLCustomizingCoveredRow = {
  fields?: TLCustomizingFieldDiff[];
  /** The row's full key — selectable for cherry-pick apply (except ONLY_ON_TARGET rows). */
  key: TLCustomizingKeyRef;
  key_display?: TLCustomizingKeyDisplayPart[];
  outcome: TLCustCoveredRowOutcome;
};

/**
 * Source-vs-target comparison verdict for one customizing key entry.
 */
export enum TLCustRowVerdict {
  SAME = 'SAME',
  DIFFERS = 'DIFFERS',
  MISSING_ON_TARGET = 'MISSING_ON_TARGET',
  DELETED_ON_SOURCE = 'DELETED_ON_SOURCE',
  MISSING_ON_BOTH = 'MISSING_ON_BOTH',
  UNCOMPARABLE = 'UNCOMPARABLE',
}
/**
 * One key entry of the transport with its source-vs-target verdict.
 */
export type TLCustomizingRowEntry = {
  compared_partially?: boolean;
  /** BC_SET only: the target row already differs, so activation would overwrite an independent target change. */
  conflicted?: boolean;
  /** Expanded rows of a generic range, aligned source-vs-target with per-row outcomes. Empty for single-row entries or when expansion wasn't available. */
  covered_rows?: TLCustomizingCoveredRow[];
  /** Side-by-side field values (union of both systems' non-initial fields). */
  fields?: TLCustomizingFieldDiff[];
  /** Wildcard/short key covering a range — moves all-or-nothing. */
  is_generic?: boolean;
  key: TLCustomizingKeyRef;
  /** Labeled key-field values (client omitted). Empty when the table's key metadata is unavailable (e.g. not a readable table) — show the reason instead. */
  key_display?: TLCustomizingKeyDisplayPart[];
  /** Plain-English explanation of the verdict — always present. */
  reason: string;
  /** Retrofit route (boundary detection): BC_SET (auto via BC-Set), SKIP_SAME, or a HANDOFF_* reason (manual handling). */
  route: TLRetrofitRoute;
  /** Plain-English explanation of the route. */
  route_reason: string;
  /** Matching rows on source; -1 = unbounded key, not counted. */
  source_row_count?: number;
  /** Matching rows on target; null = not probed. */
  target_row_count?: number | null;
  verdict: TLCustRowVerdict;
};

/**
 * All of the transport's rows for one table, with plain-language metadata.
 */
export type TLCustomizingTableGroup = {
  /** Table description (DD02T) — the primary label in the UI. */
  description?: string;
  /** Ordered key-field labels (client omitted) for column headers. */
  key_field_labels?: string[];
  rows?: TLCustomizingRowEntry[];
  tabclass?: string;
  tabname: string;
};

/**
 * One explicit truncation/notice from the SAP read — surfaced verbatim,
 * never silently dropped.
 */
export type TLCustomizingTruncationNote = {
  detail?: string;
  dropped?: number;
  /** ENTRIES (keys dropped) | ROW_DATA (values omitted) | TRKORR (TR not found). */
  scope: string;
  /** Which read reported it: 'source' or 'target'. */
  system: string;
  tabname?: string;
  trkorr?: string;
};

/**
 * A customizing transport's actual configuration rows, compared source vs
 * target — the read side of pick-and-choose retrofit.
 */
export type TLCustomizingRowsResponse = {
  /** Boundary-detection roll-up: per-route counts for the retrofit plan. */
  plan?: TLRetrofitPlanSummaryResponse;
  project_id: string;
  tables?: TLCustomizingTableGroup[];
  /** Why the target probe failed, when target_probed=false. */
  target_error?: string | null;
  /** False when the target system could not be asked about the keys (e.g. the read FM is not installed there) — verdicts then read UNCOMPARABLE, but rows can still be split. */
  target_probed?: boolean;
  transport_number: string;
  truncations?: TLCustomizingTruncationNote[];
};

export enum TLSetTransportDispositionRequestStatus {
  MANUAL_RETROFIT = 'MANUAL_RETROFIT',
  RETROFIT_REJECTED = 'RETROFIT_REJECTED',
}
export type TLSetTransportDispositionRequest = {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  comment: string;
  status: TLSetTransportDispositionRequestStatus;
  target_tr?: string | null;
};

export type TLReopenTransportDispositionRequest = {
  /**
   * @minLength 1
   * @maxLength 2000
   */
  comment: string;
};

export type TLInspectTrResponseCounts = { [key: string]: number };

export type TLInspectTrResponse = {
  counts: TLInspectTrResponseCounts;
  description?: string | null;
  /** SAP Note numbers attached to this TR via R3TR NOTE entries. Concrete evidence for the 'note_entry' signal — displayed inline so operators can see exactly which Notes the TR carries. */
  note_numbers?: string[];
  objects: TLInspectedTrObject[];
  /** TR owner (E070-AS4USER). Useful for the operator to see who created the TR before acting on it, especially when inspecting TRs owned by other team members. */
  owner?: string | null;
  project_id: string;
  /** When the TR was released on this system (E070-AS4DATE / AS4TIME). Null for modifiable TRs (status='D' — never released). Used by the FE to sort inspect cards in release order so the operator retrofits in the same sequence the changes shipped — the canonical dependency-order signal because a TR can't release if its objects don't compile against earlier-released contents. */
  released_at?: string | null;
  /** Task numbers within this TR that SAP labelled 'Repair' (TRFUNCTION='R' on the task). Concrete evidence for the 'repair_task' signal — these tasks modify SAP-owned code. */
  repair_task_numbers?: string[];
  /** TR-level signals that this is a SAP-delivered TR (SAP Note or correction). Possible values: 'correction_request' (TRFUNCTION='C'), 'sap_owner' (owner in SAP/DDIC/SAPSYS), 'note_entry' (contains R3TR NOTE entry), 'repair_task' (contains a Repair task — SAP-owned code modification), 'note_description' (description mentions SAP Note). FE shows a 'High risk: SAP-delivered' chip when this list is non-empty. */
  sap_delivery_signals?: string[];
  /** Which paired system was queried: 'source' or 'target'. */
  side: string;
  /** TR CTS status (E070-TRSTATUS): D=modifiable, L=modifiable-locked, O=release-started, R=released, N=released-frozen. Released = status in {R,O,N}. */
  status?: string | null;
  transport_number: string;
  /** TR function code (E070-TRFUNCTION): K=workbench, W=customizing, C=correction (SAP-delivered). */
  transport_type?: string | null;
};

/**
 * Apply picked customizing rows onto the target (BC-Set-style retrofit).
 */
export type TLRetrofitRowsRequest = {
  /** Must be true to write; default is a dry-run validation on the target. */
  confirm_destructive?: boolean;
  /**
   * Intended text when SAP creates a target-side transport. The current RFC does not yet carry this text into SAP; it is ignored when target_tr selects an existing transport.
   * @maxLength 60
   */
  description?: string;
  /**
   * @minItems 1
   * @maxItems 500
   */
  selected_keys: TLCustomizingKeyRef[];
  /** Existing modifiable customizing transport on the target system. When omitted, the RFC creates one. */
  target_tr?: string | null;
};

export type TLRetrofitRowResult = {
  detail?: string;
  key_display?: TLCustomizingKeyDisplayPart[];
  /** WOULD_WRITE | WOULD_DELETE | WRITTEN | DELETED | ABSENT | REFUSED */
  status: string;
  tabname: string;
};

export type TLRetrofitRowsResponse = {
  dry_run: boolean;
  messages?: string[];
  /** Customizing request created on the target. */
  new_transport?: string | null;
  next_steps?: string;
  project_id: string;
  results?: TLRetrofitRowResult[];
  /** The released source transport the rows came from. */
  transport_number: string;
};

export type TLProjectMember = {
  created_by: string;
  created_date?: string | null;
  project_id: string;
  role: TLProjectRole;
  updated_by: string;
  updated_date?: string | null;
  user_email: string;
};

export type TLPaginatedResponseProjectMember = {
  /** List of items */
  data: TLProjectMember[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLAddProjectMemberRequest = {
  role?: TLProjectRole;
  /**
   * @minLength 3
   * @maxLength 255
   * @pattern ^[^@\s]+@[A-Za-z0-9]([A-Za-z0-9.-]*[A-Za-z0-9])?$
   */
  user_email: string;
};

export type TLUpdateProjectMemberRoleRequest = {
  role: TLProjectRole;
};

export type TLUpdateProjectSystemsRequest = {
  source_system?: string | null;
  target_system?: string | null;
};

export enum TLReleaseRequestState {
  PENDING = 'PENDING',
  DISPATCHED = 'DISPATCHED',
  RELEASED = 'RELEASED',
  SYNC_FAILED = 'SYNC_FAILED',
  NOT_CONVERGED = 'NOT_CONVERGED',
  CANCELLED = 'CANCELLED',
}
export type TLReleaseRequestSummary = {
  components: string[];
  created_date: string;
  request_id: string;
  requested_by: string;
  state: TLReleaseRequestState;
  workflow_run_url: string | null;
};

export type TLComponentReleaseStatus = {
  component: string;
  running: string | null;
};

export type TLReleaseStatus = {
  active_request: TLReleaseRequestSummary | null;
  components: TLComponentReleaseStatus[];
  github_reachable: boolean;
  recent: TLReleaseRequestSummary[];
};

/**
 * POST /remediation-runs body.
 *
 * Creates one agentic run per supported ``object_id`` in ``object_ids``
 * (single-object trigger = list of one); objects of unsupported types get no
 * run and are reported on the response's ``skipped_objects``. When
 * ``transport_request_id`` is set the runs share it as a grouping tag; the
 * workflow then processes the runs sequentially.
 */
export type TLAgenticRemediationRunRequest = {
  finding_id?: string | null;
  /**
   * @minItems 1
   * @maxItems 500
   */
  object_ids: string[];
  remedy_id: string;
  rule_ids?: string[] | null;
  transport_request_id?: string | null;
};

export enum TLAgenticObjectSkipReason {
  UNSUPPORTED_OBJECT_TYPE = 'UNSUPPORTED_OBJECT_TYPE',
  SOURCE_FETCH_FAILED = 'SOURCE_FETCH_FAILED',
  NOT_EDITABLE_BY_REQUESTER = 'NOT_EDITABLE_BY_REQUESTER',
  SAP_STANDARD_OBJECT = 'SAP_STANDARD_OBJECT',
}
/**
 * An object agentic remediation left untouched, with the reason: its type
 * isn't supported (only source-bearing compilation units — CLAS, FUGR, INTF,
 * PROG — can be remediated), it is SAP-standard, a member of its unit isn't
 * editable by the requester, or its source could not be fetched from SAP.
 * Surfaced on the start response (objects no run was created for) and on run
 * DTOs (unit members a run had to exclude).
 */
export type TLAgenticSkippedObject = {
  detail?: string | null;
  object_id?: string | null;
  object_name: string;
  object_type?: string | null;
  reason: TLAgenticObjectSkipReason;
};

/**
 * Returned from POST /remediation-runs with 202.
 *
 * ``run_ids`` covers only the objects a run was created for, in request order
 * (deduplicated, minus ``skipped_objects``) — don't zip it positionally
 * against the request's ``object_ids`` when anything was skipped.
 */
export type TLAgenticRemediationRunStartedResponse = {
  run_ids: string[];
  skipped_objects?: TLAgenticSkippedObject[];
};

/**
 * True finding-level totals for each bucket, independent of the capped rollup
 * lists (which omit groups when truncated) — the authoritative sizes. The headline
 * identity ``initial - fixed + introduced == final`` holds, so the before/after
 * finding totals reconcile with what the run changed.
 */
export type TLAtcResolutionCounts = {
  final?: number;
  fixed?: number;
  initial?: number;
  introduced?: number;
  residual_undeclared?: number;
  unresolvable?: number;
};

/**
 * ATC finding severity. Values are SAP's numeric priority strings, so the enum
 * serializes back to "1"/"2"/"3" (BaseEnum is a str enum) — wire-compatible with the
 * raw ATC worklist and ``summarize_preview_atc`` payloads it's parsed from.
 */
export enum TLAtcPriority {
  NUMBER_1 = '1',
  NUMBER_2 = '2',
  NUMBER_3 = '3',
}
/**
 * A per-check rollup in a run's resolution report: one ATC check, its priority,
 * how many findings of it there were (``count``), a representative message, and a
 * bounded sample of the sub-objects it was raised on.
 */
export type TLAtcResolutionCheck = {
  check_title?: string | null;
  count?: number;
  message?: string | null;
  priority?: TLAtcPriority | null;
  subobjects?: string[];
};

/**
 * A finding the agent declared it could not remediate in this system, with
 * the concrete reason (e.g. the S/4HANA successor object is not installed).
 * Surfaced first-class so the UI can show *why* a run left something unfixed —
 * and offer to capture a curated fix rule — without parsing the transcript.
 */
export type TLAgenticUnresolvableFinding = {
  finding: string;
  object_name?: string | null;
  reason: string;
};

/**
 * Four-bucket outcome of a run's ATC remediation: what was fixed, what the agent
 * declared unresolvable (with reasons), what residual findings remain that were
 * neither fixed nor declared, and what findings the run introduced (present after
 * but not before — regressions). Findings are rolled up by check (not enumerated) so
 * the report stays bounded at ~200-finding scale. ``final_scan_available`` is False
 * when no reliable post-fix scan backs the buckets; ``baseline_available`` is False
 * when no reliable pre-fix baseline existed, so nothing could be attributed as fixed
 * or introduced; ``counts`` holds the true finding totals (reconciling before→after
 * via ``initial - fixed + introduced == final``) and ``truncated`` is True when a
 * rollup list is a sample that can disagree with ``counts`` — the counts are the
 * authority.
 */
export type TLAtcResolution = {
  baseline_available?: boolean;
  counts?: TLAtcResolutionCounts;
  final_scan_available?: boolean;
  fixed?: TLAtcResolutionCheck[];
  introduced?: TLAtcResolutionCheck[];
  residual_undeclared?: TLAtcResolutionCheck[];
  truncated?: boolean;
  unresolvable?: TLAgenticUnresolvableFinding[];
};

/**
 * The reviewer agent's terminal correctness judgement on a proposed
 * remediation: does the fix resolve the finding (APPROVED) or does it still
 * need changes (NEEDS_MODIFICATION). This is independent of risk — a separate
 * risk score (future) can flag an APPROVED proposal as needing extra human
 * validation.
 */
export enum TLAgenticReviewVerdict {
  APPROVED = 'APPROVED',
  NEEDS_MODIFICATION = 'NEEDS_MODIFICATION',
}
/**
 * Which recorded original to restore when rolling back an agentic run.
 *
 * RUN_SNAPSHOT is the pre-run ACTIVE source captured to object storage by
 * the run itself; PROGRAM_BASELINE is the member's program v1.0 (the FE's
 * "original version"), which survives even if the run's snapshots are gone.
 */
export enum TLAgenticRollbackSource {
  RUN_SNAPSHOT = 'RUN_SNAPSHOT',
  PROGRAM_BASELINE = 'PROGRAM_BASELINE',
}
export type TLAgenticRemediationRunSummaryTranscript = { [key: string]: unknown } | null;

/**
 * Run row as the LIST endpoint surfaces it — storage path only, no inline source.
 */
export type TLAgenticRemediationRunSummary = {
  /** Four-bucket ATC outcome: findings the run fixed, ones the agent declared unresolvable (with reasons), residual findings neither fixed nor declared, and findings the run introduced. Derived from the transcript's atc_resolution key. */
  readonly atc_resolution: TLAtcResolution | null;
  cache_read_tokens?: number;
  completed_at?: string | null;
  created_date: string;
  error?: string | null;
  finding_id: string | null;
  input_tokens?: number;
  object_id: string | null;
  output_tokens?: number;
  parent_run_id?: string | null;
  proposed_source_path?: string | null;
  proposed_source_size_bytes?: number | null;
  rationale?: string | null;
  remedy_id: string;
  review_atc_reviewed?: boolean;
  review_rationale?: string | null;
  review_syntax_reviewed?: boolean;
  review_verdict?: TLAgenticReviewVerdict | null;
  rollback_source?: TLAgenticRollbackSource | null;
  rolled_back_at?: string | null;
  rolled_back_by?: string | null;
  run_id: string;
  /** True when the run shipped a proposal but the SAP write/activation failed, so the fix is not durably live in SAP even though the run succeeded. Derived from the transcript's sap_write key. */
  readonly sap_write_failed: boolean;
  /** Compilation-unit members this run had to exclude because their SAP source could not be fetched, with per-member details. Derived from the transcript's skipped_objects key. */
  readonly skipped_objects: readonly TLAgenticSkippedObject[];
  started_at?: string | null;
  status: TLAgenticRemediationStatus;
  syntax_check_passed?: boolean | null;
  transcript?: TLAgenticRemediationRunSummaryTranscript;
  transport_request_id: string | null;
  /** Findings the agent declared it could not fix in this system, with reasons. Derived from the transcript's unresolvable_findings key, so historical rows surface them too. */
  readonly unresolvable_findings: readonly TLAgenticUnresolvableFinding[];
  updated_date: string;
};

export type TLAgenticRemediationRunsListResponse = {
  runs?: TLAgenticRemediationRunSummary[];
  total?: number;
};

export type TLAgenticRemediationRunDetailReviewTranscript = { [key: string]: unknown } | null;

export type TLAgenticRemediationRunDetailTranscript = { [key: string]: unknown } | null;

/**
 * Outcome of the post-completion sub-object ATC verification scan.
 *
 * COMPLETED: the verification ATC scan ran and its per-sub-object findings are
 *     recorded (``had_errors`` then says whether any residual errors remain).
 * INCONCLUSIVE: the scan could not be completed (ERROR/TIMEOUT/exception); the
 *     verification result is advisory only and does not reflect the live unit.
 */
export enum TLSubobjectVerificationStatus {
  COMPLETED = 'COMPLETED',
  INCONCLUSIVE = 'INCONCLUSIVE',
}
/**
 * One ATC finding attributed to a unit member during post-completion verification.
 */
export type TLSubobjectFinding = {
  check_title?: string;
  line?: number;
  message?: string;
  /** ATC severity (serializes to '1'=error / '2'=warning / '3'=info) */
  priority: TLAtcPriority;
};

/**
 * Per-member residual-ATC verdict from the post-completion unit scan.
 */
export type TLSubobjectVerificationEntry = {
  error_count?: number;
  findings?: TLSubobjectFinding[];
  info_count?: number;
  is_parent?: boolean;
  name: string;
  object_id: string;
  warning_count?: number;
};

/**
 * Outcome of scanning the live parent unit after a shipped remediation and
 * bucketing the ATC findings per sub-object (and the parent). ``had_errors`` is the
 * headline: True iff any member still has a priority-1 finding.
 */
export type TLSubobjectVerificationResult = {
  check_variant?: string | null;
  had_errors?: boolean;
  message?: string | null;
  status: TLSubobjectVerificationStatus;
  subobjects?: TLSubobjectVerificationEntry[];
  total_errors?: number;
};

/**
 * Detail GET adds a short-lived presigned URL; the frontend fetches the
 * proposal source directly from object storage. None until the run has a
 * stored proposal (proposed_source_path set). Also carries the reviewer's
 * turn-by-turn transcript (kept off the list response to stay lean).
 */
export type TLAgenticRemediationRunDetail = {
  /** Four-bucket ATC outcome: findings the run fixed, ones the agent declared unresolvable (with reasons), residual findings neither fixed nor declared, and findings the run introduced. Derived from the transcript's atc_resolution key. */
  readonly atc_resolution: TLAtcResolution | null;
  cache_read_tokens?: number;
  completed_at?: string | null;
  created_date: string;
  error?: string | null;
  finding_id: string | null;
  input_tokens?: number;
  object_id: string | null;
  output_tokens?: number;
  parent_run_id?: string | null;
  proposed_source_path?: string | null;
  proposed_source_size_bytes?: number | null;
  proposed_source_url?: string | null;
  rationale?: string | null;
  remedy_id: string;
  review_atc_reviewed?: boolean;
  review_rationale?: string | null;
  review_syntax_reviewed?: boolean;
  review_transcript?: TLAgenticRemediationRunDetailReviewTranscript;
  review_verdict?: TLAgenticReviewVerdict | null;
  rollback_source?: TLAgenticRollbackSource | null;
  rolled_back_at?: string | null;
  rolled_back_by?: string | null;
  run_id: string;
  /** True when the run shipped a proposal but the SAP write/activation failed, so the fix is not durably live in SAP even though the run succeeded. Derived from the transcript's sap_write key. */
  readonly sap_write_failed: boolean;
  /** Compilation-unit members this run had to exclude because their SAP source could not be fetched, with per-member details. Derived from the transcript's skipped_objects key. */
  readonly skipped_objects: readonly TLAgenticSkippedObject[];
  started_at?: string | null;
  status: TLAgenticRemediationStatus;
  subobject_verification?: TLSubobjectVerificationResult | null;
  syntax_check_passed?: boolean | null;
  transcript?: TLAgenticRemediationRunDetailTranscript;
  transport_request_id: string | null;
  /** Findings the agent declared it could not fix in this system, with reasons. Derived from the transcript's unresolvable_findings key, so historical rows surface them too. */
  readonly unresolvable_findings: readonly TLAgenticUnresolvableFinding[];
  updated_date: string;
};

/**
 * The proposed source text for a run, served inline by the BE so the web
 * editor can preview it without hitting S3 (the stored blob carries a
 * download Content-Disposition and would otherwise need S3 CORS).
 */
export type TLAgenticRemediationProposedSource = {
  run_id: string;
  size_bytes?: number | null;
  source: string;
};

/**
 * Outcome of shipping one unit member to S/4 (apply-mode): activating
 * the fix as the live source and staging the captured original as its inactive
 * version. NULL on the row means shipping was never attempted (the run produced
 * no proposal for that member).
 *
 * WRITTEN: the fix is live — the authoritative "did this ship" signal
 * (``run_shipped()`` and retry's snapshot-reset gate key off it). When the
 * inactive mirror failed, the row stays WRITTEN and ``sap_write_error``
 * carries the live-but-not-mirrored reason.
 * FAILED: the activation itself failed — the fix is NOT live;
 * ``sap_write_error`` carries the reason.
 */
export enum TLAgenticSapWriteStatus {
  WRITTEN = 'WRITTEN',
  FAILED = 'FAILED',
}
/**
 * Per-member proposal metadata as the LIST endpoint surfaces it — no inline
 * source (fetch content per member via
 * GET /remediation-runs/{run_id}/proposed-sources/{object_id}).
 */
export type TLAgenticRunProposedSourceSummary = {
  created_date: string;
  has_original_source?: boolean;
  object_id: string;
  rationale?: string | null;
  /** Why the SAP write failed (activation messages, an in-flight-scan collision, a timeout); null unless FAILED. */
  sap_write_error?: string | null;
  sap_write_status?: TLAgenticSapWriteStatus | null;
  size_bytes?: number | null;
};

export type TLAgenticRunProposedSourcesListResponse = {
  items?: TLAgenticRunProposedSourceSummary[];
  total?: number;
};

/**
 * One unit member's proposed (and, when captured, original) source, served
 * inline for the same S3-CORS reason as ``AgenticRemediationProposedSource``.
 */
export type TLAgenticRunProposedSourceContent = {
  object_id: string;
  original_source?: string | null;
  proposed_source: string;
  rationale?: string | null;
  run_id: string;
  /** Why the SAP write failed (activation messages, an in-flight-scan collision, a timeout); null unless FAILED. */
  sap_write_error?: string | null;
  sap_write_status?: TLAgenticSapWriteStatus | null;
  size_bytes?: number | null;
};

/**
 * POST /remediation-runs/{run_id}/rollback body.
 */
export type TLAgenticRollbackRequest = {
  /** Only for a unit whose transport is already released: create a new transport with this description and restore onto it. The revert then travels separately from the change it undoes, so downstream systems stay diverged until this transport is imported too. Rejected when the unit's transport is still open — the restore belongs on that one. */
  new_transport_description?: string | null;
  source: TLAgenticRollbackSource;
};

/**
 * Per-unit-member outcome of a rollback attempt.
 */
export type TLAgenticRollbackMemberResult = {
  /** Why the member was skipped or the restore did not take; null on success. */
  detail?: string | null;
  object_id: string;
  object_name: string;
  restored: boolean;
};

export type TLAgenticRollbackResponse = {
  /** True only when SAP confirmed the activation of the restored sources. */
  applied: boolean;
  members?: TLAgenticRollbackMemberResult[];
  run_id: string;
  source: TLAgenticRollbackSource;
  /** Transport the restore rode; null when no transport was assigned. */
  tr_number?: string | null;
};

/**
 * FLAG tunes feature behavior (switches and knobs); CONFIGURATION sets up a system or connection.
 */
export enum TLSettingCategory {
  FLAG = 'FLAG',
  CONFIGURATION = 'CONFIGURATION',
}
export type TLJsonValue = unknown;

export enum TLSettingDomain {
  PLATFORM = 'PLATFORM',
  SMTP = 'SMTP',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
  CONVERSATIONS = 'CONVERSATIONS',
  CODE_REMEDIATION = 'CODE_REMEDIATION',
  DATA_HARMONIZATION = 'DATA_HARMONIZATION',
  SAP = 'SAP',
  SALESFORCE = 'SALESFORCE',
  D365 = 'D365',
  DATA_ANALYTICS = 'DATA_ANALYTICS',
  DATA_FOUNDRY = 'DATA_FOUNDRY',
  AGENTS = 'AGENTS',
  WORKFLOWS = 'WORKFLOWS',
}
/**
 * Optional sub-area within a domain (e.g. which SAP system a connection field configures).
 */
export enum TLSettingGroup {
  ECC = 'ECC',
  S4 = 'S4',
  HANA = 'HANA',
  ATC = 'ATC',
  BTP_ALM = 'BTP_ALM',
  DATA360 = 'DATA360',
  SNOWFLAKE = 'SNOWFLAKE',
  DATABRICKS = 'DATABRICKS',
  CLICKHOUSE = 'CLICKHOUSE',
  ORACLE = 'ORACLE',
  LANGFUSE = 'LANGFUSE',
  MCP_GATEWAY = 'MCP_GATEWAY',
  MCP_SERVER = 'MCP_SERVER',
}
export enum TLPropertyType {
  string = 'string',
  number = 'number',
  boolean = 'boolean',
  list = 'list',
  secret = 'secret',
}
export type TLRegisteredSettingResponse = {
  /** Feature flag/knob vs system configuration */
  category: TLSettingCategory;
  /** Suggested value when adding the property */
  default?: TLJsonValue;
  description: string | null;
  /** High-level product or system area */
  domain: TLSettingDomain;
  /** Sub-area within the domain, e.g. ECC or HANA */
  group?: TLSettingGroup | null;
  /** Property key to use in the tenant configuration */
  key: string;
  /** Property type to write for this key */
  type: TLPropertyType;
};

export type TLPaginatedResponseRegisteredSettingResponse = {
  /** List of items */
  data: TLRegisteredSettingResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLResolveShareRequest = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  token: string;
};

export type TLSharedAttachmentResponse = {
  available: boolean;
  file_type: string;
  filename: string;
  program_id: string;
  size_bytes?: number | null;
};

export type TLResolveShareResponse = {
  allow_fork: boolean;
  attachments: TLSharedAttachmentResponse[];
  conversation_type: string;
  expires_at: string;
  message_count: number;
  messages: TLConversationMessageResponse[];
  shared_at: string;
  shared_by: string;
  /** Tenant the snapshot was frozen in; used to resolve /go? links on /share */
  tenant_id: string;
  title: string;
};

export type TLResolveShareAttachmentRequest = {
  /**
   * Synthetic per-share attachment id from the resolve response (e.g. 'a0')
   * @minLength 1
   * @maxLength 64
   */
  attachment_id: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  token: string;
};

export type TLResolveShareAttachmentResponse = {
  attachment_id: string;
  /** Short-lived presigned URL for the frozen attachment blob */
  download_url: string;
  download_url_expires_in_seconds: number;
  file_type: string;
  filename: string;
  size_bytes?: number | null;
};

export type TLResolveShareAttachmentPreviewRequest = {
  /**
   * Synthetic per-share attachment id from the resolve response (e.g. 'a0')
   * @minLength 1
   * @maxLength 64
   */
  attachment_id: string;
  /**
   * Maximum number of lines to preview
   * @minimum 1
   * @maximum 10000
   */
  max_lines?: number;
  /**
   * @minLength 1
   * @maxLength 255
   */
  token: string;
};

export type TLResolveSkillShareRequest = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  token: string;
};

export type TLSharedSkillAttachmentResponse = {
  display_name?: string | null;
  path: string;
  role: string;
};

export type TLResolveSkillShareResponse = {
  allow_fork: boolean;
  attachments?: TLSharedSkillAttachmentResponse[];
  description: string;
  domain: string;
  expires_at: string;
  name: string;
  shared_at: string;
  shared_by: string;
  skill_markdown: string;
};

export type TLCreateSkillDirectoryRequest = {
  /**
   * Subdirectory name under Skills
   * @minLength 1
   * @maxLength 255
   */
  name: string;
};

export type TLSkillUploadAbortRequest = {
  /** Program UUID returned from /upload/init */
  program_id: string;
};

export type TLSkillUploadAbortResponse = {
  /** Program UUID that was aborted */
  program_id: string;
  success?: boolean;
};

export type TLSkillUploadCompleteRequest = {
  /** Program UUID returned from /upload/init */
  program_id: string;
};

export type TLSkillUploadInitiateRequest = {
  /** Total file size in bytes */
  file_size?: number | null;
  /**
   * Filename to upload (.md)
   * @minLength 1
   * @maxLength 255
   */
  filename: string;
};

export type TLSkillUploadInitiateItem = {
  /** Filename this upload was initiated for */
  filename: string;
  /** Upload instructions (presigned URL + method + required headers/form fields) */
  upload: TLPutUploadInitiate | TLPostUploadInitiate;
};

export type TLSkillUploadInitiateResponse = {
  /** Filesystem node UUID of the Skills directory */
  skills_dir_id: string;
  /** One entry per file */
  uploads: TLSkillUploadInitiateItem[];
};

export type TLIntegrationsCredentialSummaryFields = { [key: string]: unknown };

export type TLIntegrationsCredentialSummary = {
  auth_method: string;
  created_at: string;
  etag?: string | null;
  expires_at?: string | null;
  fields: TLIntegrationsCredentialSummaryFields;
  id: string;
  last_resolved_at?: string | null;
  owner: string;
  secret_version?: number | null;
  status: string;
};

export type TLIntegrationsSystemStatus = {
  connectivity: string;
  credentials: string;
  last_tested_at?: string | null;
};

export type TLIntegrationsSystemConfig = { [key: string]: unknown };

export type TLIntegrationsSystem = {
  archived_at?: string | null;
  capabilities?: string[];
  config: TLIntegrationsSystemConfig;
  connector: string;
  created_at: string;
  credential?: TLIntegrationsCredentialSummary | null;
  display_name?: string | null;
  etag?: string | null;
  id: string;
  slug: string;
  status: TLIntegrationsSystemStatus;
  updated_at: string;
};

export type TLIntegrationsSystemList = {
  items: TLIntegrationsSystem[];
  next_cursor?: string | null;
};

export type TLIntegrationsSystemCreateRequestConfig = { [key: string]: unknown };

export type TLIntegrationsCredentialCreateRequestFields = { [key: string]: unknown };

export type TLIntegrationsCredentialCreateRequestSecret = { [key: string]: unknown };

export type TLIntegrationsCredentialCreateRequest = {
  auth_method: string;
  expires_at?: string | null;
  fields?: TLIntegrationsCredentialCreateRequestFields;
  secret: TLIntegrationsCredentialCreateRequestSecret;
};

export type TLIntegrationsSystemCreateRequest = {
  config: TLIntegrationsSystemCreateRequestConfig;
  connector: string;
  credential?: TLIntegrationsCredentialCreateRequest | null;
  display_name?: string | null;
  slug: string;
};

export type TLIntegrationsAuthMethod = {
  flow: string;
  name: string;
  slug: string;
};

export type TLIntegrationsConnectorSummary = {
  auth_methods?: TLIntegrationsAuthMethod[];
  capabilities?: string[];
  category?: string | null;
  category_icon?: string | null;
  category_label?: string | null;
  family?: string | null;
  family_icon?: string | null;
  family_slug?: string | null;
  icon?: string | null;
  name: string;
  slug: string;
};

export type TLIntegrationsConnectorList = {
  items: TLIntegrationsConnectorSummary[];
};

export type TLIntegrationsConnectorDetailConfigSchema = { [key: string]: unknown } | null;

export type TLIntegrationsConnectorDetailEndpoints = { [key: string]: unknown } | null;

export type TLIntegrationsConnectorDetailUi = { [key: string]: unknown } | null;

export type TLIntegrationsAuthMethodDetailCredentialSchema = { [key: string]: unknown } | null;

export type TLIntegrationsAuthMethodDetail = {
  credential_schema?: TLIntegrationsAuthMethodDetailCredentialSchema;
  description?: string | null;
  enabled_by_default?: boolean | null;
  flow: string;
  name: string;
  satisfies?: string[] | null;
  slug: string;
};

export type TLIntegrationsConnectorDetail = {
  auth_methods?: TLIntegrationsAuthMethodDetail[];
  capabilities?: string[];
  category?: string | null;
  category_icon?: string | null;
  category_label?: string | null;
  config_schema?: TLIntegrationsConnectorDetailConfigSchema;
  docs?: string | null;
  endpoints?: TLIntegrationsConnectorDetailEndpoints;
  family?: string | null;
  family_icon?: string | null;
  family_slug?: string | null;
  icon?: string | null;
  name: string;
  slug: string;
  ui?: TLIntegrationsConnectorDetailUi;
};

export type TLIntegrationsSystemValidateRequestConfig = { [key: string]: unknown };

export type TLIntegrationsSystemValidateRequest = {
  config: TLIntegrationsSystemValidateRequestConfig;
  connector: string;
  credential?: TLIntegrationsCredentialCreateRequest | null;
};

export type TLIntegrationsCheck = {
  latency_ms?: number | null;
  name: string;
  reason?: string | null;
  status: string;
};

export type TLIntegrationsTestResult = {
  checks?: TLIntegrationsCheck[];
  status: string;
  vantage: string;
};

export type TLIntegrationsValidationResult = {
  valid: boolean;
};

export type TLIntegrationsSystemUpdateRequestConfig = { [key: string]: unknown } | null;

export type TLIntegrationsSystemUpdateRequest = {
  config?: TLIntegrationsSystemUpdateRequestConfig;
  display_name?: string | null;
};

export type TLIntegrationsAuditEntryDetails = { [key: string]: unknown };

export type TLIntegrationsAuditEntry = {
  action: string;
  actor: string;
  actor_type: string;
  at: string;
  credential_id?: string | null;
  details?: TLIntegrationsAuditEntryDetails;
  hash?: string | null;
  id: string;
  system_id?: string | null;
};

export type TLIntegrationsAuditList = {
  items?: TLIntegrationsAuditEntry[];
};

export type TLIntegrationsCredentialRotateRequestFields = { [key: string]: unknown } | null;

export type TLIntegrationsCredentialRotateRequestSecret = { [key: string]: unknown } | null;

export type TLIntegrationsCredentialRotateRequest = {
  expires_at?: string | null;
  fields?: TLIntegrationsCredentialRotateRequestFields;
  secret?: TLIntegrationsCredentialRotateRequestSecret;
};

export type TLIntegrationsDependent = {
  actor: string;
  last_resolved_at?: string | null;
};

export type TLIntegrationsDependentList = {
  items?: TLIntegrationsDependent[];
  lookback_days?: number | null;
};

export type TLIntegrationsSystemPurgeRequest = {
  confirm_slug: string;
};

export type TLIntegrationsSystemTestRequest = {
  credential?: string | null;
  inline_credential?: TLIntegrationsCredentialCreateRequest | null;
};

export enum TLTenantStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  PURGING = 'PURGING',
}
export type TLTenantProperty = {
  /** Property key/name */
  key: string;
  /** Property data type */
  type: TLPropertyType;
  /** Property value - lists are stored as CSV strings */
  value: string | number | boolean;
};

export enum TLTenantVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
export type TLTenant = {
  /** Tenant configuration */
  configuration?: TLTenantProperty[];
  /** User who created the tenant */
  created_by?: string | null;
  /** Creation timestamp */
  created_date: string;
  /** Tenant status */
  status: TLTenantStatus;
  /** Unique tenant identifier */
  tenant_id: string;
  /** User who last updated the tenant */
  updated_by?: string | null;
  /** Last update timestamp */
  updated_date: string;
  /** PUBLIC tenants admit any authenticated user; PRIVATE tenants require membership */
  visibility?: TLTenantVisibility;
};

export type TLTenantCreate = {
  /** Tenant configuration */
  configuration?: TLTenantProperty[] | null;
  /**
   * Initial membership grants, applied atomically with creation
   * @maxItems 100
   * @items.maxLength 255
   */
  member_emails?: string[];
  /** Unique tenant identifier */
  tenant_id: string;
  /** PUBLIC admits any authenticated user; PRIVATE requires membership from creation */
  visibility?: TLTenantVisibility;
};

export type TLTenantUpdate = {
  /** Updated configuration */
  configuration?: TLTenantProperty[] | null;
  /** Updated status */
  status?: TLTenantStatus | null;
};

export type TLTenantMembersModifyRequest = {
  /**
   * Emails of users to act on
   * @minItems 1
   * @maxItems 100
   * @items.maxLength 255
   */
  user_emails: string[];
};

export type TLTenantMemberActionResult = {
  email: string;
  /** Why the action failed for this item */
  error?: string | null;
  /** Whether the action succeeded for this item */
  success: boolean;
};

export type TLBulkActionResponseTenantMemberActionResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLTenantMemberActionResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export type TLTenantMembersListResponse = {
  /** Whether more members exist beyond this page */
  has_more: boolean;
  limit: number;
  /** Member emails for this page */
  members: string[];
  offset: number;
};

export type TLTenantPurgeResponse = {
  /** Tenant scheduled for permanent deletion */
  tenant_id: string;
  /** Temporal workflow executing the purge */
  workflow_id: string;
};

export type TLTenantVisibilityUpdateRequest = {
  /** PUBLIC admits any authenticated user; PRIVATE requires membership */
  visibility: TLTenantVisibility;
};

export enum TLERPDomain {
  SAP = 'SAP',
  SALESFORCE = 'SALESFORCE',
  WORKDAY = 'WORKDAY',
}
/**
 * SAP credentials response.
 */
export type TLSAPCredentialsResponse = {
  created_date: string;
  domain?: TLERPDomain;
  id: string;
  system_version: TLSAPVersion;
  updated_date: string;
  user_email: string;
  user_id: string;
  username: string;
};

/**
 * Salesforce credentials response.
 */
export type TLSalesforceCredentialsResponse = {
  created_date: string;
  domain?: TLERPDomain;
  id: string;
  updated_date: string;
  user_email: string;
  user_id: string;
  username: string;
};

/**
 * List of credentials.
 */
export type TLCredentialsListResponse = {
  credentials: (TLSAPCredentialsResponse | TLSalesforceCredentialsResponse)[];
  total_count: number;
};

/**
 * Salesforce credentials request.
 */
export type TLSalesforceCredentialsRequest = {
  /** Salesforce password */
  password: string;
  /** Salesforce security token */
  security_token: string;
  /** Salesforce username */
  username: string;
};

/**
 * SAP credentials request.
 */
export type TLSAPCredentialsRequest = {
  /** SAP password */
  password: string;
  /** SAP system version (ECC, S4 */
  system_version: TLSAPVersion;
  /** SAP username */
  username: string;
};

/**
 * User preferences as JSON
 */
export type TLUserPreferencesPreferences = { [key: string]: unknown };

export type TLUserPreferences = {
  /** Creation timestamp */
  created_date: string;
  /** Unique identifier */
  id: string;
  /** User preferences as JSON */
  preferences: TLUserPreferencesPreferences;
  /** Tenant identifier */
  tenant_id: string;
  /** Last update timestamp */
  updated_date: string;
  /** User email address */
  user_email: string;
};

/**
 * Updated user preferences as JSON
 */
export type TLUserPreferencesUpdatePreferences = { [key: string]: unknown };

export type TLUserPreferencesUpdate = {
  /** Updated user preferences as JSON */
  preferences: TLUserPreferencesUpdatePreferences;
};

export type TLUserSkillResponse = {
  correlation_id?: string | null;
  created_at: string;
  description: string;
  domain?: TLDomain;
  id: string;
  name: string;
  path?: string;
  slug: string;
  source: TLSkillSource;
  status: TLSkillStatus;
  tags?: string[] | null;
  updated_at: string;
  version: number;
};

export type TLUserSkillsListResponse = {
  /** @minimum 0 */
  limit?: number;
  /** @minimum 0 */
  offset?: number;
  skills?: TLUserSkillResponse[];
  /** @minimum 0 */
  total?: number;
};

export type TLUserSkillCreateRequest = {
  correlation_id?: string | null;
  /**
   * @minLength 1
   * @maxLength 1024
   */
  description: string;
  domain?: TLDomain;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** Replace an existing same-slug skill instead of erroring on conflict */
  overwrite?: boolean;
  /** Initial SKILL.md body */
  skill_markdown?: string | null;
  /**
   * @minLength 1
   * @maxLength 128
   * @pattern ^[a-z0-9]+(?:-[a-z0-9]+)*$
   */
  slug: string;
  status?: TLSkillStatus;
  tags?: string[] | null;
};

export type TLAddSkillFromShareRequest = {
  /**
   * @minLength 1
   * @maxLength 255
   */
  token: string;
};

export type TLAddSkillFromShareResponse = {
  attachment_count: number;
  name: string;
  skill_id: string;
  slug: string;
};

export type TLImportUserSkillZipRequest = {
  /** ZIP or .skill archive containing SKILL.md */
  file: Blob;
};

export type TLPreviewUserSkillZipImportRequest = {
  /** ZIP or .skill archive containing SKILL.md */
  file: Blob;
};

export type TLSkillNormalizeRequest = {
  /** Original upload file name, used to derive a name when none can be inferred. */
  file_name?: string | null;
  /**
   * @minLength 1
   * @maxLength 120000
   */
  skill_markdown: string;
  /** When true, also run an LLM pass that tunes the description and tidies the body. */
  tune?: boolean;
};

export type TLUserSkillUpdateRequest = {
  description?: string | null;
  name?: string | null;
  status?: TLSkillStatus | null;
  tags?: string[] | null;
};

export type TLUserSkillContentPutRequest = {
  /**
   * @minLength 1
   * @maxLength 120000
   */
  skill_markdown: string;
};

export enum TLSkillShareStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
}
export type TLSkillShareMetadataResponse = {
  allow_fork: boolean;
  attachment_count: number;
  created_date: string;
  expires_at: string;
  last_viewed_at: string | null;
  share_id: string;
  status: TLSkillShareStatus;
  view_count: number;
};

export type TLCreateSkillShareRequest = {
  /** Whether recipients may add the shared skill to their own library */
  allow_fork?: boolean;
  /** Link validity in days; defaults to the deployment setting, clamped to the maximum */
  expires_in_days?: number | null;
};

export type TLCreateSkillShareResponse = {
  allow_fork: boolean;
  expires_at: string;
  share_id: string;
  /** Origin-relative URL path with the token in the fragment */
  share_url_path: string;
  /** The share token. Returned exactly once; only its hash is stored */
  token: string;
};

export type TLUserTaskApprovalFile = {
  filename: string;
  program_id?: string | null;
};

export type TLUserTaskApprovalVote = {
  approved: boolean;
  approver: string;
  comment?: string | null;
  decided_at?: string | null;
};

export type TLUserTaskApprovalContext = {
  approvers?: string[];
  execution_id: string;
  iteration_number?: number;
  message?: string | null;
  minimum_approvals?: number;
  node_id: string;
  node_name?: string | null;
  review_file_count?: number;
  review_files?: TLUserTaskApprovalFile[];
  votes?: TLUserTaskApprovalVote[];
  workflow_id: string;
  workflow_name?: string | null;
};

export type TLUserTaskKbComment = {
  author: string;
  body: string;
  commented_at: string;
};

export type TLUserTaskKbDocument = {
  filename: string;
  program_id: string;
};

export type TLUserTaskKbReviewer = {
  decided_at?: string | null;
  decision?: TLKbReviewDecision | null;
  reason?: string | null;
  reviewer_email: string;
};

export type TLUserTaskKbContext = {
  ai_summary?: string | null;
  assigned_to?: string | null;
  author?: string | null;
  comments?: TLUserTaskKbComment[];
  description?: string | null;
  document_count?: number;
  documents?: TLUserTaskKbDocument[];
  latest_comment?: string | null;
  latest_comment_by?: string | null;
  priority?: TLKbPackagePriority | null;
  review_round?: number | null;
  reviewers?: TLUserTaskKbReviewer[];
  stage?: TLKbPackageStage | null;
  status?: TLKbPackageStatus | null;
  tags?: string[];
  topic_name?: string | null;
  updated_date?: string | null;
};

export enum TLUserTaskKind {
  APPROVAL = 'APPROVAL',
  CR_REMEDIATION = 'CR_REMEDIATION',
  KB_PACKAGE = 'KB_PACKAGE',
}
export enum TLUserTaskResolution {
  DONE = 'DONE',
  RESOLVED_WITHOUT_YOU = 'RESOLVED_WITHOUT_YOU',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
}
export enum TLUserTaskStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  CLOSED = 'CLOSED',
}
export type TLUserTaskResponse = {
  approval?: TLUserTaskApprovalContext | null;
  closed_at?: string | null;
  deep_link?: string | null;
  deferred_at?: string | null;
  due_at?: string | null;
  kb?: TLUserTaskKbContext | null;
  kind: TLUserTaskKind;
  requested_at: string;
  requested_by: string;
  resolution?: TLUserTaskResolution | null;
  resolution_note?: string | null;
  resource_id: string;
  resource_type: TLResourceType;
  round?: number;
  started_at?: string | null;
  status: TLUserTaskStatus;
  task_id: string;
  title: string;
};

export type TLUserTasksResponse = {
  /** List of items */
  data: TLUserTaskResponse[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLUserTaskUpdateRequest = {
  deferred?: boolean | null;
  started?: boolean | null;
};

export type TLUserTaskHistoryEntry = {
  assignee_email: string;
  closed_at: string;
  requested_at: string;
  resolution: TLUserTaskResolution;
  resolution_note?: string | null;
};

export type TLUserTaskHistoryResponse = {
  /** List of items */
  data: TLUserTaskHistoryEntry[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

/**
 * Model for user list response.
 */
export type TLUserListResponse = {
  /** List of users */
  users?: TLUserRepresentation[];
};

export enum TLUserListSortField {
  username = 'username',
  email = 'email',
  last_login = 'last_login',
  last_modified = 'last_modified',
  created_timestamp = 'created_timestamp',
}
export type TLUserDirectoryEntry = {
  created_timestamp?: number | null;
  email?: string | null;
  enabled?: boolean | null;
  first_name?: string | null;
  id?: string | null;
  last_login?: number | null;
  last_modified?: number | null;
  last_name?: string | null;
  username?: string | null;
};

export type TLUserDirectoryResponse = {
  users?: TLUserDirectoryEntry[];
};

export enum TLExtractScopeMode {
  all = 'all',
  namespace = 'namespace',
  scv = 'scv',
  ico = 'ico',
}
export type TLExtractScope = {
  active_only?: boolean | null;
  ico_name?: string | null;
  ico_names?: string[] | null;
  include_related?: boolean | null;
  mode?: TLExtractScopeMode | null;
  namespace?: string | null;
  scv?: string | null;
};

export type TLExtractDirectRequest = {
  connection_id?: string | null;
  priority?: number | null;
  scope?: TLExtractScope | null;
};

export enum TLExtractionState {
  idle = 'idle',
  running = 'running',
  completed = 'completed',
  failed = 'failed',
  cancelled = 'cancelled',
  interrupted = 'interrupted',
}
export type TLExtractionStatusResponse = {
  available_run_ids?: string[] | null;
  cancelled?: boolean;
  done?: boolean;
  error?: string | null;
  failed?: boolean;
  finished_at_utc?: string | null;
  interrupted?: boolean;
  phase?: string | null;
  phase_label?: string | null;
  queue_position?: number | null;
  restorable?: boolean | null;
  restored?: boolean | null;
  run_id?: string;
  running?: boolean;
  status?: TLExtractionState;
};

export type TLIcoEntry = {
  interface?: string;
  name: string;
  namespace?: string;
  object_id?: string;
  sender?: string;
};

export type TLIcosResponse = {
  count?: number;
  icos?: TLIcoEntry[];
};

export type TLEdiStandard = {
  count?: number;
  kind: string;
  names?: string[];
  standard: string;
};

export type TLIflowGroup = {
  branch_count?: number;
  conditions_captured?: boolean | null;
  driver_name?: string | null;
  routing?: string | null;
  sender_key?: string | null;
};

export type TLInventoryObject = {
  display_label?: string | null;
  hits?: number;
  is_target?: boolean;
  kind?: string | null;
  name: string;
  namespace?: string | null;
  origin?: string | null;
  routed_interface?: string | null;
  source?: string | null;
};

export type TLMappingUdfs = {
  functions?: string[];
  mapping: string;
};

export type TLInventorySummaryResponse = {
  edi_by_standard?: TLEdiStandard[];
  edi_count?: number;
  function_library_count?: number;
  graphical_recovered?: string[];
  iflow_groups?: TLIflowGroup[];
  mappings_with_udfs?: number;
  message_mapping_count?: number;
  needs_tpz?: string[];
  needs_tpz_count?: number;
  object_count?: number;
  objects?: TLInventoryObject[];
  predicted_iflow_count?: number;
  predicted_topology?: string | null;
  routing_conditions_captured?: boolean | null;
  run_id: string;
  scenario_count?: number;
  supporting_total?: number;
  udf_count?: number;
  udfs_by_mapping?: TLMappingUdfs[];
};

export type TLMigrationAssessmentUploadMappingsRequest = {
  /** TPZ archive exported from SAP PI/PO */
  tpz_file: Blob;
};

export type TLMigrationAssessmentProxyResponse = { [key: string]: unknown };

export type TLNamespaceEntry = {
  namespace: string;
  object_count?: number;
  scv_captions?: string[];
};

export type TLNamespacesResponse = {
  count?: number;
  namespaces?: TLNamespaceEntry[];
};

export type TLSyncPoTenantRequest = {
  connection_id?: string | null;
};

export type TLSyncPoTenantResponse = {
  display_name?: string | null;
  synced?: boolean;
  tenant_name: string;
};

export type TLRunSummary = {
  cancelled?: boolean;
  created_at_utc?: string | null;
  done?: boolean;
  failed?: boolean;
  finished_at_utc?: string | null;
  interrupted?: boolean;
  label?: string | null;
  object_count?: number;
  phase_label?: string | null;
  run_id: string;
  running?: boolean;
  scope_mode?: TLExtractScopeMode | null;
  scope_target?: string | null;
  status?: TLExtractionState;
};

export type TLPaginatedResponseRunSummary = {
  /** List of items */
  data: TLRunSummary[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type TLClassificationArtifact = {
  classification?: string | null;
  cpi_target?: string | null;
  kind?: string | null;
  name: string;
  reason?: string | null;
};

export type TLClassificationCounts = {
  automatic?: number;
  manual?: number;
  semi?: number;
  total?: number;
};

export type TLArtifactClassificationResponse = {
  artifacts?: TLClassificationArtifact[];
  automated_pct?: number;
  counts?: TLClassificationCounts;
  note?: string | null;
  run_id: string;
};

export type TLBuildRequest = {
  allow_missing_tpz?: boolean | null;
  artifact_id?: string | null;
  artifact_name?: string | null;
  description?: string | null;
  force_recreate?: boolean | null;
  object_names?: string[] | null;
  package_id?: string | null;
  package_name?: string | null;
  target_connection_id?: string | null;
  virtualize_receivers?: boolean | null;
};

export type TLBuildArtifactResult = {
  artifact_id?: string | null;
  artifact_name?: string | null;
  error?: string | null;
  ok?: boolean;
  operation?: string | null;
  status_code?: number | null;
};

export type TLBuildUnsupportedItem = {
  kind?: string | null;
  name: string;
  reason?: string | null;
};

export type TLBuildResultResponse = {
  artifacts?: TLBuildArtifactResult[];
  artifacts_created?: number;
  artifacts_failed?: number;
  built_at?: string | null;
  collapsed_same_sender_count?: number;
  conflict?: boolean;
  cpi_tenant_name?: string | null;
  deduplicated_count?: number;
  driver_count?: number;
  error?: string | null;
  package_id?: string | null;
  predicted_iflow_count?: number;
  receiver_sink_base?: string | null;
  receivers_virtualized?: boolean;
  reconciled?: boolean | null;
  run_id: string;
  skipped_unanchored_count?: number;
  success?: boolean;
  unsupported?: TLBuildUnsupportedItem[];
  value_mappings_content_migrated?: number;
  value_mappings_created?: number;
  value_mappings_scaffolded?: number;
};

export enum TLBuildObjectRole {
  driver = 'driver',
  supporting = 'supporting',
}
export type TLBuildCandidate = {
  cpi_supported?: boolean;
  display_label?: string | null;
  kinds?: string[];
  name: string;
  namespace?: string | null;
  role?: TLBuildObjectRole;
};

export type TLBuildCandidatesResponse = {
  candidates?: TLBuildCandidate[];
  driver_count?: number;
  run_id: string;
  supporting_count?: number;
  total?: number;
};

export type TLConversionRunStatusResponseCounts = { [key: string]: number };

export enum TLConversionAiJobStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
export type TLConversionAiJob = {
  error?: string | null;
  finished_at?: string | null;
  started_at?: string | null;
  status: TLConversionAiJobStatus;
};

export enum TLConversionCheck {
  ENTRYPOINT = 'ENTRYPOINT',
  FORBIDDEN_IMPORTS = 'FORBIDDEN_IMPORTS',
  PI_RUNTIME_API = 'PI_RUNTIME_API',
  COMPILE = 'COMPILE',
}
export type TLConversionCheckResult = {
  check: TLConversionCheck;
  message?: string;
  ok?: boolean | null;
};

export enum TLConversionRevisionOrigin {
  TRANSLITERATOR = 'TRANSLITERATOR',
  AI = 'AI',
  HUMAN = 'HUMAN',
}
export type TLConversionRevision = {
  actor?: string | null;
  checks?: TLConversionCheckResult[];
  created_at?: string | null;
  groovy_source: string;
  note?: string | null;
  origin: TLConversionRevisionOrigin;
  revision: number;
};

export enum TLConversionItemStatus {
  PENDING = 'PENDING',
  AUTO = 'AUTO',
  AI_QUEUED = 'AI_QUEUED',
  AI_CONVERTED = 'AI_CONVERTED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  MANUAL = 'MANUAL',
  ACCEPTED = 'ACCEPTED',
  FAILED = 'FAILED',
}
export type TLConversionItemResponse = {
  args?: string[];
  attempts?: number;
  checks?: TLConversionCheckResult[];
  conversion_item_id: string;
  external_calls?: string[];
  fn_name?: string | null;
  groovy_source?: string | null;
  java_source?: string | null;
  origin_mm: string;
  review_note?: string | null;
  reviewed_at?: string | null;
  reviewed_by?: string | null;
  revisions?: TLConversionRevision[];
  run_id: string;
  runnable?: boolean | null;
  status: TLConversionItemStatus;
  updated_at?: string | null;
};

export type TLConversionRunStatusResponse = {
  ai_job?: TLConversionAiJob | null;
  counts?: TLConversionRunStatusResponseCounts;
  items?: TLConversionItemResponse[];
  run_id: string;
  source_unavailable_mms?: string[];
  started?: boolean;
  total?: number;
};

export enum TLConversionReviewAction {
  ACCEPT = 'ACCEPT',
  EDIT = 'EDIT',
  REJECT = 'REJECT',
  RETRY = 'RETRY',
}
export type TLConversionReviewRequest = {
  action: TLConversionReviewAction;
  groovy_source?: string | null;
  note?: string | null;
};

/**
 * Migration guidance for a single object: how risky it is, what to build instead, and how to verify it.
 */
export type TLEnhancementFinding = {
  acceptance_criteria: string[];
  better_implementation_summary: string;
  cutover_plan: string[];
  dependencies_to_prepare: string[];
  effort_hint: string;
  implementation_blueprint: string[];
  implementation_steps: string[];
  migration_complexity: string;
  migration_pattern: string;
  object_id: string;
  operational_readiness: string[];
  reason: string;
  recommended_action: string;
  risk_level: string;
  stakeholders: string[];
  target_service: string;
  test_strategy: string[];
  validation_checklist: string[];
  why_not_simple_migration: string;
};

/**
 * The completed enhancement result for a run.
 */
export type TLEnhancementResponse = {
  considered?: number;
  findings?: TLEnhancementFinding[];
  narrative?: string;
  run_id: string;
  scored_by_llm?: number;
  scored_deterministically?: number;
  truncated?: boolean;
};

export enum TLEnhancementJobStatus {
  pending = 'pending',
  running = 'running',
  completed = 'completed',
  failed = 'failed',
}
/**
 * Fire-and-forget job envelope. POST .../enhance returns this with status RUNNING (202);
 * GET .../enhance polls it until COMPLETED/FAILED. ``result`` is populated only once COMPLETED;
 * ``error`` only when FAILED.
 */
export type TLEnhancementJobResponse = {
  error?: string | null;
  finished_at?: string | null;
  result?: TLEnhancementResponse | null;
  run_id: string;
  started_at?: string | null;
  status: TLEnhancementJobStatus;
};

export type TLFeasibilityMatrixResponseByScore = { [key: string]: number };

export enum TLSapReadiness {
  Ready_to_Migrate = 'Ready to Migrate',
  Adjustment_Required = 'Adjustment Required',
  Evaluation_Required = 'Evaluation Required',
  Redesign_Required = 'Redesign Required',
  Retire = 'Retire',
}
export type TLFeasibilityIco = {
  blockers?: string[];
  label?: string | null;
  mapping_complexity?: string | null;
  name: string;
  readiness?: TLSapReadiness | null;
  reasons?: string[];
  receiver_channel?: string | null;
  referenced_mappings?: string[];
  score?: number;
  scv?: string | null;
  sender_channel?: string | null;
};

export type TLFeasibilityMatrixResponse = {
  by_score?: TLFeasibilityMatrixResponseByScore;
  ico_count?: number;
  icos?: TLFeasibilityIco[];
  run_id: string;
};

export type TLMappingsStatusResponse = {
  filename?: string | null;
  prepared?: boolean;
  prepared_at?: string | null;
  run_id: string;
  uploaded?: boolean;
  uploaded_at?: string | null;
  workspace_id?: string | null;
};

export type TLMigrationAssessmentUploadRunMappingsRequest = {
  /** TPZ archive exported from SAP PI/PO */
  tpz_file: Blob;
};

export type TLEstimatePerIco = {
  base_days?: number;
  days?: number;
  ico_name?: string | null;
  label?: string | null;
  manual_days?: number;
  readiness?: TLSapReadiness | null;
  score?: number;
};

export type TLEstimateTotals = {
  automated_ico_pct?: number;
  baseline_manual_days?: number;
  build_days?: number;
  cost_band_source?: string | null;
  cost_high?: number | null;
  cost_illustrative?: boolean | null;
  cost_low?: number | null;
  cost_mid?: number | null;
  cost_saved_high?: number | null;
  cost_saved_low?: number | null;
  cost_saved_mid?: number | null;
  currency?: string | null;
  cutover_days?: number;
  days_saved?: number;
  one_time_days?: number;
  pct_time_saved?: number;
  person_months_saved?: number;
  test_days?: number;
  total_days?: number;
  total_person_months?: number;
};

export type TLMigrationEstimateResponse = {
  ico_count?: number;
  per_ico?: TLEstimatePerIco[];
  run_id: string;
  totals?: TLEstimateTotals;
};

export type TLPlanCategory = {
  becomes?: string | null;
  category: string;
  count?: number;
  sample_objects?: string[];
};

export type TLPlanConfigGroup = {
  adapter_type: string;
  count?: number;
  roles?: string[];
};

export type TLPlanDirectory = {
  business_systems?: number;
  channels?: number;
  integrated_configurations?: number;
};

export type TLMigrationPlanResponse = {
  categories?: TLPlanCategory[];
  config_all_defaulted?: boolean;
  config_groups?: TLPlanConfigGroup[];
  config_note?: string | null;
  directory?: TLPlanDirectory;
  needs_tpz?: string[];
  needs_tpz_count?: number;
  run_id: string;
  total_objects?: number;
  udf_count?: number;
};

export enum TLReportFormat {
  html = 'html',
  pdf = 'pdf',
  xlsx = 'xlsx',
  csv = 'csv',
  json = 'json',
}
export type TLVerifyArtifactEntry = {
  is_binary?: boolean;
  name: string;
  size?: number;
};

export type TLVerifyArtifactInspect = {
  artifact_id?: string | null;
  entity_set?: string | null;
  entries?: TLVerifyArtifactEntry[];
  error?: string | null;
  found?: boolean;
  zip_size?: number;
};

export type TLVerifyArtifact = {
  id: string;
  name?: string | null;
  version?: string | null;
};

export type TLVerifyResponse = {
  artifact?: TLVerifyArtifactInspect | null;
  error?: string | null;
  found?: boolean;
  iflows?: TLVerifyArtifact[];
  message_mapping_count?: number;
  package_id?: string | null;
  run_id: string;
  script_collection_count?: number;
  value_mapping_count?: number;
};

export type TLSoftwareComponentEntry = {
  caption: string;
  is_system?: boolean;
  software_component?: string;
  vendor?: string;
  version?: string;
};

export type TLSoftwareComponentsResponse = {
  count?: number;
  software_components?: TLSoftwareComponentEntry[];
};

export type TLTestSinkChannel = {
  channel: string;
  messages?: number;
};

export type TLTestSinkChannelsResponse = {
  channels?: TLTestSinkChannel[];
  count?: number;
};

export type TLTestSinkMessage = {
  body_excerpt?: string;
  content_type?: string;
  received_at?: string;
  size_bytes?: number;
  truncated?: boolean;
};

export type TLTestSinkChannelResponse = {
  channel: string;
  count?: number;
  messages?: TLTestSinkMessage[];
};

export type TLVerifyArtifactRequest = {
  artifact_id: string;
  entity_set: string;
  target_connection_id?: string | null;
};

export type TLImportWorkspaceRequestPayload = { [key: string]: unknown };

export type TLImportWorkspaceRequest = {
  payload?: TLImportWorkspaceRequestPayload;
  target_connection_id?: string | null;
};

export type TLGenerateWorkspaceRequestPayload = { [key: string]: unknown };

export type TLGenerateWorkspaceRequest = {
  payload?: TLGenerateWorkspaceRequestPayload;
};

export type TLBackfillViewRolesFailure = {
  email: string;
  error?: string | null;
};

export type TLBackfillViewRolesResponse = {
  /** Number of users where role assignment failed */
  failed: number;
  /** Details of failed role assignments */
  failures?: TLBackfillViewRolesFailure[];
  /** Number of users successfully assigned the role */
  successful: number;
  /** Total number of users with active dashboard permissions */
  total_users: number;
};

export type TLStorageBackfillResponse = {
  /** Number of program-backed executions queued for backfill to the Data Foundry lake. */
  candidate_count: number;
  dashboard_id: string;
  message: string;
};

export enum TLCalculationType {
  incrementality = 'incrementality',
  unique_errors = 'unique_errors',
}
export type TLDHExportRequest = {
  /**
   * IDs of dashboards to export
   * @minItems 1
   */
  dashboard_ids: string[];
  /** Optional description of the export */
  description?: string | null;
  /** Whether to include permissions in the export */
  include_permissions?: boolean;
  /**
   * Name for this export
   * @maxLength 200
   */
  name: string;
};

export enum TLDHExportStatus {
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
export type TLDHExportLogResponse = {
  /** Email of the user who created the export */
  created_by: string;
  /** When the export was created */
  created_date: string;
  /** IDs of dashboards included in the export */
  dashboard_ids: string[];
  /** Description of the export */
  description?: string | null;
  /** Error message if status is FAILED */
  error_msg?: string | null;
  /** ID of the export log record */
  export_id: string;
  /** Whether permissions were included */
  include_permissions: boolean;
  /** Name of the export */
  name: string;
  /** Program ID of the uploaded export file */
  program_id?: string | null;
  /** Current export status */
  status: TLDHExportStatus;
};

export type TLDHImportRequest = {
  /** Whether to import permissions */
  include_permissions?: boolean;
  /** Program ID of the exported JSON file to import */
  program_id: string;
};

/**
 * Import summary with counts of created entities
 */
export type TLDHImportLogResponseSummary = { [key: string]: unknown };

export enum TLDHImportStatus {
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  PARTIAL = 'PARTIAL',
  FAILED = 'FAILED',
}
export type TLDHImportLogResponse = {
  /** When the import completed */
  completed_date?: string | null;
  /** Email of the user who created the import */
  created_by: string;
  /** When the import was created */
  created_date: string;
  /** Error message if status is FAILED */
  error_msg?: string | null;
  /** ID of the import log record */
  import_id: string;
  /** Whether permissions were included */
  include_permissions: boolean;
  /** Program ID of the source import file */
  program_id: string;
  /** Current import status */
  status: TLDHImportStatus;
  /** Import summary with counts of created entities */
  summary: TLDHImportLogResponseSummary;
};

export type TLStorageModeRequest = {
  /** When true, new Data Harmonization results for this tenant are written to the Data Foundry lake; when false, they are written as programs. */
  enabled: boolean;
};

export type TLStorageModeResponse = {
  /** The effective per-tenant Data Foundry storage flag after the update. */
  foundry_storage_enabled: boolean;
};

/**
 * Lake-vs-program storage split for one result type (data checks, error tracking, or
 * custom views). The dashboard/tenant top-level counts are the sum across all three.
 */
export type TLStorageCounts = {
  lake_count?: number;
  program_count?: number;
  total_executions?: number;
  unreadable_count?: number;
};

/**
 * Where a DH execution result's data lives.
 */
export enum TLStorageBackend {
  LAKE = 'LAKE',
  PROGRAM = 'PROGRAM',
}
export type TLExecutionStorageStatus = {
  batch_execution_id?: string | null;
  /** When the readability probe ran */
  checked_at?: string | null;
  completed_date?: string | null;
  data_check_id: string;
  execution_id: string;
  /** Outcome of the readability probe; None when the probe could not run */
  readable?: boolean | null;
  result_table_fqdn?: string | null;
  /** Where the result data lives; None when the execution has no result data */
  storage?: TLStorageBackend | null;
};

export type TLDataCheckStorageStatus = {
  data_check_id: string;
  /** Display name of the data check; None when the check is no longer active. */
  data_check_name?: string | null;
  executions: TLExecutionStorageStatus[];
};

export type TLDashboardStorageStatusResponse = {
  checks: TLDataCheckStorageStatus[];
  custom_views?: TLStorageCounts;
  dashboard_id: string;
  dashboard_name?: string | null;
  data_checks?: TLStorageCounts;
  error_tracking?: TLStorageCounts;
  lake_count: number;
  program_count: number;
  total_executions: number;
  /** Executions whose readability probe explicitly failed */
  unreadable_count: number;
};

/**
 * Tenant-wide rollup across all active dashboards (admin console surface).
 */
export type TLTenantStorageStatusResponse = {
  custom_views?: TLStorageCounts;
  dashboards: TLDashboardStorageStatusResponse[];
  data_checks?: TLStorageCounts;
  error_tracking?: TLStorageCounts;
  /** Effective per-tenant Data Foundry storage flag — when true, new results are written to the lake. Drives the admin-console migration toggle. */
  foundry_storage_enabled?: boolean;
  lake_count: number;
  program_count: number;
  total_executions: number;
  unreadable_count: number;
};

export type TLDeleteBatchExecutionsRequest = {
  execution_ids: string[];
};

export enum TLBatchExecutionStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
export enum TLBatchTriggerType {
  MANUAL = 'MANUAL',
  SCHEDULED = 'SCHEDULED',
  WORKFLOW = 'WORKFLOW',
}
export type TLBatchExecutionSettings = { [key: string]: unknown } | null;

export type TLBatchExecution = {
  /** When the batch execution completed */
  completed_date?: string | null;
  created_by: string;
  created_date: string;
  credential_id?: string | null;
  /** ID of the dashboard this batch execution belongs to */
  dashboard_id: string;
  /** Unique identifier for this batch execution */
  execution_id: string;
  schedule_id?: string | null;
  settings?: TLBatchExecutionSettings;
  /** When the batch execution started */
  started_date?: string | null;
  /** Current status: PENDING, RUNNING, COMPLETED, FAILED, or CANCELED */
  status: TLBatchExecutionStatus;
  /** How the batch was triggered: MANUAL, SCHEDULED, or WORKFLOW */
  trigger_type: TLBatchTriggerType;
  updated_by: string;
  updated_date: string;
};

export type TLDataCheckExecutionCounts = {
  canceled?: number;
  completed?: number;
  failed?: number;
  pending?: number;
  running?: number;
  total?: number;
};

export type TLBatchExecutionWithCounts = {
  batch_execution: TLBatchExecution;
  data_check_execution_counts: TLDataCheckExecutionCounts;
};

export type TLBatchExecutionsResponse = {
  batch_executions: TLBatchExecutionWithCounts[];
};

export type TLCategoryResponse = {
  category_id: string;
  created_by: string;
  created_date: string;
  name: string;
  updated_by: string;
  updated_date: string;
};

export type TLCategoryCreateRequest = {
  name: string;
};

export type TLCategoryUpdateRequest = {
  name?: string | null;
};

export enum TLCredentialDomain {
  SAP = 'SAP',
  SALESFORCE = 'SALESFORCE',
  WORKDAY = 'WORKDAY',
}
export type TLCredentialResponse = {
  created_by: string;
  created_date: string;
  credential_id: string;
  description?: string | null;
  domain: string;
  is_default: boolean;
  status: string;
  system_version?: string | null;
  updated_by: string;
  updated_date: string;
  username: string;
};

export type TLCredentialsResponse = {
  credentials: TLCredentialResponse[];
};

export type TLDataHarmonizationV2CredentialCreateRequest = {
  description?: string | null;
  domain: TLCredentialDomain;
  is_default?: boolean;
  /** @minLength 1 */
  password: string;
  security_token?: string | null;
  system_version?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  username: string;
};

export type TLCredentialPingRequest = {
  domain: TLCredentialDomain;
  /** @minLength 1 */
  password: string;
  security_token?: string | null;
  system_version?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  username: string;
};

export type TLDataHarmonizationV2CredentialUpdateRequest = {
  description?: string | null;
  is_default?: boolean | null;
  password?: string | null;
  security_token?: string | null;
  system_version?: string | null;
  username?: string | null;
};

export type TLCredentialExportToConnectorRequest = {
  /** Target data connector ID */
  connector_id: string;
  /** Name for the new credential */
  credential_name?: string | null;
  /** Set as default credential on the connector */
  is_default?: boolean;
};

export enum TLCustomViewStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
/**
 * A multi-select dropdown filter persisted on the view definition.
 *
 * Each spec renders as a labeled dropdown above the results table listing the column's
 * distinct values (from the latest refresh); the values a user selects filter the
 * results with IN semantics.
 */
export type TLCustomViewFilterSpec = {
  /**
   * Result column (FIELDNAME) the dropdown filters on
   * @maxLength 128
   * @pattern ^[a-zA-Z0-9_-]+$
   */
  key: string;
  /** Display label; defaults to the column's field-metadata DESCRIPTION */
  label?: string | null;
};

/**
 * A manually declared link from a column of this view to a column of a sibling view.
 */
export type TLCustomViewLinkSpec = {
  /**
   * Column of this view the link starts from
   * @minLength 1
   */
  column: string;
  /** Column of the target view to filter on; defaults to the same column name */
  target_column?: string | null;
  /** Sibling view to look up in, by id (name or id required) */
  target_view_id?: string | null;
  /** Sibling view to look up in, by name (name or id required) */
  target_view_name?: string | null;
};

export enum TLViewLinkMode {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
  OFF = 'OFF',
}
/**
 * Cross-view lookup behavior stored on the view definition.
 *
 * AUTO (the default when the config is omitted) derives links from field metadata:
 * columns of sibling ACTIVE views match when their FIELDNAME — or failing that their
 * ROLLNAME (SAP data element) — is identical. Most views never need this config; it
 * exists because name-based derivation fails in two directions:
 *
 * - Missed links: semantically identical columns whose names/metadata differ (a
 *   calculation renames EBELN to PO_NUMBER; a file-upload source has no ROLLNAME).
 *   Declare those in `links` — in AUTO mode they extend the derived set and override
 *   the auto link for the same (column, target view).
 * - Wrong links: matching is purely name-based, so generic column names (STATUS,
 *   TYPE, DESCRIPTION, ...) can link views where the lookup is semantically
 *   unrelated and the filtered result is a coincidence. MANUAL keeps only the
 *   declared links; OFF disables lookups for this view entirely.
 */
export type TLCustomViewLinksConfig = {
  /**
   * Manual links; extend (AUTO) or define (MANUAL) the derived set
   * @maxItems 50
   */
  links?: TLCustomViewLinkSpec[];
  /** AUTO (metadata-derived), MANUAL (links only), or OFF */
  mode?: TLViewLinkMode;
};

export type TLCustomViewSummaryResponse = {
  created_by: string;
  created_date: string;
  dashboard_id: string;
  description?: string | null;
  persisted_filters?: TLCustomViewFilterSpec[] | null;
  status: TLCustomViewStatus;
  updated_by: string;
  updated_date: string;
  view_id: string;
  view_links?: TLCustomViewLinksConfig | null;
  view_name: string;
};

export type TLCustomViewsResponse = {
  views?: TLCustomViewSummaryResponse[];
};

export enum TLDuplicateResolutionStrategy {
  COALESCE = 'COALESCE',
  DROP_LEFT = 'DROP_LEFT',
  DROP_RIGHT = 'DROP_RIGHT',
  RENAME_PREFIX = 'RENAME_PREFIX',
  MIN = 'MIN',
  MAX = 'MAX',
  ERROR = 'ERROR',
}
export enum TLViewJoinType {
  LEFT_JOIN = 'LEFT_JOIN',
  INNER_JOIN = 'INNER_JOIN',
  FULL_OUTER_JOIN = 'FULL_OUTER_JOIN',
}
export enum TLCaseConditionOperator {
  eq = 'eq',
  neq = 'neq',
  gt = 'gt',
  gte = 'gte',
  lt = 'lt',
  lte = 'lte',
  is_null = 'is_null',
  is_not_null = 'is_not_null',
  in = 'in',
  not_in = 'not_in',
}
export type TLCaseCondition = {
  /** Column to evaluate */
  column: string;
  /** Comparison operator */
  operator: TLCaseConditionOperator;
  /** Value to compare against (not needed for is_null/is_not_null) */
  value?: unknown | null;
};

export type TLCaseBranchInput = {
  /** Value or column reference if condition is true */
  then: unknown;
  /** Condition to evaluate */
  when: TLCaseCondition;
};

/**
 * Describes a single field/column — mirrors the structure from ET_METADATA.
 */
export type TLFieldMetadataEntry = {
  /** Data type (e.g. CHAR, DATS, DEC) */
  DATATYPE?: string | null;
  /** Decimal places */
  DECIMALS?: number | null;
  /** Human-readable description */
  DESCRIPTION?: string | null;
  /**
   * Column name
   * @minLength 1
   */
  FIELDNAME: string;
  /** Field length */
  FIELD_LENGTH?: number | null;
  /** Field type classification */
  FIELD_TYPE?: string | null;
  /** Internal ABAP type (e.g. C, D, P) */
  INTTYPE?: string | null;
  /** Data element / roll name */
  ROLLNAME?: string | null;
  /** Source table name */
  TABNAME?: string | null;
};

export enum TLCalculationOperator {
  SUM = 'SUM',
  AVG = 'AVG',
  MIN = 'MIN',
  MAX = 'MAX',
  COUNT = 'COUNT',
  COUNT_DISTINCT = 'COUNT_DISTINCT',
  LIST_AGG = 'LIST_AGG',
  LIST_DISTINCT = 'LIST_DISTINCT',
  STRING_AGG = 'STRING_AGG',
  COALESCE = 'COALESCE',
  CONCAT = 'CONCAT',
  REPLACE = 'REPLACE',
  LITERAL = 'LITERAL',
  CASE = 'CASE',
}
export type TLCalculationInput = {
  /** CASE WHEN branches */
  cases?: TLCaseBranchInput[] | null;
  /** Input column name */
  column?: string | null;
  /** Input column names */
  columns?: string[] | null;
  /** ELSE value for CASE */
  default?: unknown | null;
  /** Override field metadata for this calculated column */
  field_metadata?: TLFieldMetadataEntry | null;
  /**
   * Output column name
   * @minLength 1
   */
  name: string;
  /** Calculation operator */
  operator: TLCalculationOperator;
  /** String pattern to replace (literal) */
  pattern?: string | null;
  /** Column whose value is the pattern to replace */
  pattern_column?: string | null;
  /** Suffix appended to pattern_column value via || operator */
  pattern_suffix?: string | null;
  /** Replacement string */
  replacement?: string | null;
  /** Separator string */
  separator?: string | null;
  /** Template string with {COLUMN_NAME} placeholders */
  template?: string | null;
  /** Literal value */
  value?: unknown | null;
};

export type TLColumnSpec = {
  /** Rename the column in the output */
  alias?: string | null;
  /**
   * Source column name
   * @minLength 1
   */
  name: string;
};

export enum TLGroupCombinationType {
  UNION = 'UNION',
  UNION_ALL = 'UNION_ALL',
}
export enum TLDefaultAggregateFunction {
  MAX = 'MAX',
  MIN = 'MIN',
  FIRST = 'FIRST',
  LAST = 'LAST',
  ANY_VALUE = 'ANY_VALUE',
}
export enum TLFilterCastType {
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  VARCHAR = 'VARCHAR',
  BOOLEAN = 'BOOLEAN',
}
export enum TLFilterOperator {
  '=' = '=',
  '!=' = '!=',
  '>' = '>',
  '>=' = '>=',
  '<' = '<',
  '<=' = '<=',
  ILIKE = 'ILIKE',
  IN = 'IN',
  NOT_IN = 'NOT IN',
  IS_NULL = 'IS NULL',
  IS_NOT_NULL = 'IS NOT NULL',
  contains_any = 'contains_any',
  contains_all = 'contains_all',
  not_contains_any = 'not_contains_any',
  not_contains_all = 'not_contains_all',
}
export type TLFilter = {
  /** Cast the column to this type before comparing */
  cast?: TLFilterCastType | null;
  /** @pattern ^[a-zA-Z0-9_-]+$ */
  key: string;
  operator: TLFilterOperator;
  value?: unknown | null;
};

export enum TLSourceSelectionType {
  EXPLICIT = 'EXPLICIT',
  EXPRESSION = 'EXPRESSION',
}
/**
 * Condition tree for dynamic selection (required for EXPRESSION)
 */
export type TLCustomViewSourceCreateRequestExpression = { [key: string]: unknown } | null;

export type TLCustomViewSourceCreateRequest = {
  /** Per-source calculations */
  calculations?: TLCalculationInput[] | null;
  /** Ordered column selection with optional renaming */
  columns?: TLColumnSpec[] | null;
  /** ID of the dashboard data check (required for EXPLICIT) */
  dashboard_data_check_id?: string | null;
  /** Aggregate function for non-key columns when group_by is used (e.g. MAX, MIN) */
  default_aggregate?: TLDefaultAggregateFunction | null;
  /** Additional columns to exclude from default_aggregate beyond group_by keys and calculation source columns */
  default_aggregate_exclude?: string[] | null;
  /** Condition tree for dynamic selection (required for EXPRESSION) */
  expression?: TLCustomViewSourceCreateRequestExpression;
  /** Per-source filters */
  filters?: TLFilter[] | null;
  /** Per-source GROUP BY columns */
  group_by?: string[] | null;
  /** Whether this source is active */
  is_active?: boolean;
  /** Per-source ORDER BY columns */
  order_by?: string[] | null;
  /** When true, only include executions with issue_count > 0 */
  require_issues?: boolean | null;
  /** How data checks are selected: EXPLICIT or EXPRESSION */
  selection_type: TLSourceSelectionType;
  /** Optional display name for this source */
  source_name?: string | null;
};

export type TLCustomViewGroupCreateRequest = {
  /** Group-level calculations */
  calculations?: TLCalculationInput[] | null;
  /** Ordered column selection with optional renaming */
  column_config?: TLColumnSpec[] | null;
  /** How data check results are combined vertically */
  combination_type?: TLGroupCombinationType;
  /** Aggregate function for non-key columns when group_by is used (e.g. MAX, MIN) */
  default_aggregate?: TLDefaultAggregateFunction | null;
  /** Additional columns to exclude from default_aggregate beyond group_by keys and calculation source columns */
  default_aggregate_exclude?: string[] | null;
  /** Override duplicate resolution (inherits from view if null) */
  duplicate_resolution?: TLDuplicateResolutionStrategy | null;
  /** Group-level filters */
  filters?: TLFilter[] | null;
  /** Group-level GROUP BY columns */
  group_by?: string[] | null;
  /**
   * Display name of the group
   * @minLength 1
   * @maxLength 200
   */
  group_name: string;
  /** Whether this group is active. Set to false to skip/disable this group from the view execution */
  is_active?: boolean;
  /** Override join keys (inherits from view if null) */
  join_keys?: string[] | null;
  /** Override join type (inherits from view if null) */
  join_type?: TLViewJoinType | null;
  /** Group-level ORDER BY applied after combining sources */
  order_by?: string[] | null;
  /**
   * Order position for sequential join processing
   * @minimum 0
   */
  position: number;
  /** Sources within this group */
  sources?: TLCustomViewSourceCreateRequest[] | null;
};

export type TLCustomViewCreateRequest = {
  /** Default strategy for resolving duplicate columns */
  default_duplicate_resolution?: TLDuplicateResolutionStrategy;
  /** Default columns to join groups on */
  default_join_keys?: string[] | null;
  /** Default join type used when joining groups */
  default_join_type?: TLViewJoinType;
  /** Optional description of the view's purpose */
  description?: string | null;
  /** Groups within this view */
  groups?: TLCustomViewGroupCreateRequest[] | null;
  /** View-level ORDER BY applied to the final output */
  order_by?: string[] | null;
  /** Multi-select dropdown filters shown above the results table, one per listed column */
  persisted_filters?: TLCustomViewFilterSpec[] | null;
  /** Cross-view lookup behavior; omit for AUTO (derived from field metadata) */
  view_links?: TLCustomViewLinksConfig | null;
  /**
   * Display name of the custom view
   * @minLength 1
   * @maxLength 200
   */
  view_name: string;
};

export type TLCaseBranchOutput = {
  /** Value or column reference if condition is true */
  then: unknown;
  /** Condition to evaluate */
  when: TLCaseCondition;
};

export type TLCalculationOutput = {
  /** CASE WHEN branches */
  cases?: TLCaseBranchOutput[] | null;
  /** Input column name */
  column?: string | null;
  /** Input column names */
  columns?: string[] | null;
  /** ELSE value for CASE */
  default?: unknown | null;
  /** Override field metadata for this calculated column */
  field_metadata?: TLFieldMetadataEntry | null;
  /**
   * Output column name
   * @minLength 1
   */
  name: string;
  /** Calculation operator */
  operator: TLCalculationOperator;
  /** String pattern to replace (literal) */
  pattern?: string | null;
  /** Column whose value is the pattern to replace */
  pattern_column?: string | null;
  /** Suffix appended to pattern_column value via || operator */
  pattern_suffix?: string | null;
  /** Replacement string */
  replacement?: string | null;
  /** Separator string */
  separator?: string | null;
  /** Template string with {COLUMN_NAME} placeholders */
  template?: string | null;
  /** Literal value */
  value?: unknown | null;
};

export type TLSourceResponseExpression = { [key: string]: unknown } | null;

export type TLSourceResponse = {
  calculations?: TLCalculationOutput[] | null;
  columns?: TLColumnSpec[] | null;
  created_by: string;
  created_date: string;
  dashboard_data_check_id?: string | null;
  default_aggregate?: TLDefaultAggregateFunction | null;
  default_aggregate_exclude?: string[] | null;
  expression?: TLSourceResponseExpression;
  filters?: TLFilter[] | null;
  group_by?: string[] | null;
  group_id: string;
  is_active: boolean;
  order_by?: string[] | null;
  require_issues?: boolean | null;
  selection_type: TLSourceSelectionType;
  source_id: string;
  source_name?: string | null;
  updated_by: string;
  updated_date: string;
};

export type TLDataHarmonizationV2GroupResponse = {
  calculations?: TLCalculationOutput[] | null;
  column_config?: TLColumnSpec[] | null;
  combination_type: TLGroupCombinationType;
  created_by: string;
  created_date: string;
  default_aggregate?: TLDefaultAggregateFunction | null;
  default_aggregate_exclude?: string[] | null;
  duplicate_resolution?: TLDuplicateResolutionStrategy | null;
  filters?: TLFilter[] | null;
  group_by?: string[] | null;
  group_id: string;
  group_name: string;
  is_active: boolean;
  join_keys?: string[] | null;
  join_type?: TLViewJoinType | null;
  position: number;
  sources?: TLSourceResponse[];
  updated_by: string;
  updated_date: string;
  view_id: string;
};

export type TLCustomViewResponse = {
  created_by: string;
  created_date: string;
  dashboard_id: string;
  default_duplicate_resolution: TLDuplicateResolutionStrategy;
  default_join_keys?: string[] | null;
  default_join_type: TLViewJoinType;
  description?: string | null;
  groups?: TLDataHarmonizationV2GroupResponse[];
  order_by?: string[] | null;
  persisted_filters?: TLCustomViewFilterSpec[] | null;
  status: TLCustomViewStatus;
  updated_by: string;
  updated_date: string;
  view_id: string;
  view_links?: TLCustomViewLinksConfig | null;
  view_name: string;
};

export type TLDeleteCustomViewExecutionsRequest = {
  /**
   * Execution ids to delete
   * @minItems 1
   * @maxItems 50
   */
  execution_ids: string[];
};

export type TLCustomViewExecutionResponseFieldMetadata = { [key: string]: unknown }[] | null;

export enum TLCustomViewExecutionStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
export enum TLCustomViewExecutionStepType {
  DATA_CHECK = 'DATA_CHECK',
  GROUP = 'GROUP',
  VIEW = 'VIEW',
}
export type TLCustomViewExecutionStepResponseFieldMetadata = { [key: string]: unknown }[] | null;

export type TLCustomViewExecutionStepResponse = {
  completed_date?: string | null;
  created_date: string;
  error_message?: string | null;
  execution_id: string;
  field_metadata?: TLCustomViewExecutionStepResponseFieldMetadata;
  reference_id: string;
  reference_name?: string | null;
  result_program_id?: string | null;
  row_count?: number | null;
  started_date?: string | null;
  status: TLCustomViewExecutionStatus;
  step_id: string;
  step_type: TLCustomViewExecutionStepType;
};

export type TLCustomViewExecutionResponse = {
  batch_execution_id: string;
  completed_date?: string | null;
  created_by?: string | null;
  created_date: string;
  error_message?: string | null;
  execution_id: string;
  field_metadata?: TLCustomViewExecutionResponseFieldMetadata;
  result_program_id?: string | null;
  result_table_fqdn?: string | null;
  started_date?: string | null;
  status: TLCustomViewExecutionStatus;
  steps?: TLCustomViewExecutionStepResponse[];
  temporal_workflow_id?: string | null;
  updated_date: string;
  view_id: string;
};

export enum TLDuckdbSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
export type TLSortInput = {
  direction?: TLDuckdbSortDirection;
  /** @pattern ^[a-zA-Z0-9_-]+$ */
  key: string;
};

export type TLGetExecutionDataRequest = {
  /** Optional filters to apply to the data */
  filters?: TLFilter[];
  /**
   * Page number, must be at least 1
   * @minimum 1
   */
  page?: number;
  /**
   * Number of rows per page, must be between 1 and 1000
   * @minimum 1
   * @maximum 1000
   */
  page_size?: number;
  /** Optional sort order to apply to the data */
  sort?: TLSortInput[];
};

export type TLGetExecutionDataResponseFieldMetadataItem = { [key: string]: unknown };

export enum TLSortDirectionOutput {
  ASC = 'ASC',
  DESC = 'DESC',
}
export type TLSortOutput = {
  direction?: TLSortDirectionOutput;
  /** @pattern ^[a-zA-Z0-9_-]+$ */
  key: string;
};

export type TLGetExecutionDataResponse = {
  count: number;
  field_metadata: TLGetExecutionDataResponseFieldMetadataItem[];
  filters: TLFilter[];
  last_refreshed: string;
  page: number;
  page_size: number;
  sort: TLSortOutput[];
  total_pages: number;
  tsv_data: string;
};

export type TLExportExecutionRequest = {
  /** Optional filters to apply to the data */
  filters?: TLFilter[];
  /** Optional sort order to apply to the data */
  sort?: TLSortInput[];
};

export type TLExportExecutionResponse = {
  file: TLFile;
};

/**
 * Distinct values per persisted-filter column, sorted ascending
 */
export type TLCustomViewFilterValuesResponseValues = { [key: string]: string[] };

export type TLCustomViewFilterValuesResponse = {
  execution_id: string;
  /** Columns whose distinct values exceeded the cap and were truncated */
  truncated?: string[];
  /** Distinct values per persisted-filter column, sorted ascending */
  values?: TLCustomViewFilterValuesResponseValues;
};

export type TLGenerateFiltersForViewExecutionRequest = {
  /**
   * Natural-language description of the filters to generate
   * @minLength 1
   */
  prompt: string;
};

/**
 * Response model for generated filters.
 */
export type TLGenerateFiltersResponse = {
  /**
   * Confidence score between 0.0 and 1.0
   * @minimum 0
   * @maximum 1
   */
  confidence: number;
  /** Human-readable explanation of the generated filters */
  explanation: string;
  /** List of generated Filter objects */
  filters: TLFilter[];
  /** List of warning messages */
  warnings?: string[];
};

export type TLCustomViewGroupUpdateRequest = {
  /** Group-level calculations */
  calculations?: TLCalculationInput[] | null;
  /** Ordered column selection with optional renaming */
  column_config?: TLColumnSpec[] | null;
  /** How data check results are combined vertically */
  combination_type?: TLGroupCombinationType | null;
  /** Aggregate function for non-key columns when group_by is used */
  default_aggregate?: TLDefaultAggregateFunction | null;
  /** Additional columns to exclude from default_aggregate */
  default_aggregate_exclude?: string[] | null;
  /** Override duplicate resolution (inherits from view if null) */
  duplicate_resolution?: TLDuplicateResolutionStrategy | null;
  /** Group-level filters */
  filters?: TLFilter[] | null;
  /** Group-level GROUP BY columns */
  group_by?: string[] | null;
  /** Display name of the group */
  group_name?: string | null;
  /** Whether this group is active. Set to false to skip/disable this group from the view execution */
  is_active?: boolean | null;
  /** Override join keys (inherits from view if null) */
  join_keys?: string[] | null;
  /** Override join type (inherits from view if null) */
  join_type?: TLViewJoinType | null;
  /** Group-level ORDER BY applied after combining sources */
  order_by?: string[] | null;
  /** Order position for sequential join processing */
  position?: number | null;
};

export type TLPreviewGroupRequest = {
  config: TLCustomViewGroupCreateRequest;
  dashboard_id: string;
};

export type TLCustomViewPreviewResponseFieldMetadataItem = { [key: string]: unknown };

export type TLCustomViewPreviewResponseRowsItem = { [key: string]: unknown };

export type TLCustomViewPreviewResponse = {
  /** Column names in order */
  columns?: string[];
  /** Field metadata entries */
  field_metadata?: TLCustomViewPreviewResponseFieldMetadataItem[];
  /** Sample data rows */
  rows?: TLCustomViewPreviewResponseRowsItem[];
  /** Total number of rows in the result */
  total_row_count?: number;
};

export type TLPreviewSourceRequest = {
  config: TLCustomViewSourceCreateRequest;
  dashboard_id: string;
  preview_dashboard_data_check_id?: string | null;
};

export type TLDataCheckPreviewFieldMetadataItem = { [key: string]: unknown };

export type TLDataCheckPreviewRowsItem = { [key: string]: unknown };

export type TLDataCheckPreview = {
  /** Column names in order */
  columns?: string[];
  /** Field metadata entries */
  field_metadata?: TLDataCheckPreviewFieldMetadataItem[];
  /** Sample data rows */
  rows?: TLDataCheckPreviewRowsItem[];
  /** Total number of rows in the result */
  total_row_count?: number;
};

/**
 * Per-data-check previews keyed by dashboard_data_check_id
 */
export type TLCustomViewSourcePreviewResponsePreviews = { [key: string]: TLDataCheckPreview };

export type TLMatchedDataCheck = {
  dashboard_data_check_id: string;
  name?: string | null;
  nickname?: string | null;
};

export type TLCustomViewSourcePreviewResponse = {
  /** All data checks matched by the source expression */
  matched_data_checks?: TLMatchedDataCheck[];
  /** Per-data-check previews keyed by dashboard_data_check_id */
  previews?: TLCustomViewSourcePreviewResponsePreviews;
  /** EXPLICIT or EXPRESSION */
  selection_type: string;
  /** Display name of the source */
  source_name?: string | null;
};

export type TLPreviewViewRequest = {
  config: TLCustomViewCreateRequest;
  dashboard_id: string;
};

/**
 * Condition tree for dynamic selection
 */
export type TLCustomViewSourceUpdateRequestExpression = { [key: string]: unknown } | null;

export type TLCustomViewSourceUpdateRequest = {
  /** Per-source calculations */
  calculations?: TLCalculationInput[] | null;
  /** Ordered column selection with optional renaming */
  columns?: TLColumnSpec[] | null;
  /** ID of the dashboard data check */
  dashboard_data_check_id?: string | null;
  /** Aggregate function for non-key columns when group_by is used */
  default_aggregate?: TLDefaultAggregateFunction | null;
  /** Additional columns to exclude from default_aggregate */
  default_aggregate_exclude?: string[] | null;
  /** Condition tree for dynamic selection */
  expression?: TLCustomViewSourceUpdateRequestExpression;
  /** Per-source filters */
  filters?: TLFilter[] | null;
  /** Per-source GROUP BY columns */
  group_by?: string[] | null;
  /** Whether this source is active */
  is_active?: boolean | null;
  /** Per-source ORDER BY columns */
  order_by?: string[] | null;
  /** When true, only include executions with issue_count > 0 */
  require_issues?: boolean | null;
  /** How data checks are selected */
  selection_type?: TLSourceSelectionType | null;
  /** Optional display name for this source */
  source_name?: string | null;
};

export type TLCustomViewUpdateRequest = {
  /** Default strategy for resolving duplicate columns */
  default_duplicate_resolution?: TLDuplicateResolutionStrategy | null;
  /** Default columns to join groups on */
  default_join_keys?: string[] | null;
  /** Default join type used when joining groups */
  default_join_type?: TLViewJoinType | null;
  /** Optional description of the view's purpose */
  description?: string | null;
  /** View-level ORDER BY applied to the final output */
  order_by?: string[] | null;
  /** Multi-select dropdown filters shown above the results table; [] clears them */
  persisted_filters?: TLCustomViewFilterSpec[] | null;
  /** View status: DRAFT, ACTIVE, or INACTIVE */
  status?: TLCustomViewStatus | null;
  /** Cross-view lookup behavior; omit for AUTO (derived from field metadata) */
  view_links?: TLCustomViewLinksConfig | null;
  /** Display name of the custom view */
  view_name?: string | null;
};

/**
 * Condition tree for dynamic selection (required for EXPRESSION)
 */
export type TLCustomViewSourceReplaceRequestExpression = { [key: string]: unknown } | null;

export type TLCustomViewSourceReplaceRequest = {
  /** Per-source calculations */
  calculations?: TLCalculationInput[] | null;
  /** Ordered column selection with optional renaming */
  columns?: TLColumnSpec[] | null;
  /** ID of the dashboard data check (required for EXPLICIT) */
  dashboard_data_check_id?: string | null;
  /** Aggregate function for non-key columns when group_by is used (e.g. MAX, MIN) */
  default_aggregate?: TLDefaultAggregateFunction | null;
  /** Additional columns to exclude from default_aggregate beyond group_by keys and calculation source columns */
  default_aggregate_exclude?: string[] | null;
  /** Condition tree for dynamic selection (required for EXPRESSION) */
  expression?: TLCustomViewSourceReplaceRequestExpression;
  /** Per-source filters */
  filters?: TLFilter[] | null;
  /** Per-source GROUP BY columns */
  group_by?: string[] | null;
  /** Whether this source is active */
  is_active?: boolean;
  /** Per-source ORDER BY columns */
  order_by?: string[] | null;
  /** When true, only include executions with issue_count > 0 */
  require_issues?: boolean | null;
  /** How data checks are selected: EXPLICIT or EXPRESSION */
  selection_type: TLSourceSelectionType;
  /** Existing source to update in place; omit to create a new source */
  source_id?: string | null;
  /** Optional display name for this source */
  source_name?: string | null;
};

export type TLCustomViewGroupReplaceRequest = {
  /** Group-level calculations */
  calculations?: TLCalculationInput[] | null;
  /** Ordered column selection with optional renaming */
  column_config?: TLColumnSpec[] | null;
  /** How data check results are combined vertically */
  combination_type?: TLGroupCombinationType;
  /** Aggregate function for non-key columns when group_by is used (e.g. MAX, MIN) */
  default_aggregate?: TLDefaultAggregateFunction | null;
  /** Additional columns to exclude from default_aggregate beyond group_by keys and calculation source columns */
  default_aggregate_exclude?: string[] | null;
  /** Override duplicate resolution (inherits from view if null) */
  duplicate_resolution?: TLDuplicateResolutionStrategy | null;
  /** Group-level filters */
  filters?: TLFilter[] | null;
  /** Group-level GROUP BY columns */
  group_by?: string[] | null;
  /** Existing group to update in place; omit to create a new group */
  group_id?: string | null;
  /**
   * Display name of the group
   * @minLength 1
   * @maxLength 200
   */
  group_name: string;
  /** Whether this group is active. Set to false to skip/disable this group from the view execution */
  is_active?: boolean;
  /** Override join keys (inherits from view if null) */
  join_keys?: string[] | null;
  /** Override join type (inherits from view if null) */
  join_type?: TLViewJoinType | null;
  /** Group-level ORDER BY applied after combining sources */
  order_by?: string[] | null;
  /**
   * Ignored — the order of the groups array determines the join position
   * @minimum 0
   */
  position?: number;
  /** Full set of sources for this group; sources missing from the list are deleted */
  sources?: TLCustomViewSourceReplaceRequest[] | null;
};

export type TLCustomViewReplaceRequest = {
  /** Default strategy for resolving duplicate columns */
  default_duplicate_resolution?: TLDuplicateResolutionStrategy;
  /** Default columns to join groups on */
  default_join_keys?: string[] | null;
  /** Default join type used when joining groups */
  default_join_type?: TLViewJoinType;
  /** Optional description of the view's purpose */
  description?: string | null;
  /** Optimistic-concurrency guard: the view's updated_date as last read; a mismatch returns 409 */
  expected_updated_date?: string | null;
  /**
   * Full set of groups for this view, in join order; groups missing from the list are deleted
   * @maxItems 50
   */
  groups?: TLCustomViewGroupReplaceRequest[];
  /** View-level ORDER BY applied to the final output */
  order_by?: string[] | null;
  /** Multi-select dropdown filters shown above the results table, one per listed column */
  persisted_filters?: TLCustomViewFilterSpec[] | null;
  /** View status: DRAFT, ACTIVE, or INACTIVE; omit to keep the current status */
  status?: TLCustomViewStatus | null;
  /** Cross-view lookup behavior; omit for AUTO (derived from field metadata) */
  view_links?: TLCustomViewLinksConfig | null;
  /**
   * Display name of the custom view
   * @minLength 1
   * @maxLength 200
   */
  view_name: string;
};

export type TLCustomViewBackfillRequest = {
  /** Completed batch executions to backfill; omit to backfill the most recent missing ones */
  batch_execution_ids?: string[] | null;
  /**
   * Max missing batches to backfill when batch_execution_ids is omitted
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type TLCustomViewBackfillResponse = {
  /** PENDING executions enqueued for the custom view execution worker */
  queued_executions?: TLCustomViewExecutionResponse[];
  /** Batches that already had an execution for this view */
  skipped_batch_execution_ids?: string[];
};

export type TLCustomViewExecutionsResponse = {
  executions?: TLCustomViewExecutionResponse[];
};

export enum TLViewLinkMatchType {
  FIELDNAME = 'FIELDNAME',
  ROLLNAME = 'ROLLNAME',
  MANUAL = 'MANUAL',
}
/**
 * One resolved lookup target for a column of this view.
 */
export type TLCustomViewResolvedLink = {
  column: string;
  column_description?: string | null;
  match_type: TLViewLinkMatchType;
  target_column: string;
  target_column_description?: string | null;
  target_view_id: string;
  target_view_name: string;
};

export type TLCustomViewLinksResponse = {
  links?: TLCustomViewResolvedLink[];
  mode: TLViewLinkMode;
  view_id: string;
};

export type TLRetryDashboardDataCheckExecutionRequest = {
  /**
   * @minItems 1
   * @maxItems 50
   */
  dashboard_data_check_ids: string[];
};

export enum TLLiveConnectionAdapter {
  erpl = 'erpl',
  hana_odbc = 'hana_odbc',
  oracle_odbc = 'oracle_odbc',
  trino_odbc = 'trino_odbc',
  databricks_adbc = 'databricks_adbc',
  jde_world_odbc = 'jde_world_odbc',
}
export enum TLAccessMode {
  live = 'live',
  replicated = 'replicated',
}
/**
 * Records the data source a FOUNDRY execution ran against, for after-the-fact attribution.
 *
 * Persisted inside ``ExecutionMetadata`` as JSONB via python-mode ``model_dump()``, so
 * ``connection_id`` is ``str`` rather than ``UUID`` — the async engine has no UUID-aware
 * ``json_serializer``, same reason ``LiveConnectionBinding`` field-serializes its UUIDs.
 * Populated only when the check has a live-connection binding.
 *
 * ``mode`` is ``LIVE`` when the binding was enabled at run time, ``REPLICATED`` when it was
 * disabled. Only a ``LIVE`` run touches the live connection, so ``connection_id`` and
 * ``adapter`` are set for ``LIVE`` and ``None`` for ``REPLICATED`` — which reads the replicated
 * catalog of the same name and never engages the connection. ``catalog_name`` is the queried
 * catalog in both modes.
 */
export type TLExecutionProvenanceStamp = {
  adapter?: TLLiveConnectionAdapter | null;
  catalog_name: string;
  connection_id?: string | null;
  mode: TLAccessMode;
};

export type TLExecutionMetadata = {
  /** Pinned SAP connector name for this execution's host/connection resolution, snapshotted from the dashboard settings at batch time. None resolves the tenant default connector. */
  connector_name?: string | null;
  /** Provenance of a FOUNDRY execution's data source — set only when a live binding exists */
  provenance?: TLExecutionProvenanceStamp | null;
  /** Number of times this execution has been retried after going stale */
  retry_count?: number;
  /** SAP version used for execution */
  sap_version?: TLSAPVersion | null;
  /** Loom run id for a WORKFLOW data check execution, stamped one-way from the DH side at run start. The worker sweep polls this run and ingests its result when terminal. */
  workflow_execution_id?: string | null;
  [key: string]: unknown;
};

/**
 * Field metadata from RFC (ET_METADATA): FIELDNAME, DESCRIPTION, DATATYPE, LENGTH
 */
export type TLExecutionResultFieldMetadata = { [key: string]: unknown }[] | null;

export type TLExecutionResult = {
  /** User who canceled the execution */
  canceled_by?: string | null;
  /** Error message for failed executions */
  error?: string | null;
  /** Field metadata from RFC (ET_METADATA): FIELDNAME, DESCRIPTION, DATATYPE, LENGTH */
  field_metadata?: TLExecutionResultFieldMetadata;
  /** Number of issues found */
  issue_count?: number | null;
  /** Additional message or context */
  message?: string | null;
  /** Program ID for raw TSV output (debugging) */
  raw_tsv_program_id?: string | null;
  /** Total number of records scanned */
  total_scanned?: number | null;
  /** Number of data lines in raw TSV before parquet conversion (excluding header) */
  tsv_line_count?: number | null;
  [key: string]: unknown;
};

export enum TLDataCheckExecutionStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  SAVING = 'SAVING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
/**
 * Custom parameters used for this execution
 */
export type TLDataCheckExecutionParameters = { [key: string]: unknown } | null;

export type TLDataCheckExecution = {
  /** ID of the parent batch execution, if part of a batch run */
  batch_execution_id?: string | null;
  /** When the execution completed */
  completed_date?: string | null;
  created_by: string;
  created_date: string;
  credential_id?: string | null;
  /** ID of the dashboard-data check link */
  dashboard_data_check_id?: string | null;
  /** ID of the dashboard this execution belongs to */
  dashboard_id?: string | null;
  /** ID of the data check that was executed */
  data_check_id: string;
  /** Execution duration in milliseconds. */
  readonly duration_ms: number | null;
  /** Unique identifier for this execution */
  execution_id: string;
  execution_metadata?: TLExecutionMetadata | null;
  /** Custom parameters used for this execution */
  parameters?: TLDataCheckExecutionParameters;
  /** Execution result containing issue_count, total_scanned, and error details */
  result?: TLExecutionResult | null;
  /** UUID pointing to parquet file with the records that have issues */
  result_program_id?: string | null;
  /** Fully qualified table name in the lakehouse (catalog.schema.table) */
  result_table_fqdn?: string | null;
  readonly retry_count: number;
  readonly sap_version: TLSAPVersion;
  /** Data cleanliness ratio (0.0 to 1.0). Higher = cleaner data. Computed as (total_scanned - issue_count) / total_scanned. */
  readonly score: number | null;
  /** When the execution started */
  started_date?: string | null;
  /** Current status: PENDING, RUNNING, COMPLETED, FAILED, or CANCELED */
  status: TLDataCheckExecutionStatus;
  /** Where the result data lives: LAKE (foundry lakehouse) or PROGRAM (legacy parquet program). None when the execution has no result data. */
  readonly storage: TLStorageBackend | null;
  updated_date: string;
  /** UUID pointing to Excel export of results */
  xlsx_program_id?: string | null;
};

export type TLRetryDashboardDataCheckExecutionResponse = {
  executions: TLDataCheckExecution[];
};

export enum TLDataHarmonizationV2Priority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}
export enum TLDashboardDataCheckStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
}
export type TLDashboardDataCheckUpdateRequest = {
  /** Comments about this data check mapping */
  comments?: string | null;
  /** Custom nickname for this data check in the dashboard context */
  nickname?: string | null;
  /** Override priority level for this data check in the dashboard */
  priority?: TLDataHarmonizationV2Priority | null;
  /** Status of this data check in the dashboard */
  status?: TLDashboardDataCheckStatus | null;
};

export type TLGetDashboardExecutionsResponse = {
  executions: TLDataCheckExecution[];
};

export enum TLPermissionLevel {
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
  DATA_SCOPED = 'DATA_SCOPED',
}
export enum TLPermissionStatus {
  ACTIVE = 'ACTIVE',
  REVOKED = 'REVOKED',
}
export type TLDashboardPermissionResponse = {
  dashboard_id: string;
  granted_by: string;
  granted_date: string;
  permission_id: string;
  permission_level: TLPermissionLevel;
  revoked_by?: string | null;
  revoked_date?: string | null;
  status: TLPermissionStatus;
  updated_by: string;
  updated_date: string;
  user_email: string;
};

export type TLDashboardPermissionsResponse = {
  permissions: TLDashboardPermissionResponse[];
};

export type TLDashboardPermissionCreateRequest = {
  permission_level: TLPermissionLevel;
  /** @minItems 1 */
  user_emails: string[];
};

export type TLDashboardPermissionsBulkUpdateRequest = {
  permission_ids: string[];
  permission_level?: TLPermissionLevel | null;
  status?: TLPermissionStatus | null;
};

export type TLDashboardPermissionUpdateRequest = {
  permission_level?: TLPermissionLevel | null;
  status?: TLPermissionStatus | null;
};

export type TLDashboardSettings = {
  calc_source_view_id?: string | null;
  connector_name?: string | null;
  enrichment_join_enabled?: boolean | null;
  incrementality_baseline_batch_execution_id?: string | null;
  incrementality_baseline_error_tracking_id?: string | null;
  incrementality_enabled?: boolean | null;
  incrementality_exclude_dimensions?: string[];
  sap_version?: TLSAPVersion | null;
  strip_rule_id_from_primary_key?: boolean | null;
  unique_column_names?: string[];
  unique_error_universe_enabled?: boolean | null;
  unique_errors_exclude_dimensions?: string[];
  universe_dashboard_data_check_id?: string | string[] | null;
  [key: string]: unknown;
};

export type TLDashboardConfigResponseGraphConfig = { [key: string]: unknown } | null;

export type TLDashboardConfigResponseVignette = { [key: string]: unknown } | null;

export type TLDashboardConfigResponse = {
  config_id: string;
  created_by: string;
  created_date: string;
  dashboard_id: string;
  graph_config?: TLDashboardConfigResponseGraphConfig;
  settings?: TLDashboardSettings | null;
  updated_by: string;
  updated_date: string;
  vignette?: TLDashboardConfigResponseVignette;
};

export enum TLDashboardType {
  HARMONIZATION = 'HARMONIZATION',
  ANALYTICS = 'ANALYTICS',
}
export enum TLDashboardStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
export type TLDashboardResponseVignette = { [key: string]: unknown } | null;

export type TLDashboardResponse = {
  baseline_score?: number | null;
  config?: TLDashboardConfigResponse | null;
  created_by: string;
  created_date: string;
  dashboard_id: string;
  dashboard_type?: TLDashboardType;
  description?: string | null;
  name: string;
  score?: number | null;
  status: TLDashboardStatus;
  target_score?: number | null;
  updated_by: string;
  updated_date: string;
  vignette?: TLDashboardResponseVignette;
  workstream?: string | null;
};

export type TLDashboardsResponse = {
  dashboards?: TLDashboardResponse[];
};

export type TLDashboardConfigInputGraphConfig = { [key: string]: unknown } | null;

export type TLDashboardConfigInputSettings = { [key: string]: unknown } | null;

export type TLDashboardConfigInputVignette = { [key: string]: unknown } | null;

/**
 * Base config fields used for both create and update operations.
 */
export type TLDashboardConfigInput = {
  graph_config?: TLDashboardConfigInputGraphConfig;
  settings?: TLDashboardConfigInputSettings;
  vignette?: TLDashboardConfigInputVignette;
};

export type TLDashboardCreateRequest = {
  baseline_score?: number | null;
  config?: TLDashboardConfigInput | null;
  credential_ids?: string[] | null;
  dashboard_type?: TLDashboardType;
  data_check_ids?: string[] | null;
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  target_score?: number | null;
  workstream?: string | null;
};

export type TLDashboardUpdateRequest = {
  baseline_score?: number | null;
  dashboard_type?: TLDashboardType | null;
  description?: string | null;
  name?: string | null;
  target_score?: number | null;
  workstream?: string | null;
};

export type TLLiteralValue = {
  /** A literal value to use in the calculation (string or number). */
  literal: string | number;
};

export enum TLAnalyticsCalculationOperator {
  '+' = '+',
  '-' = '-',
  '*' = '*',
  '/' = '/',
  '%' = '%',
  concat = 'concat',
  abs = 'abs',
}
export type TLAnalyticsCalculation = {
  /**
   * Column names, calculation keys, literal numbers, or {'literal': 'string'} for string literals.
   * @minItems 1
   */
  fields: (string | number | TLLiteralValue)[];
  /**
   * Unique identifier for this calculation, used to reference it in select/order_by/etc.
   * @pattern ^[a-zA-Z_][a-zA-Z0-9_]*$
   */
  key: string;
  /** How to handle division/modulo by zero. 'null': return NULL, 'remove': filter out row, or a numeric default value. */
  on_zero?: string | number;
  /** The operation to perform. Binary: -, /, %. N-ary: +, *, concat. Unary: abs. */
  operator: TLAnalyticsCalculationOperator;
};

export enum TLAnalyticsFilterOperator {
  eq = 'eq',
  ne = 'ne',
  lt = 'lt',
  lte = 'lte',
  gt = 'gt',
  gte = 'gte',
  in = 'in',
  not_in = 'not_in',
  like = 'like',
  is_null = 'is_null',
  is_not_null = 'is_not_null',
  contains_any = 'contains_any',
  contains_all = 'contains_all',
  not_contains_any = 'not_contains_any',
  not_contains_all = 'not_contains_all',
}
export type TLAnalyticsFilter = {
  key: string;
  operator?: TLAnalyticsFilterOperator;
  value: unknown;
};

export enum TLPivotAggregate {
  sum = 'sum',
  count = 'count',
  avg = 'avg',
  min = 'min',
  max = 'max',
  first = 'first',
}
export type TLAnalyticsPivotConfig = {
  /** Aggregation function applied to value_column per pivot cell */
  aggregate?: TLPivotAggregate;
  /** When true, appends a 'Total' column summing all pivoted value columns per row */
  include_totals?: boolean;
  /** Column whose distinct values become new column headers */
  pivot_column: string;
  /** Column containing values to aggregate in pivot cells */
  value_column: string;
};

export type TLAnalyticsSelectField = {
  aggregate?: string | null;
  alias?: string | null;
  field: string;
  /** Value to replace nulls with (uses COALESCE) */
  null_values?: string | number | null;
};

export type TLAnalyticsQueryRequest = {
  /** Calculated columns that can be referenced in select, order_by, group_by, and filters. */
  calculations?: TLAnalyticsCalculation[] | null;
  distinct?: boolean;
  filters?: TLAnalyticsFilter[] | null;
  group_by?: string[] | null;
  latest_per_data_check?: boolean;
  /**
   * @minimum 1
   * @maximum 10000
   */
  limit?: number;
  order_by?: string[] | null;
  /** Time grain to partition by when using latest_per_data_check (e.g., 'started_date:day') */
  partition_by_time_grain?: string | null;
  /** Optional pivot configuration to reshape query results into a pivot table */
  pivot?: TLAnalyticsPivotConfig | null;
  /** @minItems 1 */
  select: (string | TLAnalyticsSelectField)[];
  /** Data source ID to use for the query */
  source_id?: string | null;
};

export type TLAnalyticsQueryResponseDataItem = { [key: string]: unknown };

export type TLAnalyticsQueryResponse = {
  columns: string[];
  data: TLAnalyticsQueryResponseDataItem[];
  total_rows: number;
};

export type TLAnalyticsBatchQueryRequestItem = {
  /** Caller-provided ID to correlate request with response */
  id: string;
  query: TLAnalyticsQueryRequest;
};

export type TLAnalyticsBatchQueryRequest = {
  /**
   * @minItems 1
   * @maxItems 50
   */
  queries: TLAnalyticsBatchQueryRequestItem[];
};

export type TLAnalyticsBatchQueryResultItem = {
  error?: string | null;
  result?: TLAnalyticsQueryResponse | null;
};

export type TLAnalyticsBatchQueryResponseResults = { [key: string]: TLAnalyticsBatchQueryResultItem };

export type TLAnalyticsBatchQueryResponse = {
  results: TLAnalyticsBatchQueryResponseResults;
};

export type TLDashboardConfigUpdateRequestGraphConfig = { [key: string]: unknown } | null;

export type TLDashboardConfigUpdateRequestSettings = { [key: string]: unknown } | null;

export type TLDashboardConfigUpdateRequestVignette = { [key: string]: unknown } | null;

/**
 * Request model for updating dashboard config.
 */
export type TLDashboardConfigUpdateRequest = {
  graph_config?: TLDashboardConfigUpdateRequestGraphConfig;
  settings?: TLDashboardConfigUpdateRequestSettings;
  vignette?: TLDashboardConfigUpdateRequestVignette;
};

export type TLRemoveCredentialsRequest = {
  mapping_ids: string[];
};

export type TLDashboardCredentialMappingResponse = {
  created_by: string;
  created_date: string;
  credential_id: string;
  dashboard_id: string;
  id: string;
};

export type TLDashboardCredentialMappingsResponse = {
  mappings: TLDashboardCredentialMappingResponse[];
};

export type TLAddCredentialsRequest = {
  credential_ids: string[];
};

/**
 * Custom parameters for running this data check
 */
export type TLDashboardDataCheckParameters = { [key: string]: unknown } | null;

export type TLDashboardDataCheck = {
  /** Comments for this data check */
  comments?: string | null;
  /** User who created the mapping */
  created_by: string;
  /** When the mapping was created */
  created_date: string;
  /** Unique identifier for the dashboard-data check mapping */
  dashboard_data_check_id: string;
  /** ID of the dashboard */
  dashboard_id: string;
  /** ID of the data check */
  data_check_id: string;
  /** Custom nickname for this data check in the dashboard context */
  nickname?: string | null;
  /** Custom parameters for running this data check */
  parameters?: TLDashboardDataCheckParameters;
  /** Priority level for this data check in the dashboard */
  priority?: TLDataHarmonizationV2Priority | null;
  /** Status of the mapping */
  status?: TLDashboardDataCheckStatus;
  /** User who last updated the mapping */
  updated_by: string;
  /** When the mapping was last updated */
  updated_date: string;
};

export type TLGetDashboardDataChecksResponse = {
  /** List of dashboard data checks */
  dashboard_data_checks: TLDashboardDataCheck[];
};

export type TLCategory = {
  category_id: string;
  created_by: string;
  created_date: string;
  name: string;
  updated_by: string;
  updated_date: string;
};

export enum TLDataCheckType {
  RFC = 'RFC',
  ABAP_PROGRAM = 'ABAP_PROGRAM',
  EXISTING_SAP_PROGRAM = 'EXISTING_SAP_PROGRAM',
  CUSTOM_RFC = 'CUSTOM_RFC',
  FILE_UPLOAD = 'FILE_UPLOAD',
  ODATA = 'ODATA',
  FOUNDRY = 'FOUNDRY',
  WORKFLOW = 'WORKFLOW',
}
/**
 * How a data check's total-scan / issue count is computed.
 */
export enum TLCountSourceType {
  LITERAL = 'LITERAL',
  QUERY = 'QUERY',
}
/**
 * A configurable source for a data check count (total scanned or issue count).
 *
 * A count is either a hardcoded ``LITERAL`` number or a ``QUERY`` — a Foundry SQL
 * statement that must return a single numeric value. When a data check has no count
 * source configured the execution falls back to the result-dataset row count.
 */
export type TLCountSource = {
  /** Hardcoded count (required when type=LITERAL) */
  literal_value?: number | null;
  /** Foundry SQL returning a single number (required when type=QUERY) */
  query?: string | null;
  /** Whether the count comes from a literal value or a SQL query */
  type: TLCountSourceType;
};

/**
 * Binds a FOUNDRY data check to a live connection mounted as a Foundry catalog.
 *
 * All ``LiveConnectionAdapter`` members are accepted. ERPL is the only adapter with a
 * replicated form to fall back to, so it is also the only one that can be disabled
 * (``enabled=False``); every other adapter is live-only and must stay enabled.
 *
 * Persisted inside ``DataCheckMetadata`` as JSONB, so the UUID fields are serialized
 * to ``str`` — the async engine has no UUID-aware ``json_serializer``, and raw UUIDs
 * would make ``json.dumps`` raise ``TypeError`` at insert time.
 */
export type TLLiveConnectionBindingOutput = {
  adapter?: TLLiveConnectionAdapter;
  catalog_name?: string;
  connection_id: string;
  credential_id: string;
  /** Whether the live mount is engaged. When False, the check executes without the live mount, so (for ERPL) the replicated catalog of the same name resolves instead. */
  enabled?: boolean;
};

/**
 * Supported file types
 */
export enum TLFileType {
  abap = 'abap',
  py = 'py',
  md = 'md',
  csv = 'csv',
  parquet = 'parquet',
  db = 'db',
  duckdb = 'duckdb',
  txt = 'txt',
  xls = 'xls',
  xlsx = 'xlsx',
  xlsm = 'xlsm',
  pdf = 'pdf',
  rtf = 'rtf',
  doc = 'doc',
  docx = 'docx',
  ppt = 'ppt',
  pptx = 'pptx',
  odt = 'odt',
  odp = 'odp',
  yaml = 'yaml',
  yml = 'yml',
  json = 'json',
  jsonl = 'jsonl',
  tsv = 'tsv',
  html = 'html',
  xml = 'xml',
  zip = 'zip',
  calculationview = 'calculationview',
  attributeview = 'attributeview',
  analyticview = 'analyticview',
  procedure = 'procedure',
  jpg = 'jpg',
  jpeg = 'jpeg',
  png = 'png',
  gif = 'gif',
  bmp = 'bmp',
  tif = 'tif',
  tiff = 'tiff',
  svg = 'svg',
  ico = 'ico',
  webp = 'webp',
  heic = 'heic',
  avif = 'avif',
}
/**
 * Workflow input values supplied by this check, keyed by input_schema param name
 */
export type TLWorkflowCheckBindingOutputInputValues = { [key: string]: unknown };

/**
 * Binds a WORKFLOW data check to a workflows_v2 loom workflow version.
 *
 * Each metric is bound to a distinct output path (``<node_name>.output_files.program_id``)
 * in that version's ``output_schema``. Persisted inside ``DataCheckMetadata`` as JSONB, so
 * ``workflow_id`` is serialized to ``str`` — the async engine has no UUID-aware
 * ``json_serializer``, and a raw UUID would make ``json.dumps`` raise ``TypeError`` at
 * insert time (mirrors ``LiveConnectionBinding``).
 *
 * ``workflow_version=None`` means the check follows the workflow's current version at
 * run time (edits to the workflow are picked up automatically); a set value pins the
 * check to that specific historical version.
 */
export type TLWorkflowCheckBindingOutput = {
  /** Email of the authoring user the workflow run executes as */
  created_by: string;
  /** Output path to the check's primary tabular result program */
  data_source: string;
  /** Output path to a JSON program holding field metadata */
  field_metadata?: string | null;
  /** Workflow input values supplied by this check, keyed by input_schema param name */
  input_values?: TLWorkflowCheckBindingOutputInputValues;
  /** Output path to a 1x1 scalar program holding the issue count */
  issue_count?: string | null;
  /** Output path to a 1x1 scalar program holding the total-scanned count */
  total_scanned?: string | null;
  workflow_id: string;
  /** Pinned workflow version; None follows the workflow's current version at run time */
  workflow_version?: number | null;
};

export type TLDataCheckMetadataOutput = {
  /** Business impact of issues found by this check */
  business_impact?: string | null;
  /** Field name associated with this data check */
  check_field?: string | null;
  /** Table name associated with this data check */
  check_table?: string | null;
  /** Execution type: RFC, ABAP, or EXISTING_SAP_PROGRAM */
  data_check_type?: TLDataCheckType | null;
  /** OData entity set name (required when data_check_type=ODATA) */
  entity_set?: string | null;
  /** Override for the issue count: a literal number or a Foundry SQL query. Applies to FOUNDRY and FILE_UPLOAD checks; falls back to the result row count when unset. */
  issue_count_source?: TLCountSource | null;
  /** Custom description of the issue */
  issue_description?: string | null;
  /** Live connection mounted as a Foundry catalog for this check (data_check_type=FOUNDRY only) */
  live_connection?: TLLiveConnectionBindingOutput | null;
  /** Format of the execution output (csv or json) */
  output_format?: TLFileType;
  /** Custom processing logic done on data for this data check */
  processing_logic?: string | null;
  /** Program ID (str) of the original uploaded file before parquet conversion (for FILE_UPLOAD data checks) */
  raw_uploaded_program_id?: string | null;
  /** Recommendation for addressing issues found by this check */
  recommendation?: string | null;
  /** Name of existing RFC to execute (required when data_check_type=CUSTOM_RFC) */
  rfc_name?: string | null;
  /** Name of existing SAP program to execute (required when data_check_type=EXISTING_SAP_PROGRAM) */
  sap_program_name?: string | null;
  /** SQL select clause for relevant records */
  select_relevant?: string | null;
  /** SQL select clause for result records */
  select_result?: string | null;
  /** OData service name (required when data_check_type=ODATA) */
  service_name?: string | null;
  /** Table alias associated with this data check */
  table_alias?: string | null;
  /** Override for the total-scanned count: a literal number or a Foundry SQL query. Applies to FOUNDRY and FILE_UPLOAD checks; falls back to the result row count when unset. */
  total_scan_source?: TLCountSource | null;
  /** Workflow and output-path binding for this check (data_check_type=WORKFLOW only) */
  workflow_binding?: TLWorkflowCheckBindingOutput | null;
  [key: string]: unknown;
};

export type TLDimension = {
  created_by: string;
  created_date: string;
  dimension_id: string;
  name: string;
  updated_by: string;
  updated_date: string;
};

export enum TLDataCheckStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
export type TLDashboardUsage = {
  dashboard_id: string;
  dashboard_name: string;
};

export type TLDataCheck = {
  /** Organizational grouping (e.g. Completeness, Accuracy) */
  category?: TLCategory | null;
  /** Check configuration: recommendation, business_impact, issue_description, data_check_type */
  check_metadata?: TLDataCheckMetadataOutput;
  created_by: string;
  created_date: string;
  /** Unique identifier for the data check */
  data_check_id: string;
  /** Data quality dimension */
  dimension?: TLDimension | null;
  /** Whether the check is globally available */
  is_global: boolean;
  /** ID of the library this check belongs to */
  library_id: string;
  /** Name of the data check */
  name: string;
  /** Priority level of this data check */
  priority?: TLDataHarmonizationV2Priority | null;
  /** Program ID for the check definition file */
  program_id?: string | null;
  /** Optional rule identifier */
  rule_id?: string | null;
  /** Current status of the data check */
  status: TLDataCheckStatus;
  updated_by: string;
  updated_date: string;
  /** List of dashboards using this data check */
  usages?: TLDashboardUsage[] | null;
};

export type TLDataChecksResponse = {
  /** List of data checks */
  data_checks: TLDataCheck[];
};

export type TLDashboardDataCheckItem = {
  /** ID of the existing data check to add */
  data_check_id: string;
  /** Custom nickname for this data check in the dashboard context */
  nickname?: string | null;
  /** Priority level for this data check in the dashboard */
  priority?: TLDataHarmonizationV2Priority | null;
};

export type TLDashboardDataCheckAddRequest = {
  /** List of data checks to add with their configurations */
  data_checks: TLDashboardDataCheckItem[];
};

/**
 * IDs of failed data checks with error messages
 */
export type TLDashboardDataChecksResultFailedIds = { [key: string]: string };

export type TLDashboardDataChecksResult = {
  /** IDs of failed data checks with error messages */
  failed_ids: TLDashboardDataChecksResultFailedIds;
  /** IDs of successfully added data checks */
  successful_ids: string[];
  /** Total number of data checks attempted */
  total: number;
};

export type TLDataSourceQueryRequest = {
  /** Destination catalog (defaults to the tenant query catalog) */
  catalog?: string | null;
  /** Destination schema (defaults to the shared queries schema) */
  schema_name?: string | null;
  /**
   * SQL whose result is materialized as the source's lake table
   * @minLength 1
   */
  sql: string;
  /** Destination table (defaults to a generated name) */
  table_name?: string | null;
};

export type TLDataSourceQueryResponse = {
  /** Foundry query job id to poll for completion */
  job_id: string;
  /** Lake table FQDN the query will materialize into */
  table_fqdn: string;
};

export type TLImportDashboardDataSourceFileHarmonizationRequest = {
  /** Destination catalog (defaults to the tenant upload catalog) */
  catalog?: string | null;
  file: Blob;
  /** Destination schema (defaults to the shared uploads schema) */
  schema_name?: string | null;
  /** Destination table (defaults to a name derived from the file) */
  table_name?: string | null;
};

export type TLDataSourceImportFileResponse = {
  /** Foundry import job id to poll for completion */
  job_id: string;
  /** Uploaded filename, echo into source provenance */
  original_filename?: string | null;
  /** Worksheets in an uploaded workbook that this import leaves behind. A dashboard upload takes the first sheet only; the rest need Data Foundry import */
  skipped_sheets?: string[];
  /** Lake table FQDN the import will create */
  table_fqdn: string;
};

export enum TLErrorTrackingStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
/**
 * Column metadata for the result parquet file
 */
export type TLErrorTrackingFieldMetadata = { [key: string]: unknown }[] | null;

export type TLErrorTracking = {
  /** ID of the batch execution that produced this error tracking */
  batch_execution_id?: string | null;
  created_by: string;
  created_date: string;
  /** ID of the dashboard this error tracking belongs to */
  dashboard_id: string;
  /** Unique identifier for this error tracking entry */
  error_tracking_id: string;
  /** Column metadata for the result parquet file */
  field_metadata?: TLErrorTrackingFieldMetadata;
  /** UUID pointing to parquet file with aggregated issue records across ALL checks */
  program_id?: string | null;
  /** Fully qualified lakehouse table name for aggregated issues */
  result_table_fqdn?: string | null;
  /** Current status of the error tracking entry */
  status: TLErrorTrackingStatus;
  updated_by: string;
  updated_date: string;
  /** UUID pointing to Excel export of aggregated issues */
  xlsx_program_id?: string | null;
};

export type TLGetAllErrorTrackingResponse = {
  error_tracking_results: TLErrorTracking[];
};

export type TLExecuteDashboardResponse = {
  batch_execution: TLBatchExecution;
};

export type TLDashboardScheduleResponse = {
  created_by?: string | null;
  created_date?: string | null;
  dashboard_id: string;
  end_date?: string | null;
  expression: string;
  is_active: boolean;
  last_run_at?: string | null;
  next_run_at?: string | null;
  schedule_id: string;
  schedule_type: TLScheduleType;
  start_date?: string | null;
  timezone: string;
  updated_by?: string | null;
  updated_date?: string | null;
};

export type TLDashboardSchedulesResponse = {
  schedules: TLDashboardScheduleResponse[];
};

export type TLDashboardScheduleCreateRequest = {
  /** Schedule won't execute after this UTC datetime. */
  end_date?: string | null;
  /** For CRON: 5-field cron expression (e.g., '0 9 * * *'). For ONE_TIME: ISO datetime string in UTC (e.g., '2026-02-01T10:00:00Z'). For RRULE: RFC 5545 recurrence rule (e.g., 'FREQ=WEEKLY;INTERVAL=2;BYDAY=SU') */
  expression: string;
  /** Schedule type: CRON for recurring, ONE_TIME for single execution, RRULE for RFC 5545 recurrence rules */
  schedule_type: TLScheduleType;
  /** Schedule won't execute before this UTC datetime. */
  start_date?: string | null;
  /** IANA timezone for cron interpretation (e.g., 'America/New_York'). Determines when cron expressions fire. Does not affect start_date/end_date. */
  timezone?: string;
};

export type TLDashboardScheduleUpdateRequest = {
  /** Schedule won't execute after this UTC datetime. */
  end_date?: string | null;
  /** For CRON: 5-field cron expression. For ONE_TIME: ISO datetime string in UTC. For RRULE: RFC 5545 recurrence rule (e.g., 'FREQ=WEEKLY;INTERVAL=2;BYDAY=SU'). */
  expression?: string | null;
  /** Set to false to pause the schedule, true to resume. */
  is_active?: boolean | null;
  /** Schedule won't execute before this UTC datetime. */
  start_date?: string | null;
  /** IANA timezone for cron interpretation. Does not affect start_date/end_date. */
  timezone?: string | null;
};

export type TLDataCheckBulkUpdateRequest = {
  /** Category ID for the check */
  category_id?: string | null;
  /** Field name associated with this data check */
  check_field?: string | null;
  /** Table name associated with this data check */
  check_table?: string | null;
  /** List of data check IDs to update */
  data_check_ids: string[];
  /** Dimension ID for the check */
  dimension_id?: string | null;
  /** Whether this check is global */
  is_global?: boolean | null;
  /** Priority level */
  priority?: TLDataHarmonizationV2Priority | null;
};

export type TLBulkUpdateResponse = {
  /** List of data check IDs that failed to update */
  failed_ids: string[];
  /** Total number of data checks requested to update */
  total: number;
  /** List of successfully updated data check IDs */
  updated_ids: string[];
};

/**
 * Binds a FOUNDRY data check to a live connection mounted as a Foundry catalog.
 *
 * All ``LiveConnectionAdapter`` members are accepted. ERPL is the only adapter with a
 * replicated form to fall back to, so it is also the only one that can be disabled
 * (``enabled=False``); every other adapter is live-only and must stay enabled.
 *
 * Persisted inside ``DataCheckMetadata`` as JSONB, so the UUID fields are serialized
 * to ``str`` — the async engine has no UUID-aware ``json_serializer``, and raw UUIDs
 * would make ``json.dumps`` raise ``TypeError`` at insert time.
 */
export type TLLiveConnectionBindingInput = {
  adapter?: TLLiveConnectionAdapter;
  catalog_name?: string;
  connection_id: string;
  credential_id: string;
  /** Whether the live mount is engaged. When False, the check executes without the live mount, so (for ERPL) the replicated catalog of the same name resolves instead. */
  enabled?: boolean;
};

export type TLValidateCountQueryRequest = {
  /** Live connection to mount as a Foundry catalog for the probe, mirroring the data check's live_connection binding */
  live_connection?: TLLiveConnectionBindingInput | null;
  /**
   * Foundry SQL query expected to return a single number
   * @minLength 1
   */
  query: string;
};

export type TLValidateCountQueryResponse = {
  /** Why the query is not a valid single-number source, when invalid */
  error?: string | null;
  /** Whether the query resolves to a single non-negative whole number */
  valid: boolean;
  /** The numeric value the query returned, when valid */
  value?: number | null;
};

/**
 * Workflow input values supplied by this check, keyed by input_schema param name
 */
export type TLWorkflowCheckBindingInputInputValues = { [key: string]: unknown };

/**
 * Binds a WORKFLOW data check to a workflows_v2 loom workflow version.
 *
 * Each metric is bound to a distinct output path (``<node_name>.output_files.program_id``)
 * in that version's ``output_schema``. Persisted inside ``DataCheckMetadata`` as JSONB, so
 * ``workflow_id`` is serialized to ``str`` — the async engine has no UUID-aware
 * ``json_serializer``, and a raw UUID would make ``json.dumps`` raise ``TypeError`` at
 * insert time (mirrors ``LiveConnectionBinding``).
 *
 * ``workflow_version=None`` means the check follows the workflow's current version at
 * run time (edits to the workflow are picked up automatically); a set value pins the
 * check to that specific historical version.
 */
export type TLWorkflowCheckBindingInput = {
  /** Email of the authoring user the workflow run executes as */
  created_by: string;
  /** Output path to the check's primary tabular result program */
  data_source: string;
  /** Output path to a JSON program holding field metadata */
  field_metadata?: string | null;
  /** Workflow input values supplied by this check, keyed by input_schema param name */
  input_values?: TLWorkflowCheckBindingInputInputValues;
  /** Output path to a 1x1 scalar program holding the issue count */
  issue_count?: string | null;
  /** Output path to a 1x1 scalar program holding the total-scanned count */
  total_scanned?: string | null;
  workflow_id: string;
  /** Pinned workflow version; None follows the workflow's current version at run time */
  workflow_version?: number | null;
};

export type TLDataCheckMetadataInput = {
  /** Business impact of issues found by this check */
  business_impact?: string | null;
  /** Field name associated with this data check */
  check_field?: string | null;
  /** Table name associated with this data check */
  check_table?: string | null;
  /** Execution type: RFC, ABAP, or EXISTING_SAP_PROGRAM */
  data_check_type?: TLDataCheckType | null;
  /** OData entity set name (required when data_check_type=ODATA) */
  entity_set?: string | null;
  /** Override for the issue count: a literal number or a Foundry SQL query. Applies to FOUNDRY and FILE_UPLOAD checks; falls back to the result row count when unset. */
  issue_count_source?: TLCountSource | null;
  /** Custom description of the issue */
  issue_description?: string | null;
  /** Live connection mounted as a Foundry catalog for this check (data_check_type=FOUNDRY only) */
  live_connection?: TLLiveConnectionBindingInput | null;
  /** Format of the execution output (csv or json) */
  output_format?: TLFileType;
  /** Custom processing logic done on data for this data check */
  processing_logic?: string | null;
  /** Program ID (str) of the original uploaded file before parquet conversion (for FILE_UPLOAD data checks) */
  raw_uploaded_program_id?: string | null;
  /** Recommendation for addressing issues found by this check */
  recommendation?: string | null;
  /** Name of existing RFC to execute (required when data_check_type=CUSTOM_RFC) */
  rfc_name?: string | null;
  /** Name of existing SAP program to execute (required when data_check_type=EXISTING_SAP_PROGRAM) */
  sap_program_name?: string | null;
  /** SQL select clause for relevant records */
  select_relevant?: string | null;
  /** SQL select clause for result records */
  select_result?: string | null;
  /** OData service name (required when data_check_type=ODATA) */
  service_name?: string | null;
  /** Table alias associated with this data check */
  table_alias?: string | null;
  /** Override for the total-scanned count: a literal number or a Foundry SQL query. Applies to FOUNDRY and FILE_UPLOAD checks; falls back to the result row count when unset. */
  total_scan_source?: TLCountSource | null;
  /** Workflow and output-path binding for this check (data_check_type=WORKFLOW only) */
  workflow_binding?: TLWorkflowCheckBindingInput | null;
  [key: string]: unknown;
};

export type TLDataCheckUpdateRequest = {
  /** Category ID for the check */
  category_id?: string | null;
  /** Dimension ID for the check */
  dimension_id?: string | null;
  /** Whether this check is global */
  is_global?: boolean | null;
  /** Metadata for the data check */
  metadata?: TLDataCheckMetadataInput | null;
  /** Name of the data check */
  name?: string | null;
  /** Priority level */
  priority?: TLDataHarmonizationV2Priority | null;
  /** Program ID associated with this check */
  program_id?: string | null;
  /** Rule ID for the check */
  rule_id?: string | null;
};

export type TLDataCheckCodeUpdateRequest = {
  code: string;
};

export enum TLLookupFilterOperator {
  eq = 'eq',
  lte = 'lte',
  gte = 'gte',
  lt = 'lt',
  gt = 'gt',
}
export type TLLookupFilter = {
  /** Column name to filter on */
  column_name: string;
  /** Filter operator */
  operator: TLLookupFilterOperator;
  /** Filter value (can use $dashboard_id for substitution) */
  value: string;
};

export type TLLookupOrderByOutput = {
  /** Column name to order by */
  column_name: string;
  /** Sort direction: ASC or DESC */
  direction?: TLSortDirectionOutput;
};

export enum TLLookupTable {
  dh_error_tracking = 'dh_error_tracking',
  dh_data_check_executions = 'dh_data_check_executions',
}
export type TLDataSourceMetadataOutput = {
  /** Execution the output resolved to when attached (provenance only; resolution is live-latest) */
  attached_execution_id?: string | null;
  /** Dot-notation path to field on dashboard object */
  dashboard_field_path?: string | null;
  /** Foundry import job that produced the table */
  import_job_id?: string | null;
  /** Column containing the program_id */
  lookup_column?: string | null;
  /** Column to filter by date (uses <= filter_date) */
  lookup_date_column?: string | null;
  /** Filters to apply when looking up */
  lookup_filters?: TLLookupFilter[] | null;
  /** Ordering for lookup results */
  lookup_order_by?: TLLookupOrderByOutput | null;
  /** Table to look up program_id from */
  lookup_table?: TLLookupTable | null;
  /** Uploaded file the table was imported from */
  original_filename?: string | null;
  /** Output filename within the node's outputs */
  output_filename?: string | null;
  /** Workflow node that produces the output file */
  output_node_name?: string | null;
  /** Direct program ID reference */
  program_id?: string | null;
  /** Whether the source will resolve to a program_id */
  returns_program_id?: boolean | null;
  /** SQL the table was materialized from, for query-backed sources */
  sql_query?: string | null;
  /** Lakehouse table FQDN holding the direct source content (preferred over program_id) */
  table_fqdn?: string | null;
  /** Custom view ID to resolve latest execution from */
  view_id?: string | null;
  /** Workflow whose latest completed output backs this source */
  workflow_id?: string | null;
};

export enum TLDataSourceStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DELETED = 'DELETED',
}
export enum TLDataSourceType {
  DIRECT = 'DIRECT',
  TABLE_LOOKUP = 'TABLE_LOOKUP',
  DASHBOARD_FIELD = 'DASHBOARD_FIELD',
  EXECUTION_DATA = 'EXECUTION_DATA',
  CUSTOM_VIEW = 'CUSTOM_VIEW',
  FOUNDRY = 'FOUNDRY',
  WORKFLOW = 'WORKFLOW',
}
export type TLDataSource = {
  created_by: string;
  created_date: string;
  /** ID of the dashboard this source feeds into */
  dashboard_id: string;
  /** Display name of the data source */
  name: string;
  /** Unique identifier for this data source */
  source_id: string;
  /** Type-specific configuration for resolving the source data */
  source_metadata?: TLDataSourceMetadataOutput;
  /** Current status of the data source */
  status: TLDataSourceStatus;
  /** Source type determining how the source data resolves */
  type: TLDataSourceType;
  updated_by: string;
  updated_date: string;
};

export type TLDataSourcesResponse = {
  /** List of data sources */
  data_sources: TLDataSource[];
};

export type TLLookupOrderByInput = {
  /** Column name to order by */
  column_name: string;
  /** Sort direction: ASC or DESC */
  direction?: TLDuckdbSortDirection;
};

export type TLDataSourceMetadataInput = {
  /** Execution the output resolved to when attached (provenance only; resolution is live-latest) */
  attached_execution_id?: string | null;
  /** Dot-notation path to field on dashboard object */
  dashboard_field_path?: string | null;
  /** Foundry import job that produced the table */
  import_job_id?: string | null;
  /** Column containing the program_id */
  lookup_column?: string | null;
  /** Column to filter by date (uses <= filter_date) */
  lookup_date_column?: string | null;
  /** Filters to apply when looking up */
  lookup_filters?: TLLookupFilter[] | null;
  /** Ordering for lookup results */
  lookup_order_by?: TLLookupOrderByInput | null;
  /** Table to look up program_id from */
  lookup_table?: TLLookupTable | null;
  /** Uploaded file the table was imported from */
  original_filename?: string | null;
  /** Output filename within the node's outputs */
  output_filename?: string | null;
  /** Workflow node that produces the output file */
  output_node_name?: string | null;
  /** Direct program ID reference */
  program_id?: string | null;
  /** Whether the source will resolve to a program_id */
  returns_program_id?: boolean | null;
  /** SQL the table was materialized from, for query-backed sources */
  sql_query?: string | null;
  /** Lakehouse table FQDN holding the direct source content (preferred over program_id) */
  table_fqdn?: string | null;
  /** Custom view ID to resolve latest execution from */
  view_id?: string | null;
  /** Workflow whose latest completed output backs this source */
  workflow_id?: string | null;
};

export type TLDataSourceCreateRequest = {
  /** Dashboard ID to create the source for */
  dashboard_id: string;
  /**
   * Name of the data source
   * @maxLength 200
   */
  name: string;
  /** Source metadata */
  source_metadata?: TLDataSourceMetadataInput;
  /** Type of the data source */
  type: TLDataSourceType;
};

export type TLDataSourceResponse = {
  /** The data source */
  data_source: TLDataSource;
};

export type TLFoundryTableAttachItem = {
  /** Data source name; defaults to the table name, or '<schema>.<table>' when two selected tables share one */
  name?: string | null;
  /** Lake table to attach, as catalog.schema.table */
  table_fqdn: string;
};

/**
 * Attach several Data Foundry lake tables as FOUNDRY data sources in one request.
 */
export type TLBulkAttachFoundryTablesRequest = {
  /** Dashboard to attach the sources to */
  dashboard_id: string;
  /**
   * Lake tables to attach
   * @minItems 1
   * @maxItems 100
   */
  tables: TLFoundryTableAttachItem[];
};

export type TLFoundryTableAttachResult = {
  /** Why the action failed for this item */
  error?: string | null;
  /** Created data source; unset when the item failed */
  source_id?: string | null;
  /** Whether the action succeeded for this item */
  success: boolean;
  table_fqdn: string;
};

export type TLBulkActionResponseFoundryTableAttachResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLFoundryTableAttachResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export type TLWorkflowOutputAttachItem = {
  /** Data source name; defaults to '<output_node_name>/<output_filename>' */
  name?: string | null;
  /**
   * Output filename within the node's outputs
   * @minLength 1
   */
  output_filename: string;
  /**
   * Workflow node that produces the output file
   * @minLength 1
   */
  output_node_name: string;
};

/**
 * Attach output files of one workflow's latest completed run as WORKFLOW data sources.
 */
export type TLBulkAttachWorkflowOutputsRequest = {
  /** Dashboard to attach the sources to */
  dashboard_id: string;
  /**
   * Output files to attach
   * @minItems 1
   * @maxItems 100
   */
  outputs: TLWorkflowOutputAttachItem[];
  /** Workflow whose latest completed run backs every source */
  workflow_id: string;
};

export type TLWorkflowOutputAttachResult = {
  /** Why the action failed for this item */
  error?: string | null;
  output_filename: string;
  output_node_name: string;
  /** Created data source; unset when the item failed */
  source_id?: string | null;
  /** Whether the action succeeded for this item */
  success: boolean;
};

export type TLBulkActionResponseWorkflowOutputAttachResult = {
  /** Number of items the action failed for */
  failed: number;
  /** Per-item outcomes, in the order they were processed */
  results: TLWorkflowOutputAttachResult[];
  /** Number of items the action succeeded for */
  succeeded: number;
  /** Number of distinct items acted on */
  total: number;
};

export type TLDataSourceUpdateRequest = {
  /** Name of the data source */
  name?: string | null;
  /** Source metadata */
  source_metadata?: TLDataSourceMetadataInput | null;
};

export type TLUpdateDirectSourceContentDataHarmonizationRequest = {
  /** New content file for the direct data source */
  file: Blob;
};

export type TLDataSourceContentUpdateResponse = {
  /** ID of the program that was updated */
  program_id: string;
  /** ID of the updated data source */
  source_id: string;
  /** User who performed the update */
  updated_by?: string | null;
  /** New version of the program after update */
  version?: string | null;
};

export type TLCopyDataSourceRequest = {
  /** @minItems 1 */
  dashboard_ids: string[];
};

export type TLCopyDataSourceError = {
  dashboard_id: string;
  error: string;
};

export type TLCopyDataSourceResponse = {
  error_results: TLCopyDataSourceError[];
  failed: number;
  succeeded: number;
  total: number;
};

export type TLDataSourcePreviewResponseDataItem = { [key: string]: unknown };

export enum TLResolutionType {
  program_id = 'program_id',
  scalar = 'scalar',
  execution_data = 'execution_data',
  table_fqdn = 'table_fqdn',
  none = 'none',
}
export type TLDataSourcePreviewResponse = {
  columns: string[];
  data: TLDataSourcePreviewResponseDataItem[];
  resolution_type: TLResolutionType;
  source_id: string;
  source_name: string;
  total_rows: number;
};

/**
 * Normalized column-type vocabulary the graph-builder UI switches on.
 *
 * USER marks columns whose value is an email that the UI may display as a
 * full name (e.g. execution-data ``created_by``).
 */
export enum TLDHColumnType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  TIME = 'TIME',
  DATETIME = 'DATETIME',
  USER = 'USER',
}
export type TLDataSourceSchemaColumn = {
  /** Whether sum/avg/min/max are valid; count is valid on every column regardless */
  aggregatable: boolean;
  /** User-friendly description (curated fields only) */
  description?: string | null;
  /** Whether GROUP BY on this column is valid */
  groupable: boolean;
  /** True when the value is a list */
  is_array?: boolean;
  /** User-friendly display name */
  label: string;
  /** Column name, as usable in analytics queries */
  name: string;
  /** Engine-reported type (DuckDB / Arrow / Postgres); None when there is no engine type */
  native_type?: string | null;
  /** Whether the column can be null; None when the engine does not report it */
  nullable?: boolean | null;
  /** Normalized column type for the graph-builder UI */
  type: TLDHColumnType;
};

export type TLDataSourceSchemaResponse = {
  /** Typed columns available for this source */
  columns: TLDataSourceSchemaColumn[];
  /** How the source resolves */
  resolution_type: TLResolutionType;
  /** The data source ID */
  source_id: string;
};

export type TLDimensionResponse = {
  created_by: string;
  created_date: string;
  dimension_id: string;
  name: string;
  updated_by: string;
  updated_date: string;
};

export type TLDimensionCreateRequest = {
  name: string;
};

export type TLDimensionUpdateRequest = {
  name?: string | null;
};

export type TLDeleteErrorTrackingsRequest = {
  error_tracking_ids: string[];
};

export type TLGetErrorTrackingRequest = {
  /** Optional filters to apply to the data */
  filters?: TLFilter[];
  /**
   * Page number, must be at least 1
   * @minimum 1
   */
  page?: number;
  /**
   * Number of rows per page, must be between 1 and 1000
   * @minimum 1
   * @maximum 1000
   */
  page_size?: number;
  /** Optional sort order to apply to the data */
  sort?: TLSortInput[];
};

export type TLGetErrorTrackingResponseFieldMetadataItem = { [key: string]: unknown };

export type TLGetErrorTrackingResponse = {
  count: number;
  field_metadata: TLGetErrorTrackingResponseFieldMetadataItem[];
  filters: TLFilter[];
  last_refreshed: string;
  page: number;
  page_size: number;
  sort: TLSortOutput[];
  total_pages: number;
  tsv_data: string;
};

export type TLExportErrorTrackingRequest = {
  /** Optional filters to apply to the data */
  filters?: TLFilter[];
  /** Optional sort order to apply to the data */
  sort?: TLSortInput[];
};

export type TLExportErrorTrackingResponse = {
  file: TLFile;
};

export type TLGenerateFiltersForErrorTrackingRequest = {
  /** Natural language prompt describing desired filters */
  prompt: string;
};

export type TLRefreshErrorTrackingResponse = {
  error_tracking: TLErrorTracking;
};

export type TLListExecutionsResponse = {
  executions: TLDataCheckExecution[];
  limit: number;
  offset: number;
  total_count: number;
};

export type TLCancelExecutionRequest = {
  /**
   * @minItems 1
   * @maxItems 50
   */
  execution_ids: string[];
};

export type TLCancelExecutionResponse = {
  executions: TLDataCheckExecution[];
};

export type TLDeleteExecutionRequest = {
  /**
   * List of execution IDs to delete
   * @minItems 1
   */
  execution_ids: string[];
};

export type TLDeleteExecutionResponse = {
  /** Number of executions successfully deleted */
  deleted_count: number;
};

export type TLBulkExportExecutionResultRequest = {
  /**
   * Dashboard data checks whose latest execution results should be bundled into one zip.
   * @minItems 1
   * @maxItems 50
   */
  dashboard_data_check_ids: string[];
};

export type TLBulkExportExecutionResultResponse = {
  file: TLFile;
  /** Data checks skipped because they had no exportable latest execution result. */
  skipped_dashboard_data_check_ids?: string[];
};

export type TLGetExecutionResultRequest = {
  /** Optional filters to apply to the data */
  filters?: TLFilter[];
  /**
   * Page number, must be at least 1
   * @minimum 1
   */
  page?: number;
  /**
   * Number of rows per page, must be between 1 and 1000
   * @minimum 1
   * @maximum 1000
   */
  page_size?: number;
  /** Optional sort order to apply to the data */
  sort?: TLSortInput[];
};

export type TLGetExecutionResultResponse = {
  count: number;
  filters: TLFilter[];
  page: number;
  page_size: number;
  sort: TLSortOutput[];
  total_pages: number;
  tsv_data: string;
};

export type TLExportExecutionResultRequest = {
  /** Optional filters to apply to the data */
  filters?: TLFilter[];
  /** Optional sort order to apply to the data */
  sort?: TLSortInput[];
};

export type TLExportExecutionResultResponse = {
  /** Presigned export file; None when the export runs async */
  file?: TLFile | null;
  /** True when the export is large and the user will be notified once it's ready */
  notify_on_completion?: boolean;
};

export type TLGenerateFiltersForExecutionRequest = {
  /** Natural language prompt describing desired filters */
  prompt: string;
};

export enum TLLibraryStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
export enum TLLibraryType {
  DEFAULT = 'DEFAULT',
  CUSTOM = 'CUSTOM',
}
export type TLLibraryResponse = {
  created_by: string;
  created_date: string;
  data_check_count?: number;
  description: string | null;
  library_id: string;
  name: string;
  status: TLLibraryStatus;
  type: TLLibraryType;
  updated_by: string;
  updated_date: string;
};

export type TLLibrariesResponse = {
  /** List of libraries */
  libraries: TLLibraryResponse[];
};

export type TLLibraryCreateRequest = {
  description?: string | null;
  name: string;
  /** Optional list of program IDs to associate with this library */
  program_ids?: string[] | null;
  /** Library type (DEFAULT or CUSTOM) */
  type?: TLLibraryType;
};

export type TLLibraryUpdateRequest = {
  description?: string | null;
  name?: string | null;
};

export type TLDataChecksRemoveRequest = {
  /**
   * List of data check IDs to remove from library
   * @minItems 1
   */
  data_check_ids: string[];
};

export type TLDataChecksRemoveResult = {
  failed_ids: string[];
  successful_ids: string[];
  total: number;
};

export type TLDataCheckCreateRequest = {
  /** Category ID for the check */
  category_id?: string | null;
  /** Dimension ID for the check */
  dimension_id?: string | null;
  /** Whether this check is global */
  is_global?: boolean | null;
  /** Metadata for the data check */
  metadata?: TLDataCheckMetadataInput | null;
  /**
   * Name of the data check
   * @maxLength 200
   */
  name: string;
  /** Priority level */
  priority?: TLDataHarmonizationV2Priority | null;
  /** Program ID associated with this check (optional for ODATA and WORKFLOW types) */
  program_id?: string | null;
  /** Rule ID for the check */
  rule_id?: string | null;
};

export type TLDataCheckError = {
  /** Error message describing why the creation failed */
  error: string;
  /** Name of the data check that failed */
  name: string;
  /** Program ID if available */
  program_id?: string | null;
};

export type TLDataChecksCreateResult = {
  /** Data checks that failed to create */
  failed: TLDataCheckError[];
  /** Successfully created data checks */
  successful: TLDataCheck[];
  /** Total number of data checks attempted */
  total_attempted: number;
  /** Number of failed data checks */
  total_failed: number;
  /** Number of successfully created data checks */
  total_successful: number;
};

export type TLSavedFilterResponseConfig = { [key: string]: unknown };

export enum TLSavedFilterStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}
export enum TLSavedFilterTargetType {
  DASHBOARD = 'DASHBOARD',
  TABLE = 'TABLE',
}
export type TLSavedFilterResponse = {
  config: TLSavedFilterResponseConfig;
  created_by: string;
  created_date: string;
  description?: string | null;
  filter_id: string;
  filter_name: string;
  is_public: boolean;
  status: TLSavedFilterStatus;
  target_id: string;
  target_type: TLSavedFilterTargetType;
  updated_by: string;
  updated_date: string;
};

/**
 * Filter and sort configuration
 */
export type TLSavedFilterCreateRequestConfig = { [key: string]: unknown };

export type TLSavedFilterCreateRequest = {
  /** Filter and sort configuration */
  config: TLSavedFilterCreateRequestConfig;
  description?: string | null;
  /**
   * @minLength 1
   * @maxLength 200
   */
  filter_name: string;
  is_public?: boolean;
  /**
   * @minLength 1
   * @maxLength 255
   */
  target_id: string;
  target_type: TLSavedFilterTargetType;
};

export type TLSavedFilterUpdateRequestConfig = { [key: string]: unknown } | null;

export type TLSavedFilterUpdateRequest = {
  config?: TLSavedFilterUpdateRequestConfig;
  description?: string | null;
  filter_name?: string | null;
  is_public?: boolean | null;
};

export type TLVersionResponse = {
  /** Backend application version */
  version: string;
};

export enum TLOperationCategory {
  schema = 'schema',
  graph_struct = 'graph_struct',
  field = 'field',
  validation = 'validation',
  lifecycle = 'lifecycle',
}
export enum TLOperationFamily {
  structural_cleanup = 'structural_cleanup',
  schema_remap = 'schema_remap',
  meta_validation = 'meta_validation',
  table_repoint = 'table_repoint',
  field_level = 'field_level',
  structural_repair = 'structural_repair',
  hdu = 'hdu',
}
export enum TLParamSource {
  SCHEMA_MAPPING = 'SCHEMA_MAPPING',
  HDU_RULES = 'HDU_RULES',
  PRIMARY_KEYS = 'PRIMARY_KEYS',
  FIELD_REMAPPING = 'FIELD_REMAPPING',
  TABLE_REMAPPING = 'TABLE_REMAPPING',
  DDIC_KEYS = 'DDIC_KEYS',
  VIEW_OVERRIDES = 'VIEW_OVERRIDES',
  COMPAT_VIEW_OVERRIDES = 'COMPAT_VIEW_OVERRIDES',
  SAP_FIELD_CATALOG = 'SAP_FIELD_CATALOG',
  FDM_VARIABLES = 'FDM_VARIABLES',
  INLINE_PARAM = 'INLINE_PARAM',
}
export enum TLParamType {
  string = 'string',
  boolean = 'boolean',
  object = 'object',
  list = 'list',
  number = 'number',
}
export type TLParamSpecResponse = {
  default?: unknown;
  description: string;
  required: boolean;
  source?: TLParamSource | null;
  type: TLParamType;
};

export type TLOperationResponseParamsSchema = { [key: string]: TLParamSpecResponse };

export type TLOperationResponse = {
  category: TLOperationCategory;
  consumes?: string[];
  description: string;
  family?: TLOperationFamily | null;
  is_custom: boolean;
  label: string;
  name: string;
  params_schema: TLOperationResponseParamsSchema;
  preconditions?: string[];
  produces?: string[];
  when_to_use?: string | null;
};

export type TLOperationCatalogResponse = {
  /** @minimum 1 */
  limit?: number;
  /** @minimum 0 */
  offset?: number;
  operations?: TLOperationResponse[];
  /** @minimum 0 */
  total?: number;
};

export type TLRunOperationRequestParams = { [key: string]: unknown };

export type TLRunOperationRequest = {
  operation: string;
  params?: TLRunOperationRequestParams;
  target_id?: string | null;
};

export type TLRunOperationResponseChangesItem = { [key: string]: unknown };

export type TLRunOperationResponse = {
  changes: TLRunOperationResponseChangesItem[];
  error?: string | null;
  new_program_version?: string | null;
  skipped: boolean;
  success: boolean;
  warnings: string[];
};

export type TLViewParityCheckRequest = {
  /** HANA connection the source view is executed on (hana_odbc live mount). */
  connection_id: string;
  /** Credential for the source connection. */
  credential_id: string;
  /** Max rows fetched per view. */
  row_limit?: number | null;
  /** Optional separate HANA connection for the target view (cross-system parity). Provided together with target_credential_id or not at all; omitted, the target runs on the source connection. */
  target_connection_id?: string | null;
  /** Credential for the target connection. */
  target_credential_id?: string | null;
  /** Remediated target to compare against the source; must already be written back to SAP. */
  target_id: string;
};

export type TLViewParityCheckResponse = {
  execution_id: string;
  source_view_path: string;
  target_view_path: string;
  workflow_id: string;
};

export type TLRunViewWorkflowRequest = {
  target_id?: string | null;
  workflow_id: string;
};

export type TLDispatchViewWorkflowResponse = {
  execution_id: string;
  workflow_id: string;
};

export enum TLWorkItemType {
  CODE = 'CODE',
  VIEW = 'VIEW',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
  DATA = 'DATA',
  MIGRATION = 'MIGRATION',
}
export enum TLWorkstream {
  Code_Remediation = 'Code Remediation',
  View_Remediation = 'View Remediation',
  Knowledge_Base = 'Knowledge Base',
  Data_Harmonization = 'Data Harmonization',
  Migration = 'Migration',
}
export enum TLWorkItemStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  PENDING_REVIEW = 'PENDING_REVIEW',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
}
export enum TLWorkItemSortField {
  name = 'name',
  status = 'status',
  priority = 'priority',
  created_date = 'created_date',
  updated_date = 'updated_date',
}
export enum TLWorkItemResourceType {
  CR_REMEDY_OBJECT = 'CR_REMEDY_OBJECT',
  VR_HANA_VIEW = 'VR_HANA_VIEW',
  KNOWLEDGE_BASE_PACKAGE = 'KNOWLEDGE_BASE_PACKAGE',
}
export enum TLWorkItemSubType {
  code_remediation = 'code_remediation',
  retrofit = 'retrofit',
}
export type TLWorkItemNavigationMetadata = { [key: string]: unknown } | null;

export type TLWorkItem = {
  assigned_by: string | null;
  assignee_email: string | null;
  created_by: string;
  created_date: string;
  domain: TLWorkItemType;
  id: string;
  name: string;
  navigation_metadata: TLWorkItemNavigationMetadata;
  normalized_status: TLWorkItemStatus;
  original_assignee: string | null;
  parent_name: string | null;
  priority: TLPriority | null;
  resource_id: string | null;
  resource_type: TLWorkItemResourceType | null;
  source_id: string;
  source_status: string;
  sub_type: TLWorkItemSubType | null;
  updated_by: string;
  updated_date: string;
  workstream: TLWorkstream | null;
};

export type TLPaginatedResponseWorkItem = {
  /** List of items */
  data: TLWorkItem[];
  /** Current offset */
  offset: number;
  /** Page size */
  page_size: number;
  /** Total number of items matching the query */
  total_count: number;
  /** Total number of items with no filters applied; set only by endpoints that opt in */
  unfiltered_count?: number | null;
};

export type ListLlmModelCostsParams = {
  /**
   * Filter by provider
   */
  provider?: TLLlmProvider | null;
  /**
   * Filter by model name
   */
  model?: string | null;
  /**
   * Maximum entries to return
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * Zero-based offset for pagination
   * @minimum 0
   */
  offset?: number;
};

export type DeleteLlmModelCostPathParameters = {
  costId: string;
};
export type UpdateLlmModelCostPathParameters = {
  costId: string;
};
export type ListApiKeysParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type RevokeApiKeyPathParameters = {
  keyId: string;
};
export type ListGroupsParams = {
  search?: string | null;
};

export type ListAuthzDirectoryGroupsParams = {
  /**
   * Optional group-name search filter
   */
  search?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetUserGroupsPathParameters = {
  email: string;
};
export type DeleteGroupPathParameters = {
  groupId: string;
};
export type GetGroupPathParameters = {
  groupId: string;
};
export type UpdateGroupPathParameters = {
  groupId: string;
};
export type RemoveGroupMembersPathParameters = {
  groupId: string;
};
export type GetGroupMembersPathParameters = {
  groupId: string;
};
export type AddGroupMembersPathParameters = {
  groupId: string;
};
export type GetGroupRolesPathParameters = {
  groupId: string;
};
export type AssignRolesToGroupPathParameters = {
  groupId: string;
};
export type RemoveRolesFromGroupPathParameters = {
  groupId: string;
};
export type ListAuthzDirectoryRolesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type UpdateRolePathParameters = {
  roleName: string;
};
export type GetRoleCompositesPathParameters = {
  roleName: string;
};
export type ListAuthzDirectoryUsersParams = {
  /**
   * Search by username, first/last name, or email
   */
  search?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetAuthzDirectoryUserPathParameters = {
  email: string;
};
export type UpdateUserEnabledPathParameters = {
  email: string;
};
export type ListRecentWorkflowExecutionsV2Params = {
  /**
   * Max executions to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of executions to skip
   * @minimum 0
   */
  offset?: number;
  /**
   * Filter by execution status
   */
  status?: TLWfExecutionStatus | null;
  /**
   * Filter by trigger type
   */
  trigger_type?: TLWfTriggerType | null;
  /**
   * Filter by workflow
   */
  workflow_id?: string | null;
  /**
   * Search by workflow name (case-insensitive partial match)
   */
  workflow_name?: string | null;
  /**
   * Match workflow name or execution ID (case-insensitive partial match)
   */
  search?: string | null;
  /**
   * Filter by executor email (exact match)
   */
  executed_by?: string | null;
  /**
   * Only executions started at or after this time
   */
  started_after?: string | null;
  /**
   * Only executions started at or before this time
   */
  started_before?: string | null;
};

export type ListTemplatesV2Params = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
};

export type DeleteTemplateV2PathParameters = {
  templateId: string;
};
export type GetTemplateV2PathParameters = {
  templateId: string;
};
export type PatchTemplateV2PathParameters = {
  templateId: string;
};
export type UpdateTemplateV2PathParameters = {
  templateId: string;
};
export type MergeWorkflowIntoTemplateV2PathParameters = {
  templateId: string;
};
export type ListTemplatePermissionsV2PathParameters = {
  templateId: string;
};
export type ListTemplatePermissionsV2Params = {
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GrantTemplatePermissionsV2PathParameters = {
  templateId: string;
};
export type LeaveTemplateV2PathParameters = {
  templateId: string;
};
export type RevokeTemplatePermissionsV2PathParameters = {
  templateId: string;
};
export type ListTemplateVersionsV2PathParameters = {
  templateId: string;
};
export type ListTemplateVersionsV2Params = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
};

export type GetTemplateVersionV2PathParameters = {
  templateId: string;
  version: number;
};
export type UpdateTemplateVisibilityV2PathParameters = {
  templateId: string;
};
export type CreateWorkflowFromTemplateV2PathParameters = {
  templateId: string;
};
export type ListWorkflowsV2Params = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
  /**
   * Case-insensitive partial match on name, description, or tags
   */
  search?: string | null;
  /**
   * Filter by status
   */
  status?: TLWfWorkflowStatus | null;
  /**
   * Owned by me / shared with me
   */
  ownership?: TLWfOwnershipScope;
  /**
   * Match workflows carrying any of these tags
   */
  tags?: string[] | null;
  /**
   * Match workflows owned by any of these emails
   */
  created_by?: string[] | null;
  /**
   * Filter to workflows instantiated from this template
   */
  source_template_id?: string | null;
  /**
   * Field to sort by
   */
  sort_by?: TLWfWorkflowSortField;
  /**
   * Sort direction
   */
  sort_dir?: TLSortDirection;
};

export type GetWorkflowNodesV2Params = {
  /**
   * Filter nodes by category
   */
  category?: TLNodeCategory | null;
};

export type GetWorkflowNodeV2PathParameters = {
  nodeName: string;
};
export type GetWorkflowNodeDocsV2PathParameters = {
  nodeName: string;
};
export type GetWorkflowOperatorsV2Params = {
  /**
   * Filter operators by category
   */
  category?: TLOperatorCategory | null;
};

export type DeleteWorkflowV2PathParameters = {
  workflowId: string;
};
export type GetWorkflowV2PathParameters = {
  workflowId: string;
};
export type PatchWorkflowV2PathParameters = {
  workflowId: string;
};
export type UpdateWorkflowV2PathParameters = {
  workflowId: string;
};
export type ArchiveWorkflowV2PathParameters = {
  workflowId: string;
};
export type GenerateWorkflowChangeSummaryV2PathParameters = {
  workflowId: string;
};
export type ListWorkflowExecutionsV2PathParameters = {
  workflowId: string;
};
export type ListWorkflowExecutionsV2Params = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type CreateWorkflowExecutionV2PathParameters = {
  workflowId: string;
};
export type TestExecuteWorkflowNodeV2PathParameters = {
  workflowId: string;
};
export type GetWorkflowExecutionV2PathParameters = {
  workflowId: string;
  executionId: string;
};
export type CancelWorkflowExecutionV2PathParameters = {
  workflowId: string;
  executionId: string;
};
export type ExportWorkflowExecutionOutputsV2PathParameters = {
  workflowId: string;
  executionId: string;
};
export type ExportWorkflowExecutionOutputsV2Params = {
  /**
   * @minimum 60
   * @maximum 86400
   */
  expiration?: number;
};

export type SubmitWorkflowApprovalDecisionV2PathParameters = {
  workflowId: string;
  executionId: string;
  nodeId: string;
};
export type ExportWorkflowExecutionNodeOutputsV2PathParameters = {
  workflowId: string;
  executionId: string;
  nodeId: string;
};
export type ExportWorkflowExecutionNodeOutputsV2Params = {
  /**
   * @minimum 60
   * @maximum 86400
   */
  expiration?: number;
  /**
   * Restrict the export to one loop pass, as the 0-based iteration_number (iteration 0 is the pass shown as 'pass 1'). Omit to export every pass, each into its own pass-NN/ directory.
   */
  iteration?: number | null;
};

export type DownloadExecutionFileV2PathParameters = {
  workflowId: string;
  executionId: string;
  nodeId: string;
  programId: string;
};
export type DownloadExecutionFileV2Params = {
  /**
   * @minimum 60
   * @maximum 86400
   */
  expiration?: number;
};

export type PreviewExecutionFileV2PathParameters = {
  workflowId: string;
  executionId: string;
  nodeId: string;
  programId: string;
};
export type PreviewExecutionFileV2Params = {
  /**
   * @minimum 1
   * @maximum 10000
   */
  max_lines?: number;
};

export type StreamWorkflowExecutionV2PathParameters = {
  workflowId: string;
  executionId: string;
};
export type ListWorkflowPermissionsV2PathParameters = {
  workflowId: string;
};
export type ListWorkflowPermissionsV2Params = {
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GrantWorkflowPermissionsV2PathParameters = {
  workflowId: string;
};
export type LeaveWorkflowV2PathParameters = {
  workflowId: string;
};
export type RevokeWorkflowPermissionsV2PathParameters = {
  workflowId: string;
};
export type PublishWorkflowV2PathParameters = {
  workflowId: string;
};
export type GetWorkflowSchedulesPathParameters = {
  workflowId: string;
};
export type GetWorkflowSchedulesParams = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
};

export type CreateWorkflowSchedulePathParameters = {
  workflowId: string;
};
export type DeleteWorkflowSchedulePathParameters = {
  workflowId: string;
  scheduleId: string;
};
export type UpdateWorkflowSchedulePathParameters = {
  workflowId: string;
  scheduleId: string;
};
export type UnsubscribeFromWorkflowV2PathParameters = {
  workflowId: string;
};
export type SubscribeToWorkflowV2PathParameters = {
  workflowId: string;
};
export type UnarchiveWorkflowV2PathParameters = {
  workflowId: string;
};
export type ListWorkflowVersionsV2PathParameters = {
  workflowId: string;
};
export type ListWorkflowVersionsV2Params = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
};

export type GetWorkflowVersionV2PathParameters = {
  workflowId: string;
  version: number;
};
export type UpdateWorkflowVisibilityV2PathParameters = {
  workflowId: string;
};
export type GetScanFindingsPathParameters = {
  objectId: string;
  scanId: string;
};
export type UpdateFindingsStatusPathParameters = {
  objectId: string;
  scanId: string;
};
export type UpdateFindingStatusPathParameters = {
  objectId: string;
  scanId: string;
  findingId: string;
};
export type UpdateFindingStatusParams = {
  /**
   * New status for the finding
   */
  status: TLFindingStatus;
};

export type PreviewPackageImportParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetRemediationAnalysisStatusPathParameters = {
  jobId: string;
};
export type DeleteRemedyPathParameters = {
  remedyId: string;
};
export type GetRemedyDetailPathParameters = {
  remedyId: string;
};
export type GetRemedyDetailParams = {
  /**
   * Filter objects to these statuses (e.g. FLAGGED_FOR_FUNCTIONAL); omit for all.
   */
  status?: TLScopeObjectStatus[] | null;
  /**
   * Filter objects by their latest AI-run status (e.g. FAILED to find runs to re-run); omit for all.
   */
  agentic_run_status?: TLAgenticRemediationStatus[] | null;
};

export type AssignObjectsToUsersPathParameters = {
  remedyId: string;
};
export type ActivateObjectsPathParameters = {
  remedyId: string;
};
export type ReconcileProgramFileSubobjectInsertParentTrViaAdtAsyncPathParameters = {
  remedyId: string;
};
export type CheckActiveCodePathParameters = {
  remedyId: string;
};
export type GetRemediationReportDashboardPathParameters = {
  remedyId: string;
};
export type GetRemediationReportDashboardParams = {
  /**
   * Only objects in these packages
   */
  packages?: string[] | null;
  /**
   * ATC priorities as SAP reports them: "1"/"2"/"3"
   */
  priorities?: string[] | null;
};

export type UpdateRemedyPathParameters = {
  remedyId: string;
};
export type RemediateFlePathParameters = {
  remedyId: string;
};
export type GetSourceCodePathParameters = {
  remedyId: string;
};
export type GetSourceCodeParams = {
  /**
   * Unique identifier of the object
   */
  object_id: string;
  /**
   * Which S/4 source version to return: the inactive working copy (default) or the live active version
   */
  version?: TLSourceCodeVersion;
};

export type CreateModLogPathParameters = {
  remedyId: string;
};
export type GetObjectsWithFindingsPathParameters = {
  remedyId: string;
};
export type ListRemediationReportsPathParameters = {
  remedyId: string;
};
export type ListRemediationReportsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type StartRemediationReportPathParameters = {
  remedyId: string;
};
export type GetRemediationReportStatusPathParameters = {
  remedyId: string;
  jobId: string;
};
export type ScanPathParameters = {
  remedyId: string;
};
export type PerformSyntaxCheckPathParameters = {
  remedyId: string;
};
export type UpdateSourceCodePathParameters = {
  remedyId: string;
};
export type GetRelatedObjectsPathParameters = {
  remedyId: string;
  objectId: string;
};
export type UpdateObjectStatusPathParameters = {
  remedyId: string;
  objectId: string;
};
export type UpdateObjectStatusParams = {
  /**
   * New status for the object
   */
  status: TLScopeObjectStatus;
};

export type ListRemediationSapObjectsParams = {
  /**
   * Repository object type to search for
   */
  object_type: TLSearchableObjectType;
  /**
   * Object name glob (e.g. 'ZCL_FI*'). A '*' is appended when no wildcard is supplied. With name_end set this is instead the literal range start: no wildcards are accepted and no '*' is appended.
   * @minLength 1
   * @maxLength 120
   */
  name_pattern: string;
  /**
   * Optional inclusive range end (SAP select-options BT). Both endpoints must be literal names sharing at least two leading characters — a broader range is rejected, and a single one-character name is served by a plain pattern search instead. Names compare as uppercase ASCII, so '_' sorts after letters and '/NAMESPACE/' names sort before 'A'. A range matching more objects than the search cap is rejected rather than truncated.
   */
  name_end?: string | null;
  /**
   * SAP system to search
   */
  sap_version?: TLSAPVersion;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetFindingMetadataPathParameters = {
  scanId: string;
  findingId: string;
};
export type PreviewTransportImportParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ExportFixLibraryRulesParams = {
  format?: TLFixLibraryExportFormat;
};

export type ExportSelectedFixLibraryRulesParams = {
  format?: TLFixLibraryExportFormat;
};

export type ImportFixLibraryRulesParams = {
  on_conflict?: TLFixLibraryImportConflict;
};

export type DeleteFixExamplePathParameters = {
  fixTemplateId: string;
};
export type UpdateFixExamplePathParameters = {
  fixTemplateId: string;
};
export type DeleteCodestreamArtifactPathParameters = {
  kind: TLCodestreamArtifactKind;
};
export type PutCodestreamArtifactPathParameters = {
  kind: TLCodestreamArtifactKind;
};
export type GetCredentialMappingsPathParameters = {
  credentialId: string;
};
export type AddCredentialMappingPathParameters = {
  credentialId: string;
};
export type RemoveCredentialMappingPathParameters = {
  credentialId: string;
  connectionId: string;
};
export type CancelMessagePathParameters = {
  conversationId: string;
  messageId: string;
};
export type DeleteConversationPathParameters = {
  conversationId: string;
};
export type GetUserConversationsParams = {
  conversation_type?: TLConversationType | null;
};

export type GetMessageToolExecutionsPathParameters = {
  messageId: string;
};
export type GetSharedProgramsParams = {
  /**
   * Page size
   * @minimum 1
   * @maximum 100
   */
  page_size?: number;
  /**
   * Offset
   * @minimum 0
   */
  offset?: number;
  /**
   * Search by filename
   */
  search?: string | null;
};

export type GetUserProgramsParams = {
  /**
   * Page size
   * @minimum 1
   * @maximum 100
   */
  page_size?: number;
  /**
   * Offset
   * @minimum 0
   */
  offset?: number;
  /**
   * Search by filename
   */
  search?: string | null;
};

export type GetProgramPermissionsByProgramIdPathParameters = {
  programId: string;
};
export type GrantPermissionPathParameters = {
  programId: string;
};
export type RenameConversationPathParameters = {
  conversationId: string;
};
export type StreamMessagePathParameters = {
  messageId: string;
};
export type GetToolExecutionPathParameters = {
  toolExecutionId: string;
};
export type GetConversationPathParameters = {
  conversationId: string;
};
export type GetConversationParams = {
  /**
   * ISO timestamp to filter messages updated after this time
   */
  last_updated?: string | null;
};

export type UpdateConversationPathParameters = {
  conversationId: string;
};
export type GetContextUsagePathParameters = {
  conversationId: string;
};
export type ExportConversationToSkillPathParameters = {
  conversationId: string;
};
export type StreamExportConversationToSkillPathParameters = {
  conversationId: string;
};
export type ExportConversationToWorkflowPathParameters = {
  conversationId: string;
};
export type StreamExportConversationToWorkflowPathParameters = {
  conversationId: string;
};
export type GetConversationFilesPathParameters = {
  conversationId: string;
};
export type GetFilePreviewPathParameters = {
  conversationId: string;
  programId: string;
};
export type GetFilePreviewParams = {
  /**
   * Number of lines/rows per page
   */
  limit?: number | null;
  /**
   * Lines (text/code) or rows (tabular) already shown; start of this page
   * @minimum 0
   */
  offset?: number;
  /**
   * Deprecated alias for `limit`
   * @deprecated
   */
  max_lines?: number | null;
  /**
   * Filter tabular rows to those matching this term
   */
  search?: string | null;
};

export type SearchConversationFilePreviewPathParameters = {
  conversationId: string;
  programId: string;
};
export type SearchConversationFilePreviewParams = {
  /**
   * Case-insensitive substring to find
   * @minLength 1
   * @maxLength 1000
   */
  query: string;
};

export type ForkConversationPathParameters = {
  conversationId: string;
};
export type DeleteMessagePathParameters = {
  conversationId: string;
  messageId: string;
};
export type EditMessagePathParameters = {
  conversationId: string;
  messageId: string;
};
export type GetConversationMessagesPathParameters = {
  conversationId: string;
};
export type CancelMessageStreamingPathParameters = {
  conversationId: string;
  messageId: string;
};
export type ProcessFeedbackPathParameters = {
  conversationId: string;
  messageId: string;
};
export type ListQueuedMessagesPathParameters = {
  conversationId: string;
};
export type ListQueuedMessagesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type DeleteQueuedMessagePathParameters = {
  conversationId: string;
  queuedMessageId: string;
};
export type UpdateQueuedMessagePathParameters = {
  conversationId: string;
  queuedMessageId: string;
};
export type RetryQueuedMessagePathParameters = {
  conversationId: string;
  queuedMessageId: string;
};
export type SendQueuedMessageImmediatelyPathParameters = {
  conversationId: string;
  queuedMessageId: string;
};
export type ClearConversationScratchpadPathParameters = {
  conversationId: string;
};
export type GetConversationScratchpadPathParameters = {
  conversationId: string;
};
export type GetConversationSharePathParameters = {
  conversationId: string;
};
export type CreateConversationSharePathParameters = {
  conversationId: string;
};
export type RevokeConversationSharePathParameters = {
  conversationId: string;
};
export type SummarizeConversationPathParameters = {
  conversationId: string;
};
export type ListCredentialsForCurrentUserParams = {
  /**
   * If set, only credentials for connectors in this domain; if omitted, all domains
   */
  domain?: TLConnectorDomain | null;
  /**
   * If set, only credentials mapped to a connection of this type (e.g. ODATA, REST_API)
   */
  connection_type?: TLConnectionType | null;
  /**
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type DeleteConnectorCredentialPathParameters = {
  credentialId: string;
};
export type UpdateConnectorCredentialPathParameters = {
  credentialId: string;
};
export type GetConnectionsByConnectorParams = {
  /**
   * ID of the connector to get connections for
   */
  connector_id: string;
  /**
   * Optional filter by connection type (e.g. RFC, ODATA)
   */
  connection_type?: TLConnectionType | null;
};

export type DeleteConnectionPathParameters = {
  connectionId: string;
};
export type GetConnectionByIdPathParameters = {
  connectionId: string;
};
export type GetConnectionByIdParams = {
  /**
   * Optional connection type to validate the connection matches
   */
  connection_type?: TLConnectionType | null;
};

export type UpdateConnectionPathParameters = {
  connectionId: string;
};
export type GetCredentialsByConnectionPathParameters = {
  connectionId: string;
};
export type DisableConnectionPathParameters = {
  connectionId: string;
};
export type EnableConnectionPathParameters = {
  connectionId: string;
};
export type PurgeConnectionDocsFromKbPathParameters = {
  connectionId: string;
};
export type GetConnectionKbDocsStatusPathParameters = {
  connectionId: string;
};
export type IngestConnectionDocsToKbPathParameters = {
  connectionId: string;
};
export type ListSftpConnectionEntriesPathParameters = {
  connectionId: string;
};
export type ListSftpConnectionEntriesParams = {
  /**
   * Directory to list; blank lists the login directory
   */
  path?: string;
  /**
   * Credential mapped to the connection; uses the connection default when omitted
   */
  credential_id?: string | null;
};

export type GetAllConnectorsParams = {
  /**
   * Filter by domain
   */
  domain?: TLConnectorDomain | null;
  /**
   * Filter by active status
   */
  is_active?: boolean | null;
  /**
   * Filter by version identifier
   */
  version_identifier?: TLVersionIdentifier | null;
  /**
   * Filter to connectors with an active connection of this type (e.g. INTEGRATION_SUITE, SAP's Integration Suite)
   */
  connection_type?: TLConnectionType | null;
  /**
   * Maximum number of results
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  /**
   * Offset for pagination
   * @minimum 0
   */
  offset?: number;
};

export type PreviewConnectorNameParams = {
  /**
   * Human-readable label to sanitize
   * @minLength 1
   * @maxLength 200
   */
  label: string;
  /**
   * Domain the connector will be created under
   */
  domain: TLConnectorDomain;
  /**
   * Version identifier, if applicable
   */
  version_identifier?: TLVersionIdentifier | null;
};

export type DeleteConnectorPathParameters = {
  connectorId: string;
};
export type GetConnectorByIdPathParameters = {
  connectorId: string;
};
export type UpdateConnectorPathParameters = {
  connectorId: string;
};
export type DisableConnectorPathParameters = {
  connectorId: string;
};
export type EnableConnectorPathParameters = {
  connectorId: string;
};
export type CreateDirectoryPathParameters = {
  domain: string;
};
export type LinkProgramPathParameters = {
  domain: string;
};
export type ListDomainRootPathParameters = {
  domain: string;
};
export type ListDomainRootParams = {
  /**
   * Filter by FILE or DIRECTORY
   */
  node_type?: TLNodeType | null;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type DeleteNodePathParameters = {
  nodeId: string;
};
export type GetNodePathParameters = {
  nodeId: string;
};
export type GetBreadcrumbPathParameters = {
  nodeId: string;
};
export type ListNodeChildrenPathParameters = {
  nodeId: string;
};
export type ListNodeChildrenParams = {
  /**
   * Filter by FILE or DIRECTORY
   */
  node_type?: TLNodeType | null;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type MoveNodePathParameters = {
  nodeId: string;
};
export type RenameNodePathParameters = {
  nodeId: string;
};
export type ListTenantRootParams = {
  /**
   * Include global shared directories
   */
  include_global?: boolean;
};

export type SearchGatewayServicesParams = {
  /**
   * DPC class-name prefix (passed to p_clsnm; prefix match, not a wildcard)
   * @maxLength 120
   */
  search?: string;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type ConfirmMethodCdsParams = {
  /**
   * Full gateway service name, e.g. /AIF/CONF_REC_ASSGN_SRV
   * @maxLength 120
   */
  service_name: string;
  /**
   * Entity set name
   * @maxLength 120
   */
  entity_name: string;
  method_type: TLGatewayMethodType;
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type GetGatewayServiceParams = {
  /**
   * Full gateway service name, e.g. /AIF/CONF_REC_ASSGN_SRV
   * @maxLength 120
   */
  service_name: string;
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type GenerateMethodCdsParams = {
  /**
   * Full gateway service name, e.g. /AIF/CONF_REC_ASSGN_SRV
   * @maxLength 120
   */
  service_name: string;
  /**
   * Entity set name
   * @maxLength 120
   */
  entity_name: string;
  method_type: TLGatewayMethodType;
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type GetMethodSourceParams = {
  /**
   * Full gateway service name, e.g. /AIF/CONF_REC_ASSGN_SRV
   * @maxLength 120
   */
  service_name: string;
  /**
   * Entity set name
   * @maxLength 120
   */
  entity_name: string;
  method_type: TLGatewayMethodType;
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type GenerateRemediationPlanParams = {
  /**
   * Full gateway service name, e.g. /AIF/CONF_REC_ASSGN_SRV
   * @maxLength 120
   */
  service_name: string;
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type PushToTransportParams = {
  /**
   * Full gateway service name, e.g. /AIF/CONF_REC_ASSGN_SRV
   * @maxLength 120
   */
  service_name: string;
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type GetTransportStatusPathParameters = {
  transportId: string;
};
export type GetTransportStatusParams = {
  /**
   * Data connector to run against (admin override)
   */
  connector_name?: string | null;
};

export type ListAccessPrincipalsParams = {
  /**
   * Matches user name, username, or email, and group name
   */
  search?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetCatalogTreeParams = {
  /**
   * Case-insensitive substring match on table name
   */
  search?: string | null;
  /**
   * Catalog-level cursor from a previous page's next_cursor
   */
  cursor?: string | null;
  /**
   * Table rows per schema before per-schema cursor paging takes over
   */
  tables_per_schema?: number | null;
};

export type ListCatalogTreeCatalogsParams = {
  /**
   * Case-insensitive substring match on catalog name
   */
  search?: string | null;
  /**
   * Opaque cursor from a previous page's next_cursor
   */
  cursor?: string | null;
  /**
   * Minimum items per page (may be exceeded)
   */
  limit?: number | null;
};

export type ListCatalogTreeSchemasPathParameters = {
  catalog: string;
};
export type ListCatalogTreeSchemasParams = {
  /**
   * Case-insensitive substring match on schema name
   */
  search?: string | null;
  /**
   * Opaque cursor from a previous page's next_cursor
   */
  cursor?: string | null;
  /**
   * Minimum items per page (may be exceeded)
   */
  limit?: number | null;
};

export type ListCatalogTreeTablesPathParameters = {
  catalog: string;
};
export type ListCatalogTreeTablesParams = {
  /**
   * Restrict to one schema; all schemas when omitted
   */
  table_schema?: string | null;
  /**
   * Case-insensitive substring match on table name
   */
  search?: string | null;
  /**
   * Opaque cursor from a previous page's next_cursor
   */
  cursor?: string | null;
  /**
   * Minimum items per page (may be exceeded)
   */
  limit?: number | null;
  /**
   * Exact table name(s) to resolve columns for and restrict the response to, repeatable
   */
  table?: string[] | null;
};

export type DeleteConsoleTabPathParameters = {
  tabId: string;
};
export type GetLakePathParameters = {
  lake: string;
};
export type PutLakePathParameters = {
  lake: string;
};
export type ListCatalogsPathParameters = {
  lake: string;
};
export type ListCatalogsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  cursor?: string | null;
  prefix?: string | null;
  source_system?: TLSourceSystemKey | null;
  created_after?: string | null;
  created_before?: string | null;
};

export type DeleteCatalogPathParameters = {
  lake: string;
  catalog: string;
};
export type ControlPlaneGetCatalogPathParameters = {
  lake: string;
  catalog: string;
};
export type PutCatalogPathParameters = {
  lake: string;
  catalog: string;
};
export type ListReplicationGroupsPathParameters = {
  lake: string;
  catalog: string;
};
export type ListReplicationGroupsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  cursor?: string | null;
  adapter?: string | null;
  strategy?: TLReplicationStrategy | null;
  schedule_enabled?: boolean | null;
  created_after?: string | null;
  created_before?: string | null;
};

export type CreateReplicationGroupPathParameters = {
  lake: string;
  catalog: string;
};
export type DeleteReplicationGroupPathParameters = {
  lake: string;
  catalog: string;
  replicationGroupId: string;
};
export type GetReplicationGroupPathParameters = {
  lake: string;
  catalog: string;
  replicationGroupId: string;
};
export type UpdateReplicationGroupPathParameters = {
  lake: string;
  catalog: string;
  replicationGroupId: string;
};
export type ListReplicationRunsPathParameters = {
  lake: string;
  catalog: string;
  replicationGroupId: string;
};
export type ListReplicationRunsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  cursor?: string | null;
  status?: TLReplicationRunStatus[] | null;
  created_after?: string | null;
  created_before?: string | null;
};

export type StartReplicationRunPathParameters = {
  lake: string;
  catalog: string;
  replicationGroupId: string;
};
export type GetReplicationRunPathParameters = {
  lake: string;
  catalog: string;
  replicationGroupId: string;
  runId: string;
};
export type ListReplicationTableRunsPathParameters = {
  lake: string;
  catalog: string;
  replicationGroupId: string;
  runId: string;
};
export type ListReplicationTableRunsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  cursor?: string | null;
  status?: TLReplicationRunStatus[] | null;
  table?: string | null;
  created_after?: string | null;
  created_before?: string | null;
};

export type GetReplicationRunByIdPathParameters = {
  runId: string;
};
export type UpdateSourcePathParameters = {
  sourceName: string;
};
export type ListFoundryQueryRunHistoryParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetQueryBatchStatusPathParameters = {
  jobId: string;
};
export type GetCatalogParams = {
  /**
   * Filter to a specific catalog
   */
  table_catalog?: string | null;
  /**
   * Filter to a specific schema
   */
  table_schema?: string | null;
};

export type GetCatalogTablesParams = {
  /**
   * Filter to a specific catalog
   */
  table_catalog?: string | null;
  /**
   * Filter to a specific schema
   */
  table_schema?: string | null;
};

export type GetChunkDataParams = {
  /**
   * Cloud URI of the query result
   */
  result_path: string;
  /**
   * Zero-based chunk index
   * @minimum 0
   */
  chunk_number: number;
};

export type GetFoundryQueryExportStatusPathParameters = {
  exportJobId: string;
};
export type GetQueryStatusPathParameters = {
  jobId: string;
};
export type GetQueryStatusParams = {
  /**
   * Long-poll: wait up to this many seconds for completion before responding. Values above the deployment's configured cap are clamped to it.
   * @minimum 0
   * @maximum 300
   */
  wait_seconds?: number;
};

export type CancelQueryPathParameters = {
  jobId: string;
};
export type GetQueryResultDataPathParameters = {
  jobId: string;
};
export type GetQueryResultDataParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 5000
   */
  page_size?: number;
};

export type ExportFoundryQueryResultPathParameters = {
  jobId: string;
};
export type DeleteSourcePathParameters = {
  catalogName: string;
};
export type UpdateSourceCredentialsPathParameters = {
  catalogName: string;
};
export type DeleteTableAccessParams = {
  /**
   * USER or GROUP
   */
  subject_type: TLFoundryAccessPrincipalType;
  /**
   * Keycloak user id, or group path such as /finance
   * @minLength 1
   */
  subject_id: string;
  /**
   * Catalog name; omit to address the whole lake
   */
  catalog?: string | null;
  /**
   * Schema name; needs catalog
   */
  schema_name?: string | null;
  /**
   * Table name; needs schema_name
   */
  table?: string | null;
};

export type ListTableAccessParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * Catalog name; omit to address the whole lake
   */
  catalog?: string | null;
  /**
   * Schema name; needs catalog
   */
  schema_name?: string | null;
  /**
   * Table name; needs schema_name
   */
  table?: string | null;
};

export type UpdateTableAccessParams = {
  /**
   * USER or GROUP
   */
  subject_type: TLFoundryAccessPrincipalType;
  /**
   * Keycloak user id, or group path such as /finance
   * @minLength 1
   */
  subject_id: string;
  /**
   * Catalog name; omit to address the whole lake
   */
  catalog?: string | null;
  /**
   * Schema name; needs catalog
   */
  schema_name?: string | null;
  /**
   * Table name; needs schema_name
   */
  table?: string | null;
};

export type ListFoundryWorkbookSheetsPathParameters = {
  programId: string;
};
export type GetFoundryTableImportStatusPathParameters = {
  jobId: string;
};
export type ListGovernanceGrantsParams = {
  /**
   * Filter by governance namespace
   */
  namespace?: string | null;
  /**
   * Filter by subject type
   */
  subject_type?: TLGovernanceGrantSubjectType | null;
  /**
   * Filter by subject id
   */
  subject_id?: string | null;
  /**
   * Filter by resource pattern prefix
   */
  resource_prefix?: string | null;
  /**
   * Exact resource; returns the grants whose pattern covers it (itself and its ancestors)
   */
  resource?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type DeleteGovernanceGrantPathParameters = {
  grantId: string;
};
export type ListHanaViewsParams = {
  /**
   * Maximum views to return.
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of views to skip.
   * @minimum 0
   */
  offset?: number;
  /**
   * Filter by the email of the currently assigned user.
   */
  assigned_to?: string | null;
  /**
   * Filter by the email of the currently assigned reviewer.
   */
  reviewer_email?: string | null;
  /**
   * When true, restricts to READY_FOR_REVIEW views with a pending review decision.
   */
  awaiting_review?: boolean;
  /**
   * Case-insensitive partial match on view name, description, or package.
   */
  search?: string | null;
};

export type GetBulkRemediatedUploadJobStatusPathParameters = {
  jobId: string;
};
export type GetHanaViewWriteBackJobPathParameters = {
  jobId: string;
};
export type SearchSapViewsParams = {
  /**
   * Case-insensitive substring match on OBJECT_NAME.
   * @minLength 1
   */
  query: string;
  /**
   * Maximum results to return. Narrow your query if you need to see more.
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * HANA connection ID (data-connectors Connections row)
   */
  connection_id: string;
  /**
   * HANA credential ID (data-connectors ConnectorCredentials row)
   */
  credential_id: string;
};

export type GetSetupJobStatusPathParameters = {
  jobId: string;
};
export type GetHanaViewPathParameters = {
  viewId: string;
};
export type UpdateHanaViewMetadataPathParameters = {
  viewId: string;
};
export type ListHanaViewActivityPathParameters = {
  viewId: string;
};
export type ListHanaViewActivityParams = {
  /**
   * Page number, 1-indexed.
   * @minimum 1
   */
  page?: number;
  /**
   * Audit entries per page (newest first).
   * @minimum 1
   * @maximum 200
   */
  page_size?: number;
};

export type AssignUserToHanaViewPathParameters = {
  viewId: string;
};
export type GetHanaViewDagPathParameters = {
  viewId: string;
};
export type GetHanaViewDagParams = {
  /**
   * Version id (e.g. '1.0'). Omit to fetch the latest.
   */
  version?: string | null;
};

export type GetHanaViewProcedureSqlPathParameters = {
  viewId: string;
};
export type GetHanaViewProcedureSqlParams = {
  /**
   * Version id (e.g. '1.0'). Omit to fetch the latest.
   */
  version?: string | null;
};

export type PublishHanaViewToSapPathParameters = {
  viewId: string;
};
export type UploadRemediatedHanaViewXmlPathParameters = {
  viewId: string;
};
export type SubmitHanaViewForReviewPathParameters = {
  viewId: string;
};
export type ApproveHanaViewReviewPathParameters = {
  viewId: string;
};
export type RejectHanaViewReviewPathParameters = {
  viewId: string;
};
export type StartHanaViewPathParameters = {
  viewId: string;
};
export type ListHanaViewTargetsPathParameters = {
  viewId: string;
};
export type ListHanaViewTargetsParams = {
  /**
   * Maximum targets to return.
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of targets to skip.
   * @minimum 0
   */
  offset?: number;
};

export type GetHanaViewTargetDagPathParameters = {
  viewId: string;
  targetId: string;
};
export type GetHanaViewTargetDagParams = {
  /**
   * Version id (e.g. '1.0'). Omit to fetch the latest.
   */
  version?: string | null;
};

export type GetHanaViewTargetProcedureSqlPathParameters = {
  viewId: string;
  targetId: string;
};
export type GetHanaViewTargetProcedureSqlParams = {
  /**
   * Version id (e.g. '1.0'). Omit to fetch the latest.
   */
  version?: string | null;
};

export type ListHanaViewTargetVersionsPathParameters = {
  viewId: string;
  targetId: string;
};
export type ListHanaViewTargetVersionsParams = {
  /**
   * Maximum versions to return.
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of versions to skip.
   * @minimum 0
   */
  offset?: number;
};

export type GetHanaViewTargetXmlPathParameters = {
  viewId: string;
  targetId: string;
};
export type GetHanaViewTargetXmlParams = {
  /**
   * Version id (e.g. '1.0'). Omit to fetch the latest.
   */
  version?: string | null;
};

export type UpdateHanaViewTargetXmlPathParameters = {
  viewId: string;
  targetId: string;
};
export type ListHanaViewVersionsPathParameters = {
  viewId: string;
};
export type GetHanaViewXmlPathParameters = {
  viewId: string;
};
export type GetHanaViewXmlParams = {
  /**
   * Version id (e.g. '1.0'). Omit to fetch the latest.
   */
  version?: string | null;
};

export type ListJobSchedulesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ListJobRunsPathParameters = {
  jobName: string;
};
export type ListJobRunsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetJobRunPathParameters = {
  jobName: string;
  runId: string;
};
export type TriggerJobPathParameters = {
  jobName: string;
};
export type ListKbDocumentsParams = {
  status?: TLKbDocumentStatus[] | null;
  topic_id?: string[] | null;
  tags?: string[] | null;
  assigned_to?: string | null;
  /**
   * Match documents any of whose review rounds assign this email
   */
  reviewer?: string | null;
  /**
   * Case-insensitive match on filename or display name
   */
  search?: string | null;
  /**
   * Only this package's documents (drill-in view)
   */
  package_id?: string | null;
  /**
   * true = only documents in a package, false = only loose
   */
  grouped?: boolean | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetKbDocumentStatsParams = {
  topic_id?: string[] | null;
  package_id?: string | null;
};

export type ListKbTopLevelItemsParams = {
  status?: TLKbDocumentStatus[] | null;
  topic_id?: string[] | null;
  tags?: string[] | null;
  assigned_to?: string | null;
  /**
   * Case-insensitive match on item name
   */
  search?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetKbDocumentArchiveManifestPathParameters = {
  documentId: string;
};
export type GetKbDocumentContentPathParameters = {
  documentId: string;
};
export type GetKbDocumentSourcePathParameters = {
  documentId: string;
};
export type CompleteKbExternalSourceAuthorizationParams = {
  /**
   * @maxLength 256
   */
  state: string;
  code?: string | null;
};

export type GetKbExternalSourceEntryStatusPathParameters = {
  packageId: string;
};
export type RetryKbExternalSourceEntryPathParameters = {
  packageId: string;
};
export type CreateKbExternalSourceConnectUrlPathParameters = {
  connectionId: string;
};
export type DisconnectKbExternalSourcePathParameters = {
  connectionId: string;
};
export type ListKbExternalSourceItemsPathParameters = {
  connectionId: string;
};
export type ListKbExternalSourceItemsParams = {
  resource_id?: string | null;
  cursor?: string | null;
};

export type StageKbExternalSourceFilesPathParameters = {
  connectionId: string;
};
export type GetKbExternalSourceStatusPathParameters = {
  connectionId: string;
};
export type ListPackagesParams = {
  stage?: TLKbPackageStage[] | null;
  status?: TLKbPackageStatus[] | null;
  topic_id?: string[] | null;
  assigned_to?: string | null;
  created_by?: string | null;
  /**
   * Match packages where assigned_to or a reviewer from any review round is any of these emails
   */
  owner?: string[] | null;
  tags?: string[] | null;
  search?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetPackageStatsParams = {
  topic_id?: string | null;
};

export type DeletePackagePathParameters = {
  packageId: string;
};
export type GetPackagePathParameters = {
  packageId: string;
};
export type UpdatePackagePathParameters = {
  packageId: string;
};
export type AcceptReviewPathParameters = {
  packageId: string;
};
export type ApprovePackagePathParameters = {
  packageId: string;
};
export type AddCommentPathParameters = {
  packageId: string;
};
export type SendKbMessagePathParameters = {
  packageId: string;
};
export type ListDocumentsPathParameters = {
  packageId: string;
};
export type ListDocumentsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type AddDocumentPathParameters = {
  packageId: string;
};
export type RemoveDocumentPathParameters = {
  packageId: string;
  documentId: string;
};
export type GetPackageHistoryPathParameters = {
  packageId: string;
};
export type GetPackageHistoryParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type RejectPackagePathParameters = {
  packageId: string;
};
export type RetryKbPackagePromotionPathParameters = {
  packageId: string;
};
export type SearchPackagePathParameters = {
  packageId: string;
};
export type SubmitPackagePathParameters = {
  packageId: string;
};
export type GetPackageSuggestedPromptsPathParameters = {
  packageId: string;
};
export type GetKbPackageValidationStatusPathParameters = {
  packageId: string;
};
export type GetKbProgramArchiveManifestPathParameters = {
  programId: string;
};
export type ListTagsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  search?: string | null;
};

export type DeleteTagPathParameters = {
  tagId: string;
};
export type GetTagPathParameters = {
  tagId: string;
};
export type UpdateTagPathParameters = {
  tagId: string;
};
export type ListTopicsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type DeleteTopicPathParameters = {
  topicId: string;
};
export type GetTopicPathParameters = {
  topicId: string;
};
export type UpdateTopicPathParameters = {
  topicId: string;
};
export type ListWikiTopicGraphsParams = {
  /**
   * Node ceiling per topic graph
   * @minimum 1
   * @maximum 500
   */
  max_nodes?: number;
  /**
   * Include cited source documents as graph nodes
   */
  include_sources?: boolean;
};

export type GetWikiPagePathParameters = {
  programId: string;
};
export type GetWikiSourcePathParameters = {
  programId: string;
};
export type GetWikiSourceParams = {
  /**
   * Download URL expiration in seconds
   * @minimum 60
   * @maximum 86400
   */
  expiration?: number;
};

export type ListWikiTopicsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ListWikiTopicDocumentsPathParameters = {
  topicId: string;
};
export type ListWikiTopicDocumentsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetWikiTopicGraphPathParameters = {
  topicId: string;
};
export type ListWikiTopicLinksPathParameters = {
  topicId: string;
};
export type ListWikiTopicLinksParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ListWikiTopicPagesPathParameters = {
  topicId: string;
};
export type ListWikiTopicPagesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ResetWikiTopicPathParameters = {
  topicId: string;
};
export type SynthesizeWikiTopicPathParameters = {
  topicId: string;
};
export type ListLlmModelsParams = {
  /**
   * Filter by provider
   */
  provider?: TLLlmProvider | null;
  /**
   * Filter by catalog status
   */
  status?: TLLlmModelStatus | null;
  /**
   * Substring match on model slug or display name
   */
  search?: string | null;
  /**
   * Page size
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Zero-based offset for pagination
   * @minimum 0
   */
  offset?: number;
};

export type UpdateLlmModelPathParameters = {
  modelId: string;
};
export type ChangeLlmModelStatusPathParameters = {
  modelId: string;
};
export type GetCostUsageTimeseriesParams = {
  /**
   * Inclusive lower bound (ISO datetime)
   */
  from_date: string;
  /**
   * Exclusive upper bound (ISO datetime)
   */
  to_date: string;
  granularity?: TLUsageGranularity;
  /**
   * IANA timezone, e.g. America/Los_Angeles
   */
  timezone?: string;
  /**
   * Optional user-email filters. Omit for all users
   */
  user_emails?: string[] | null;
  /**
   * Deprecated alias for user_emails; merged into user_emails. Will be removed.
   * @deprecated
   */
  user_email?: string | null;
  /**
   * Optional group filters; expanded to member emails. Omit for all groups
   */
  group_ids?: string[] | null;
  /**
   * Optional conversation type filter
   */
  conversation_type?: TLConversationType | null;
  /**
   * Optional tenant filters. Omit for all tenants
   */
  tenant_ids?: string[] | null;
  /**
   * Maximum buckets to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  /**
   * Zero-based offset for pagination
   * @minimum 0
   */
  offset?: number;
};

export type ListUsageFilterGroupsParams = {
  /**
   * Optional group-name search filter
   */
  search?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Zero-based offset for pagination
   * @minimum 0
   */
  offset?: number;
};

export type ListUsageFilterGroupMembersPathParameters = {
  groupId: string;
};
export type ListUsageFilterGroupMembersParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Zero-based offset for pagination
   * @minimum 0
   */
  offset?: number;
};

export type GetUsageMetadataParams = {
  /**
   * Inclusive lower bound (ISO datetime)
   */
  from_date: string;
  /**
   * Exclusive upper bound (ISO datetime)
   */
  to_date: string;
  /**
   * IANA timezone, e.g. America/Los_Angeles
   */
  timezone?: string;
  /**
   * Optional tenant filters. Omit for all tenants
   */
  tenant_ids?: string[] | null;
  /**
   * Optional user filters. Omit for all users
   */
  user_emails?: string[] | null;
  /**
   * Optional group filters; expanded to member emails. Omit for all groups
   */
  group_ids?: string[] | null;
  /**
   * Optional conversation type filters. Omit for all types
   */
  conversation_types?: TLConversationType[] | null;
  /**
   * Optional model-name filters. Omit for all models
   */
  models?: string[] | null;
};

export type GetTokenUsageTimeseriesParams = {
  /**
   * Inclusive lower bound (ISO datetime)
   */
  from_date: string;
  /**
   * Exclusive upper bound (ISO datetime)
   */
  to_date: string;
  granularity?: TLUsageGranularity;
  /**
   * IANA timezone, e.g. America/Los_Angeles
   */
  timezone?: string;
  /**
   * Optional user-email filters. Omit for all users
   */
  user_emails?: string[] | null;
  /**
   * Deprecated alias for user_emails; merged into user_emails. Will be removed.
   * @deprecated
   */
  user_email?: string | null;
  /**
   * Optional group filters; expanded to member emails. Omit for all groups
   */
  group_ids?: string[] | null;
  /**
   * Optional conversation type filter
   */
  conversation_type?: TLConversationType | null;
  /**
   * Optional tenant filters. Omit for all tenants
   */
  tenant_ids?: string[] | null;
  /**
   * Maximum buckets to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  /**
   * Zero-based offset for pagination
   * @minimum 0
   */
  offset?: number;
};

export type ListMcpConnectionsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type RevokeMcpConnectionPathParameters = {
  connectionId: string;
};
export type JiraOauthCallbackParams = {
  code?: string | null;
  state?: string | null;
  error?: string | null;
  error_description?: string | null;
};

export type WorkiqCallbackParams = {
  code?: string | null;
  state?: string | null;
  error?: string | null;
  error_description?: string | null;
};

export type GetLibraryInstantiateStatusPathParameters = {
  jobId: string;
};
export type ListLibraryTemplatesParams = {
  /**
   * Matches name, description, and table and field names
   */
  search?: string | null;
  sort?: TLNexusLibrarySort;
  source_domain?: TLConnectorDomain | null;
  target_domain?: TLConnectorDomain | null;
  cursor?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  page_size?: number;
};

export type GetLibraryTemplateGraphPathParameters = {
  templateId: string;
};
export type InstantiateLibraryTemplatePathParameters = {
  templateId: string;
};
export type ListLibraryTemplateMappingsPathParameters = {
  templateId: string;
};
export type ListLibraryTemplateMappingsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ListProjectsParams = {
  search?: string | null;
  /**
   * Filter by ownership: ALL, OWNED, or SHARED
   */
  ownership?: TLNexusOwnershipScope;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type DeleteProjectPathParameters = {
  projectId: string;
};
export type GetProjectPathParameters = {
  projectId: string;
};
export type UpdateProjectPathParameters = {
  projectId: string;
};
export type ListCommentThreadsPathParameters = {
  projectId: string;
};
export type ListCommentThreadsParams = {
  /**
   * Only threads anchored to this field node
   */
  node_id?: string | null;
  /**
   * Only threads in this state
   */
  status?: TLNexusThreadStatus | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type CreateCommentThreadPathParameters = {
  projectId: string;
};
export type ListCommentThreadCommentsPathParameters = {
  projectId: string;
  threadId: string;
};
export type ListCommentThreadCommentsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type CreateCommentThreadReplyPathParameters = {
  projectId: string;
  threadId: string;
};
export type DeleteCommentThreadCommentPathParameters = {
  projectId: string;
  threadId: string;
  commentId: string;
};
export type UpdateCommentThreadCommentPathParameters = {
  projectId: string;
  threadId: string;
  commentId: string;
};
export type ReopenCommentThreadPathParameters = {
  projectId: string;
  threadId: string;
};
export type ResolveCommentThreadPathParameters = {
  projectId: string;
  threadId: string;
};
export type PreviewFilterPathParameters = {
  projectId: string;
};
export type RunQueryPathParameters = {
  projectId: string;
};
export type FindReuseCandidatesPathParameters = {
  projectId: string;
};
export type SearchTablesPathParameters = {
  projectId: string;
};
export type SuggestMappingPathParameters = {
  projectId: string;
};
export type AddTablePathParameters = {
  projectId: string;
};
export type AddTablesPathParameters = {
  projectId: string;
};
export type ValidateMappingPathParameters = {
  projectId: string;
};
export type ValidateSqlPathParameters = {
  projectId: string;
};
export type GetGraphPathParameters = {
  projectId: string;
};
export type CreateEdgePathParameters = {
  projectId: string;
};
export type DeleteEdgePathParameters = {
  projectId: string;
  edgeId: string;
};
export type UpdateEdgePathParameters = {
  projectId: string;
  edgeId: string;
};
export type ExportMappingsPathParameters = {
  projectId: string;
};
export type CreateFieldMappingPathParameters = {
  projectId: string;
};
export type ValidateNexusFieldMappingsBulkPathParameters = {
  projectId: string;
};
export type DeleteFieldMappingPathParameters = {
  projectId: string;
  mappingId: string;
};
export type UpdateFieldMappingPathParameters = {
  projectId: string;
  mappingId: string;
};
export type ValidateNexusFieldMappingPathParameters = {
  projectId: string;
  mappingId: string;
};
export type ValidateNexusFieldMappingParams = {
  /**
   * @minimum 1
   * @maximum 10000
   */
  limit?: number;
};

export type CreateNodesPathParameters = {
  projectId: string;
};
export type DeleteNexusNodePathParameters = {
  projectId: string;
  nodeId: string;
};
export type UpdateNodePathParameters = {
  projectId: string;
  nodeId: string;
};
export type GetNodeDataPathParameters = {
  projectId: string;
  nodeId: string;
};
export type GetNodeDataParams = {
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type DeleteNexusTableFilterPathParameters = {
  projectId: string;
  nodeId: string;
};
export type GetNexusTableFilterPathParameters = {
  projectId: string;
  nodeId: string;
};
export type SetNexusTableFilterPathParameters = {
  projectId: string;
  nodeId: string;
};
export type RemeasureNexusNodeColumnsPathParameters = {
  projectId: string;
  nodeId: string;
};
export type ImportSchemaPathParameters = {
  projectId: string;
};
export type GetSchemaImportTemplatePathParameters = {
  projectId: string;
};
export type ListKnowledgeDocumentsPathParameters = {
  projectId: string;
};
export type ListKnowledgeDocumentsParams = {
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type UploadKnowledgeDocumentPathParameters = {
  projectId: string;
};
export type AddFromProgramPathParameters = {
  projectId: string;
};
export type SearchKnowledgeBasePathParameters = {
  projectId: string;
};
export type DeleteKnowledgeDocumentPathParameters = {
  projectId: string;
  documentId: string;
};
export type GetKnowledgeDocumentPathParameters = {
  projectId: string;
  documentId: string;
};
export type ListNexusProjectPermissionsPathParameters = {
  projectId: string;
};
export type ListNexusProjectPermissionsParams = {
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GrantNexusProjectPermissionsPathParameters = {
  projectId: string;
};
export type LeaveNexusProjectPathParameters = {
  projectId: string;
};
export type RevokeNexusProjectPermissionsPathParameters = {
  projectId: string;
};
export type PlexusAssignTablesPathParameters = {
  projectId: string;
};
export type PlexusClearAssumptionCachePathParameters = {
  projectId: string;
};
export type PlexusListConventionDecisionsPathParameters = {
  projectId: string;
};
export type PlexusListConventionDecisionsParams = {
  /**
   * Scope to a single Plexus run.
   */
  batch_id?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type PlexusProposeMappingsPathParameters = {
  projectId: string;
};
export type ImportFieldMappingProposalsPathParameters = {
  projectId: string;
};
export type GetFieldMappingImportTemplatePathParameters = {
  projectId: string;
};
export type ListReviewAuditPathParameters = {
  projectId: string;
};
export type ListReviewAuditParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetBlueprintSignoffPathParameters = {
  projectId: string;
};
export type SubmitBlueprintSignoffPathParameters = {
  projectId: string;
};
export type ApproveBlueprintSignoffPathParameters = {
  projectId: string;
};
export type ListBlueprintSignoffsPathParameters = {
  projectId: string;
};
export type ListBlueprintSignoffsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type RejectBlueprintSignoffPathParameters = {
  projectId: string;
};
export type UploadDataFilePathParameters = {
  projectId: string;
};
export type GetNexusDataUploadStatusPathParameters = {
  projectId: string;
  jobId: string;
};
export type ListNexusProjectVersionsPathParameters = {
  projectId: string;
};
export type ListNexusProjectVersionsParams = {
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type PublishNexusProjectVersionPathParameters = {
  projectId: string;
};
export type GetNexusProjectVersionPathParameters = {
  projectId: string;
  version: number;
};
export type RestoreNexusProjectVersionPathParameters = {
  projectId: string;
  version: number;
};
export type ListProposalsParams = {
  project_id?: string[] | null;
  status?: TLNexusProposalStatus[] | null;
  source_origin?: TLNexusSourceOrigin[] | null;
  proposal_type?: TLNexusProposalType[] | null;
  confidence_min?: number | null;
  confidence_max?: number | null;
  batch_id?: string | null;
  assigned_to?: string | null;
  unassigned?: boolean;
  has_comments?: boolean;
  lens?: TLNexusReviewerLens;
  created_after?: string | null;
  search?: string | null;
  cursor?: string | null;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type GetStatsParams = {
  project_id?: string[] | null;
  source_origin?: TLNexusSourceOrigin[] | null;
  proposal_type?: TLNexusProposalType[] | null;
  confidence_min?: number | null;
  confidence_max?: number | null;
  batch_id?: string | null;
  has_comments?: boolean;
  created_after?: string | null;
  search?: string | null;
};

export type GetProposalPathParameters = {
  proposalId: string;
};
export type AcceptProposalPathParameters = {
  proposalId: string;
};
export type AssignProposalPathParameters = {
  proposalId: string;
};
export type CommentProposalPathParameters = {
  proposalId: string;
};
export type NeedsInfoProposalPathParameters = {
  proposalId: string;
};
export type GetNeighborhoodPathParameters = {
  proposalId: string;
};
export type RejectProposalPathParameters = {
  proposalId: string;
};
export type GetNotificationsParams = {
  /**
   * Page size
   * @minimum 1
   */
  limit?: number;
  /**
   * Offset
   * @minimum 0
   */
  offset?: number;
  /**
   * Filter by read status
   */
  is_read?: boolean | null;
  /**
   * Filter by notification status
   */
  status?: TLNotificationStatus | null;
  /**
   * Filter by a single domain (deprecated: use `domains`)
   */
  domain?: TLDomain | null;
  /**
   * Filter by one or more domains (repeatable)
   */
  domains?: TLDomain[] | null;
  /**
   * Only notifications created at or after this time (ISO 8601; naive datetimes are treated as UTC)
   */
  created_after?: string | null;
};

export type MarkAllNotificationsReadParams = {
  /**
   * Restrict to these priorities
   */
  priorities?: TLNotificationPriority[] | null;
  /**
   * Only mark notifications created at or after this time (ISO 8601; naive datetimes are treated as UTC)
   */
  created_after?: string | null;
};

export type GetSubscriptionsParams = {
  /**
   * Page size
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Offset
   * @minimum 0
   */
  offset?: number;
  /**
   * Filter to subscriptions on this resource type
   */
  resource_type?: TLResourceType | null;
  /**
   * Filter to subscriptions on this resource id
   */
  resource_id?: string | null;
};

export type DeleteNotificationPathParameters = {
  notificationId: string;
};
export type ArchiveNotificationPathParameters = {
  notificationId: string;
};
export type AuthorizeMcpOauthClientParams = {
  client_id: string;
  redirect_uri: string;
  response_type: string;
  code_challenge?: string | null;
  code_challenge_method?: string | null;
  state?: string | null;
  resource?: string | null;
  scope?: string | null;
};

export type GetMcpConsentRequestParams = {
  request_id: string;
};

export type ListPlatformSkillsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * Optional product domain filter; returns GLOBAL plus this domain. Omit for all domains.
   */
  domain?: TLDomain | null;
  /**
   * Filter skills by status (e.g. ACTIVE); omit to include all statuses
   */
  status?: TLSkillStatus | null;
};

export type ImportPlatformSkillZipParams = {
  /**
   * Product domain for the imported skill
   */
  domain?: TLDomain;
  /**
   * Optional slug override; otherwise derived from SKILL.md name
   */
  slug?: string | null;
  /**
   * Replace an existing same-slug platform skill instead of erroring
   */
  overwrite?: boolean;
};

export type DeletePlatformSkillPathParameters = {
  slug: string;
};
export type GetPlatformSkillPathParameters = {
  slug: string;
};
export type UpdatePlatformSkillPathParameters = {
  slug: string;
};
export type PlatformListAttachmentsPathParameters = {
  slug: string;
};
export type PlatformListAttachmentsParams = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
};

export type PlatformCreateAttachmentPathParameters = {
  slug: string;
};
export type PlatformAbortPlatformSkillAttachmentUploadPathParameters = {
  slug: string;
};
export type PlatformCompletePlatformSkillAttachmentUploadPathParameters = {
  slug: string;
};
export type PlatformInitiatePlatformSkillAttachmentUploadPathParameters = {
  slug: string;
};
export type PlatformDeleteAttachmentPathParameters = {
  slug: string;
  attachmentId: string;
};
export type PlatformGetAttachmentPathParameters = {
  slug: string;
  attachmentId: string;
};
export type PlatformUpdateAttachmentPathParameters = {
  slug: string;
  attachmentId: string;
};
export type PlatformGetAttachmentContentPathParameters = {
  slug: string;
  attachmentId: string;
};
export type PlatformPutAttachmentContentPathParameters = {
  slug: string;
  attachmentId: string;
};
export type PlatformDownloadPlatformSkillAttachmentPathParameters = {
  slug: string;
  attachmentId: string;
};
export type GetPlatformSkillContentPathParameters = {
  slug: string;
};
export type ExportPlatformSkillZipPathParameters = {
  slug: string;
};
export type GetPreviewAtcScanPathParameters = {
  previewScanId: string;
};
export type ListProgramsParams = {
  /**
   * Filter programs by domain
   */
  domain?: TLDomain | null;
  correlation_id?: string | null;
  /**
   * When true, exclude programs that are subobjects of another saved program (filters by program_metadata.parent_program_id is null). Editor library passes this; other consumers leave it default.
   */
  parents_only?: boolean;
};

export type UploadProgramsParams = {
  /**
   * Domain for the uploaded programs
   */
  domain: TLDomain;
};

export type DeleteProgramPathParameters = {
  programId: string;
};
export type GetProgramPathParameters = {
  programId: string;
};
export type GetProgramParams = {
  /**
   * Optional version. If not provided, returns the latest version
   */
  version?: string | null;
};

export type SaveProgramPathParameters = {
  programId: string;
};
export type GetPresignedUrlPathParameters = {
  programId: string;
};
export type GetPresignedUrlParams = {
  /**
   * URL expiration time in seconds (1 minute to 24 hours)
   * @minimum 60
   * @maximum 86400
   */
  expiration?: number;
};

export type GetProgramPreviewPathParameters = {
  programId: string;
};
export type GetProgramPreviewParams = {
  /**
   * Number of lines/rows per page
   */
  limit?: number | null;
  /**
   * Lines (text/code) or rows (tabular) already shown; start of this page
   * @minimum 0
   */
  offset?: number;
  /**
   * Deprecated alias for `limit`
   * @deprecated
   */
  max_lines?: number | null;
  /**
   * Filter tabular rows to those matching this term
   */
  search?: string | null;
};

export type SearchProgramPreviewPathParameters = {
  programId: string;
};
export type SearchProgramPreviewParams = {
  /**
   * Case-insensitive substring to find
   * @minLength 1
   * @maxLength 1000
   */
  query: string;
};

export type RenameProgramPathParameters = {
  programId: string;
};
export type UpdateProgramPathParameters = {
  programId: string;
};
export type GetProgramVersionHistoryPathParameters = {
  programId: string;
};
export type SearchFunctionGroupsParams = {
  /**
   * Name pattern (e.g. 'ZMY*')
   * @minLength 1
   * @maxLength 60
   */
  q: string;
  /**
   * Max function groups to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  sap_version?: TLSAPVersion;
};

export type SearchMyObjectsParams = {
  /**
   * ADT object search pattern (e.g. 'Z*', 'ZFOO*'). Defaults to Z*.
   */
  pattern?: string | null;
  /**
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  sap_version?: TLSAPVersion;
};

export type GetObjectTransportCandidatesParams = {
  /**
   * Object kind the TR must accept (to-be-created objects)
   */
  kind?: TLObjectKind | null;
  /**
   * Would-be object name
   */
  name?: string | null;
  /**
   * Target package
   */
  package?: string | null;
  /**
   * Parent function group (FUNC only)
   */
  parent_group?: string | null;
  /**
   * ADT URI of an EXISTING object; mutually exclusive with kind/name/package
   */
  object_uri?: string | null;
  sap_version?: TLSAPVersion;
};

export type CreateObjectParams = {
  sap_version?: TLSAPVersion;
};

export type ActivateObjectPathParameters = {
  objectUri: string;
};
export type ActivateObjectParams = {
  /**
   * Override the object name used in the activation request body. Defaults to the last URI segment uppercased.
   */
  object_name?: string | null;
  sap_version?: TLSAPVersion;
};

export type GetObjectChildrenPathParameters = {
  objectUri: string;
};
export type GetObjectChildrenParams = {
  /**
   * Max children to return
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * Offset for pagination
   * @minimum 0
   */
  offset?: number;
  sap_version?: TLSAPVersion;
};

export type GetObjectMetadataPathParameters = {
  objectUri: string;
};
export type GetObjectMetadataParams = {
  sap_version?: TLSAPVersion;
};

export type NavigateFromSourcePathParameters = {
  objectUri: string;
};
export type NavigateFromSourceParams = {
  sap_version?: TLSAPVersion;
};

export type PrettyPrintObjectPathParameters = {
  objectUri: string;
};
export type PrettyPrintObjectParams = {
  sap_version?: TLSAPVersion;
};

export type GetObjectSourcePathParameters = {
  objectUri: string;
};
export type GetObjectSourceParams = {
  /**
   * ABAP source version — 'active' (default) or 'inactive' for uncommitted edits
   */
  version?: GetObjectSourceVersion;
  sap_version?: TLSAPVersion;
};

export enum GetObjectSourceVersion {
  active = 'active',
  inactive = 'inactive',
}
export type SaveObjectSourcePathParameters = {
  objectUri: string;
};
export type SaveObjectSourceParams = {
  sap_version?: TLSAPVersion;
};

export type SyntaxCheckObjectPathParameters = {
  objectUri: string;
};
export type SyntaxCheckObjectParams = {
  sap_version?: TLSAPVersion;
};

export type GetTableDataPreviewPathParameters = {
  objectUri: string;
};
export type GetTableDataPreviewParams = {
  /**
   * Max rows to sample (Eclipse default 100). SAP treats this as an upper bound.
   * @minimum 1
   * @maximum 5000
   */
  rowNumber?: number;
  sap_version?: TLSAPVersion;
};

export type GetObjectTransportInfoPathParameters = {
  objectUri: string;
};
export type GetObjectTransportInfoParams = {
  sap_version?: TLSAPVersion;
};

export type GetUsageReferencesPathParameters = {
  objectUri: string;
};
export type GetUsageReferencesParams = {
  sap_version?: TLSAPVersion;
  limit?: number | null;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type SearchPackagesParams = {
  /**
   * Name pattern (e.g. 'Z*')
   * @minLength 1
   * @maxLength 60
   */
  q: string;
  /**
   * Max packages to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  sap_version?: TLSAPVersion;
};

export type ExpandPackagePathParameters = {
  packageId: string;
};
export type ExpandPackageParams = {
  /**
   * Max nodes to return
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * Offset for pagination
   * @minimum 0
   */
  offset?: number;
  /**
   * ADT parent type; DEVC/K for a package root, DEVC/OC for the Source Code Library virtual subfolder, DEVC/P for the Programs virtual subfolder
   */
  parent_type?: ExpandPackageParentType;
  /**
   * Target SAP system (S4 or ECC).
   */
  sap_version?: TLSAPVersion;
};

export enum ExpandPackageParentType {
  'DEVC/K' = 'DEVC/K',
  'DEVC/OC' = 'DEVC/OC',
  'DEVC/P' = 'DEVC/P',
}
export type GetPrettyPrintSettingsParams = {
  sap_version?: TLSAPVersion;
};

export type UpdatePrettyPrintSettingsParams = {
  sap_version?: TLSAPVersion;
};

export type ListProgramSubobjectsPathParameters = {
  parentProgramId: string;
};
export type GetSapGuiUrlParams = {
  /**
   * Object kind: PROG, INCL, INTF, CLAS, FUGR, FUNC, TABLE.
   * @minLength 1
   * @maxLength 8
   */
  kind: string;
  /**
   * Object name (e.g. ZSWAG_PROG_142137, USR02).
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  sap_version?: TLSAPVersion;
};

export type ListTransportsParams = {
  /**
   * Max TRs to return
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * Offset for pagination
   * @minimum 0
   */
  offset?: number;
  /**
   * SAP requestStatus filter: D=modifiable (default), R=released, L=locked. Pass to override.
   * @minLength 1
   * @maxLength 4
   */
  status?: string;
  sap_version?: TLSAPVersion;
};

export type CreateTransportParams = {
  sap_version?: TLSAPVersion;
};

export type GetTransportPathParameters = {
  transport: string;
};
export type GetTransportParams = {
  sap_version?: TLSAPVersion;
};

export type GetProjectsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * Case-insensitive substring match on project name. Blank is the same as omitting it.
   */
  search?: string | null;
  /**
   * Field to sort by
   */
  sort_by?: TLProjectListSortField;
  /**
   * Sort direction
   */
  sort_dir?: TLSortDirection;
};

export type RenameProjectPathParameters = {
  projectId: string;
};
export type RenameProjectParams = {
  new_name: string;
};

export type GetProjectByIdPathParameters = {
  projectId: string;
};
export type ListFunctionalSpecsPathParameters = {
  projectId: string;
};
export type ListFunctionalSpecsParams = {
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type CreateFunctionalSpecPathParameters = {
  projectId: string;
};
export type DeleteFunctionalSpecPathParameters = {
  projectId: string;
  specId: string;
};
export type GetFunctionalSpecPathParameters = {
  projectId: string;
  specId: string;
};
export type UploadFunctionalSpecDocxPathParameters = {
  projectId: string;
  specId: string;
};
export type UploadFunctionalSpecDocxParams = {
  /**
   * Target SAP system version for extracted objects
   */
  sap_version?: TLSAPVersion;
};

export type ApplyObjectEndpointPathParameters = {
  projectId: string;
};
export type ApplyObjectEndpointParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ClassifyObjectPathParameters = {
  projectId: string;
};
export type ClassifyObjectParams = {
  /**
   * @minLength 1
   * @maxLength 500
   */
  object_uri: string;
  /**
   * @minimum 1
   * @maximum 3650
   */
  max_days_back?: number;
  /**
   * @minimum 1
   * @maximum 500
   */
  max_versions?: number;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type DiffObjectPathParameters = {
  projectId: string;
};
export type DiffObjectParams = {
  /**
   * @minLength 1
   * @maxLength 500
   */
  object_uri: string;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type DiscoverPackagePathParameters = {
  projectId: string;
};
export type DiscoverPackageParams = {
  /**
   * @minLength 1
   * @maxLength 100
   */
  source_package: string;
  target_package?: string | null;
  name_glob?: string | null;
  /**
   * @minimum 1
   * @maximum 20
   */
  max_concurrency?: number;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type DiscoverProgressPathParameters = {
  projectId: string;
};
export type DiscoverProgressParams = {
  /**
   * @minLength 1
   * @maxLength 100
   */
  source_package: string;
  target_package?: string | null;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ListHistoryPathParameters = {
  projectId: string;
};
export type ListHistoryParams = {
  /**
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  name_filter?: string | null;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ExportChangeRecordPathParameters = {
  projectId: string;
};
export type ExportChangeRecordParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ScanObjectsAtcPathParameters = {
  projectId: string;
};
export type ScanObjectsAtcParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ObjectsInTransportsPathParameters = {
  projectId: string;
};
export type ObjectsInTransportsParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type OrderObjectsPathParameters = {
  projectId: string;
};
export type OrderObjectsParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type RetainTargetEndpointPathParameters = {
  projectId: string;
};
export type RetainTargetEndpointParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ProbePathParameters = {
  projectId: string;
};
export type ProbeParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type CreateRemediationHandoffPathParameters = {
  projectId: string;
};
export type CreateRemediationHandoffParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type TargetPackageCheckPathParameters = {
  projectId: string;
};
export type TargetPackageCheckParams = {
  /**
   * @minLength 1
   * @maxLength 30
   */
  package: string;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ListTransportDispositionsPathParameters = {
  projectId: string;
};
export type ListTransportDispositionsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type CockpitCheckPathParameters = {
  projectId: string;
};
export type CockpitCheckParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type CockpitListPathParameters = {
  projectId: string;
};
export type CockpitListParams = {
  /**
   * @pattern ^(source|target)$
   */
  side?: string;
  /**
   * Release-state filter: released (default), modifiable, or all.
   */
  status?: TLCockpitTransportStatusFilter;
  /**
   * Drop TRs already (at least partially) retrofitted in this project.
   */
  exclude_retrofitted?: boolean;
  /**
   * Drop source TRs with a terminal Retrofitted, Manual Retrofit, or Retrofit Rejected outcome.
   */
  exclude_processed?: boolean;
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type CockpitExportTrackerPathParameters = {
  projectId: string;
};
export type CockpitExportTrackerParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type RetrofitTrEndpointPathParameters = {
  projectId: string;
};
export type RetrofitTrEndpointParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type CockpitTrDetailPathParameters = {
  projectId: string;
  transportNumber: string;
};
export type CockpitTrDetailParams = {
  /**
   * @pattern ^(source|target)$
   */
  side?: string;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type CompleteLandscapeSyncTransportPathParameters = {
  projectId: string;
  transportNumber: string;
};
export type CompleteLandscapeSyncTransportParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type GetCustomizingRowsPathParameters = {
  projectId: string;
  transportNumber: string;
};
export type GetCustomizingRowsParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type SetTransportDispositionPathParameters = {
  projectId: string;
  transportNumber: string;
};
export type SetTransportDispositionParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type ReopenTransportDispositionPathParameters = {
  projectId: string;
  transportNumber: string;
};
export type ReopenTransportDispositionParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type InspectTrPathParameters = {
  projectId: string;
  transportNumber: string;
};
export type InspectTrParams = {
  /**
   * @pattern ^(source|target)$
   */
  side?: string;
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type RetrofitCustomizingRowsPathParameters = {
  projectId: string;
  transportNumber: string;
};
export type RetrofitCustomizingRowsParams = {
  /**
   * Data-Connectors connector to use as the SOURCE system (overrides tenant settings).
   */
  source_connector_id?: string | null;
  /**
   * Credential on the source connector; omit to use your own credential.
   */
  source_credential_id?: string | null;
  /**
   * Data-Connectors connector to use as the TARGET system (overrides tenant settings).
   */
  target_connector_id?: string | null;
  /**
   * Credential on the target connector; omit to use your own credential.
   */
  target_credential_id?: string | null;
};

export type GetProjectMembersPathParameters = {
  projectId: string;
};
export type GetProjectMembersParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type AddProjectMemberPathParameters = {
  projectId: string;
};
export type RemoveProjectMemberPathParameters = {
  projectId: string;
  userEmail: string;
};
export type UpdateProjectMemberRolePathParameters = {
  projectId: string;
  userEmail: string;
};
export type UpdateProjectSystemsPathParameters = {
  projectId: string;
};
export type ListRunsForRemedyPathParameters = {
  remedyId: string;
};
export type ListRunsForRemedyParams = {
  /**
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetRunPathParameters = {
  runId: string;
};
export type CancelRunPathParameters = {
  runId: string;
};
export type GetProposedSourcePathParameters = {
  runId: string;
};
export type ListRunProposedSourcesPathParameters = {
  runId: string;
};
export type ListRunProposedSourcesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetRunProposedSourceForObjectPathParameters = {
  runId: string;
  objectId: string;
};
export type RetryRunPathParameters = {
  runId: string;
};
export type RollbackAgenticRunPathParameters = {
  runId: string;
};
export type ListRegisteredSettingsParams = {
  /**
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ListSkillContentsParams = {
  /**
   * Filter by FILE or DIRECTORY
   */
  node_type?: TLNodeType | null;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type DeleteSkillNodePathParameters = {
  nodeId: string;
};
export type GetSkillNodePathParameters = {
  nodeId: string;
};
export type GetSkillNodeBreadcrumbPathParameters = {
  nodeId: string;
};
export type ListSkillNodeChildrenPathParameters = {
  nodeId: string;
};
export type ListSkillNodeChildrenParams = {
  /**
   * Filter by FILE or DIRECTORY
   */
  node_type?: TLNodeType | null;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type MoveSkillNodePathParameters = {
  nodeId: string;
};
export type RenameSkillNodePathParameters = {
  nodeId: string;
};
export type ListSystemsParams = {
  /**
   * Filter by connector slug
   */
  connector?: string | null;
  /**
   * Filter by capability
   */
  capability?: string | null;
  /**
   * Filter by connectivity status
   */
  status?: string | null;
  /**
   * Free-text filter on slug/name
   */
  q?: string | null;
  /**
   * Opaque pagination cursor
   */
  cursor?: string | null;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
};

export type ListSystemConnectorsParams = {
  /**
   * Filter by capability
   */
  capability?: string | null;
  /**
   * Filter by connector category
   */
  category?: string | null;
  /**
   * Free-text filter on slug/name
   */
  q?: string | null;
};

export type GetSystemConnectorFamilyIconPathParameters = {
  familySlug: string;
};
export type GetSystemConnectorPathParameters = {
  slug: string;
};
export type GetSystemConnectorIconPathParameters = {
  slug: string;
};
export type ArchiveSystemPathParameters = {
  sysRef: string;
};
export type ArchiveSystemParams = {
  /**
   * Archive even when recently resolved
   */
  force?: boolean;
};

export type GetSystemPathParameters = {
  sysRef: string;
};
export type UpdateSystemPathParameters = {
  sysRef: string;
};
export type ListSystemAuditPathParameters = {
  sysRef: string;
};
export type ListSystemAuditParams = {
  /**
   * @minimum 1
   * @maximum 500
   */
  limit?: number;
};

export type RevokeMySystemCredentialPathParameters = {
  sysRef: string;
};
export type GetMySystemCredentialPathParameters = {
  sysRef: string;
};
export type RotateMySystemCredentialPathParameters = {
  sysRef: string;
};
export type SetMySystemCredentialPathParameters = {
  sysRef: string;
};
export type ListSystemDependentsPathParameters = {
  sysRef: string;
};
export type PurgeSystemPathParameters = {
  sysRef: string;
};
export type TestSystemPathParameters = {
  sysRef: string;
};
export type GetAllTenantsParams = {
  status?: TLTenantStatus | null;
};

export type UpdateTenantPathParameters = {
  tenantId: string;
};
export type DeleteTenantPathParameters = {
  tenantId: string;
};
export type GetTenantPathParameters = {
  tenantId: string;
};
export type RemoveTenantMembersPathParameters = {
  tenantId: string;
};
export type ListTenantMembersPathParameters = {
  tenantId: string;
};
export type ListTenantMembersParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type AddTenantMembersPathParameters = {
  tenantId: string;
};
export type PermanentlyDeleteTenantPathParameters = {
  tenantId: string;
};
export type RestoreTenantPathParameters = {
  tenantId: string;
};
export type UpdateTenantVisibilityPathParameters = {
  tenantId: string;
};
export type RetrieveUserErpCredentialsParams = {
  domain?: TLERPDomain | null;
};

export type RemoveUserErpCredentialsPathParameters = {
  credentialId: string;
};
export type ListUserSkillsParams = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
  /**
   * Filter skills by product domain; omit for all domains
   */
  domain?: TLDomain | null;
  /**
   * Filter skills by project or domain entity
   */
  correlation_id?: string | null;
  /**
   * Filter skills by status (e.g. ACTIVE); omit to include all statuses
   */
  status?: TLSkillStatus | null;
};

export type ImportUserSkillZipParams = {
  /**
   * Product domain for the imported skill
   */
  domain?: TLDomain;
  /**
   * Optional project or entity correlation ID
   */
  correlation_id?: string | null;
  /**
   * Replace an existing same-slug skill instead of erroring
   */
  overwrite?: boolean;
};

export type DeleteUserSkillPathParameters = {
  skillId: string;
};
export type GetUserSkillPathParameters = {
  skillId: string;
};
export type UpdateUserSkillPathParameters = {
  skillId: string;
};
export type ListAttachmentsPathParameters = {
  skillId: string;
};
export type ListAttachmentsParams = {
  /**
   * Max results to return
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of results to skip
   * @minimum 0
   */
  offset?: number;
};

export type CreateAttachmentPathParameters = {
  skillId: string;
};
export type AbortUserSkillAttachmentUploadPathParameters = {
  skillId: string;
};
export type CompleteUserSkillAttachmentUploadPathParameters = {
  skillId: string;
};
export type InitiateUserSkillAttachmentUploadPathParameters = {
  skillId: string;
};
export type DeleteAttachmentPathParameters = {
  skillId: string;
  attachmentId: string;
};
export type GetAttachmentPathParameters = {
  skillId: string;
  attachmentId: string;
};
export type UpdateAttachmentPathParameters = {
  skillId: string;
  attachmentId: string;
};
export type GetAttachmentContentPathParameters = {
  skillId: string;
  attachmentId: string;
};
export type PutAttachmentContentPathParameters = {
  skillId: string;
  attachmentId: string;
};
export type DownloadUserSkillAttachmentPathParameters = {
  skillId: string;
  attachmentId: string;
};
export type GetUserSkillContentPathParameters = {
  skillId: string;
};
export type PutUserSkillContentPathParameters = {
  skillId: string;
};
export type ExportUserSkillZipPathParameters = {
  skillId: string;
};
export type PromoteUserSkillToPlatformPathParameters = {
  skillId: string;
};
export type PromoteUserSkillToPlatformParams = {
  /**
   * Platform domain for the promoted skill
   */
  domain?: TLDomain;
};

export type GetSkillSharePathParameters = {
  skillId: string;
};
export type CreateSkillSharePathParameters = {
  skillId: string;
};
export type RevokeSkillSharePathParameters = {
  skillId: string;
};
export type ListUserTasksParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type ListClosedUserTasksParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type UpdateUserTaskPathParameters = {
  taskId: string;
};
export type GetUserTaskHistoryPathParameters = {
  taskId: string;
};
export type GetUserTaskHistoryParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type GetUserListParams = {
  first?: number | null;
  max?: number | null;
  search?: string | null;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  emailVerified?: boolean | null;
  enabled?: boolean | null;
  exact?: boolean | null;
  briefRepresentation?: boolean | null;
  idpAlias?: string | null;
  idpUserId?: string | null;
  q?: string | null;
};

export type GetUsersByRolePathParameters = {
  roleName: string;
};
export type GetUsersByRoleParams = {
  first?: number | null;
  max?: number | null;
  search?: string | null;
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  emailVerified?: boolean | null;
  enabled?: boolean | null;
  exact?: boolean | null;
  briefRepresentation?: boolean | null;
  idpAlias?: string | null;
  idpUserId?: string | null;
  q?: string | null;
};

export type ListUserDirectoryParams = {
  /**
   * Search by username, first/last name, or email
   */
  search?: string | null;
  /**
   * Sort field: username, email, last_login, last_modified, created_timestamp
   */
  sort_by?: TLUserListSortField;
  /**
   * Sort direction: asc, desc
   */
  sort_dir?: TLSortDirection;
};

export type GetUserRolesPathParameters = {
  email: string;
};
export type MigrationAssessmentExtractionStatusParams = {
  run_id?: string | null;
};

export type MigrationAssessmentListIcosParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * Force a fresh Directory query (bypass the 6h cache).
   */
  refresh?: boolean;
  /**
   * SAP PI/PO connection to read; omitted uses the default connector.
   */
  connection_id?: string | null;
};

export type MigrationAssessmentListNamespacesParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * SAP PI/PO connection to read; omitted uses the default connector.
   */
  connection_id?: string | null;
};

export type MigrationAssessmentListRunsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type MigrationAssessmentArtifactClassificationPathParameters = {
  runId: string;
};
export type MigrationAssessmentBuildRunPathParameters = {
  runId: string;
};
export type MigrationAssessmentListBuildCandidatesPathParameters = {
  runId: string;
};
export type MigrationAssessmentGetBuildResultPathParameters = {
  runId: string;
};
export type MigrationAssessmentConversionStatusPathParameters = {
  runId: string;
};
export type MigrationAssessmentStartConversionPathParameters = {
  runId: string;
};
export type MigrationAssessmentStartConversionParams = {
  /**
   * Re-convert even if conversion state already exists.
   */
  force?: boolean;
};

export type MigrationAssessmentStartAiConversionPathParameters = {
  runId: string;
};
export type MigrationAssessmentStartAiConversionParams = {
  /**
   * Re-run even if a completed AI job exists.
   */
  force?: boolean;
};

export type MigrationAssessmentGetConversionItemPathParameters = {
  runId: string;
  conversionItemId: string;
};
export type MigrationAssessmentReviewConversionItemPathParameters = {
  runId: string;
  conversionItemId: string;
};
export type MigrationAssessmentEnhancementStatusPathParameters = {
  runId: string;
};
export type MigrationAssessmentEnhanceRunPathParameters = {
  runId: string;
};
export type MigrationAssessmentEnhanceRunParams = {
  /**
   * Re-run even if a completed job exists (Regenerate).
   */
  force?: boolean;
};

export type MigrationAssessmentFeasibilityMatrixPathParameters = {
  runId: string;
};
export type MigrationAssessmentRunInventorySummaryPathParameters = {
  runId: string;
};
export type MigrationAssessmentRunMappingsStatusPathParameters = {
  runId: string;
};
export type MigrationAssessmentPrepareRunMappingsPathParameters = {
  runId: string;
};
export type MigrationAssessmentUploadRunMappingsPathParameters = {
  runId: string;
};
export type MigrationAssessmentMigrationEstimatePathParameters = {
  runId: string;
};
export type MigrationAssessmentMigrationPlanPathParameters = {
  runId: string;
};
export type MigrationAssessmentMigrationReportPathParameters = {
  runId: string;
};
export type MigrationAssessmentMigrationReportParams = {
  report_format?: TLReportFormat;
};

export type MigrationAssessmentVerifyBuildPathParameters = {
  runId: string;
};
export type MigrationAssessmentListSoftwareComponentsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
  /**
   * SAP PI/PO connection to read; omitted uses the default connector.
   */
  connection_id?: string | null;
};

export type MigrationAssessmentTestSinkChannelsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type MigrationAssessmentTestSinkChannelPathParameters = {
  channel: string;
};
export type MigrationAssessmentTestSinkChannelParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type MigrationAssessmentBuildIntegrationPathParameters = {
  workspaceId: string;
};
export type MigrationAssessmentPrepareWorkspacePathParameters = {
  workspaceId: string;
};
export type BackfillDashboardStoragePathParameters = {
  dashboardId: string;
};
export type BackfillUniqueErrorsPathParameters = {
  dashboardId: string;
};
export type TriggerCalculationPathParameters = {
  dashboardId: string;
  calculationType: TLCalculationType;
};
export type DownloadExportPathParameters = {
  exportId: string;
};
export type GetTenantStorageStatusParams = {
  /**
   * Run the per-execution readability probes (slow). Off by default for the fast counts-only call; the UI fetches this separately as an async follow-up.
   */
  probe_readability?: boolean;
  /**
   * Bypass cached probe results and re-probe readability
   */
  refresh?: boolean;
};

export type GetBatchExecutionsByDashboardPathParameters = {
  dashboardId: string;
};
export type CancelBatchExecutionPathParameters = {
  batchExecutionId: string;
};
export type DeleteCategoryPathParameters = {
  categoryId: string;
};
export type UpdateCategoryPathParameters = {
  categoryId: string;
};
export type GetAllCredentialsParams = {
  /**
   * Filter by domain
   */
  domain?: TLCredentialDomain | null;
};

export type DeleteCredentialPathParameters = {
  credentialId: string;
};
export type GetCredentialByIdPathParameters = {
  credentialId: string;
};
export type UpdateCredentialPathParameters = {
  credentialId: string;
};
export type ExportCredentialToConnectorPathParameters = {
  credentialId: string;
};
export type PingCredentialByIdPathParameters = {
  credentialId: string;
};
export type GetAllCustomViewsByDashboardPathParameters = {
  dashboardId: string;
};
export type GetAllCustomViewsByDashboardParams = {
  status?: TLCustomViewStatus | null;
};

export type CreateCustomViewForDashboardPathParameters = {
  dashboardId: string;
};
export type GetCustomViewExecutionByIdPathParameters = {
  executionId: string;
};
export type GetCustomViewExecutionDataByIdPathParameters = {
  executionId: string;
};
export type ExportCustomViewExecutionDataByIdPathParameters = {
  executionId: string;
};
export type GetCustomViewExecutionFilterValuesPathParameters = {
  executionId: string;
};
export type GenerateFiltersForCustomViewExecutionPathParameters = {
  executionId: string;
};
export type RecalculateCustomViewExecutionByIdPathParameters = {
  executionId: string;
};
export type DeleteCustomViewGroupByIdPathParameters = {
  groupId: string;
};
export type UpdateCustomViewGroupByIdPathParameters = {
  groupId: string;
};
export type CreateCustomViewGroupSourcePathParameters = {
  groupId: string;
};
export type DeleteCustomViewGroupSourceByIdPathParameters = {
  sourceId: string;
};
export type UpdateCustomViewGroupSourceByIdPathParameters = {
  sourceId: string;
};
export type DeleteCustomViewByIdPathParameters = {
  viewId: string;
};
export type GetCustomViewByIdPathParameters = {
  viewId: string;
};
export type UpdateCustomViewByIdPathParameters = {
  viewId: string;
};
export type ReplaceCustomViewPathParameters = {
  viewId: string;
};
export type BackfillCustomViewExecutionsPathParameters = {
  viewId: string;
};
export type GetAllCustomViewExecutionsByViewPathParameters = {
  viewId: string;
};
export type CreateCustomViewGroupPathParameters = {
  viewId: string;
};
export type GetCustomViewLinksByIdPathParameters = {
  viewId: string;
};
export type TriggerCustomViewExecutionPathParameters = {
  viewId: string;
};
export type UpdateDashboardDataCheckPathParameters = {
  dashboardDataCheckId: string;
};
export type GetDashboardDataCheckExecutionsPathParameters = {
  dashboardDataCheckId: string;
};
export type GetDashboardDataCheckExecutionsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type GetDashboardPermissionsPathParameters = {
  dashboardId: string;
};
export type CreateDashboardPermissionPathParameters = {
  dashboardId: string;
};
export type BulkUpdateDashboardPermissionsPathParameters = {
  dashboardId: string;
};
export type DeleteDashboardPermissionPathParameters = {
  dashboardId: string;
  permissionId: string;
};
export type UpdateDashboardPermissionPathParameters = {
  dashboardId: string;
  permissionId: string;
};
export type GetAllDashboardsParams = {
  /**
   * Include dashboard config in response
   */
  include_config?: boolean;
};

export type DeleteDashboardPathParameters = {
  dashboardId: string;
};
export type GetDashboardByIdPathParameters = {
  dashboardId: string;
};
export type GetDashboardByIdParams = {
  /**
   * Include dashboard config in response
   */
  include_config?: boolean;
};

export type UpdateDashboardPathParameters = {
  dashboardId: string;
};
export type ExecuteDashboardAnalyticsQueryPathParameters = {
  dashboardId: string;
};
export type ExecuteBatchDashboardAnalyticsQueriesPathParameters = {
  dashboardId: string;
};
export type UpdateDashboardConfigPathParameters = {
  dashboardId: string;
};
export type RemoveCredentialsFromDashboardPathParameters = {
  dashboardId: string;
};
export type GetDashboardCredentialsPathParameters = {
  dashboardId: string;
};
export type AddCredentialsToDashboardPathParameters = {
  dashboardId: string;
};
export type GetDashboardDataCheckRecordsPathParameters = {
  dashboardId: string;
};
export type GetDashboardDataChecksPathParameters = {
  dashboardId: string;
};
export type AddDataChecksToDashboardPathParameters = {
  dashboardId: string;
};
export type MaterializeDashboardDataSourceQueryPathParameters = {
  dashboardId: string;
};
export type GetDashboardDataSourceQueryStatusPathParameters = {
  dashboardId: string;
  jobId: string;
};
export type ImportDashboardDataSourceFilePathParameters = {
  dashboardId: string;
};
export type GetDashboardDataSourceImportStatusPathParameters = {
  dashboardId: string;
  jobId: string;
};
export type GetAllErrorTrackingPathParameters = {
  dashboardId: string;
};
export type ExecuteDashboardPathParameters = {
  dashboardId: string;
};
export type GetDashboardExecutionsPathParameters = {
  dashboardId: string;
};
export type GetDashboardExecutionsParams = {
  /**
   * @minimum 1
   */
  limit?: number;
};

export type GetDashboardSchedulesPathParameters = {
  dashboardId: string;
};
export type CreateDashboardSchedulePathParameters = {
  dashboardId: string;
};
export type DeleteDashboardSchedulePathParameters = {
  dashboardId: string;
  scheduleId: string;
};
export type UpdateDashboardSchedulePathParameters = {
  dashboardId: string;
  scheduleId: string;
};
export type GetDashboardStorageStatusPathParameters = {
  dashboardId: string;
};
export type GetDashboardStorageStatusParams = {
  /**
   * Bypass cached probe results and re-probe readability
   */
  refresh?: boolean;
};

export type GetAllDataChecksParams = {
  /**
   * Filter by library IDs
   */
  library_ids?: string[] | null;
};

export type UpdateDataCheckPathParameters = {
  dataCheckId: string;
};
export type UpdateDataCheckCodePathParameters = {
  dataCheckId: string;
};
export type GetDataSourcesParams = {
  /**
   * Filter by dashboard ID
   */
  dashboard_id?: string | null;
};

export type GetArchivedDataSourcesParams = {
  /**
   * Dashboard ID to get archived sources for
   */
  dashboard_id: string;
};

export type ArchiveDataSourcePathParameters = {
  sourceId: string;
};
export type GetDataSourcePathParameters = {
  sourceId: string;
};
export type UpdateDataSourcePathParameters = {
  sourceId: string;
};
export type UpdateDirectSourceContentPathParameters = {
  sourceId: string;
};
export type CopyDataSourcePathParameters = {
  sourceId: string;
};
export type DeleteDataSourcePathParameters = {
  sourceId: string;
};
export type GetDataSourcePreviewPathParameters = {
  sourceId: string;
};
export type GetDataSourcePreviewParams = {
  /**
   * Date to use for resolution (ISO format)
   */
  filter_date?: string | null;
  /**
   * Maximum number of rows to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
};

export type RestoreDataSourcePathParameters = {
  sourceId: string;
};
export type GetDataSourceSchemaPathParameters = {
  sourceId: string;
};
export type GetDataSourceSchemaParams = {
  /**
   * Date to use for resolution (ISO format)
   */
  filter_date?: string | null;
};

export type DeleteDimensionPathParameters = {
  dimensionId: string;
};
export type UpdateDimensionPathParameters = {
  dimensionId: string;
};
export type GetErrorTrackingDataPathParameters = {
  errorTrackingId: string;
};
export type ExportErrorTrackingDataPathParameters = {
  errorTrackingId: string;
};
export type GenerateFiltersForErrorTrackingPathParameters = {
  errorTrackingId: string;
};
export type RecalculateErrorTrackingPathParameters = {
  errorTrackingId: string;
};
export type ListExecutionsParams = {
  /**
   * Number of executions to return
   * @minimum 1
   * @maximum 1000
   */
  limit?: number;
  /**
   * Number of executions to skip
   * @minimum 0
   */
  offset?: number;
  /**
   * Filter by execution status
   */
  status?: TLDataCheckExecutionStatus[] | null;
  /**
   * Filter by dashboard ID
   */
  dashboard_id?: string[] | null;
};

export type GetExecutionResultPathParameters = {
  executionId: string;
};
export type ExportExecutionResultPathParameters = {
  executionId: string;
};
export type GenerateFiltersForExecutionResultPathParameters = {
  executionId: string;
};
export type DeleteLibraryPathParameters = {
  libraryId: string;
};
export type GetLibraryPathParameters = {
  libraryId: string;
};
export type UpdateLibraryPathParameters = {
  libraryId: string;
};
export type RemoveDataChecksFromLibraryPathParameters = {
  libraryId: string;
};
export type GetLibraryDataChecksPathParameters = {
  libraryId: string;
};
export type AddDataChecksToLibraryPathParameters = {
  libraryId: string;
};
export type ArchiveFiltersParams = {
  /**
   * List of filter IDs to archive
   */
  filter_ids: string[];
};

export type GetAllFiltersParams = {
  /**
   * Dashboard or table ID to get filters for
   */
  target_id: string;
  /**
   * Filter by public/private visibility
   */
  is_public?: boolean | null;
};

export type GetFilterByIdPathParameters = {
  filterId: string;
};
export type UpdateFilterPathParameters = {
  filterId: string;
};
export type ListTransformationOperationsParams = {
  category?: TLOperationCategory | null;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
  /**
   * @minimum 0
   */
  offset?: number;
};

export type RunSingleTransformationOperationPathParameters = {
  viewId: string;
};
export type CreateViewParityCheckPathParameters = {
  viewId: string;
};
export type RunViewTransformationWorkflowPathParameters = {
  viewId: string;
};
export type ListWorklistTasksParams = {
  /**
   * Filter by domain (repeatable): CODE, VIEW, KNOWLEDGE_BASE, DATA, MIGRATION
   */
  domain?: TLWorkItemType[] | null;
  /**
   * Filter by workstream (repeatable). Can be combined with `domain`.
   */
  workstream?: TLWorkstream[] | null;
  /**
   * Filter by normalized status (repeatable)
   */
  status?: TLWorkItemStatus[] | null;
  /**
   * Filter by priority (repeatable)
   */
  priority?: TLPriority[] | null;
  /**
   * Search by item name (case-insensitive contains)
   */
  search?: string | null;
  /**
   * Field to sort by
   */
  sort_by?: TLWorkItemSortField;
  /**
   * Sort direction
   */
  sort_dir?: TLSortDirection;
  /**
   * Page size
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * Number of items to skip
   * @minimum 0
   */
  offset?: number;
  /**
   * Filter by assignee email. admin only — silently ignored for other roles.
   */
  assignee?: string | null;
};
